import { r as registerInstance, z as getAssetPath, h, H as Host, g as getElement } from "./main-bb89b2f2.js";
import { c as commonjsGlobal } from "./_commonjsHelpers-1c8beb5f-77f246c3.js";
import { T as TranslationService } from "./translation-service-06f7c8c7-b6396601.js";
import "vue";
var lottie = { exports: {} };
(function(module, exports) {
  typeof navigator < "u" && function(e, t) {
    module.exports = t();
  }(commonjsGlobal, function() {
    var svgNS = "http://www.w3.org/2000/svg", locationHref = "", _useWebWorker = !1, initialDefaultFrame = -999999, setWebWorker = function(t) {
      _useWebWorker = !!t;
    }, getWebWorker = function() {
      return _useWebWorker;
    }, setLocationHref = function(t) {
      locationHref = t;
    }, getLocationHref = function() {
      return locationHref;
    };
    function createTag(e) {
      return document.createElement(e);
    }
    function extendPrototype(e, t) {
      var r, i = e.length, s;
      for (r = 0; r < i; r += 1) {
        s = e[r].prototype;
        for (var a in s)
          Object.prototype.hasOwnProperty.call(s, a) && (t.prototype[a] = s[a]);
      }
    }
    function getDescriptor(e, t) {
      return Object.getOwnPropertyDescriptor(e, t);
    }
    function createProxyFunction(e) {
      function t() {
      }
      return t.prototype = e, t;
    }
    var audioControllerFactory = function() {
      function e(t) {
        this.audios = [], this.audioFactory = t, this._volume = 1, this._isMuted = !1;
      }
      return e.prototype = {
        addAudio: function(r) {
          this.audios.push(r);
        },
        pause: function() {
          var r, i = this.audios.length;
          for (r = 0; r < i; r += 1)
            this.audios[r].pause();
        },
        resume: function() {
          var r, i = this.audios.length;
          for (r = 0; r < i; r += 1)
            this.audios[r].resume();
        },
        setRate: function(r) {
          var i, s = this.audios.length;
          for (i = 0; i < s; i += 1)
            this.audios[i].setRate(r);
        },
        createAudio: function(r) {
          return this.audioFactory ? this.audioFactory(r) : window.Howl ? new window.Howl({
            src: [r]
          }) : {
            isPlaying: !1,
            play: function() {
              this.isPlaying = !0;
            },
            seek: function() {
              this.isPlaying = !1;
            },
            playing: function() {
            },
            rate: function() {
            },
            setVolume: function() {
            }
          };
        },
        setAudioFactory: function(r) {
          this.audioFactory = r;
        },
        setVolume: function(r) {
          this._volume = r, this._updateVolume();
        },
        mute: function() {
          this._isMuted = !0, this._updateVolume();
        },
        unmute: function() {
          this._isMuted = !1, this._updateVolume();
        },
        getVolume: function() {
          return this._volume;
        },
        _updateVolume: function() {
          var r, i = this.audios.length;
          for (r = 0; r < i; r += 1)
            this.audios[r].volume(this._volume * (this._isMuted ? 0 : 1));
        }
      }, function() {
        return new e();
      };
    }(), createTypedArray = function() {
      function e(r, i) {
        var s = 0, a = [], n;
        switch (r) {
          case "int16":
          case "uint8c":
            n = 1;
            break;
          default:
            n = 1.1;
            break;
        }
        for (s = 0; s < i; s += 1)
          a.push(n);
        return a;
      }
      function t(r, i) {
        return r === "float32" ? new Float32Array(i) : r === "int16" ? new Int16Array(i) : r === "uint8c" ? new Uint8ClampedArray(i) : e(r, i);
      }
      return typeof Uint8ClampedArray == "function" && typeof Float32Array == "function" ? t : e;
    }();
    function createSizedArray(e) {
      return Array.apply(null, {
        length: e
      });
    }
    function _typeof$6(e) {
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof$6 = function(r) {
        return typeof r;
      } : _typeof$6 = function(r) {
        return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
      }, _typeof$6(e);
    }
    var subframeEnabled = !0, expressionsPlugin = null, expressionsInterfaces = null, idPrefix$1 = "", isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent), bmPow = Math.pow, bmSqrt = Math.sqrt, bmFloor = Math.floor, bmMax = Math.max, bmMin = Math.min, BMMath = {};
    (function() {
      var e = ["abs", "acos", "acosh", "asin", "asinh", "atan", "atanh", "atan2", "ceil", "cbrt", "expm1", "clz32", "cos", "cosh", "exp", "floor", "fround", "hypot", "imul", "log", "log1p", "log2", "log10", "max", "min", "pow", "random", "round", "sign", "sin", "sinh", "sqrt", "tan", "tanh", "trunc", "E", "LN10", "LN2", "LOG10E", "LOG2E", "PI", "SQRT1_2", "SQRT2"], t, r = e.length;
      for (t = 0; t < r; t += 1)
        BMMath[e[t]] = Math[e[t]];
    })(), BMMath.random = Math.random, BMMath.abs = function(e) {
      var t = _typeof$6(e);
      if (t === "object" && e.length) {
        var r = createSizedArray(e.length), i, s = e.length;
        for (i = 0; i < s; i += 1)
          r[i] = Math.abs(e[i]);
        return r;
      }
      return Math.abs(e);
    };
    var defaultCurveSegments = 150, degToRads = Math.PI / 180, roundCorner = 0.5519;
    function styleDiv(e) {
      e.style.position = "absolute", e.style.top = 0, e.style.left = 0, e.style.display = "block", e.style.transformOrigin = "0 0", e.style.webkitTransformOrigin = "0 0", e.style.backfaceVisibility = "visible", e.style.webkitBackfaceVisibility = "visible", e.style.transformStyle = "preserve-3d", e.style.webkitTransformStyle = "preserve-3d", e.style.mozTransformStyle = "preserve-3d";
    }
    function BMEnterFrameEvent(e, t, r, i) {
      this.type = e, this.currentTime = t, this.totalTime = r, this.direction = i < 0 ? -1 : 1;
    }
    function BMCompleteEvent(e, t) {
      this.type = e, this.direction = t < 0 ? -1 : 1;
    }
    function BMCompleteLoopEvent(e, t, r, i) {
      this.type = e, this.currentLoop = r, this.totalLoops = t, this.direction = i < 0 ? -1 : 1;
    }
    function BMSegmentStartEvent(e, t, r) {
      this.type = e, this.firstFrame = t, this.totalFrames = r;
    }
    function BMDestroyEvent(e, t) {
      this.type = e, this.target = t;
    }
    function BMRenderFrameErrorEvent(e, t) {
      this.type = "renderFrameError", this.nativeError = e, this.currentTime = t;
    }
    function BMConfigErrorEvent(e) {
      this.type = "configError", this.nativeError = e;
    }
    var createElementID = function() {
      var e = 0;
      return function() {
        return e += 1, idPrefix$1 + "__lottie_element_" + e;
      };
    }();
    function HSVtoRGB(e, t, r) {
      var i, s, a, n, l, o, p, y;
      switch (n = Math.floor(e * 6), l = e * 6 - n, o = r * (1 - t), p = r * (1 - l * t), y = r * (1 - (1 - l) * t), n % 6) {
        case 0:
          i = r, s = y, a = o;
          break;
        case 1:
          i = p, s = r, a = o;
          break;
        case 2:
          i = o, s = r, a = y;
          break;
        case 3:
          i = o, s = p, a = r;
          break;
        case 4:
          i = y, s = o, a = r;
          break;
        case 5:
          i = r, s = o, a = p;
          break;
      }
      return [i, s, a];
    }
    function RGBtoHSV(e, t, r) {
      var i = Math.max(e, t, r), s = Math.min(e, t, r), a = i - s, n, l = i === 0 ? 0 : a / i, o = i / 255;
      switch (i) {
        case s:
          n = 0;
          break;
        case e:
          n = t - r + a * (t < r ? 6 : 0), n /= 6 * a;
          break;
        case t:
          n = r - e + a * 2, n /= 6 * a;
          break;
        case r:
          n = e - t + a * 4, n /= 6 * a;
          break;
      }
      return [n, l, o];
    }
    function addSaturationToRGB(e, t) {
      var r = RGBtoHSV(e[0] * 255, e[1] * 255, e[2] * 255);
      return r[1] += t, r[1] > 1 ? r[1] = 1 : r[1] <= 0 && (r[1] = 0), HSVtoRGB(r[0], r[1], r[2]);
    }
    function addBrightnessToRGB(e, t) {
      var r = RGBtoHSV(e[0] * 255, e[1] * 255, e[2] * 255);
      return r[2] += t, r[2] > 1 ? r[2] = 1 : r[2] < 0 && (r[2] = 0), HSVtoRGB(r[0], r[1], r[2]);
    }
    function addHueToRGB(e, t) {
      var r = RGBtoHSV(e[0] * 255, e[1] * 255, e[2] * 255);
      return r[0] += t / 360, r[0] > 1 ? r[0] -= 1 : r[0] < 0 && (r[0] += 1), HSVtoRGB(r[0], r[1], r[2]);
    }
    var rgbToHex = function() {
      var e = [], t, r;
      for (t = 0; t < 256; t += 1)
        r = t.toString(16), e[t] = r.length === 1 ? "0" + r : r;
      return function(i, s, a) {
        return i < 0 && (i = 0), s < 0 && (s = 0), a < 0 && (a = 0), "#" + e[i] + e[s] + e[a];
      };
    }(), setSubframeEnabled = function(t) {
      subframeEnabled = !!t;
    }, getSubframeEnabled = function() {
      return subframeEnabled;
    }, setExpressionsPlugin = function(t) {
      expressionsPlugin = t;
    }, getExpressionsPlugin = function() {
      return expressionsPlugin;
    }, setExpressionInterfaces = function(t) {
      expressionsInterfaces = t;
    }, getExpressionInterfaces = function() {
      return expressionsInterfaces;
    }, setDefaultCurveSegments = function(t) {
      defaultCurveSegments = t;
    }, getDefaultCurveSegments = function() {
      return defaultCurveSegments;
    }, setIdPrefix = function(t) {
      idPrefix$1 = t;
    };
    function createNS(e) {
      return document.createElementNS(svgNS, e);
    }
    function _typeof$5(e) {
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof$5 = function(r) {
        return typeof r;
      } : _typeof$5 = function(r) {
        return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
      }, _typeof$5(e);
    }
    var dataManager = function() {
      var e = 1, t = [], r, i, s = {
        onmessage: function() {
        },
        postMessage: function(P) {
          r({
            data: P
          });
        }
      }, a = {
        postMessage: function(P) {
          s.onmessage({
            data: P
          });
        }
      };
      function n(u) {
        if (window.Worker && window.Blob && getWebWorker()) {
          var P = new Blob(["var _workerSelf = self; self.onmessage = ", u.toString()], {
            type: "text/javascript"
          }), b = URL.createObjectURL(P);
          return new Worker(b);
        }
        return r = u, s;
      }
      function l() {
        i || (i = n(function(P) {
          function b() {
            function C(I, R) {
              var x, T, v = I.length, _, F, w, N;
              for (T = 0; T < v; T += 1)
                if (x = I[T], "ks" in x && !x.completed) {
                  if (x.completed = !0, x.hasMask) {
                    var O = x.masksProperties;
                    for (F = O.length, _ = 0; _ < F; _ += 1)
                      if (O[_].pt.k.i)
                        E(O[_].pt.k);
                      else
                        for (N = O[_].pt.k.length, w = 0; w < N; w += 1)
                          O[_].pt.k[w].s && E(O[_].pt.k[w].s[0]), O[_].pt.k[w].e && E(O[_].pt.k[w].e[0]);
                  }
                  x.ty === 0 ? (x.layers = f(x.refId, R), C(x.layers, R)) : x.ty === 4 && g(x.shapes);
                }
            }
            function c(I, R) {
              if (I) {
                var x = 0, T = I.length;
                for (x = 0; x < T; x += 1)
                  I[x].t === 1 && (I[x].data.layers = f(I[x].data.refId, R), C(I[x].data.layers, R));
              }
            }
            function m(I, R) {
              for (var x = 0, T = R.length; x < T; ) {
                if (R[x].id === I)
                  return R[x];
                x += 1;
              }
              return null;
            }
            function f(I, R) {
              var x = m(I, R);
              return x ? x.layers.__used ? JSON.parse(JSON.stringify(x.layers)) : (x.layers.__used = !0, x.layers) : null;
            }
            function g(I) {
              var R, x = I.length, T, v;
              for (R = x - 1; R >= 0; R -= 1)
                if (I[R].ty === "sh")
                  if (I[R].ks.k.i)
                    E(I[R].ks.k);
                  else
                    for (v = I[R].ks.k.length, T = 0; T < v; T += 1)
                      I[R].ks.k[T].s && E(I[R].ks.k[T].s[0]), I[R].ks.k[T].e && E(I[R].ks.k[T].e[0]);
                else
                  I[R].ty === "gr" && g(I[R].it);
            }
            function E(I) {
              var R, x = I.i.length;
              for (R = 0; R < x; R += 1)
                I.i[R][0] += I.v[R][0], I.i[R][1] += I.v[R][1], I.o[R][0] += I.v[R][0], I.o[R][1] += I.v[R][1];
            }
            function A(I, R) {
              var x = R ? R.split(".") : [100, 100, 100];
              return I[0] > x[0] ? !0 : x[0] > I[0] ? !1 : I[1] > x[1] ? !0 : x[1] > I[1] ? !1 : I[2] > x[2] ? !0 : x[2] > I[2] ? !1 : null;
            }
            var k = function() {
              var I = [4, 4, 14];
              function R(T) {
                var v = T.t.d;
                T.t.d = {
                  k: [{
                    s: v,
                    t: 0
                  }]
                };
              }
              function x(T) {
                var v, _ = T.length;
                for (v = 0; v < _; v += 1)
                  T[v].ty === 5 && R(T[v]);
              }
              return function(T) {
                if (A(I, T.v) && (x(T.layers), T.assets)) {
                  var v, _ = T.assets.length;
                  for (v = 0; v < _; v += 1)
                    T.assets[v].layers && x(T.assets[v].layers);
                }
              };
            }(), M = function() {
              var I = [4, 7, 99];
              return function(R) {
                if (R.chars && !A(I, R.v)) {
                  var x, T = R.chars.length;
                  for (x = 0; x < T; x += 1) {
                    var v = R.chars[x];
                    v.data && v.data.shapes && (g(v.data.shapes), v.data.ip = 0, v.data.op = 99999, v.data.st = 0, v.data.sr = 1, v.data.ks = {
                      p: {
                        k: [0, 0],
                        a: 0
                      },
                      s: {
                        k: [100, 100],
                        a: 0
                      },
                      a: {
                        k: [0, 0],
                        a: 0
                      },
                      r: {
                        k: 0,
                        a: 0
                      },
                      o: {
                        k: 100,
                        a: 0
                      }
                    }, R.chars[x].t || (v.data.shapes.push({
                      ty: "no"
                    }), v.data.shapes[0].it.push({
                      p: {
                        k: [0, 0],
                        a: 0
                      },
                      s: {
                        k: [100, 100],
                        a: 0
                      },
                      a: {
                        k: [0, 0],
                        a: 0
                      },
                      r: {
                        k: 0,
                        a: 0
                      },
                      o: {
                        k: 100,
                        a: 0
                      },
                      sk: {
                        k: 0,
                        a: 0
                      },
                      sa: {
                        k: 0,
                        a: 0
                      },
                      ty: "tr"
                    })));
                  }
                }
              };
            }(), L = function() {
              var I = [5, 7, 15];
              function R(T) {
                var v = T.t.p;
                typeof v.a == "number" && (v.a = {
                  a: 0,
                  k: v.a
                }), typeof v.p == "number" && (v.p = {
                  a: 0,
                  k: v.p
                }), typeof v.r == "number" && (v.r = {
                  a: 0,
                  k: v.r
                });
              }
              function x(T) {
                var v, _ = T.length;
                for (v = 0; v < _; v += 1)
                  T[v].ty === 5 && R(T[v]);
              }
              return function(T) {
                if (A(I, T.v) && (x(T.layers), T.assets)) {
                  var v, _ = T.assets.length;
                  for (v = 0; v < _; v += 1)
                    T.assets[v].layers && x(T.assets[v].layers);
                }
              };
            }(), B = function() {
              var I = [4, 1, 9];
              function R(T) {
                var v, _ = T.length, F, w;
                for (v = 0; v < _; v += 1)
                  if (T[v].ty === "gr")
                    R(T[v].it);
                  else if (T[v].ty === "fl" || T[v].ty === "st")
                    if (T[v].c.k && T[v].c.k[0].i)
                      for (w = T[v].c.k.length, F = 0; F < w; F += 1)
                        T[v].c.k[F].s && (T[v].c.k[F].s[0] /= 255, T[v].c.k[F].s[1] /= 255, T[v].c.k[F].s[2] /= 255, T[v].c.k[F].s[3] /= 255), T[v].c.k[F].e && (T[v].c.k[F].e[0] /= 255, T[v].c.k[F].e[1] /= 255, T[v].c.k[F].e[2] /= 255, T[v].c.k[F].e[3] /= 255);
                    else
                      T[v].c.k[0] /= 255, T[v].c.k[1] /= 255, T[v].c.k[2] /= 255, T[v].c.k[3] /= 255;
              }
              function x(T) {
                var v, _ = T.length;
                for (v = 0; v < _; v += 1)
                  T[v].ty === 4 && R(T[v].shapes);
              }
              return function(T) {
                if (A(I, T.v) && (x(T.layers), T.assets)) {
                  var v, _ = T.assets.length;
                  for (v = 0; v < _; v += 1)
                    T.assets[v].layers && x(T.assets[v].layers);
                }
              };
            }(), D = function() {
              var I = [4, 4, 18];
              function R(T) {
                var v, _ = T.length, F, w;
                for (v = _ - 1; v >= 0; v -= 1)
                  if (T[v].ty === "sh")
                    if (T[v].ks.k.i)
                      T[v].ks.k.c = T[v].closed;
                    else
                      for (w = T[v].ks.k.length, F = 0; F < w; F += 1)
                        T[v].ks.k[F].s && (T[v].ks.k[F].s[0].c = T[v].closed), T[v].ks.k[F].e && (T[v].ks.k[F].e[0].c = T[v].closed);
                  else
                    T[v].ty === "gr" && R(T[v].it);
              }
              function x(T) {
                var v, _, F = T.length, w, N, O, j;
                for (_ = 0; _ < F; _ += 1) {
                  if (v = T[_], v.hasMask) {
                    var H = v.masksProperties;
                    for (N = H.length, w = 0; w < N; w += 1)
                      if (H[w].pt.k.i)
                        H[w].pt.k.c = H[w].cl;
                      else
                        for (j = H[w].pt.k.length, O = 0; O < j; O += 1)
                          H[w].pt.k[O].s && (H[w].pt.k[O].s[0].c = H[w].cl), H[w].pt.k[O].e && (H[w].pt.k[O].e[0].c = H[w].cl);
                  }
                  v.ty === 4 && R(v.shapes);
                }
              }
              return function(T) {
                if (A(I, T.v) && (x(T.layers), T.assets)) {
                  var v, _ = T.assets.length;
                  for (v = 0; v < _; v += 1)
                    T.assets[v].layers && x(T.assets[v].layers);
                }
              };
            }();
            function V(I) {
              I.__complete || (B(I), k(I), M(I), L(I), D(I), C(I.layers, I.assets), c(I.chars, I.assets), I.__complete = !0);
            }
            var z = {};
            return z.completeData = V, z.checkColors = B, z.checkChars = M, z.checkPathProperties = L, z.checkShapes = D, z.completeLayers = C, z;
          }
          if (a.dataManager || (a.dataManager = b()), a.assetLoader || (a.assetLoader = function() {
            function C(m) {
              var f = m.getResponseHeader("content-type");
              return f && m.responseType === "json" && f.indexOf("json") !== -1 || m.response && _typeof$5(m.response) === "object" ? m.response : m.response && typeof m.response == "string" ? JSON.parse(m.response) : m.responseText ? JSON.parse(m.responseText) : null;
            }
            function c(m, f, g, E) {
              var A, k = new XMLHttpRequest();
              try {
                k.responseType = "json";
              } catch {
              }
              k.onreadystatechange = function() {
                if (k.readyState === 4)
                  if (k.status === 200)
                    A = C(k), g(A);
                  else
                    try {
                      A = C(k), g(A);
                    } catch (M) {
                      E && E(M);
                    }
              };
              try {
                k.open(["G", "E", "T"].join(""), m, !0);
              } catch {
                k.open(["G", "E", "T"].join(""), f + "/" + m, !0);
              }
              k.send();
            }
            return {
              load: c
            };
          }()), P.data.type === "loadAnimation")
            a.assetLoader.load(P.data.path, P.data.fullPath, function(C) {
              a.dataManager.completeData(C), a.postMessage({
                id: P.data.id,
                payload: C,
                status: "success"
              });
            }, function() {
              a.postMessage({
                id: P.data.id,
                status: "error"
              });
            });
          else if (P.data.type === "complete") {
            var d = P.data.animation;
            a.dataManager.completeData(d), a.postMessage({
              id: P.data.id,
              payload: d,
              status: "success"
            });
          } else
            P.data.type === "loadData" && a.assetLoader.load(P.data.path, P.data.fullPath, function(C) {
              a.postMessage({
                id: P.data.id,
                payload: C,
                status: "success"
              });
            }, function() {
              a.postMessage({
                id: P.data.id,
                status: "error"
              });
            });
        }), i.onmessage = function(u) {
          var P = u.data, b = P.id, d = t[b];
          t[b] = null, P.status === "success" ? d.onComplete(P.payload) : d.onError && d.onError();
        });
      }
      function o(u, P) {
        e += 1;
        var b = "processId_" + e;
        return t[b] = {
          onComplete: u,
          onError: P
        }, b;
      }
      function p(u, P, b) {
        l();
        var d = o(P, b);
        i.postMessage({
          type: "loadAnimation",
          path: u,
          fullPath: window.location.origin + window.location.pathname,
          id: d
        });
      }
      function y(u, P, b) {
        l();
        var d = o(P, b);
        i.postMessage({
          type: "loadData",
          path: u,
          fullPath: window.location.origin + window.location.pathname,
          id: d
        });
      }
      function S(u, P, b) {
        l();
        var d = o(P, b);
        i.postMessage({
          type: "complete",
          animation: u,
          id: d
        });
      }
      return {
        loadAnimation: p,
        loadData: y,
        completeAnimation: S
      };
    }(), ImagePreloader = function() {
      var e = function() {
        var c = createTag("canvas");
        c.width = 1, c.height = 1;
        var m = c.getContext("2d");
        return m.fillStyle = "rgba(0,0,0,0)", m.fillRect(0, 0, 1, 1), c;
      }();
      function t() {
        this.loadedAssets += 1, this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages && this.imagesLoadedCb && this.imagesLoadedCb(null);
      }
      function r() {
        this.loadedFootagesCount += 1, this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages && this.imagesLoadedCb && this.imagesLoadedCb(null);
      }
      function i(c, m, f) {
        var g = "";
        if (c.e)
          g = c.p;
        else if (m) {
          var E = c.p;
          E.indexOf("images/") !== -1 && (E = E.split("/")[1]), g = m + E;
        } else
          g = f, g += c.u ? c.u : "", g += c.p;
        return g;
      }
      function s(c) {
        var m = 0, f = setInterval(function() {
          var g = c.getBBox();
          (g.width || m > 500) && (this._imageLoaded(), clearInterval(f)), m += 1;
        }.bind(this), 50);
      }
      function a(c) {
        var m = i(c, this.assetsPath, this.path), f = createNS("image");
        isSafari ? this.testImageLoaded(f) : f.addEventListener("load", this._imageLoaded, !1), f.addEventListener("error", function() {
          g.img = e, this._imageLoaded();
        }.bind(this), !1), f.setAttributeNS("http://www.w3.org/1999/xlink", "href", m), this._elementHelper.append ? this._elementHelper.append(f) : this._elementHelper.appendChild(f);
        var g = {
          img: f,
          assetData: c
        };
        return g;
      }
      function n(c) {
        var m = i(c, this.assetsPath, this.path), f = createTag("img");
        f.crossOrigin = "anonymous", f.addEventListener("load", this._imageLoaded, !1), f.addEventListener("error", function() {
          g.img = e, this._imageLoaded();
        }.bind(this), !1), f.src = m;
        var g = {
          img: f,
          assetData: c
        };
        return g;
      }
      function l(c) {
        var m = {
          assetData: c
        }, f = i(c, this.assetsPath, this.path);
        return dataManager.loadData(f, function(g) {
          m.img = g, this._footageLoaded();
        }.bind(this), function() {
          m.img = {}, this._footageLoaded();
        }.bind(this)), m;
      }
      function o(c, m) {
        this.imagesLoadedCb = m;
        var f, g = c.length;
        for (f = 0; f < g; f += 1)
          c[f].layers || (!c[f].t || c[f].t === "seq" ? (this.totalImages += 1, this.images.push(this._createImageData(c[f]))) : c[f].t === 3 && (this.totalFootages += 1, this.images.push(this.createFootageData(c[f]))));
      }
      function p(c) {
        this.path = c || "";
      }
      function y(c) {
        this.assetsPath = c || "";
      }
      function S(c) {
        for (var m = 0, f = this.images.length; m < f; ) {
          if (this.images[m].assetData === c)
            return this.images[m].img;
          m += 1;
        }
        return null;
      }
      function u() {
        this.imagesLoadedCb = null, this.images.length = 0;
      }
      function P() {
        return this.totalImages === this.loadedAssets;
      }
      function b() {
        return this.totalFootages === this.loadedFootagesCount;
      }
      function d(c, m) {
        c === "svg" ? (this._elementHelper = m, this._createImageData = this.createImageData.bind(this)) : this._createImageData = this.createImgData.bind(this);
      }
      function C() {
        this._imageLoaded = t.bind(this), this._footageLoaded = r.bind(this), this.testImageLoaded = s.bind(this), this.createFootageData = l.bind(this), this.assetsPath = "", this.path = "", this.totalImages = 0, this.totalFootages = 0, this.loadedAssets = 0, this.loadedFootagesCount = 0, this.imagesLoadedCb = null, this.images = [];
      }
      return C.prototype = {
        loadAssets: o,
        setAssetsPath: y,
        setPath: p,
        loadedImages: P,
        loadedFootages: b,
        destroy: u,
        getAsset: S,
        createImgData: n,
        createImageData: a,
        imageLoaded: t,
        footageLoaded: r,
        setCacheType: d
      }, C;
    }();
    function BaseEvent() {
    }
    BaseEvent.prototype = {
      triggerEvent: function(t, r) {
        if (this._cbs[t])
          for (var i = this._cbs[t], s = 0; s < i.length; s += 1)
            i[s](r);
      },
      addEventListener: function(t, r) {
        return this._cbs[t] || (this._cbs[t] = []), this._cbs[t].push(r), function() {
          this.removeEventListener(t, r);
        }.bind(this);
      },
      removeEventListener: function(t, r) {
        if (!r)
          this._cbs[t] = null;
        else if (this._cbs[t]) {
          for (var i = 0, s = this._cbs[t].length; i < s; )
            this._cbs[t][i] === r && (this._cbs[t].splice(i, 1), i -= 1, s -= 1), i += 1;
          this._cbs[t].length || (this._cbs[t] = null);
        }
      }
    };
    var markerParser = function() {
      function e(t) {
        for (var r = t.split(`\r
`), i = {}, s, a = 0, n = 0; n < r.length; n += 1)
          s = r[n].split(":"), s.length === 2 && (i[s[0]] = s[1].trim(), a += 1);
        if (a === 0)
          throw new Error();
        return i;
      }
      return function(t) {
        for (var r = [], i = 0; i < t.length; i += 1) {
          var s = t[i], a = {
            time: s.tm,
            duration: s.dr
          };
          try {
            a.payload = JSON.parse(t[i].cm);
          } catch {
            try {
              a.payload = e(t[i].cm);
            } catch {
              a.payload = {
                name: t[i].cm
              };
            }
          }
          r.push(a);
        }
        return r;
      };
    }(), ProjectInterface = function() {
      function e(t) {
        this.compositions.push(t);
      }
      return function() {
        function t(r) {
          for (var i = 0, s = this.compositions.length; i < s; ) {
            if (this.compositions[i].data && this.compositions[i].data.nm === r)
              return this.compositions[i].prepareFrame && this.compositions[i].data.xt && this.compositions[i].prepareFrame(this.currentFrame), this.compositions[i].compInterface;
            i += 1;
          }
          return null;
        }
        return t.compositions = [], t.currentFrame = 0, t.registerComposition = e, t;
      };
    }(), renderers = {}, registerRenderer = function(t, r) {
      renderers[t] = r;
    };
    function getRenderer(e) {
      return renderers[e];
    }
    function getRegisteredRenderer() {
      if (renderers.canvas)
        return "canvas";
      for (var e in renderers)
        if (renderers[e])
          return e;
      return "";
    }
    function _typeof$4(e) {
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof$4 = function(r) {
        return typeof r;
      } : _typeof$4 = function(r) {
        return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
      }, _typeof$4(e);
    }
    var AnimationItem = function() {
      this._cbs = [], this.name = "", this.path = "", this.isLoaded = !1, this.currentFrame = 0, this.currentRawFrame = 0, this.firstFrame = 0, this.totalFrames = 0, this.frameRate = 0, this.frameMult = 0, this.playSpeed = 1, this.playDirection = 1, this.playCount = 0, this.animationData = {}, this.assets = [], this.isPaused = !0, this.autoplay = !1, this.loop = !0, this.renderer = null, this.animationID = createElementID(), this.assetsPath = "", this.timeCompleted = 0, this.segmentPos = 0, this.isSubframeEnabled = getSubframeEnabled(), this.segments = [], this._idle = !0, this._completedLoop = !1, this.projectInterface = ProjectInterface(), this.imagePreloader = new ImagePreloader(), this.audioController = audioControllerFactory(), this.markers = [], this.configAnimation = this.configAnimation.bind(this), this.onSetupError = this.onSetupError.bind(this), this.onSegmentComplete = this.onSegmentComplete.bind(this), this.drawnFrameEvent = new BMEnterFrameEvent("drawnFrame", 0, 0, 0), this.expressionsPlugin = getExpressionsPlugin();
    };
    extendPrototype([BaseEvent], AnimationItem), AnimationItem.prototype.setParams = function(e) {
      (e.wrapper || e.container) && (this.wrapper = e.wrapper || e.container);
      var t = "svg";
      e.animType ? t = e.animType : e.renderer && (t = e.renderer);
      var r = getRenderer(t);
      this.renderer = new r(this, e.rendererSettings), this.imagePreloader.setCacheType(t, this.renderer.globalData.defs), this.renderer.setProjectInterface(this.projectInterface), this.animType = t, e.loop === "" || e.loop === null || e.loop === void 0 || e.loop === !0 ? this.loop = !0 : e.loop === !1 ? this.loop = !1 : this.loop = parseInt(e.loop, 10), this.autoplay = "autoplay" in e ? e.autoplay : !0, this.name = e.name ? e.name : "", this.autoloadSegments = Object.prototype.hasOwnProperty.call(e, "autoloadSegments") ? e.autoloadSegments : !0, this.assetsPath = e.assetsPath, this.initialSegment = e.initialSegment, e.audioFactory && this.audioController.setAudioFactory(e.audioFactory), e.animationData ? this.setupAnimation(e.animationData) : e.path && (e.path.lastIndexOf("\\") !== -1 ? this.path = e.path.substr(0, e.path.lastIndexOf("\\") + 1) : this.path = e.path.substr(0, e.path.lastIndexOf("/") + 1), this.fileName = e.path.substr(e.path.lastIndexOf("/") + 1), this.fileName = this.fileName.substr(0, this.fileName.lastIndexOf(".json")), dataManager.loadAnimation(e.path, this.configAnimation, this.onSetupError));
    }, AnimationItem.prototype.onSetupError = function() {
      this.trigger("data_failed");
    }, AnimationItem.prototype.setupAnimation = function(e) {
      dataManager.completeAnimation(e, this.configAnimation);
    }, AnimationItem.prototype.setData = function(e, t) {
      t && _typeof$4(t) !== "object" && (t = JSON.parse(t));
      var r = {
        wrapper: e,
        animationData: t
      }, i = e.attributes;
      r.path = i.getNamedItem("data-animation-path") ? i.getNamedItem("data-animation-path").value : i.getNamedItem("data-bm-path") ? i.getNamedItem("data-bm-path").value : i.getNamedItem("bm-path") ? i.getNamedItem("bm-path").value : "", r.animType = i.getNamedItem("data-anim-type") ? i.getNamedItem("data-anim-type").value : i.getNamedItem("data-bm-type") ? i.getNamedItem("data-bm-type").value : i.getNamedItem("bm-type") ? i.getNamedItem("bm-type").value : i.getNamedItem("data-bm-renderer") ? i.getNamedItem("data-bm-renderer").value : i.getNamedItem("bm-renderer") ? i.getNamedItem("bm-renderer").value : getRegisteredRenderer() || "canvas";
      var s = i.getNamedItem("data-anim-loop") ? i.getNamedItem("data-anim-loop").value : i.getNamedItem("data-bm-loop") ? i.getNamedItem("data-bm-loop").value : i.getNamedItem("bm-loop") ? i.getNamedItem("bm-loop").value : "";
      s === "false" ? r.loop = !1 : s === "true" ? r.loop = !0 : s !== "" && (r.loop = parseInt(s, 10));
      var a = i.getNamedItem("data-anim-autoplay") ? i.getNamedItem("data-anim-autoplay").value : i.getNamedItem("data-bm-autoplay") ? i.getNamedItem("data-bm-autoplay").value : i.getNamedItem("bm-autoplay") ? i.getNamedItem("bm-autoplay").value : !0;
      r.autoplay = a !== "false", r.name = i.getNamedItem("data-name") ? i.getNamedItem("data-name").value : i.getNamedItem("data-bm-name") ? i.getNamedItem("data-bm-name").value : i.getNamedItem("bm-name") ? i.getNamedItem("bm-name").value : "";
      var n = i.getNamedItem("data-anim-prerender") ? i.getNamedItem("data-anim-prerender").value : i.getNamedItem("data-bm-prerender") ? i.getNamedItem("data-bm-prerender").value : i.getNamedItem("bm-prerender") ? i.getNamedItem("bm-prerender").value : "";
      n === "false" && (r.prerender = !1), r.path ? this.setParams(r) : this.trigger("destroy");
    }, AnimationItem.prototype.includeLayers = function(e) {
      e.op > this.animationData.op && (this.animationData.op = e.op, this.totalFrames = Math.floor(e.op - this.animationData.ip));
      var t = this.animationData.layers, r, i = t.length, s = e.layers, a, n = s.length;
      for (a = 0; a < n; a += 1)
        for (r = 0; r < i; ) {
          if (t[r].id === s[a].id) {
            t[r] = s[a];
            break;
          }
          r += 1;
        }
      if ((e.chars || e.fonts) && (this.renderer.globalData.fontManager.addChars(e.chars), this.renderer.globalData.fontManager.addFonts(e.fonts, this.renderer.globalData.defs)), e.assets)
        for (i = e.assets.length, r = 0; r < i; r += 1)
          this.animationData.assets.push(e.assets[r]);
      this.animationData.__complete = !1, dataManager.completeAnimation(this.animationData, this.onSegmentComplete);
    }, AnimationItem.prototype.onSegmentComplete = function(e) {
      this.animationData = e;
      var t = getExpressionsPlugin();
      t && t.initExpressions(this), this.loadNextSegment();
    }, AnimationItem.prototype.loadNextSegment = function() {
      var e = this.animationData.segments;
      if (!e || e.length === 0 || !this.autoloadSegments) {
        this.trigger("data_ready"), this.timeCompleted = this.totalFrames;
        return;
      }
      var t = e.shift();
      this.timeCompleted = t.time * this.frameRate;
      var r = this.path + this.fileName + "_" + this.segmentPos + ".json";
      this.segmentPos += 1, dataManager.loadData(r, this.includeLayers.bind(this), function() {
        this.trigger("data_failed");
      }.bind(this));
    }, AnimationItem.prototype.loadSegments = function() {
      var e = this.animationData.segments;
      e || (this.timeCompleted = this.totalFrames), this.loadNextSegment();
    }, AnimationItem.prototype.imagesLoaded = function() {
      this.trigger("loaded_images"), this.checkLoaded();
    }, AnimationItem.prototype.preloadImages = function() {
      this.imagePreloader.setAssetsPath(this.assetsPath), this.imagePreloader.setPath(this.path), this.imagePreloader.loadAssets(this.animationData.assets, this.imagesLoaded.bind(this));
    }, AnimationItem.prototype.configAnimation = function(e) {
      if (this.renderer)
        try {
          this.animationData = e, this.initialSegment ? (this.totalFrames = Math.floor(this.initialSegment[1] - this.initialSegment[0]), this.firstFrame = Math.round(this.initialSegment[0])) : (this.totalFrames = Math.floor(this.animationData.op - this.animationData.ip), this.firstFrame = Math.round(this.animationData.ip)), this.renderer.configAnimation(e), e.assets || (e.assets = []), this.assets = this.animationData.assets, this.frameRate = this.animationData.fr, this.frameMult = this.animationData.fr / 1e3, this.renderer.searchExtraCompositions(e.assets), this.markers = markerParser(e.markers || []), this.trigger("config_ready"), this.preloadImages(), this.loadSegments(), this.updaFrameModifier(), this.waitForFontsLoaded(), this.isPaused && this.audioController.pause();
        } catch (t) {
          this.triggerConfigError(t);
        }
    }, AnimationItem.prototype.waitForFontsLoaded = function() {
      this.renderer && (this.renderer.globalData.fontManager.isLoaded ? this.checkLoaded() : setTimeout(this.waitForFontsLoaded.bind(this), 20));
    }, AnimationItem.prototype.checkLoaded = function() {
      if (!this.isLoaded && this.renderer.globalData.fontManager.isLoaded && (this.imagePreloader.loadedImages() || this.renderer.rendererType !== "canvas") && this.imagePreloader.loadedFootages()) {
        this.isLoaded = !0;
        var e = getExpressionsPlugin();
        e && e.initExpressions(this), this.renderer.initItems(), setTimeout(function() {
          this.trigger("DOMLoaded");
        }.bind(this), 0), this.gotoFrame(), this.autoplay && this.play();
      }
    }, AnimationItem.prototype.resize = function(e, t) {
      var r = typeof e == "number" ? e : void 0, i = typeof t == "number" ? t : void 0;
      this.renderer.updateContainerSize(r, i);
    }, AnimationItem.prototype.setSubframe = function(e) {
      this.isSubframeEnabled = !!e;
    }, AnimationItem.prototype.gotoFrame = function() {
      this.currentFrame = this.isSubframeEnabled ? this.currentRawFrame : ~~this.currentRawFrame, this.timeCompleted !== this.totalFrames && this.currentFrame > this.timeCompleted && (this.currentFrame = this.timeCompleted), this.trigger("enterFrame"), this.renderFrame(), this.trigger("drawnFrame");
    }, AnimationItem.prototype.renderFrame = function() {
      if (!(this.isLoaded === !1 || !this.renderer))
        try {
          this.expressionsPlugin && this.expressionsPlugin.resetFrame(), this.renderer.renderFrame(this.currentFrame + this.firstFrame);
        } catch (e) {
          this.triggerRenderFrameError(e);
        }
    }, AnimationItem.prototype.play = function(e) {
      e && this.name !== e || this.isPaused === !0 && (this.isPaused = !1, this.trigger("_play"), this.audioController.resume(), this._idle && (this._idle = !1, this.trigger("_active")));
    }, AnimationItem.prototype.pause = function(e) {
      e && this.name !== e || this.isPaused === !1 && (this.isPaused = !0, this.trigger("_pause"), this._idle = !0, this.trigger("_idle"), this.audioController.pause());
    }, AnimationItem.prototype.togglePause = function(e) {
      e && this.name !== e || (this.isPaused === !0 ? this.play() : this.pause());
    }, AnimationItem.prototype.stop = function(e) {
      e && this.name !== e || (this.pause(), this.playCount = 0, this._completedLoop = !1, this.setCurrentRawFrameValue(0));
    }, AnimationItem.prototype.getMarkerData = function(e) {
      for (var t, r = 0; r < this.markers.length; r += 1)
        if (t = this.markers[r], t.payload && t.payload.name === e)
          return t;
      return null;
    }, AnimationItem.prototype.goToAndStop = function(e, t, r) {
      if (!(r && this.name !== r)) {
        var i = Number(e);
        if (isNaN(i)) {
          var s = this.getMarkerData(e);
          s && this.goToAndStop(s.time, !0);
        } else
          t ? this.setCurrentRawFrameValue(e) : this.setCurrentRawFrameValue(e * this.frameModifier);
        this.pause();
      }
    }, AnimationItem.prototype.goToAndPlay = function(e, t, r) {
      if (!(r && this.name !== r)) {
        var i = Number(e);
        if (isNaN(i)) {
          var s = this.getMarkerData(e);
          s && (s.duration ? this.playSegments([s.time, s.time + s.duration], !0) : this.goToAndStop(s.time, !0));
        } else
          this.goToAndStop(i, t, r);
        this.play();
      }
    }, AnimationItem.prototype.advanceTime = function(e) {
      if (!(this.isPaused === !0 || this.isLoaded === !1)) {
        var t = this.currentRawFrame + e * this.frameModifier, r = !1;
        t >= this.totalFrames - 1 && this.frameModifier > 0 ? !this.loop || this.playCount === this.loop ? this.checkSegments(t > this.totalFrames ? t % this.totalFrames : 0) || (r = !0, t = this.totalFrames - 1) : t >= this.totalFrames ? (this.playCount += 1, this.checkSegments(t % this.totalFrames) || (this.setCurrentRawFrameValue(t % this.totalFrames), this._completedLoop = !0, this.trigger("loopComplete"))) : this.setCurrentRawFrameValue(t) : t < 0 ? this.checkSegments(t % this.totalFrames) || (this.loop && !(this.playCount-- <= 0 && this.loop !== !0) ? (this.setCurrentRawFrameValue(this.totalFrames + t % this.totalFrames), this._completedLoop ? this.trigger("loopComplete") : this._completedLoop = !0) : (r = !0, t = 0)) : this.setCurrentRawFrameValue(t), r && (this.setCurrentRawFrameValue(t), this.pause(), this.trigger("complete"));
      }
    }, AnimationItem.prototype.adjustSegment = function(e, t) {
      this.playCount = 0, e[1] < e[0] ? (this.frameModifier > 0 && (this.playSpeed < 0 ? this.setSpeed(-this.playSpeed) : this.setDirection(-1)), this.totalFrames = e[0] - e[1], this.timeCompleted = this.totalFrames, this.firstFrame = e[1], this.setCurrentRawFrameValue(this.totalFrames - 1e-3 - t)) : e[1] > e[0] && (this.frameModifier < 0 && (this.playSpeed < 0 ? this.setSpeed(-this.playSpeed) : this.setDirection(1)), this.totalFrames = e[1] - e[0], this.timeCompleted = this.totalFrames, this.firstFrame = e[0], this.setCurrentRawFrameValue(1e-3 + t)), this.trigger("segmentStart");
    }, AnimationItem.prototype.setSegment = function(e, t) {
      var r = -1;
      this.isPaused && (this.currentRawFrame + this.firstFrame < e ? r = e : this.currentRawFrame + this.firstFrame > t && (r = t - e)), this.firstFrame = e, this.totalFrames = t - e, this.timeCompleted = this.totalFrames, r !== -1 && this.goToAndStop(r, !0);
    }, AnimationItem.prototype.playSegments = function(e, t) {
      if (t && (this.segments.length = 0), _typeof$4(e[0]) === "object") {
        var r, i = e.length;
        for (r = 0; r < i; r += 1)
          this.segments.push(e[r]);
      } else
        this.segments.push(e);
      this.segments.length && t && this.adjustSegment(this.segments.shift(), 0), this.isPaused && this.play();
    }, AnimationItem.prototype.resetSegments = function(e) {
      this.segments.length = 0, this.segments.push([this.animationData.ip, this.animationData.op]), e && this.checkSegments(0);
    }, AnimationItem.prototype.checkSegments = function(e) {
      return this.segments.length ? (this.adjustSegment(this.segments.shift(), e), !0) : !1;
    }, AnimationItem.prototype.destroy = function(e) {
      e && this.name !== e || !this.renderer || (this.renderer.destroy(), this.imagePreloader.destroy(), this.trigger("destroy"), this._cbs = null, this.onEnterFrame = null, this.onLoopComplete = null, this.onComplete = null, this.onSegmentStart = null, this.onDestroy = null, this.renderer = null, this.expressionsPlugin = null, this.imagePreloader = null, this.projectInterface = null);
    }, AnimationItem.prototype.setCurrentRawFrameValue = function(e) {
      this.currentRawFrame = e, this.gotoFrame();
    }, AnimationItem.prototype.setSpeed = function(e) {
      this.playSpeed = e, this.updaFrameModifier();
    }, AnimationItem.prototype.setDirection = function(e) {
      this.playDirection = e < 0 ? -1 : 1, this.updaFrameModifier();
    }, AnimationItem.prototype.setLoop = function(e) {
      this.loop = e;
    }, AnimationItem.prototype.setVolume = function(e, t) {
      t && this.name !== t || this.audioController.setVolume(e);
    }, AnimationItem.prototype.getVolume = function() {
      return this.audioController.getVolume();
    }, AnimationItem.prototype.mute = function(e) {
      e && this.name !== e || this.audioController.mute();
    }, AnimationItem.prototype.unmute = function(e) {
      e && this.name !== e || this.audioController.unmute();
    }, AnimationItem.prototype.updaFrameModifier = function() {
      this.frameModifier = this.frameMult * this.playSpeed * this.playDirection, this.audioController.setRate(this.playSpeed * this.playDirection);
    }, AnimationItem.prototype.getPath = function() {
      return this.path;
    }, AnimationItem.prototype.getAssetsPath = function(e) {
      var t = "";
      if (e.e)
        t = e.p;
      else if (this.assetsPath) {
        var r = e.p;
        r.indexOf("images/") !== -1 && (r = r.split("/")[1]), t = this.assetsPath + r;
      } else
        t = this.path, t += e.u ? e.u : "", t += e.p;
      return t;
    }, AnimationItem.prototype.getAssetData = function(e) {
      for (var t = 0, r = this.assets.length; t < r; ) {
        if (e === this.assets[t].id)
          return this.assets[t];
        t += 1;
      }
      return null;
    }, AnimationItem.prototype.hide = function() {
      this.renderer.hide();
    }, AnimationItem.prototype.show = function() {
      this.renderer.show();
    }, AnimationItem.prototype.getDuration = function(e) {
      return e ? this.totalFrames : this.totalFrames / this.frameRate;
    }, AnimationItem.prototype.updateDocumentData = function(e, t, r) {
      try {
        var i = this.renderer.getElementByPath(e);
        i.updateDocumentData(t, r);
      } catch {
      }
    }, AnimationItem.prototype.trigger = function(e) {
      if (this._cbs && this._cbs[e])
        switch (e) {
          case "enterFrame":
            this.triggerEvent(e, new BMEnterFrameEvent(e, this.currentFrame, this.totalFrames, this.frameModifier));
            break;
          case "drawnFrame":
            this.drawnFrameEvent.currentTime = this.currentFrame, this.drawnFrameEvent.totalTime = this.totalFrames, this.drawnFrameEvent.direction = this.frameModifier, this.triggerEvent(e, this.drawnFrameEvent);
            break;
          case "loopComplete":
            this.triggerEvent(e, new BMCompleteLoopEvent(e, this.loop, this.playCount, this.frameMult));
            break;
          case "complete":
            this.triggerEvent(e, new BMCompleteEvent(e, this.frameMult));
            break;
          case "segmentStart":
            this.triggerEvent(e, new BMSegmentStartEvent(e, this.firstFrame, this.totalFrames));
            break;
          case "destroy":
            this.triggerEvent(e, new BMDestroyEvent(e, this));
            break;
          default:
            this.triggerEvent(e);
        }
      e === "enterFrame" && this.onEnterFrame && this.onEnterFrame.call(this, new BMEnterFrameEvent(e, this.currentFrame, this.totalFrames, this.frameMult)), e === "loopComplete" && this.onLoopComplete && this.onLoopComplete.call(this, new BMCompleteLoopEvent(e, this.loop, this.playCount, this.frameMult)), e === "complete" && this.onComplete && this.onComplete.call(this, new BMCompleteEvent(e, this.frameMult)), e === "segmentStart" && this.onSegmentStart && this.onSegmentStart.call(this, new BMSegmentStartEvent(e, this.firstFrame, this.totalFrames)), e === "destroy" && this.onDestroy && this.onDestroy.call(this, new BMDestroyEvent(e, this));
    }, AnimationItem.prototype.triggerRenderFrameError = function(e) {
      var t = new BMRenderFrameErrorEvent(e, this.currentFrame);
      this.triggerEvent("error", t), this.onError && this.onError.call(this, t);
    }, AnimationItem.prototype.triggerConfigError = function(e) {
      var t = new BMConfigErrorEvent(e, this.currentFrame);
      this.triggerEvent("error", t), this.onError && this.onError.call(this, t);
    };
    var animationManager = function() {
      var e = {}, t = [], r = 0, i = 0, s = 0, a = !0, n = !1;
      function l(x) {
        for (var T = 0, v = x.target; T < i; )
          t[T].animation === v && (t.splice(T, 1), T -= 1, i -= 1, v.isPaused || S()), T += 1;
      }
      function o(x, T) {
        if (!x)
          return null;
        for (var v = 0; v < i; ) {
          if (t[v].elem === x && t[v].elem !== null)
            return t[v].animation;
          v += 1;
        }
        var _ = new AnimationItem();
        return u(_, x), _.setData(x, T), _;
      }
      function p() {
        var x, T = t.length, v = [];
        for (x = 0; x < T; x += 1)
          v.push(t[x].animation);
        return v;
      }
      function y() {
        s += 1, B();
      }
      function S() {
        s -= 1;
      }
      function u(x, T) {
        x.addEventListener("destroy", l), x.addEventListener("_active", y), x.addEventListener("_idle", S), t.push({
          elem: T,
          animation: x
        }), i += 1;
      }
      function P(x) {
        var T = new AnimationItem();
        return u(T, null), T.setParams(x), T;
      }
      function b(x, T) {
        var v;
        for (v = 0; v < i; v += 1)
          t[v].animation.setSpeed(x, T);
      }
      function d(x, T) {
        var v;
        for (v = 0; v < i; v += 1)
          t[v].animation.setDirection(x, T);
      }
      function C(x) {
        var T;
        for (T = 0; T < i; T += 1)
          t[T].animation.play(x);
      }
      function c(x) {
        var T = x - r, v;
        for (v = 0; v < i; v += 1)
          t[v].animation.advanceTime(T);
        r = x, s && !n ? window.requestAnimationFrame(c) : a = !0;
      }
      function m(x) {
        r = x, window.requestAnimationFrame(c);
      }
      function f(x) {
        var T;
        for (T = 0; T < i; T += 1)
          t[T].animation.pause(x);
      }
      function g(x, T, v) {
        var _;
        for (_ = 0; _ < i; _ += 1)
          t[_].animation.goToAndStop(x, T, v);
      }
      function E(x) {
        var T;
        for (T = 0; T < i; T += 1)
          t[T].animation.stop(x);
      }
      function A(x) {
        var T;
        for (T = 0; T < i; T += 1)
          t[T].animation.togglePause(x);
      }
      function k(x) {
        var T;
        for (T = i - 1; T >= 0; T -= 1)
          t[T].animation.destroy(x);
      }
      function M(x, T, v) {
        var _ = [].concat([].slice.call(document.getElementsByClassName("lottie")), [].slice.call(document.getElementsByClassName("bodymovin"))), F, w = _.length;
        for (F = 0; F < w; F += 1)
          v && _[F].setAttribute("data-bm-type", v), o(_[F], x);
        if (T && w === 0) {
          v || (v = "svg");
          var N = document.getElementsByTagName("body")[0];
          N.innerText = "";
          var O = createTag("div");
          O.style.width = "100%", O.style.height = "100%", O.setAttribute("data-bm-type", v), N.appendChild(O), o(O, x);
        }
      }
      function L() {
        var x;
        for (x = 0; x < i; x += 1)
          t[x].animation.resize();
      }
      function B() {
        !n && s && a && (window.requestAnimationFrame(m), a = !1);
      }
      function D() {
        n = !0;
      }
      function V() {
        n = !1, B();
      }
      function z(x, T) {
        var v;
        for (v = 0; v < i; v += 1)
          t[v].animation.setVolume(x, T);
      }
      function I(x) {
        var T;
        for (T = 0; T < i; T += 1)
          t[T].animation.mute(x);
      }
      function R(x) {
        var T;
        for (T = 0; T < i; T += 1)
          t[T].animation.unmute(x);
      }
      return e.registerAnimation = o, e.loadAnimation = P, e.setSpeed = b, e.setDirection = d, e.play = C, e.pause = f, e.stop = E, e.togglePause = A, e.searchAnimations = M, e.resize = L, e.goToAndStop = g, e.destroy = k, e.freeze = D, e.unfreeze = V, e.setVolume = z, e.mute = I, e.unmute = R, e.getRegisteredAnimations = p, e;
    }(), BezierFactory = function() {
      var e = {};
      e.getBezierEasing = r;
      var t = {};
      function r(m, f, g, E, A) {
        var k = A || ("bez_" + m + "_" + f + "_" + g + "_" + E).replace(/\./g, "p");
        if (t[k])
          return t[k];
        var M = new c([m, f, g, E]);
        return t[k] = M, M;
      }
      var i = 4, s = 1e-3, a = 1e-7, n = 10, l = 11, o = 1 / (l - 1), p = typeof Float32Array == "function";
      function y(m, f) {
        return 1 - 3 * f + 3 * m;
      }
      function S(m, f) {
        return 3 * f - 6 * m;
      }
      function u(m) {
        return 3 * m;
      }
      function P(m, f, g) {
        return ((y(f, g) * m + S(f, g)) * m + u(f)) * m;
      }
      function b(m, f, g) {
        return 3 * y(f, g) * m * m + 2 * S(f, g) * m + u(f);
      }
      function d(m, f, g, E, A) {
        var k, M, L = 0;
        do
          M = f + (g - f) / 2, k = P(M, E, A) - m, k > 0 ? g = M : f = M;
        while (Math.abs(k) > a && ++L < n);
        return M;
      }
      function C(m, f, g, E) {
        for (var A = 0; A < i; ++A) {
          var k = b(f, g, E);
          if (k === 0)
            return f;
          var M = P(f, g, E) - m;
          f -= M / k;
        }
        return f;
      }
      function c(m) {
        this._p = m, this._mSampleValues = p ? new Float32Array(l) : new Array(l), this._precomputed = !1, this.get = this.get.bind(this);
      }
      return c.prototype = {
        get: function(f) {
          var g = this._p[0], E = this._p[1], A = this._p[2], k = this._p[3];
          return this._precomputed || this._precompute(), g === E && A === k ? f : f === 0 ? 0 : f === 1 ? 1 : P(this._getTForX(f), E, k);
        },
        // Private part
        _precompute: function() {
          var f = this._p[0], g = this._p[1], E = this._p[2], A = this._p[3];
          this._precomputed = !0, (f !== g || E !== A) && this._calcSampleValues();
        },
        _calcSampleValues: function() {
          for (var f = this._p[0], g = this._p[2], E = 0; E < l; ++E)
            this._mSampleValues[E] = P(E * o, f, g);
        },
        /**
             * getTForX chose the fastest heuristic to determine the percentage value precisely from a given X projection.
             */
        _getTForX: function(f) {
          for (var g = this._p[0], E = this._p[2], A = this._mSampleValues, k = 0, M = 1, L = l - 1; M !== L && A[M] <= f; ++M)
            k += o;
          --M;
          var B = (f - A[M]) / (A[M + 1] - A[M]), D = k + B * o, V = b(D, g, E);
          return V >= s ? C(f, D, g, E) : V === 0 ? D : d(f, k, k + o, g, E);
        }
      }, e;
    }(), pooling = function() {
      function e(t) {
        return t.concat(createSizedArray(t.length));
      }
      return {
        double: e
      };
    }(), poolFactory = function() {
      return function(e, t, r) {
        var i = 0, s = e, a = createSizedArray(s), n = {
          newElement: l,
          release: o
        };
        function l() {
          var p;
          return i ? (i -= 1, p = a[i]) : p = t(), p;
        }
        function o(p) {
          i === s && (a = pooling.double(a), s *= 2), r && r(p), a[i] = p, i += 1;
        }
        return n;
      };
    }(), bezierLengthPool = function() {
      function e() {
        return {
          addedLength: 0,
          percents: createTypedArray("float32", getDefaultCurveSegments()),
          lengths: createTypedArray("float32", getDefaultCurveSegments())
        };
      }
      return poolFactory(8, e);
    }(), segmentsLengthPool = function() {
      function e() {
        return {
          lengths: [],
          totalLength: 0
        };
      }
      function t(r) {
        var i, s = r.lengths.length;
        for (i = 0; i < s; i += 1)
          bezierLengthPool.release(r.lengths[i]);
        r.lengths.length = 0;
      }
      return poolFactory(8, e, t);
    }();
    function bezFunction() {
      var e = Math;
      function t(u, P, b, d, C, c) {
        var m = u * d + P * C + b * c - C * d - c * u - b * P;
        return m > -1e-3 && m < 1e-3;
      }
      function r(u, P, b, d, C, c, m, f, g) {
        if (b === 0 && c === 0 && g === 0)
          return t(u, P, d, C, m, f);
        var E = e.sqrt(e.pow(d - u, 2) + e.pow(C - P, 2) + e.pow(c - b, 2)), A = e.sqrt(e.pow(m - u, 2) + e.pow(f - P, 2) + e.pow(g - b, 2)), k = e.sqrt(e.pow(m - d, 2) + e.pow(f - C, 2) + e.pow(g - c, 2)), M;
        return E > A ? E > k ? M = E - A - k : M = k - A - E : k > A ? M = k - A - E : M = A - E - k, M > -1e-4 && M < 1e-4;
      }
      var i = function() {
        return function(u, P, b, d) {
          var C = getDefaultCurveSegments(), c, m, f, g, E, A = 0, k, M = [], L = [], B = bezierLengthPool.newElement();
          for (f = b.length, c = 0; c < C; c += 1) {
            for (E = c / (C - 1), k = 0, m = 0; m < f; m += 1)
              g = bmPow(1 - E, 3) * u[m] + 3 * bmPow(1 - E, 2) * E * b[m] + 3 * (1 - E) * bmPow(E, 2) * d[m] + bmPow(E, 3) * P[m], M[m] = g, L[m] !== null && (k += bmPow(M[m] - L[m], 2)), L[m] = M[m];
            k && (k = bmSqrt(k), A += k), B.percents[c] = E, B.lengths[c] = A;
          }
          return B.addedLength = A, B;
        };
      }();
      function s(u) {
        var P = segmentsLengthPool.newElement(), b = u.c, d = u.v, C = u.o, c = u.i, m, f = u._length, g = P.lengths, E = 0;
        for (m = 0; m < f - 1; m += 1)
          g[m] = i(d[m], d[m + 1], C[m], c[m + 1]), E += g[m].addedLength;
        return b && f && (g[m] = i(d[m], d[0], C[m], c[0]), E += g[m].addedLength), P.totalLength = E, P;
      }
      function a(u) {
        this.segmentLength = 0, this.points = new Array(u);
      }
      function n(u, P) {
        this.partialLength = u, this.point = P;
      }
      var l = function() {
        var u = {};
        return function(P, b, d, C) {
          var c = (P[0] + "_" + P[1] + "_" + b[0] + "_" + b[1] + "_" + d[0] + "_" + d[1] + "_" + C[0] + "_" + C[1]).replace(/\./g, "p");
          if (!u[c]) {
            var m = getDefaultCurveSegments(), f, g, E, A, k, M = 0, L, B, D = null;
            P.length === 2 && (P[0] !== b[0] || P[1] !== b[1]) && t(P[0], P[1], b[0], b[1], P[0] + d[0], P[1] + d[1]) && t(P[0], P[1], b[0], b[1], b[0] + C[0], b[1] + C[1]) && (m = 2);
            var V = new a(m);
            for (E = d.length, f = 0; f < m; f += 1) {
              for (B = createSizedArray(E), k = f / (m - 1), L = 0, g = 0; g < E; g += 1)
                A = bmPow(1 - k, 3) * P[g] + 3 * bmPow(1 - k, 2) * k * (P[g] + d[g]) + 3 * (1 - k) * bmPow(k, 2) * (b[g] + C[g]) + bmPow(k, 3) * b[g], B[g] = A, D !== null && (L += bmPow(B[g] - D[g], 2));
              L = bmSqrt(L), M += L, V.points[f] = new n(L, B), D = B;
            }
            V.segmentLength = M, u[c] = V;
          }
          return u[c];
        };
      }();
      function o(u, P) {
        var b = P.percents, d = P.lengths, C = b.length, c = bmFloor((C - 1) * u), m = u * P.addedLength, f = 0;
        if (c === C - 1 || c === 0 || m === d[c])
          return b[c];
        for (var g = d[c] > m ? -1 : 1, E = !0; E; )
          if (d[c] <= m && d[c + 1] > m ? (f = (m - d[c]) / (d[c + 1] - d[c]), E = !1) : c += g, c < 0 || c >= C - 1) {
            if (c === C - 1)
              return b[c];
            E = !1;
          }
        return b[c] + (b[c + 1] - b[c]) * f;
      }
      function p(u, P, b, d, C, c) {
        var m = o(C, c), f = 1 - m, g = e.round((f * f * f * u[0] + (m * f * f + f * m * f + f * f * m) * b[0] + (m * m * f + f * m * m + m * f * m) * d[0] + m * m * m * P[0]) * 1e3) / 1e3, E = e.round((f * f * f * u[1] + (m * f * f + f * m * f + f * f * m) * b[1] + (m * m * f + f * m * m + m * f * m) * d[1] + m * m * m * P[1]) * 1e3) / 1e3;
        return [g, E];
      }
      var y = createTypedArray("float32", 8);
      function S(u, P, b, d, C, c, m) {
        C < 0 ? C = 0 : C > 1 && (C = 1);
        var f = o(C, m);
        c = c > 1 ? 1 : c;
        var g = o(c, m), E, A = u.length, k = 1 - f, M = 1 - g, L = k * k * k, B = f * k * k * 3, D = f * f * k * 3, V = f * f * f, z = k * k * M, I = f * k * M + k * f * M + k * k * g, R = f * f * M + k * f * g + f * k * g, x = f * f * g, T = k * M * M, v = f * M * M + k * g * M + k * M * g, _ = f * g * M + k * g * g + f * M * g, F = f * g * g, w = M * M * M, N = g * M * M + M * g * M + M * M * g, O = g * g * M + M * g * g + g * M * g, j = g * g * g;
        for (E = 0; E < A; E += 1)
          y[E * 4] = e.round((L * u[E] + B * b[E] + D * d[E] + V * P[E]) * 1e3) / 1e3, y[E * 4 + 1] = e.round((z * u[E] + I * b[E] + R * d[E] + x * P[E]) * 1e3) / 1e3, y[E * 4 + 2] = e.round((T * u[E] + v * b[E] + _ * d[E] + F * P[E]) * 1e3) / 1e3, y[E * 4 + 3] = e.round((w * u[E] + N * b[E] + O * d[E] + j * P[E]) * 1e3) / 1e3;
        return y;
      }
      return {
        getSegmentsLength: s,
        getNewSegment: S,
        getPointInSegment: p,
        buildBezierData: l,
        pointOnLine2D: t,
        pointOnLine3D: r
      };
    }
    var bez = bezFunction(), initFrame = initialDefaultFrame, mathAbs = Math.abs;
    function interpolateValue(e, t) {
      var r = this.offsetTime, i;
      this.propType === "multidimensional" && (i = createTypedArray("float32", this.pv.length));
      for (var s = t.lastIndex, a = s, n = this.keyframes.length - 1, l = !0, o, p, y; l; ) {
        if (o = this.keyframes[a], p = this.keyframes[a + 1], a === n - 1 && e >= p.t - r) {
          o.h && (o = p), s = 0;
          break;
        }
        if (p.t - r > e) {
          s = a;
          break;
        }
        a < n - 1 ? a += 1 : (s = 0, l = !1);
      }
      y = this.keyframesMetadata[a] || {};
      var S, u, P, b, d, C, c = p.t - r, m = o.t - r, f;
      if (o.to) {
        y.bezierData || (y.bezierData = bez.buildBezierData(o.s, p.s || o.e, o.to, o.ti));
        var g = y.bezierData;
        if (e >= c || e < m) {
          var E = e >= c ? g.points.length - 1 : 0;
          for (u = g.points[E].point.length, S = 0; S < u; S += 1)
            i[S] = g.points[E].point[S];
        } else {
          y.__fnct ? C = y.__fnct : (C = BezierFactory.getBezierEasing(o.o.x, o.o.y, o.i.x, o.i.y, o.n).get, y.__fnct = C), P = C((e - m) / (c - m));
          var A = g.segmentLength * P, k, M = t.lastFrame < e && t._lastKeyframeIndex === a ? t._lastAddedLength : 0;
          for (d = t.lastFrame < e && t._lastKeyframeIndex === a ? t._lastPoint : 0, l = !0, b = g.points.length; l; ) {
            if (M += g.points[d].partialLength, A === 0 || P === 0 || d === g.points.length - 1) {
              for (u = g.points[d].point.length, S = 0; S < u; S += 1)
                i[S] = g.points[d].point[S];
              break;
            } else if (A >= M && A < M + g.points[d + 1].partialLength) {
              for (k = (A - M) / g.points[d + 1].partialLength, u = g.points[d].point.length, S = 0; S < u; S += 1)
                i[S] = g.points[d].point[S] + (g.points[d + 1].point[S] - g.points[d].point[S]) * k;
              break;
            }
            d < b - 1 ? d += 1 : l = !1;
          }
          t._lastPoint = d, t._lastAddedLength = M - g.points[d].partialLength, t._lastKeyframeIndex = a;
        }
      } else {
        var L, B, D, V, z;
        if (n = o.s.length, f = p.s || o.e, this.sh && o.h !== 1)
          if (e >= c)
            i[0] = f[0], i[1] = f[1], i[2] = f[2];
          else if (e <= m)
            i[0] = o.s[0], i[1] = o.s[1], i[2] = o.s[2];
          else {
            var I = createQuaternion(o.s), R = createQuaternion(f), x = (e - m) / (c - m);
            quaternionToEuler(i, slerp(I, R, x));
          }
        else
          for (a = 0; a < n; a += 1)
            o.h !== 1 && (e >= c ? P = 1 : e < m ? P = 0 : (o.o.x.constructor === Array ? (y.__fnct || (y.__fnct = []), y.__fnct[a] ? C = y.__fnct[a] : (L = o.o.x[a] === void 0 ? o.o.x[0] : o.o.x[a], B = o.o.y[a] === void 0 ? o.o.y[0] : o.o.y[a], D = o.i.x[a] === void 0 ? o.i.x[0] : o.i.x[a], V = o.i.y[a] === void 0 ? o.i.y[0] : o.i.y[a], C = BezierFactory.getBezierEasing(L, B, D, V).get, y.__fnct[a] = C)) : y.__fnct ? C = y.__fnct : (L = o.o.x, B = o.o.y, D = o.i.x, V = o.i.y, C = BezierFactory.getBezierEasing(L, B, D, V).get, o.keyframeMetadata = C), P = C((e - m) / (c - m)))), f = p.s || o.e, z = o.h === 1 ? o.s[a] : o.s[a] + (f[a] - o.s[a]) * P, this.propType === "multidimensional" ? i[a] = z : i = z;
      }
      return t.lastIndex = s, i;
    }
    function slerp(e, t, r) {
      var i = [], s = e[0], a = e[1], n = e[2], l = e[3], o = t[0], p = t[1], y = t[2], S = t[3], u, P, b, d, C;
      return P = s * o + a * p + n * y + l * S, P < 0 && (P = -P, o = -o, p = -p, y = -y, S = -S), 1 - P > 1e-6 ? (u = Math.acos(P), b = Math.sin(u), d = Math.sin((1 - r) * u) / b, C = Math.sin(r * u) / b) : (d = 1 - r, C = r), i[0] = d * s + C * o, i[1] = d * a + C * p, i[2] = d * n + C * y, i[3] = d * l + C * S, i;
    }
    function quaternionToEuler(e, t) {
      var r = t[0], i = t[1], s = t[2], a = t[3], n = Math.atan2(2 * i * a - 2 * r * s, 1 - 2 * i * i - 2 * s * s), l = Math.asin(2 * r * i + 2 * s * a), o = Math.atan2(2 * r * a - 2 * i * s, 1 - 2 * r * r - 2 * s * s);
      e[0] = n / degToRads, e[1] = l / degToRads, e[2] = o / degToRads;
    }
    function createQuaternion(e) {
      var t = e[0] * degToRads, r = e[1] * degToRads, i = e[2] * degToRads, s = Math.cos(t / 2), a = Math.cos(r / 2), n = Math.cos(i / 2), l = Math.sin(t / 2), o = Math.sin(r / 2), p = Math.sin(i / 2), y = s * a * n - l * o * p, S = l * o * n + s * a * p, u = l * a * n + s * o * p, P = s * o * n - l * a * p;
      return [S, u, P, y];
    }
    function getValueAtCurrentTime() {
      var e = this.comp.renderedFrame - this.offsetTime, t = this.keyframes[0].t - this.offsetTime, r = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
      if (!(e === this._caching.lastFrame || this._caching.lastFrame !== initFrame && (this._caching.lastFrame >= r && e >= r || this._caching.lastFrame < t && e < t))) {
        this._caching.lastFrame >= e && (this._caching._lastKeyframeIndex = -1, this._caching.lastIndex = 0);
        var i = this.interpolateValue(e, this._caching);
        this.pv = i;
      }
      return this._caching.lastFrame = e, this.pv;
    }
    function setVValue(e) {
      var t;
      if (this.propType === "unidimensional")
        t = e * this.mult, mathAbs(this.v - t) > 1e-5 && (this.v = t, this._mdf = !0);
      else
        for (var r = 0, i = this.v.length; r < i; )
          t = e[r] * this.mult, mathAbs(this.v[r] - t) > 1e-5 && (this.v[r] = t, this._mdf = !0), r += 1;
    }
    function processEffectsSequence() {
      if (!(this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length)) {
        if (this.lock) {
          this.setVValue(this.pv);
          return;
        }
        this.lock = !0, this._mdf = this._isFirstFrame;
        var e, t = this.effectsSequence.length, r = this.kf ? this.pv : this.data.k;
        for (e = 0; e < t; e += 1)
          r = this.effectsSequence[e](r);
        this.setVValue(r), this._isFirstFrame = !1, this.lock = !1, this.frameId = this.elem.globalData.frameId;
      }
    }
    function addEffect(e) {
      this.effectsSequence.push(e), this.container.addDynamicProperty(this);
    }
    function ValueProperty(e, t, r, i) {
      this.propType = "unidimensional", this.mult = r || 1, this.data = t, this.v = r ? t.k * r : t.k, this.pv = t.k, this._mdf = !1, this.elem = e, this.container = i, this.comp = e.comp, this.k = !1, this.kf = !1, this.vel = 0, this.effectsSequence = [], this._isFirstFrame = !0, this.getValue = processEffectsSequence, this.setVValue = setVValue, this.addEffect = addEffect;
    }
    function MultiDimensionalProperty(e, t, r, i) {
      this.propType = "multidimensional", this.mult = r || 1, this.data = t, this._mdf = !1, this.elem = e, this.container = i, this.comp = e.comp, this.k = !1, this.kf = !1, this.frameId = -1;
      var s, a = t.k.length;
      for (this.v = createTypedArray("float32", a), this.pv = createTypedArray("float32", a), this.vel = createTypedArray("float32", a), s = 0; s < a; s += 1)
        this.v[s] = t.k[s] * this.mult, this.pv[s] = t.k[s];
      this._isFirstFrame = !0, this.effectsSequence = [], this.getValue = processEffectsSequence, this.setVValue = setVValue, this.addEffect = addEffect;
    }
    function KeyframedValueProperty(e, t, r, i) {
      this.propType = "unidimensional", this.keyframes = t.k, this.keyframesMetadata = [], this.offsetTime = e.data.st, this.frameId = -1, this._caching = {
        lastFrame: initFrame,
        lastIndex: 0,
        value: 0,
        _lastKeyframeIndex: -1
      }, this.k = !0, this.kf = !0, this.data = t, this.mult = r || 1, this.elem = e, this.container = i, this.comp = e.comp, this.v = initFrame, this.pv = initFrame, this._isFirstFrame = !0, this.getValue = processEffectsSequence, this.setVValue = setVValue, this.interpolateValue = interpolateValue, this.effectsSequence = [getValueAtCurrentTime.bind(this)], this.addEffect = addEffect;
    }
    function KeyframedMultidimensionalProperty(e, t, r, i) {
      this.propType = "multidimensional";
      var s, a = t.k.length, n, l, o, p;
      for (s = 0; s < a - 1; s += 1)
        t.k[s].to && t.k[s].s && t.k[s + 1] && t.k[s + 1].s && (n = t.k[s].s, l = t.k[s + 1].s, o = t.k[s].to, p = t.k[s].ti, (n.length === 2 && !(n[0] === l[0] && n[1] === l[1]) && bez.pointOnLine2D(n[0], n[1], l[0], l[1], n[0] + o[0], n[1] + o[1]) && bez.pointOnLine2D(n[0], n[1], l[0], l[1], l[0] + p[0], l[1] + p[1]) || n.length === 3 && !(n[0] === l[0] && n[1] === l[1] && n[2] === l[2]) && bez.pointOnLine3D(n[0], n[1], n[2], l[0], l[1], l[2], n[0] + o[0], n[1] + o[1], n[2] + o[2]) && bez.pointOnLine3D(n[0], n[1], n[2], l[0], l[1], l[2], l[0] + p[0], l[1] + p[1], l[2] + p[2])) && (t.k[s].to = null, t.k[s].ti = null), n[0] === l[0] && n[1] === l[1] && o[0] === 0 && o[1] === 0 && p[0] === 0 && p[1] === 0 && (n.length === 2 || n[2] === l[2] && o[2] === 0 && p[2] === 0) && (t.k[s].to = null, t.k[s].ti = null));
      this.effectsSequence = [getValueAtCurrentTime.bind(this)], this.data = t, this.keyframes = t.k, this.keyframesMetadata = [], this.offsetTime = e.data.st, this.k = !0, this.kf = !0, this._isFirstFrame = !0, this.mult = r || 1, this.elem = e, this.container = i, this.comp = e.comp, this.getValue = processEffectsSequence, this.setVValue = setVValue, this.interpolateValue = interpolateValue, this.frameId = -1;
      var y = t.k[0].s.length;
      for (this.v = createTypedArray("float32", y), this.pv = createTypedArray("float32", y), s = 0; s < y; s += 1)
        this.v[s] = initFrame, this.pv[s] = initFrame;
      this._caching = {
        lastFrame: initFrame,
        lastIndex: 0,
        value: createTypedArray("float32", y)
      }, this.addEffect = addEffect;
    }
    var PropertyFactory = function() {
      function e(r, i, s, a, n) {
        i.sid && (i = r.globalData.slotManager.getProp(i));
        var l;
        if (!i.k.length)
          l = new ValueProperty(r, i, a, n);
        else if (typeof i.k[0] == "number")
          l = new MultiDimensionalProperty(r, i, a, n);
        else
          switch (s) {
            case 0:
              l = new KeyframedValueProperty(r, i, a, n);
              break;
            case 1:
              l = new KeyframedMultidimensionalProperty(r, i, a, n);
              break;
          }
        return l.effectsSequence.length && n.addDynamicProperty(l), l;
      }
      var t = {
        getProp: e
      };
      return t;
    }();
    function DynamicPropertyContainer() {
    }
    DynamicPropertyContainer.prototype = {
      addDynamicProperty: function(t) {
        this.dynamicProperties.indexOf(t) === -1 && (this.dynamicProperties.push(t), this.container.addDynamicProperty(this), this._isAnimated = !0);
      },
      iterateDynamicProperties: function() {
        this._mdf = !1;
        var t, r = this.dynamicProperties.length;
        for (t = 0; t < r; t += 1)
          this.dynamicProperties[t].getValue(), this.dynamicProperties[t]._mdf && (this._mdf = !0);
      },
      initDynamicPropertyContainer: function(t) {
        this.container = t, this.dynamicProperties = [], this._mdf = !1, this._isAnimated = !1;
      }
    };
    var pointPool = function() {
      function e() {
        return createTypedArray("float32", 2);
      }
      return poolFactory(8, e);
    }();
    function ShapePath() {
      this.c = !1, this._length = 0, this._maxLength = 8, this.v = createSizedArray(this._maxLength), this.o = createSizedArray(this._maxLength), this.i = createSizedArray(this._maxLength);
    }
    ShapePath.prototype.setPathData = function(e, t) {
      this.c = e, this.setLength(t);
      for (var r = 0; r < t; )
        this.v[r] = pointPool.newElement(), this.o[r] = pointPool.newElement(), this.i[r] = pointPool.newElement(), r += 1;
    }, ShapePath.prototype.setLength = function(e) {
      for (; this._maxLength < e; )
        this.doubleArrayLength();
      this._length = e;
    }, ShapePath.prototype.doubleArrayLength = function() {
      this.v = this.v.concat(createSizedArray(this._maxLength)), this.i = this.i.concat(createSizedArray(this._maxLength)), this.o = this.o.concat(createSizedArray(this._maxLength)), this._maxLength *= 2;
    }, ShapePath.prototype.setXYAt = function(e, t, r, i, s) {
      var a;
      switch (this._length = Math.max(this._length, i + 1), this._length >= this._maxLength && this.doubleArrayLength(), r) {
        case "v":
          a = this.v;
          break;
        case "i":
          a = this.i;
          break;
        case "o":
          a = this.o;
          break;
        default:
          a = [];
          break;
      }
      (!a[i] || a[i] && !s) && (a[i] = pointPool.newElement()), a[i][0] = e, a[i][1] = t;
    }, ShapePath.prototype.setTripleAt = function(e, t, r, i, s, a, n, l) {
      this.setXYAt(e, t, "v", n, l), this.setXYAt(r, i, "o", n, l), this.setXYAt(s, a, "i", n, l);
    }, ShapePath.prototype.reverse = function() {
      var e = new ShapePath();
      e.setPathData(this.c, this._length);
      var t = this.v, r = this.o, i = this.i, s = 0;
      this.c && (e.setTripleAt(t[0][0], t[0][1], i[0][0], i[0][1], r[0][0], r[0][1], 0, !1), s = 1);
      var a = this._length - 1, n = this._length, l;
      for (l = s; l < n; l += 1)
        e.setTripleAt(t[a][0], t[a][1], i[a][0], i[a][1], r[a][0], r[a][1], l, !1), a -= 1;
      return e;
    }, ShapePath.prototype.length = function() {
      return this._length;
    };
    var shapePool = function() {
      function e() {
        return new ShapePath();
      }
      function t(s) {
        var a = s._length, n;
        for (n = 0; n < a; n += 1)
          pointPool.release(s.v[n]), pointPool.release(s.i[n]), pointPool.release(s.o[n]), s.v[n] = null, s.i[n] = null, s.o[n] = null;
        s._length = 0, s.c = !1;
      }
      function r(s) {
        var a = i.newElement(), n, l = s._length === void 0 ? s.v.length : s._length;
        for (a.setLength(l), a.c = s.c, n = 0; n < l; n += 1)
          a.setTripleAt(s.v[n][0], s.v[n][1], s.o[n][0], s.o[n][1], s.i[n][0], s.i[n][1], n);
        return a;
      }
      var i = poolFactory(4, e, t);
      return i.clone = r, i;
    }();
    function ShapeCollection() {
      this._length = 0, this._maxLength = 4, this.shapes = createSizedArray(this._maxLength);
    }
    ShapeCollection.prototype.addShape = function(e) {
      this._length === this._maxLength && (this.shapes = this.shapes.concat(createSizedArray(this._maxLength)), this._maxLength *= 2), this.shapes[this._length] = e, this._length += 1;
    }, ShapeCollection.prototype.releaseShapes = function() {
      var e;
      for (e = 0; e < this._length; e += 1)
        shapePool.release(this.shapes[e]);
      this._length = 0;
    };
    var shapeCollectionPool = function() {
      var e = {
        newShapeCollection: s,
        release: a
      }, t = 0, r = 4, i = createSizedArray(r);
      function s() {
        var n;
        return t ? (t -= 1, n = i[t]) : n = new ShapeCollection(), n;
      }
      function a(n) {
        var l, o = n._length;
        for (l = 0; l < o; l += 1)
          shapePool.release(n.shapes[l]);
        n._length = 0, t === r && (i = pooling.double(i), r *= 2), i[t] = n, t += 1;
      }
      return e;
    }(), ShapePropertyFactory = function() {
      var e = -999999;
      function t(c, m, f) {
        var g = f.lastIndex, E, A, k, M, L, B, D, V, z, I = this.keyframes;
        if (c < I[0].t - this.offsetTime)
          E = I[0].s[0], k = !0, g = 0;
        else if (c >= I[I.length - 1].t - this.offsetTime)
          E = I[I.length - 1].s ? I[I.length - 1].s[0] : I[I.length - 2].e[0], k = !0;
        else {
          for (var R = g, x = I.length - 1, T = !0, v, _, F; T && (v = I[R], _ = I[R + 1], !(_.t - this.offsetTime > c)); )
            R < x - 1 ? R += 1 : T = !1;
          if (F = this.keyframesMetadata[R] || {}, k = v.h === 1, g = R, !k) {
            if (c >= _.t - this.offsetTime)
              V = 1;
            else if (c < v.t - this.offsetTime)
              V = 0;
            else {
              var w;
              F.__fnct ? w = F.__fnct : (w = BezierFactory.getBezierEasing(v.o.x, v.o.y, v.i.x, v.i.y).get, F.__fnct = w), V = w((c - (v.t - this.offsetTime)) / (_.t - this.offsetTime - (v.t - this.offsetTime)));
            }
            A = _.s ? _.s[0] : v.e[0];
          }
          E = v.s[0];
        }
        for (B = m._length, D = E.i[0].length, f.lastIndex = g, M = 0; M < B; M += 1)
          for (L = 0; L < D; L += 1)
            z = k ? E.i[M][L] : E.i[M][L] + (A.i[M][L] - E.i[M][L]) * V, m.i[M][L] = z, z = k ? E.o[M][L] : E.o[M][L] + (A.o[M][L] - E.o[M][L]) * V, m.o[M][L] = z, z = k ? E.v[M][L] : E.v[M][L] + (A.v[M][L] - E.v[M][L]) * V, m.v[M][L] = z;
      }
      function r() {
        var c = this.comp.renderedFrame - this.offsetTime, m = this.keyframes[0].t - this.offsetTime, f = this.keyframes[this.keyframes.length - 1].t - this.offsetTime, g = this._caching.lastFrame;
        return g !== e && (g < m && c < m || g > f && c > f) || (this._caching.lastIndex = g < c ? this._caching.lastIndex : 0, this.interpolateShape(c, this.pv, this._caching)), this._caching.lastFrame = c, this.pv;
      }
      function i() {
        this.paths = this.localShapeCollection;
      }
      function s(c, m) {
        if (c._length !== m._length || c.c !== m.c)
          return !1;
        var f, g = c._length;
        for (f = 0; f < g; f += 1)
          if (c.v[f][0] !== m.v[f][0] || c.v[f][1] !== m.v[f][1] || c.o[f][0] !== m.o[f][0] || c.o[f][1] !== m.o[f][1] || c.i[f][0] !== m.i[f][0] || c.i[f][1] !== m.i[f][1])
            return !1;
        return !0;
      }
      function a(c) {
        s(this.v, c) || (this.v = shapePool.clone(c), this.localShapeCollection.releaseShapes(), this.localShapeCollection.addShape(this.v), this._mdf = !0, this.paths = this.localShapeCollection);
      }
      function n() {
        if (this.elem.globalData.frameId !== this.frameId) {
          if (!this.effectsSequence.length) {
            this._mdf = !1;
            return;
          }
          if (this.lock) {
            this.setVValue(this.pv);
            return;
          }
          this.lock = !0, this._mdf = !1;
          var c;
          this.kf ? c = this.pv : this.data.ks ? c = this.data.ks.k : c = this.data.pt.k;
          var m, f = this.effectsSequence.length;
          for (m = 0; m < f; m += 1)
            c = this.effectsSequence[m](c);
          this.setVValue(c), this.lock = !1, this.frameId = this.elem.globalData.frameId;
        }
      }
      function l(c, m, f) {
        this.propType = "shape", this.comp = c.comp, this.container = c, this.elem = c, this.data = m, this.k = !1, this.kf = !1, this._mdf = !1;
        var g = f === 3 ? m.pt.k : m.ks.k;
        this.v = shapePool.clone(g), this.pv = shapePool.clone(this.v), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.paths = this.localShapeCollection, this.paths.addShape(this.v), this.reset = i, this.effectsSequence = [];
      }
      function o(c) {
        this.effectsSequence.push(c), this.container.addDynamicProperty(this);
      }
      l.prototype.interpolateShape = t, l.prototype.getValue = n, l.prototype.setVValue = a, l.prototype.addEffect = o;
      function p(c, m, f) {
        this.propType = "shape", this.comp = c.comp, this.elem = c, this.container = c, this.offsetTime = c.data.st, this.keyframes = f === 3 ? m.pt.k : m.ks.k, this.keyframesMetadata = [], this.k = !0, this.kf = !0;
        var g = this.keyframes[0].s[0].i.length;
        this.v = shapePool.newElement(), this.v.setPathData(this.keyframes[0].s[0].c, g), this.pv = shapePool.clone(this.v), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.paths = this.localShapeCollection, this.paths.addShape(this.v), this.lastFrame = e, this.reset = i, this._caching = {
          lastFrame: e,
          lastIndex: 0
        }, this.effectsSequence = [r.bind(this)];
      }
      p.prototype.getValue = n, p.prototype.interpolateShape = t, p.prototype.setVValue = a, p.prototype.addEffect = o;
      var y = function() {
        var c = roundCorner;
        function m(f, g) {
          this.v = shapePool.newElement(), this.v.setPathData(!0, 4), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.paths = this.localShapeCollection, this.localShapeCollection.addShape(this.v), this.d = g.d, this.elem = f, this.comp = f.comp, this.frameId = -1, this.initDynamicPropertyContainer(f), this.p = PropertyFactory.getProp(f, g.p, 1, 0, this), this.s = PropertyFactory.getProp(f, g.s, 1, 0, this), this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertEllToPath());
        }
        return m.prototype = {
          reset: i,
          getValue: function() {
            this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertEllToPath());
          },
          convertEllToPath: function() {
            var g = this.p.v[0], E = this.p.v[1], A = this.s.v[0] / 2, k = this.s.v[1] / 2, M = this.d !== 3, L = this.v;
            L.v[0][0] = g, L.v[0][1] = E - k, L.v[1][0] = M ? g + A : g - A, L.v[1][1] = E, L.v[2][0] = g, L.v[2][1] = E + k, L.v[3][0] = M ? g - A : g + A, L.v[3][1] = E, L.i[0][0] = M ? g - A * c : g + A * c, L.i[0][1] = E - k, L.i[1][0] = M ? g + A : g - A, L.i[1][1] = E - k * c, L.i[2][0] = M ? g + A * c : g - A * c, L.i[2][1] = E + k, L.i[3][0] = M ? g - A : g + A, L.i[3][1] = E + k * c, L.o[0][0] = M ? g + A * c : g - A * c, L.o[0][1] = E - k, L.o[1][0] = M ? g + A : g - A, L.o[1][1] = E + k * c, L.o[2][0] = M ? g - A * c : g + A * c, L.o[2][1] = E + k, L.o[3][0] = M ? g - A : g + A, L.o[3][1] = E - k * c;
          }
        }, extendPrototype([DynamicPropertyContainer], m), m;
      }(), S = function() {
        function c(m, f) {
          this.v = shapePool.newElement(), this.v.setPathData(!0, 0), this.elem = m, this.comp = m.comp, this.data = f, this.frameId = -1, this.d = f.d, this.initDynamicPropertyContainer(m), f.sy === 1 ? (this.ir = PropertyFactory.getProp(m, f.ir, 0, 0, this), this.is = PropertyFactory.getProp(m, f.is, 0, 0.01, this), this.convertToPath = this.convertStarToPath) : this.convertToPath = this.convertPolygonToPath, this.pt = PropertyFactory.getProp(m, f.pt, 0, 0, this), this.p = PropertyFactory.getProp(m, f.p, 1, 0, this), this.r = PropertyFactory.getProp(m, f.r, 0, degToRads, this), this.or = PropertyFactory.getProp(m, f.or, 0, 0, this), this.os = PropertyFactory.getProp(m, f.os, 0, 0.01, this), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.localShapeCollection.addShape(this.v), this.paths = this.localShapeCollection, this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertToPath());
        }
        return c.prototype = {
          reset: i,
          getValue: function() {
            this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertToPath());
          },
          convertStarToPath: function() {
            var f = Math.floor(this.pt.v) * 2, g = Math.PI * 2 / f, E = !0, A = this.or.v, k = this.ir.v, M = this.os.v, L = this.is.v, B = 2 * Math.PI * A / (f * 2), D = 2 * Math.PI * k / (f * 2), V, z, I, R, x = -Math.PI / 2;
            x += this.r.v;
            var T = this.data.d === 3 ? -1 : 1;
            for (this.v._length = 0, V = 0; V < f; V += 1) {
              z = E ? A : k, I = E ? M : L, R = E ? B : D;
              var v = z * Math.cos(x), _ = z * Math.sin(x), F = v === 0 && _ === 0 ? 0 : _ / Math.sqrt(v * v + _ * _), w = v === 0 && _ === 0 ? 0 : -v / Math.sqrt(v * v + _ * _);
              v += +this.p.v[0], _ += +this.p.v[1], this.v.setTripleAt(v, _, v - F * R * I * T, _ - w * R * I * T, v + F * R * I * T, _ + w * R * I * T, V, !0), E = !E, x += g * T;
            }
          },
          convertPolygonToPath: function() {
            var f = Math.floor(this.pt.v), g = Math.PI * 2 / f, E = this.or.v, A = this.os.v, k = 2 * Math.PI * E / (f * 4), M, L = -Math.PI * 0.5, B = this.data.d === 3 ? -1 : 1;
            for (L += this.r.v, this.v._length = 0, M = 0; M < f; M += 1) {
              var D = E * Math.cos(L), V = E * Math.sin(L), z = D === 0 && V === 0 ? 0 : V / Math.sqrt(D * D + V * V), I = D === 0 && V === 0 ? 0 : -D / Math.sqrt(D * D + V * V);
              D += +this.p.v[0], V += +this.p.v[1], this.v.setTripleAt(D, V, D - z * k * A * B, V - I * k * A * B, D + z * k * A * B, V + I * k * A * B, M, !0), L += g * B;
            }
            this.paths.length = 0, this.paths[0] = this.v;
          }
        }, extendPrototype([DynamicPropertyContainer], c), c;
      }(), u = function() {
        function c(m, f) {
          this.v = shapePool.newElement(), this.v.c = !0, this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.localShapeCollection.addShape(this.v), this.paths = this.localShapeCollection, this.elem = m, this.comp = m.comp, this.frameId = -1, this.d = f.d, this.initDynamicPropertyContainer(m), this.p = PropertyFactory.getProp(m, f.p, 1, 0, this), this.s = PropertyFactory.getProp(m, f.s, 1, 0, this), this.r = PropertyFactory.getProp(m, f.r, 0, 0, this), this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertRectToPath());
        }
        return c.prototype = {
          convertRectToPath: function() {
            var f = this.p.v[0], g = this.p.v[1], E = this.s.v[0] / 2, A = this.s.v[1] / 2, k = bmMin(E, A, this.r.v), M = k * (1 - roundCorner);
            this.v._length = 0, this.d === 2 || this.d === 1 ? (this.v.setTripleAt(f + E, g - A + k, f + E, g - A + k, f + E, g - A + M, 0, !0), this.v.setTripleAt(f + E, g + A - k, f + E, g + A - M, f + E, g + A - k, 1, !0), k !== 0 ? (this.v.setTripleAt(f + E - k, g + A, f + E - k, g + A, f + E - M, g + A, 2, !0), this.v.setTripleAt(f - E + k, g + A, f - E + M, g + A, f - E + k, g + A, 3, !0), this.v.setTripleAt(f - E, g + A - k, f - E, g + A - k, f - E, g + A - M, 4, !0), this.v.setTripleAt(f - E, g - A + k, f - E, g - A + M, f - E, g - A + k, 5, !0), this.v.setTripleAt(f - E + k, g - A, f - E + k, g - A, f - E + M, g - A, 6, !0), this.v.setTripleAt(f + E - k, g - A, f + E - M, g - A, f + E - k, g - A, 7, !0)) : (this.v.setTripleAt(f - E, g + A, f - E + M, g + A, f - E, g + A, 2), this.v.setTripleAt(f - E, g - A, f - E, g - A + M, f - E, g - A, 3))) : (this.v.setTripleAt(f + E, g - A + k, f + E, g - A + M, f + E, g - A + k, 0, !0), k !== 0 ? (this.v.setTripleAt(f + E - k, g - A, f + E - k, g - A, f + E - M, g - A, 1, !0), this.v.setTripleAt(f - E + k, g - A, f - E + M, g - A, f - E + k, g - A, 2, !0), this.v.setTripleAt(f - E, g - A + k, f - E, g - A + k, f - E, g - A + M, 3, !0), this.v.setTripleAt(f - E, g + A - k, f - E, g + A - M, f - E, g + A - k, 4, !0), this.v.setTripleAt(f - E + k, g + A, f - E + k, g + A, f - E + M, g + A, 5, !0), this.v.setTripleAt(f + E - k, g + A, f + E - M, g + A, f + E - k, g + A, 6, !0), this.v.setTripleAt(f + E, g + A - k, f + E, g + A - k, f + E, g + A - M, 7, !0)) : (this.v.setTripleAt(f - E, g - A, f - E + M, g - A, f - E, g - A, 1, !0), this.v.setTripleAt(f - E, g + A, f - E, g + A - M, f - E, g + A, 2, !0), this.v.setTripleAt(f + E, g + A, f + E - M, g + A, f + E, g + A, 3, !0)));
          },
          getValue: function() {
            this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertRectToPath());
          },
          reset: i
        }, extendPrototype([DynamicPropertyContainer], c), c;
      }();
      function P(c, m, f) {
        var g;
        if (f === 3 || f === 4) {
          var E = f === 3 ? m.pt : m.ks, A = E.k;
          A.length ? g = new p(c, m, f) : g = new l(c, m, f);
        } else
          f === 5 ? g = new u(c, m) : f === 6 ? g = new y(c, m) : f === 7 && (g = new S(c, m));
        return g.k && c.addDynamicProperty(g), g;
      }
      function b() {
        return l;
      }
      function d() {
        return p;
      }
      var C = {};
      return C.getShapeProp = P, C.getConstructorFunction = b, C.getKeyframedConstructorFunction = d, C;
    }();
    /*!
     Transformation Matrix v2.0
     (c) Epistemex 2014-2015
     www.epistemex.com
     By Ken Fyrstenberg
     Contributions by leeoniya.
     License: MIT, header required.
     */
    var Matrix = function() {
      var e = Math.cos, t = Math.sin, r = Math.tan, i = Math.round;
      function s() {
        return this.props[0] = 1, this.props[1] = 0, this.props[2] = 0, this.props[3] = 0, this.props[4] = 0, this.props[5] = 1, this.props[6] = 0, this.props[7] = 0, this.props[8] = 0, this.props[9] = 0, this.props[10] = 1, this.props[11] = 0, this.props[12] = 0, this.props[13] = 0, this.props[14] = 0, this.props[15] = 1, this;
      }
      function a(v) {
        if (v === 0)
          return this;
        var _ = e(v), F = t(v);
        return this._t(_, -F, 0, 0, F, _, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
      }
      function n(v) {
        if (v === 0)
          return this;
        var _ = e(v), F = t(v);
        return this._t(1, 0, 0, 0, 0, _, -F, 0, 0, F, _, 0, 0, 0, 0, 1);
      }
      function l(v) {
        if (v === 0)
          return this;
        var _ = e(v), F = t(v);
        return this._t(_, 0, F, 0, 0, 1, 0, 0, -F, 0, _, 0, 0, 0, 0, 1);
      }
      function o(v) {
        if (v === 0)
          return this;
        var _ = e(v), F = t(v);
        return this._t(_, -F, 0, 0, F, _, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
      }
      function p(v, _) {
        return this._t(1, _, v, 1, 0, 0);
      }
      function y(v, _) {
        return this.shear(r(v), r(_));
      }
      function S(v, _) {
        var F = e(_), w = t(_);
        return this._t(F, w, 0, 0, -w, F, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(1, 0, 0, 0, r(v), 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(F, -w, 0, 0, w, F, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
      }
      function u(v, _, F) {
        return !F && F !== 0 && (F = 1), v === 1 && _ === 1 && F === 1 ? this : this._t(v, 0, 0, 0, 0, _, 0, 0, 0, 0, F, 0, 0, 0, 0, 1);
      }
      function P(v, _, F, w, N, O, j, H, W, $, Y, ee, X, J, Z, q) {
        return this.props[0] = v, this.props[1] = _, this.props[2] = F, this.props[3] = w, this.props[4] = N, this.props[5] = O, this.props[6] = j, this.props[7] = H, this.props[8] = W, this.props[9] = $, this.props[10] = Y, this.props[11] = ee, this.props[12] = X, this.props[13] = J, this.props[14] = Z, this.props[15] = q, this;
      }
      function b(v, _, F) {
        return F = F || 0, v !== 0 || _ !== 0 || F !== 0 ? this._t(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, v, _, F, 1) : this;
      }
      function d(v, _, F, w, N, O, j, H, W, $, Y, ee, X, J, Z, q) {
        var G = this.props;
        if (v === 1 && _ === 0 && F === 0 && w === 0 && N === 0 && O === 1 && j === 0 && H === 0 && W === 0 && $ === 0 && Y === 1 && ee === 0)
          return G[12] = G[12] * v + G[15] * X, G[13] = G[13] * O + G[15] * J, G[14] = G[14] * Y + G[15] * Z, G[15] *= q, this._identityCalculated = !1, this;
        var re = G[0], ne = G[1], ie = G[2], te = G[3], se = G[4], ae = G[5], U = G[6], oe = G[7], he = G[8], K = G[9], le = G[10], Q = G[11], fe = G[12], pe = G[13], ce = G[14], ue = G[15];
        return G[0] = re * v + ne * N + ie * W + te * X, G[1] = re * _ + ne * O + ie * $ + te * J, G[2] = re * F + ne * j + ie * Y + te * Z, G[3] = re * w + ne * H + ie * ee + te * q, G[4] = se * v + ae * N + U * W + oe * X, G[5] = se * _ + ae * O + U * $ + oe * J, G[6] = se * F + ae * j + U * Y + oe * Z, G[7] = se * w + ae * H + U * ee + oe * q, G[8] = he * v + K * N + le * W + Q * X, G[9] = he * _ + K * O + le * $ + Q * J, G[10] = he * F + K * j + le * Y + Q * Z, G[11] = he * w + K * H + le * ee + Q * q, G[12] = fe * v + pe * N + ce * W + ue * X, G[13] = fe * _ + pe * O + ce * $ + ue * J, G[14] = fe * F + pe * j + ce * Y + ue * Z, G[15] = fe * w + pe * H + ce * ee + ue * q, this._identityCalculated = !1, this;
      }
      function C(v) {
        var _ = v.props;
        return this.transform(_[0], _[1], _[2], _[3], _[4], _[5], _[6], _[7], _[8], _[9], _[10], _[11], _[12], _[13], _[14], _[15]);
      }
      function c() {
        return this._identityCalculated || (this._identity = !(this.props[0] !== 1 || this.props[1] !== 0 || this.props[2] !== 0 || this.props[3] !== 0 || this.props[4] !== 0 || this.props[5] !== 1 || this.props[6] !== 0 || this.props[7] !== 0 || this.props[8] !== 0 || this.props[9] !== 0 || this.props[10] !== 1 || this.props[11] !== 0 || this.props[12] !== 0 || this.props[13] !== 0 || this.props[14] !== 0 || this.props[15] !== 1), this._identityCalculated = !0), this._identity;
      }
      function m(v) {
        for (var _ = 0; _ < 16; ) {
          if (v.props[_] !== this.props[_])
            return !1;
          _ += 1;
        }
        return !0;
      }
      function f(v) {
        var _;
        for (_ = 0; _ < 16; _ += 1)
          v.props[_] = this.props[_];
        return v;
      }
      function g(v) {
        var _;
        for (_ = 0; _ < 16; _ += 1)
          this.props[_] = v[_];
      }
      function E(v, _, F) {
        return {
          x: v * this.props[0] + _ * this.props[4] + F * this.props[8] + this.props[12],
          y: v * this.props[1] + _ * this.props[5] + F * this.props[9] + this.props[13],
          z: v * this.props[2] + _ * this.props[6] + F * this.props[10] + this.props[14]
        };
      }
      function A(v, _, F) {
        return v * this.props[0] + _ * this.props[4] + F * this.props[8] + this.props[12];
      }
      function k(v, _, F) {
        return v * this.props[1] + _ * this.props[5] + F * this.props[9] + this.props[13];
      }
      function M(v, _, F) {
        return v * this.props[2] + _ * this.props[6] + F * this.props[10] + this.props[14];
      }
      function L() {
        var v = this.props[0] * this.props[5] - this.props[1] * this.props[4], _ = this.props[5] / v, F = -this.props[1] / v, w = -this.props[4] / v, N = this.props[0] / v, O = (this.props[4] * this.props[13] - this.props[5] * this.props[12]) / v, j = -(this.props[0] * this.props[13] - this.props[1] * this.props[12]) / v, H = new Matrix();
        return H.props[0] = _, H.props[1] = F, H.props[4] = w, H.props[5] = N, H.props[12] = O, H.props[13] = j, H;
      }
      function B(v) {
        var _ = this.getInverseMatrix();
        return _.applyToPointArray(v[0], v[1], v[2] || 0);
      }
      function D(v) {
        var _, F = v.length, w = [];
        for (_ = 0; _ < F; _ += 1)
          w[_] = B(v[_]);
        return w;
      }
      function V(v, _, F) {
        var w = createTypedArray("float32", 6);
        if (this.isIdentity())
          w[0] = v[0], w[1] = v[1], w[2] = _[0], w[3] = _[1], w[4] = F[0], w[5] = F[1];
        else {
          var N = this.props[0], O = this.props[1], j = this.props[4], H = this.props[5], W = this.props[12], $ = this.props[13];
          w[0] = v[0] * N + v[1] * j + W, w[1] = v[0] * O + v[1] * H + $, w[2] = _[0] * N + _[1] * j + W, w[3] = _[0] * O + _[1] * H + $, w[4] = F[0] * N + F[1] * j + W, w[5] = F[0] * O + F[1] * H + $;
        }
        return w;
      }
      function z(v, _, F) {
        var w;
        return this.isIdentity() ? w = [v, _, F] : w = [v * this.props[0] + _ * this.props[4] + F * this.props[8] + this.props[12], v * this.props[1] + _ * this.props[5] + F * this.props[9] + this.props[13], v * this.props[2] + _ * this.props[6] + F * this.props[10] + this.props[14]], w;
      }
      function I(v, _) {
        if (this.isIdentity())
          return v + "," + _;
        var F = this.props;
        return Math.round((v * F[0] + _ * F[4] + F[12]) * 100) / 100 + "," + Math.round((v * F[1] + _ * F[5] + F[13]) * 100) / 100;
      }
      function R() {
        for (var v = 0, _ = this.props, F = "matrix3d(", w = 1e4; v < 16; )
          F += i(_[v] * w) / w, F += v === 15 ? ")" : ",", v += 1;
        return F;
      }
      function x(v) {
        var _ = 1e4;
        return v < 1e-6 && v > 0 || v > -1e-6 && v < 0 ? i(v * _) / _ : v;
      }
      function T() {
        var v = this.props, _ = x(v[0]), F = x(v[1]), w = x(v[4]), N = x(v[5]), O = x(v[12]), j = x(v[13]);
        return "matrix(" + _ + "," + F + "," + w + "," + N + "," + O + "," + j + ")";
      }
      return function() {
        this.reset = s, this.rotate = a, this.rotateX = n, this.rotateY = l, this.rotateZ = o, this.skew = y, this.skewFromAxis = S, this.shear = p, this.scale = u, this.setTransform = P, this.translate = b, this.transform = d, this.multiply = C, this.applyToPoint = E, this.applyToX = A, this.applyToY = k, this.applyToZ = M, this.applyToPointArray = z, this.applyToTriplePoints = V, this.applyToPointStringified = I, this.toCSS = R, this.to2dCSS = T, this.clone = f, this.cloneFromProps = g, this.equals = m, this.inversePoints = D, this.inversePoint = B, this.getInverseMatrix = L, this._t = this.transform, this.isIdentity = c, this._identity = !0, this._identityCalculated = !1, this.props = createTypedArray("float32", 16), this.reset();
      };
    }();
    function _typeof$3(e) {
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof$3 = function(r) {
        return typeof r;
      } : _typeof$3 = function(r) {
        return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
      }, _typeof$3(e);
    }
    var lottie = {};
    function setLocation(e) {
      setLocationHref(e);
    }
    function searchAnimations() {
      animationManager.searchAnimations();
    }
    function setSubframeRendering(e) {
      setSubframeEnabled(e);
    }
    function setPrefix(e) {
      setIdPrefix(e);
    }
    function loadAnimation(e) {
      return animationManager.loadAnimation(e);
    }
    function setQuality(e) {
      if (typeof e == "string")
        switch (e) {
          case "high":
            setDefaultCurveSegments(200);
            break;
          default:
          case "medium":
            setDefaultCurveSegments(50);
            break;
          case "low":
            setDefaultCurveSegments(10);
            break;
        }
      else
        !isNaN(e) && e > 1 && setDefaultCurveSegments(e);
    }
    function inBrowser() {
      return typeof navigator < "u";
    }
    function installPlugin(e, t) {
      e === "expressions" && setExpressionsPlugin(t);
    }
    function getFactory(e) {
      switch (e) {
        case "propertyFactory":
          return PropertyFactory;
        case "shapePropertyFactory":
          return ShapePropertyFactory;
        case "matrix":
          return Matrix;
        default:
          return null;
      }
    }
    lottie.play = animationManager.play, lottie.pause = animationManager.pause, lottie.setLocationHref = setLocation, lottie.togglePause = animationManager.togglePause, lottie.setSpeed = animationManager.setSpeed, lottie.setDirection = animationManager.setDirection, lottie.stop = animationManager.stop, lottie.searchAnimations = searchAnimations, lottie.registerAnimation = animationManager.registerAnimation, lottie.loadAnimation = loadAnimation, lottie.setSubframeRendering = setSubframeRendering, lottie.resize = animationManager.resize, lottie.goToAndStop = animationManager.goToAndStop, lottie.destroy = animationManager.destroy, lottie.setQuality = setQuality, lottie.inBrowser = inBrowser, lottie.installPlugin = installPlugin, lottie.freeze = animationManager.freeze, lottie.unfreeze = animationManager.unfreeze, lottie.setVolume = animationManager.setVolume, lottie.mute = animationManager.mute, lottie.unmute = animationManager.unmute, lottie.getRegisteredAnimations = animationManager.getRegisteredAnimations, lottie.useWebWorker = setWebWorker, lottie.setIDPrefix = setPrefix, lottie.__getFactory = getFactory, lottie.version = "5.12.2";
    function checkReady() {
      document.readyState === "complete" && (clearInterval(readyStateCheckInterval), searchAnimations());
    }
    function getQueryVariable(e) {
      for (var t = queryString.split("&"), r = 0; r < t.length; r += 1) {
        var i = t[r].split("=");
        if (decodeURIComponent(i[0]) == e)
          return decodeURIComponent(i[1]);
      }
      return null;
    }
    var queryString = "";
    {
      var scripts = document.getElementsByTagName("script"), index = scripts.length - 1, myScript = scripts[index] || {
        src: ""
      };
      queryString = myScript.src ? myScript.src.replace(/^[^\?]+\??/, "") : "", getQueryVariable("renderer");
    }
    var readyStateCheckInterval = setInterval(checkReady, 100);
    try {
      _typeof$3(exports) !== "object" && (window.bodymovin = lottie);
    } catch (e) {
    }
    var ShapeModifiers = function() {
      var e = {}, t = {};
      e.registerModifier = r, e.getModifier = i;
      function r(s, a) {
        t[s] || (t[s] = a);
      }
      function i(s, a, n) {
        return new t[s](a, n);
      }
      return e;
    }();
    function ShapeModifier() {
    }
    ShapeModifier.prototype.initModifierProperties = function() {
    }, ShapeModifier.prototype.addShapeToModifier = function() {
    }, ShapeModifier.prototype.addShape = function(e) {
      if (!this.closed) {
        e.sh.container.addDynamicProperty(e.sh);
        var t = {
          shape: e.sh,
          data: e,
          localShapeCollection: shapeCollectionPool.newShapeCollection()
        };
        this.shapes.push(t), this.addShapeToModifier(t), this._isAnimated && e.setAsAnimated();
      }
    }, ShapeModifier.prototype.init = function(e, t) {
      this.shapes = [], this.elem = e, this.initDynamicPropertyContainer(e), this.initModifierProperties(e, t), this.frameId = initialDefaultFrame, this.closed = !1, this.k = !1, this.dynamicProperties.length ? this.k = !0 : this.getValue(!0);
    }, ShapeModifier.prototype.processKeys = function() {
      this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties());
    }, extendPrototype([DynamicPropertyContainer], ShapeModifier);
    function TrimModifier() {
    }
    extendPrototype([ShapeModifier], TrimModifier), TrimModifier.prototype.initModifierProperties = function(e, t) {
      this.s = PropertyFactory.getProp(e, t.s, 0, 0.01, this), this.e = PropertyFactory.getProp(e, t.e, 0, 0.01, this), this.o = PropertyFactory.getProp(e, t.o, 0, 0, this), this.sValue = 0, this.eValue = 0, this.getValue = this.processKeys, this.m = t.m, this._isAnimated = !!this.s.effectsSequence.length || !!this.e.effectsSequence.length || !!this.o.effectsSequence.length;
    }, TrimModifier.prototype.addShapeToModifier = function(e) {
      e.pathsData = [];
    }, TrimModifier.prototype.calculateShapeEdges = function(e, t, r, i, s) {
      var a = [];
      t <= 1 ? a.push({
        s: e,
        e: t
      }) : e >= 1 ? a.push({
        s: e - 1,
        e: t - 1
      }) : (a.push({
        s: e,
        e: 1
      }), a.push({
        s: 0,
        e: t - 1
      }));
      var n = [], l, o = a.length, p;
      for (l = 0; l < o; l += 1)
        if (p = a[l], !(p.e * s < i || p.s * s > i + r)) {
          var y, S;
          p.s * s <= i ? y = 0 : y = (p.s * s - i) / r, p.e * s >= i + r ? S = 1 : S = (p.e * s - i) / r, n.push([y, S]);
        }
      return n.length || n.push([0, 0]), n;
    }, TrimModifier.prototype.releasePathsData = function(e) {
      var t, r = e.length;
      for (t = 0; t < r; t += 1)
        segmentsLengthPool.release(e[t]);
      return e.length = 0, e;
    }, TrimModifier.prototype.processShapes = function(e) {
      var t, r;
      if (this._mdf || e) {
        var i = this.o.v % 360 / 360;
        if (i < 0 && (i += 1), this.s.v > 1 ? t = 1 + i : this.s.v < 0 ? t = 0 + i : t = this.s.v + i, this.e.v > 1 ? r = 1 + i : this.e.v < 0 ? r = 0 + i : r = this.e.v + i, t > r) {
          var s = t;
          t = r, r = s;
        }
        t = Math.round(t * 1e4) * 1e-4, r = Math.round(r * 1e4) * 1e-4, this.sValue = t, this.eValue = r;
      } else
        t = this.sValue, r = this.eValue;
      var a, n, l = this.shapes.length, o, p, y, S, u, P = 0;
      if (r === t)
        for (n = 0; n < l; n += 1)
          this.shapes[n].localShapeCollection.releaseShapes(), this.shapes[n].shape._mdf = !0, this.shapes[n].shape.paths = this.shapes[n].localShapeCollection, this._mdf && (this.shapes[n].pathsData.length = 0);
      else if (r === 1 && t === 0 || r === 0 && t === 1) {
        if (this._mdf)
          for (n = 0; n < l; n += 1)
            this.shapes[n].pathsData.length = 0, this.shapes[n].shape._mdf = !0;
      } else {
        var b = [], d, C;
        for (n = 0; n < l; n += 1)
          if (d = this.shapes[n], !d.shape._mdf && !this._mdf && !e && this.m !== 2)
            d.shape.paths = d.localShapeCollection;
          else {
            if (a = d.shape.paths, p = a._length, u = 0, !d.shape._mdf && d.pathsData.length)
              u = d.totalShapeLength;
            else {
              for (y = this.releasePathsData(d.pathsData), o = 0; o < p; o += 1)
                S = bez.getSegmentsLength(a.shapes[o]), y.push(S), u += S.totalLength;
              d.totalShapeLength = u, d.pathsData = y;
            }
            P += u, d.shape._mdf = !0;
          }
        var c = t, m = r, f = 0, g;
        for (n = l - 1; n >= 0; n -= 1)
          if (d = this.shapes[n], d.shape._mdf) {
            for (C = d.localShapeCollection, C.releaseShapes(), this.m === 2 && l > 1 ? (g = this.calculateShapeEdges(t, r, d.totalShapeLength, f, P), f += d.totalShapeLength) : g = [[c, m]], p = g.length, o = 0; o < p; o += 1) {
              c = g[o][0], m = g[o][1], b.length = 0, m <= 1 ? b.push({
                s: d.totalShapeLength * c,
                e: d.totalShapeLength * m
              }) : c >= 1 ? b.push({
                s: d.totalShapeLength * (c - 1),
                e: d.totalShapeLength * (m - 1)
              }) : (b.push({
                s: d.totalShapeLength * c,
                e: d.totalShapeLength
              }), b.push({
                s: 0,
                e: d.totalShapeLength * (m - 1)
              }));
              var E = this.addShapes(d, b[0]);
              if (b[0].s !== b[0].e) {
                if (b.length > 1) {
                  var A = d.shape.paths.shapes[d.shape.paths._length - 1];
                  if (A.c) {
                    var k = E.pop();
                    this.addPaths(E, C), E = this.addShapes(d, b[1], k);
                  } else
                    this.addPaths(E, C), E = this.addShapes(d, b[1]);
                }
                this.addPaths(E, C);
              }
            }
            d.shape.paths = C;
          }
      }
    }, TrimModifier.prototype.addPaths = function(e, t) {
      var r, i = e.length;
      for (r = 0; r < i; r += 1)
        t.addShape(e[r]);
    }, TrimModifier.prototype.addSegment = function(e, t, r, i, s, a, n) {
      s.setXYAt(t[0], t[1], "o", a), s.setXYAt(r[0], r[1], "i", a + 1), n && s.setXYAt(e[0], e[1], "v", a), s.setXYAt(i[0], i[1], "v", a + 1);
    }, TrimModifier.prototype.addSegmentFromArray = function(e, t, r, i) {
      t.setXYAt(e[1], e[5], "o", r), t.setXYAt(e[2], e[6], "i", r + 1), i && t.setXYAt(e[0], e[4], "v", r), t.setXYAt(e[3], e[7], "v", r + 1);
    }, TrimModifier.prototype.addShapes = function(e, t, r) {
      var i = e.pathsData, s = e.shape.paths.shapes, a, n = e.shape.paths._length, l, o, p = 0, y, S, u, P, b = [], d, C = !0;
      for (r ? (S = r._length, d = r._length) : (r = shapePool.newElement(), S = 0, d = 0), b.push(r), a = 0; a < n; a += 1) {
        for (u = i[a].lengths, r.c = s[a].c, o = s[a].c ? u.length : u.length + 1, l = 1; l < o; l += 1)
          if (y = u[l - 1], p + y.addedLength < t.s)
            p += y.addedLength, r.c = !1;
          else if (p > t.e) {
            r.c = !1;
            break;
          } else
            t.s <= p && t.e >= p + y.addedLength ? (this.addSegment(s[a].v[l - 1], s[a].o[l - 1], s[a].i[l], s[a].v[l], r, S, C), C = !1) : (P = bez.getNewSegment(s[a].v[l - 1], s[a].v[l], s[a].o[l - 1], s[a].i[l], (t.s - p) / y.addedLength, (t.e - p) / y.addedLength, u[l - 1]), this.addSegmentFromArray(P, r, S, C), C = !1, r.c = !1), p += y.addedLength, S += 1;
        if (s[a].c && u.length) {
          if (y = u[l - 1], p <= t.e) {
            var c = u[l - 1].addedLength;
            t.s <= p && t.e >= p + c ? (this.addSegment(s[a].v[l - 1], s[a].o[l - 1], s[a].i[0], s[a].v[0], r, S, C), C = !1) : (P = bez.getNewSegment(s[a].v[l - 1], s[a].v[0], s[a].o[l - 1], s[a].i[0], (t.s - p) / c, (t.e - p) / c, u[l - 1]), this.addSegmentFromArray(P, r, S, C), C = !1, r.c = !1);
          } else
            r.c = !1;
          p += y.addedLength, S += 1;
        }
        if (r._length && (r.setXYAt(r.v[d][0], r.v[d][1], "i", d), r.setXYAt(r.v[r._length - 1][0], r.v[r._length - 1][1], "o", r._length - 1)), p > t.e)
          break;
        a < n - 1 && (r = shapePool.newElement(), C = !0, b.push(r), S = 0);
      }
      return b;
    };
    function PuckerAndBloatModifier() {
    }
    extendPrototype([ShapeModifier], PuckerAndBloatModifier), PuckerAndBloatModifier.prototype.initModifierProperties = function(e, t) {
      this.getValue = this.processKeys, this.amount = PropertyFactory.getProp(e, t.a, 0, null, this), this._isAnimated = !!this.amount.effectsSequence.length;
    }, PuckerAndBloatModifier.prototype.processPath = function(e, t) {
      var r = t / 100, i = [0, 0], s = e._length, a = 0;
      for (a = 0; a < s; a += 1)
        i[0] += e.v[a][0], i[1] += e.v[a][1];
      i[0] /= s, i[1] /= s;
      var n = shapePool.newElement();
      n.c = e.c;
      var l, o, p, y, S, u;
      for (a = 0; a < s; a += 1)
        l = e.v[a][0] + (i[0] - e.v[a][0]) * r, o = e.v[a][1] + (i[1] - e.v[a][1]) * r, p = e.o[a][0] + (i[0] - e.o[a][0]) * -r, y = e.o[a][1] + (i[1] - e.o[a][1]) * -r, S = e.i[a][0] + (i[0] - e.i[a][0]) * -r, u = e.i[a][1] + (i[1] - e.i[a][1]) * -r, n.setTripleAt(l, o, p, y, S, u, a);
      return n;
    }, PuckerAndBloatModifier.prototype.processShapes = function(e) {
      var t, r, i = this.shapes.length, s, a, n = this.amount.v;
      if (n !== 0) {
        var l, o;
        for (r = 0; r < i; r += 1) {
          if (l = this.shapes[r], o = l.localShapeCollection, !(!l.shape._mdf && !this._mdf && !e))
            for (o.releaseShapes(), l.shape._mdf = !0, t = l.shape.paths.shapes, a = l.shape.paths._length, s = 0; s < a; s += 1)
              o.addShape(this.processPath(t[s], n));
          l.shape.paths = l.localShapeCollection;
        }
      }
      this.dynamicProperties.length || (this._mdf = !1);
    };
    var TransformPropertyFactory = function() {
      var e = [0, 0];
      function t(o) {
        var p = this._mdf;
        this.iterateDynamicProperties(), this._mdf = this._mdf || p, this.a && o.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.s && o.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.sk && o.skewFromAxis(-this.sk.v, this.sa.v), this.r ? o.rotate(-this.r.v) : o.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.data.p.s ? this.data.p.z ? o.translate(this.px.v, this.py.v, -this.pz.v) : o.translate(this.px.v, this.py.v, 0) : o.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
      }
      function r(o) {
        if (this.elem.globalData.frameId !== this.frameId) {
          if (this._isDirty && (this.precalculateMatrix(), this._isDirty = !1), this.iterateDynamicProperties(), this._mdf || o) {
            var p;
            if (this.v.cloneFromProps(this.pre.props), this.appliedTransformations < 1 && this.v.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.appliedTransformations < 2 && this.v.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.sk && this.appliedTransformations < 3 && this.v.skewFromAxis(-this.sk.v, this.sa.v), this.r && this.appliedTransformations < 4 ? this.v.rotate(-this.r.v) : !this.r && this.appliedTransformations < 4 && this.v.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.autoOriented) {
              var y, S;
              if (p = this.elem.globalData.frameRate, this.p && this.p.keyframes && this.p.getValueAtTime)
                this.p._caching.lastFrame + this.p.offsetTime <= this.p.keyframes[0].t ? (y = this.p.getValueAtTime((this.p.keyframes[0].t + 0.01) / p, 0), S = this.p.getValueAtTime(this.p.keyframes[0].t / p, 0)) : this.p._caching.lastFrame + this.p.offsetTime >= this.p.keyframes[this.p.keyframes.length - 1].t ? (y = this.p.getValueAtTime(this.p.keyframes[this.p.keyframes.length - 1].t / p, 0), S = this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length - 1].t - 0.05) / p, 0)) : (y = this.p.pv, S = this.p.getValueAtTime((this.p._caching.lastFrame + this.p.offsetTime - 0.01) / p, this.p.offsetTime));
              else if (this.px && this.px.keyframes && this.py.keyframes && this.px.getValueAtTime && this.py.getValueAtTime) {
                y = [], S = [];
                var u = this.px, P = this.py;
                u._caching.lastFrame + u.offsetTime <= u.keyframes[0].t ? (y[0] = u.getValueAtTime((u.keyframes[0].t + 0.01) / p, 0), y[1] = P.getValueAtTime((P.keyframes[0].t + 0.01) / p, 0), S[0] = u.getValueAtTime(u.keyframes[0].t / p, 0), S[1] = P.getValueAtTime(P.keyframes[0].t / p, 0)) : u._caching.lastFrame + u.offsetTime >= u.keyframes[u.keyframes.length - 1].t ? (y[0] = u.getValueAtTime(u.keyframes[u.keyframes.length - 1].t / p, 0), y[1] = P.getValueAtTime(P.keyframes[P.keyframes.length - 1].t / p, 0), S[0] = u.getValueAtTime((u.keyframes[u.keyframes.length - 1].t - 0.01) / p, 0), S[1] = P.getValueAtTime((P.keyframes[P.keyframes.length - 1].t - 0.01) / p, 0)) : (y = [u.pv, P.pv], S[0] = u.getValueAtTime((u._caching.lastFrame + u.offsetTime - 0.01) / p, u.offsetTime), S[1] = P.getValueAtTime((P._caching.lastFrame + P.offsetTime - 0.01) / p, P.offsetTime));
              } else
                S = e, y = S;
              this.v.rotate(-Math.atan2(y[1] - S[1], y[0] - S[0]));
            }
            this.data.p && this.data.p.s ? this.data.p.z ? this.v.translate(this.px.v, this.py.v, -this.pz.v) : this.v.translate(this.px.v, this.py.v, 0) : this.v.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
          }
          this.frameId = this.elem.globalData.frameId;
        }
      }
      function i() {
        if (this.appliedTransformations = 0, this.pre.reset(), !this.a.effectsSequence.length)
          this.pre.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.appliedTransformations = 1;
        else
          return;
        if (!this.s.effectsSequence.length)
          this.pre.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.appliedTransformations = 2;
        else
          return;
        if (this.sk)
          if (!this.sk.effectsSequence.length && !this.sa.effectsSequence.length)
            this.pre.skewFromAxis(-this.sk.v, this.sa.v), this.appliedTransformations = 3;
          else
            return;
        this.r ? this.r.effectsSequence.length || (this.pre.rotate(-this.r.v), this.appliedTransformations = 4) : !this.rz.effectsSequence.length && !this.ry.effectsSequence.length && !this.rx.effectsSequence.length && !this.or.effectsSequence.length && (this.pre.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.appliedTransformations = 4);
      }
      function s() {
      }
      function a(o) {
        this._addDynamicProperty(o), this.elem.addDynamicProperty(o), this._isDirty = !0;
      }
      function n(o, p, y) {
        if (this.elem = o, this.frameId = -1, this.propType = "transform", this.data = p, this.v = new Matrix(), this.pre = new Matrix(), this.appliedTransformations = 0, this.initDynamicPropertyContainer(y || o), p.p && p.p.s ? (this.px = PropertyFactory.getProp(o, p.p.x, 0, 0, this), this.py = PropertyFactory.getProp(o, p.p.y, 0, 0, this), p.p.z && (this.pz = PropertyFactory.getProp(o, p.p.z, 0, 0, this))) : this.p = PropertyFactory.getProp(o, p.p || {
          k: [0, 0, 0]
        }, 1, 0, this), p.rx) {
          if (this.rx = PropertyFactory.getProp(o, p.rx, 0, degToRads, this), this.ry = PropertyFactory.getProp(o, p.ry, 0, degToRads, this), this.rz = PropertyFactory.getProp(o, p.rz, 0, degToRads, this), p.or.k[0].ti) {
            var S, u = p.or.k.length;
            for (S = 0; S < u; S += 1)
              p.or.k[S].to = null, p.or.k[S].ti = null;
          }
          this.or = PropertyFactory.getProp(o, p.or, 1, degToRads, this), this.or.sh = !0;
        } else
          this.r = PropertyFactory.getProp(o, p.r || {
            k: 0
          }, 0, degToRads, this);
        p.sk && (this.sk = PropertyFactory.getProp(o, p.sk, 0, degToRads, this), this.sa = PropertyFactory.getProp(o, p.sa, 0, degToRads, this)), this.a = PropertyFactory.getProp(o, p.a || {
          k: [0, 0, 0]
        }, 1, 0, this), this.s = PropertyFactory.getProp(o, p.s || {
          k: [100, 100, 100]
        }, 1, 0.01, this), p.o ? this.o = PropertyFactory.getProp(o, p.o, 0, 0.01, o) : this.o = {
          _mdf: !1,
          v: 1
        }, this._isDirty = !0, this.dynamicProperties.length || this.getValue(!0);
      }
      n.prototype = {
        applyToMatrix: t,
        getValue: r,
        precalculateMatrix: i,
        autoOrient: s
      }, extendPrototype([DynamicPropertyContainer], n), n.prototype.addDynamicProperty = a, n.prototype._addDynamicProperty = DynamicPropertyContainer.prototype.addDynamicProperty;
      function l(o, p, y) {
        return new n(o, p, y);
      }
      return {
        getTransformProperty: l
      };
    }();
    function RepeaterModifier() {
    }
    extendPrototype([ShapeModifier], RepeaterModifier), RepeaterModifier.prototype.initModifierProperties = function(e, t) {
      this.getValue = this.processKeys, this.c = PropertyFactory.getProp(e, t.c, 0, null, this), this.o = PropertyFactory.getProp(e, t.o, 0, null, this), this.tr = TransformPropertyFactory.getTransformProperty(e, t.tr, this), this.so = PropertyFactory.getProp(e, t.tr.so, 0, 0.01, this), this.eo = PropertyFactory.getProp(e, t.tr.eo, 0, 0.01, this), this.data = t, this.dynamicProperties.length || this.getValue(!0), this._isAnimated = !!this.dynamicProperties.length, this.pMatrix = new Matrix(), this.rMatrix = new Matrix(), this.sMatrix = new Matrix(), this.tMatrix = new Matrix(), this.matrix = new Matrix();
    }, RepeaterModifier.prototype.applyTransforms = function(e, t, r, i, s, a) {
      var n = a ? -1 : 1, l = i.s.v[0] + (1 - i.s.v[0]) * (1 - s), o = i.s.v[1] + (1 - i.s.v[1]) * (1 - s);
      e.translate(i.p.v[0] * n * s, i.p.v[1] * n * s, i.p.v[2]), t.translate(-i.a.v[0], -i.a.v[1], i.a.v[2]), t.rotate(-i.r.v * n * s), t.translate(i.a.v[0], i.a.v[1], i.a.v[2]), r.translate(-i.a.v[0], -i.a.v[1], i.a.v[2]), r.scale(a ? 1 / l : l, a ? 1 / o : o), r.translate(i.a.v[0], i.a.v[1], i.a.v[2]);
    }, RepeaterModifier.prototype.init = function(e, t, r, i) {
      for (this.elem = e, this.arr = t, this.pos = r, this.elemsData = i, this._currentCopies = 0, this._elements = [], this._groups = [], this.frameId = -1, this.initDynamicPropertyContainer(e), this.initModifierProperties(e, t[r]); r > 0; )
        r -= 1, this._elements.unshift(t[r]);
      this.dynamicProperties.length ? this.k = !0 : this.getValue(!0);
    }, RepeaterModifier.prototype.resetElements = function(e) {
      var t, r = e.length;
      for (t = 0; t < r; t += 1)
        e[t]._processed = !1, e[t].ty === "gr" && this.resetElements(e[t].it);
    }, RepeaterModifier.prototype.cloneElements = function(e) {
      var t = JSON.parse(JSON.stringify(e));
      return this.resetElements(t), t;
    }, RepeaterModifier.prototype.changeGroupRender = function(e, t) {
      var r, i = e.length;
      for (r = 0; r < i; r += 1)
        e[r]._render = t, e[r].ty === "gr" && this.changeGroupRender(e[r].it, t);
    }, RepeaterModifier.prototype.processShapes = function(e) {
      var t, r, i, s, a, n = !1;
      if (this._mdf || e) {
        var l = Math.ceil(this.c.v);
        if (this._groups.length < l) {
          for (; this._groups.length < l; ) {
            var o = {
              it: this.cloneElements(this._elements),
              ty: "gr"
            };
            o.it.push({
              a: {
                a: 0,
                ix: 1,
                k: [0, 0]
              },
              nm: "Transform",
              o: {
                a: 0,
                ix: 7,
                k: 100
              },
              p: {
                a: 0,
                ix: 2,
                k: [0, 0]
              },
              r: {
                a: 1,
                ix: 6,
                k: [{
                  s: 0,
                  e: 0,
                  t: 0
                }, {
                  s: 0,
                  e: 0,
                  t: 1
                }]
              },
              s: {
                a: 0,
                ix: 3,
                k: [100, 100]
              },
              sa: {
                a: 0,
                ix: 5,
                k: 0
              },
              sk: {
                a: 0,
                ix: 4,
                k: 0
              },
              ty: "tr"
            }), this.arr.splice(0, 0, o), this._groups.splice(0, 0, o), this._currentCopies += 1;
          }
          this.elem.reloadShapes(), n = !0;
        }
        a = 0;
        var p;
        for (i = 0; i <= this._groups.length - 1; i += 1) {
          if (p = a < l, this._groups[i]._render = p, this.changeGroupRender(this._groups[i].it, p), !p) {
            var y = this.elemsData[i].it, S = y[y.length - 1];
            S.transform.op.v !== 0 ? (S.transform.op._mdf = !0, S.transform.op.v = 0) : S.transform.op._mdf = !1;
          }
          a += 1;
        }
        this._currentCopies = l;
        var u = this.o.v, P = u % 1, b = u > 0 ? Math.floor(u) : Math.ceil(u), d = this.pMatrix.props, C = this.rMatrix.props, c = this.sMatrix.props;
        this.pMatrix.reset(), this.rMatrix.reset(), this.sMatrix.reset(), this.tMatrix.reset(), this.matrix.reset();
        var m = 0;
        if (u > 0) {
          for (; m < b; )
            this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !1), m += 1;
          P && (this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, P, !1), m += P);
        } else if (u < 0) {
          for (; m > b; )
            this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !0), m -= 1;
          P && (this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, -P, !0), m -= P);
        }
        i = this.data.m === 1 ? 0 : this._currentCopies - 1, s = this.data.m === 1 ? 1 : -1, a = this._currentCopies;
        for (var f, g; a; ) {
          if (t = this.elemsData[i].it, r = t[t.length - 1].transform.mProps.v.props, g = r.length, t[t.length - 1].transform.mProps._mdf = !0, t[t.length - 1].transform.op._mdf = !0, t[t.length - 1].transform.op.v = this._currentCopies === 1 ? this.so.v : this.so.v + (this.eo.v - this.so.v) * (i / (this._currentCopies - 1)), m !== 0) {
            for ((i !== 0 && s === 1 || i !== this._currentCopies - 1 && s === -1) && this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !1), this.matrix.transform(C[0], C[1], C[2], C[3], C[4], C[5], C[6], C[7], C[8], C[9], C[10], C[11], C[12], C[13], C[14], C[15]), this.matrix.transform(c[0], c[1], c[2], c[3], c[4], c[5], c[6], c[7], c[8], c[9], c[10], c[11], c[12], c[13], c[14], c[15]), this.matrix.transform(d[0], d[1], d[2], d[3], d[4], d[5], d[6], d[7], d[8], d[9], d[10], d[11], d[12], d[13], d[14], d[15]), f = 0; f < g; f += 1)
              r[f] = this.matrix.props[f];
            this.matrix.reset();
          } else
            for (this.matrix.reset(), f = 0; f < g; f += 1)
              r[f] = this.matrix.props[f];
          m += 1, a -= 1, i += s;
        }
      } else
        for (a = this._currentCopies, i = 0, s = 1; a; )
          t = this.elemsData[i].it, r = t[t.length - 1].transform.mProps.v.props, t[t.length - 1].transform.mProps._mdf = !1, t[t.length - 1].transform.op._mdf = !1, a -= 1, i += s;
      return n;
    }, RepeaterModifier.prototype.addShape = function() {
    };
    function RoundCornersModifier() {
    }
    extendPrototype([ShapeModifier], RoundCornersModifier), RoundCornersModifier.prototype.initModifierProperties = function(e, t) {
      this.getValue = this.processKeys, this.rd = PropertyFactory.getProp(e, t.r, 0, null, this), this._isAnimated = !!this.rd.effectsSequence.length;
    }, RoundCornersModifier.prototype.processPath = function(e, t) {
      var r = shapePool.newElement();
      r.c = e.c;
      var i, s = e._length, a, n, l, o, p, y, S = 0, u, P, b, d, C, c;
      for (i = 0; i < s; i += 1)
        a = e.v[i], l = e.o[i], n = e.i[i], a[0] === l[0] && a[1] === l[1] && a[0] === n[0] && a[1] === n[1] ? (i === 0 || i === s - 1) && !e.c ? (r.setTripleAt(a[0], a[1], l[0], l[1], n[0], n[1], S), S += 1) : (i === 0 ? o = e.v[s - 1] : o = e.v[i - 1], p = Math.sqrt(Math.pow(a[0] - o[0], 2) + Math.pow(a[1] - o[1], 2)), y = p ? Math.min(p / 2, t) / p : 0, C = a[0] + (o[0] - a[0]) * y, u = C, c = a[1] - (a[1] - o[1]) * y, P = c, b = u - (u - a[0]) * roundCorner, d = P - (P - a[1]) * roundCorner, r.setTripleAt(u, P, b, d, C, c, S), S += 1, i === s - 1 ? o = e.v[0] : o = e.v[i + 1], p = Math.sqrt(Math.pow(a[0] - o[0], 2) + Math.pow(a[1] - o[1], 2)), y = p ? Math.min(p / 2, t) / p : 0, b = a[0] + (o[0] - a[0]) * y, u = b, d = a[1] + (o[1] - a[1]) * y, P = d, C = u - (u - a[0]) * roundCorner, c = P - (P - a[1]) * roundCorner, r.setTripleAt(u, P, b, d, C, c, S), S += 1) : (r.setTripleAt(e.v[i][0], e.v[i][1], e.o[i][0], e.o[i][1], e.i[i][0], e.i[i][1], S), S += 1);
      return r;
    }, RoundCornersModifier.prototype.processShapes = function(e) {
      var t, r, i = this.shapes.length, s, a, n = this.rd.v;
      if (n !== 0) {
        var l, o;
        for (r = 0; r < i; r += 1) {
          if (l = this.shapes[r], o = l.localShapeCollection, !(!l.shape._mdf && !this._mdf && !e))
            for (o.releaseShapes(), l.shape._mdf = !0, t = l.shape.paths.shapes, a = l.shape.paths._length, s = 0; s < a; s += 1)
              o.addShape(this.processPath(t[s], n));
          l.shape.paths = l.localShapeCollection;
        }
      }
      this.dynamicProperties.length || (this._mdf = !1);
    };
    function floatEqual(e, t) {
      return Math.abs(e - t) * 1e5 <= Math.min(Math.abs(e), Math.abs(t));
    }
    function floatZero(e) {
      return Math.abs(e) <= 1e-5;
    }
    function lerp(e, t, r) {
      return e * (1 - r) + t * r;
    }
    function lerpPoint(e, t, r) {
      return [lerp(e[0], t[0], r), lerp(e[1], t[1], r)];
    }
    function quadRoots(e, t, r) {
      if (e === 0)
        return [];
      var i = t * t - 4 * e * r;
      if (i < 0)
        return [];
      var s = -t / (2 * e);
      if (i === 0)
        return [s];
      var a = Math.sqrt(i) / (2 * e);
      return [s - a, s + a];
    }
    function polynomialCoefficients(e, t, r, i) {
      return [-e + 3 * t - 3 * r + i, 3 * e - 6 * t + 3 * r, -3 * e + 3 * t, e];
    }
    function singlePoint(e) {
      return new PolynomialBezier(e, e, e, e, !1);
    }
    function PolynomialBezier(e, t, r, i, s) {
      s && pointEqual(e, t) && (t = lerpPoint(e, i, 1 / 3)), s && pointEqual(r, i) && (r = lerpPoint(e, i, 2 / 3));
      var a = polynomialCoefficients(e[0], t[0], r[0], i[0]), n = polynomialCoefficients(e[1], t[1], r[1], i[1]);
      this.a = [a[0], n[0]], this.b = [a[1], n[1]], this.c = [a[2], n[2]], this.d = [a[3], n[3]], this.points = [e, t, r, i];
    }
    PolynomialBezier.prototype.point = function(e) {
      return [((this.a[0] * e + this.b[0]) * e + this.c[0]) * e + this.d[0], ((this.a[1] * e + this.b[1]) * e + this.c[1]) * e + this.d[1]];
    }, PolynomialBezier.prototype.derivative = function(e) {
      return [(3 * e * this.a[0] + 2 * this.b[0]) * e + this.c[0], (3 * e * this.a[1] + 2 * this.b[1]) * e + this.c[1]];
    }, PolynomialBezier.prototype.tangentAngle = function(e) {
      var t = this.derivative(e);
      return Math.atan2(t[1], t[0]);
    }, PolynomialBezier.prototype.normalAngle = function(e) {
      var t = this.derivative(e);
      return Math.atan2(t[0], t[1]);
    }, PolynomialBezier.prototype.inflectionPoints = function() {
      var e = this.a[1] * this.b[0] - this.a[0] * this.b[1];
      if (floatZero(e))
        return [];
      var t = -0.5 * (this.a[1] * this.c[0] - this.a[0] * this.c[1]) / e, r = t * t - 1 / 3 * (this.b[1] * this.c[0] - this.b[0] * this.c[1]) / e;
      if (r < 0)
        return [];
      var i = Math.sqrt(r);
      return floatZero(i) ? i > 0 && i < 1 ? [t] : [] : [t - i, t + i].filter(function(s) {
        return s > 0 && s < 1;
      });
    }, PolynomialBezier.prototype.split = function(e) {
      if (e <= 0)
        return [singlePoint(this.points[0]), this];
      if (e >= 1)
        return [this, singlePoint(this.points[this.points.length - 1])];
      var t = lerpPoint(this.points[0], this.points[1], e), r = lerpPoint(this.points[1], this.points[2], e), i = lerpPoint(this.points[2], this.points[3], e), s = lerpPoint(t, r, e), a = lerpPoint(r, i, e), n = lerpPoint(s, a, e);
      return [new PolynomialBezier(this.points[0], t, s, n, !0), new PolynomialBezier(n, a, i, this.points[3], !0)];
    };
    function extrema(e, t) {
      var r = e.points[0][t], i = e.points[e.points.length - 1][t];
      if (r > i) {
        var s = i;
        i = r, r = s;
      }
      for (var a = quadRoots(3 * e.a[t], 2 * e.b[t], e.c[t]), n = 0; n < a.length; n += 1)
        if (a[n] > 0 && a[n] < 1) {
          var l = e.point(a[n])[t];
          l < r ? r = l : l > i && (i = l);
        }
      return {
        min: r,
        max: i
      };
    }
    PolynomialBezier.prototype.bounds = function() {
      return {
        x: extrema(this, 0),
        y: extrema(this, 1)
      };
    }, PolynomialBezier.prototype.boundingBox = function() {
      var e = this.bounds();
      return {
        left: e.x.min,
        right: e.x.max,
        top: e.y.min,
        bottom: e.y.max,
        width: e.x.max - e.x.min,
        height: e.y.max - e.y.min,
        cx: (e.x.max + e.x.min) / 2,
        cy: (e.y.max + e.y.min) / 2
      };
    };
    function intersectData(e, t, r) {
      var i = e.boundingBox();
      return {
        cx: i.cx,
        cy: i.cy,
        width: i.width,
        height: i.height,
        bez: e,
        t: (t + r) / 2,
        t1: t,
        t2: r
      };
    }
    function splitData(e) {
      var t = e.bez.split(0.5);
      return [intersectData(t[0], e.t1, e.t), intersectData(t[1], e.t, e.t2)];
    }
    function boxIntersect(e, t) {
      return Math.abs(e.cx - t.cx) * 2 < e.width + t.width && Math.abs(e.cy - t.cy) * 2 < e.height + t.height;
    }
    function intersectsImpl(e, t, r, i, s, a) {
      if (boxIntersect(e, t)) {
        if (r >= a || e.width <= i && e.height <= i && t.width <= i && t.height <= i) {
          s.push([e.t, t.t]);
          return;
        }
        var n = splitData(e), l = splitData(t);
        intersectsImpl(n[0], l[0], r + 1, i, s, a), intersectsImpl(n[0], l[1], r + 1, i, s, a), intersectsImpl(n[1], l[0], r + 1, i, s, a), intersectsImpl(n[1], l[1], r + 1, i, s, a);
      }
    }
    PolynomialBezier.prototype.intersections = function(e, t, r) {
      t === void 0 && (t = 2), r === void 0 && (r = 7);
      var i = [];
      return intersectsImpl(intersectData(this, 0, 1), intersectData(e, 0, 1), 0, t, i, r), i;
    }, PolynomialBezier.shapeSegment = function(e, t) {
      var r = (t + 1) % e.length();
      return new PolynomialBezier(e.v[t], e.o[t], e.i[r], e.v[r], !0);
    }, PolynomialBezier.shapeSegmentInverted = function(e, t) {
      var r = (t + 1) % e.length();
      return new PolynomialBezier(e.v[r], e.i[r], e.o[t], e.v[t], !0);
    };
    function crossProduct(e, t) {
      return [e[1] * t[2] - e[2] * t[1], e[2] * t[0] - e[0] * t[2], e[0] * t[1] - e[1] * t[0]];
    }
    function lineIntersection(e, t, r, i) {
      var s = [e[0], e[1], 1], a = [t[0], t[1], 1], n = [r[0], r[1], 1], l = [i[0], i[1], 1], o = crossProduct(crossProduct(s, a), crossProduct(n, l));
      return floatZero(o[2]) ? null : [o[0] / o[2], o[1] / o[2]];
    }
    function polarOffset(e, t, r) {
      return [e[0] + Math.cos(t) * r, e[1] - Math.sin(t) * r];
    }
    function pointDistance(e, t) {
      return Math.hypot(e[0] - t[0], e[1] - t[1]);
    }
    function pointEqual(e, t) {
      return floatEqual(e[0], t[0]) && floatEqual(e[1], t[1]);
    }
    function ZigZagModifier() {
    }
    extendPrototype([ShapeModifier], ZigZagModifier), ZigZagModifier.prototype.initModifierProperties = function(e, t) {
      this.getValue = this.processKeys, this.amplitude = PropertyFactory.getProp(e, t.s, 0, null, this), this.frequency = PropertyFactory.getProp(e, t.r, 0, null, this), this.pointsType = PropertyFactory.getProp(e, t.pt, 0, null, this), this._isAnimated = this.amplitude.effectsSequence.length !== 0 || this.frequency.effectsSequence.length !== 0 || this.pointsType.effectsSequence.length !== 0;
    };
    function setPoint(e, t, r, i, s, a, n) {
      var l = r - Math.PI / 2, o = r + Math.PI / 2, p = t[0] + Math.cos(r) * i * s, y = t[1] - Math.sin(r) * i * s;
      e.setTripleAt(p, y, p + Math.cos(l) * a, y - Math.sin(l) * a, p + Math.cos(o) * n, y - Math.sin(o) * n, e.length());
    }
    function getPerpendicularVector(e, t) {
      var r = [t[0] - e[0], t[1] - e[1]], i = -Math.PI * 0.5, s = [Math.cos(i) * r[0] - Math.sin(i) * r[1], Math.sin(i) * r[0] + Math.cos(i) * r[1]];
      return s;
    }
    function getProjectingAngle(e, t) {
      var r = t === 0 ? e.length() - 1 : t - 1, i = (t + 1) % e.length(), s = e.v[r], a = e.v[i], n = getPerpendicularVector(s, a);
      return Math.atan2(0, 1) - Math.atan2(n[1], n[0]);
    }
    function zigZagCorner(e, t, r, i, s, a, n) {
      var l = getProjectingAngle(t, r), o = t.v[r % t._length], p = t.v[r === 0 ? t._length - 1 : r - 1], y = t.v[(r + 1) % t._length], S = a === 2 ? Math.sqrt(Math.pow(o[0] - p[0], 2) + Math.pow(o[1] - p[1], 2)) : 0, u = a === 2 ? Math.sqrt(Math.pow(o[0] - y[0], 2) + Math.pow(o[1] - y[1], 2)) : 0;
      setPoint(e, t.v[r % t._length], l, n, i, u / ((s + 1) * 2), S / ((s + 1) * 2));
    }
    function zigZagSegment(e, t, r, i, s, a) {
      for (var n = 0; n < i; n += 1) {
        var l = (n + 1) / (i + 1), o = s === 2 ? Math.sqrt(Math.pow(t.points[3][0] - t.points[0][0], 2) + Math.pow(t.points[3][1] - t.points[0][1], 2)) : 0, p = t.normalAngle(l), y = t.point(l);
        setPoint(e, y, p, a, r, o / ((i + 1) * 2), o / ((i + 1) * 2)), a = -a;
      }
      return a;
    }
    ZigZagModifier.prototype.processPath = function(e, t, r, i) {
      var s = e._length, a = shapePool.newElement();
      if (a.c = e.c, e.c || (s -= 1), s === 0)
        return a;
      var n = -1, l = PolynomialBezier.shapeSegment(e, 0);
      zigZagCorner(a, e, 0, t, r, i, n);
      for (var o = 0; o < s; o += 1)
        n = zigZagSegment(a, l, t, r, i, -n), o === s - 1 && !e.c ? l = null : l = PolynomialBezier.shapeSegment(e, (o + 1) % s), zigZagCorner(a, e, o + 1, t, r, i, n);
      return a;
    }, ZigZagModifier.prototype.processShapes = function(e) {
      var t, r, i = this.shapes.length, s, a, n = this.amplitude.v, l = Math.max(0, Math.round(this.frequency.v)), o = this.pointsType.v;
      if (n !== 0) {
        var p, y;
        for (r = 0; r < i; r += 1) {
          if (p = this.shapes[r], y = p.localShapeCollection, !(!p.shape._mdf && !this._mdf && !e))
            for (y.releaseShapes(), p.shape._mdf = !0, t = p.shape.paths.shapes, a = p.shape.paths._length, s = 0; s < a; s += 1)
              y.addShape(this.processPath(t[s], n, l, o));
          p.shape.paths = p.localShapeCollection;
        }
      }
      this.dynamicProperties.length || (this._mdf = !1);
    };
    function linearOffset(e, t, r) {
      var i = Math.atan2(t[0] - e[0], t[1] - e[1]);
      return [polarOffset(e, i, r), polarOffset(t, i, r)];
    }
    function offsetSegment(e, t) {
      var r, i, s, a, n, l, o;
      o = linearOffset(e.points[0], e.points[1], t), r = o[0], i = o[1], o = linearOffset(e.points[1], e.points[2], t), s = o[0], a = o[1], o = linearOffset(e.points[2], e.points[3], t), n = o[0], l = o[1];
      var p = lineIntersection(r, i, s, a);
      p === null && (p = i);
      var y = lineIntersection(n, l, s, a);
      return y === null && (y = n), new PolynomialBezier(r, p, y, l);
    }
    function joinLines(e, t, r, i, s) {
      var a = t.points[3], n = r.points[0];
      if (i === 3 || pointEqual(a, n))
        return a;
      if (i === 2) {
        var l = -t.tangentAngle(1), o = -r.tangentAngle(0) + Math.PI, p = lineIntersection(a, polarOffset(a, l + Math.PI / 2, 100), n, polarOffset(n, l + Math.PI / 2, 100)), y = p ? pointDistance(p, a) : pointDistance(a, n) / 2, S = polarOffset(a, l, 2 * y * roundCorner);
        return e.setXYAt(S[0], S[1], "o", e.length() - 1), S = polarOffset(n, o, 2 * y * roundCorner), e.setTripleAt(n[0], n[1], n[0], n[1], S[0], S[1], e.length()), n;
      }
      var u = pointEqual(a, t.points[2]) ? t.points[0] : t.points[2], P = pointEqual(n, r.points[1]) ? r.points[3] : r.points[1], b = lineIntersection(u, a, n, P);
      return b && pointDistance(b, a) < s ? (e.setTripleAt(b[0], b[1], b[0], b[1], b[0], b[1], e.length()), b) : a;
    }
    function getIntersection(e, t) {
      var r = e.intersections(t);
      return r.length && floatEqual(r[0][0], 1) && r.shift(), r.length ? r[0] : null;
    }
    function pruneSegmentIntersection(e, t) {
      var r = e.slice(), i = t.slice(), s = getIntersection(e[e.length - 1], t[0]);
      return s && (r[e.length - 1] = e[e.length - 1].split(s[0])[0], i[0] = t[0].split(s[1])[1]), e.length > 1 && t.length > 1 && (s = getIntersection(e[0], t[t.length - 1]), s) ? [[e[0].split(s[0])[0]], [t[t.length - 1].split(s[1])[1]]] : [r, i];
    }
    function pruneIntersections(e) {
      for (var t, r = 1; r < e.length; r += 1)
        t = pruneSegmentIntersection(e[r - 1], e[r]), e[r - 1] = t[0], e[r] = t[1];
      return e.length > 1 && (t = pruneSegmentIntersection(e[e.length - 1], e[0]), e[e.length - 1] = t[0], e[0] = t[1]), e;
    }
    function offsetSegmentSplit(e, t) {
      var r = e.inflectionPoints(), i, s, a, n;
      if (r.length === 0)
        return [offsetSegment(e, t)];
      if (r.length === 1 || floatEqual(r[1], 1))
        return a = e.split(r[0]), i = a[0], s = a[1], [offsetSegment(i, t), offsetSegment(s, t)];
      a = e.split(r[0]), i = a[0];
      var l = (r[1] - r[0]) / (1 - r[0]);
      return a = a[1].split(l), n = a[0], s = a[1], [offsetSegment(i, t), offsetSegment(n, t), offsetSegment(s, t)];
    }
    function OffsetPathModifier() {
    }
    extendPrototype([ShapeModifier], OffsetPathModifier), OffsetPathModifier.prototype.initModifierProperties = function(e, t) {
      this.getValue = this.processKeys, this.amount = PropertyFactory.getProp(e, t.a, 0, null, this), this.miterLimit = PropertyFactory.getProp(e, t.ml, 0, null, this), this.lineJoin = t.lj, this._isAnimated = this.amount.effectsSequence.length !== 0;
    }, OffsetPathModifier.prototype.processPath = function(e, t, r, i) {
      var s = shapePool.newElement();
      s.c = e.c;
      var a = e.length();
      e.c || (a -= 1);
      var n, l, o, p = [];
      for (n = 0; n < a; n += 1)
        o = PolynomialBezier.shapeSegment(e, n), p.push(offsetSegmentSplit(o, t));
      if (!e.c)
        for (n = a - 1; n >= 0; n -= 1)
          o = PolynomialBezier.shapeSegmentInverted(e, n), p.push(offsetSegmentSplit(o, t));
      p = pruneIntersections(p);
      var y = null, S = null;
      for (n = 0; n < p.length; n += 1) {
        var u = p[n];
        for (S && (y = joinLines(s, S, u[0], r, i)), S = u[u.length - 1], l = 0; l < u.length; l += 1)
          o = u[l], y && pointEqual(o.points[0], y) ? s.setXYAt(o.points[1][0], o.points[1][1], "o", s.length() - 1) : s.setTripleAt(o.points[0][0], o.points[0][1], o.points[1][0], o.points[1][1], o.points[0][0], o.points[0][1], s.length()), s.setTripleAt(o.points[3][0], o.points[3][1], o.points[3][0], o.points[3][1], o.points[2][0], o.points[2][1], s.length()), y = o.points[3];
      }
      return p.length && joinLines(s, S, p[0][0], r, i), s;
    }, OffsetPathModifier.prototype.processShapes = function(e) {
      var t, r, i = this.shapes.length, s, a, n = this.amount.v, l = this.miterLimit.v, o = this.lineJoin;
      if (n !== 0) {
        var p, y;
        for (r = 0; r < i; r += 1) {
          if (p = this.shapes[r], y = p.localShapeCollection, !(!p.shape._mdf && !this._mdf && !e))
            for (y.releaseShapes(), p.shape._mdf = !0, t = p.shape.paths.shapes, a = p.shape.paths._length, s = 0; s < a; s += 1)
              y.addShape(this.processPath(t[s], n, o, l));
          p.shape.paths = p.localShapeCollection;
        }
      }
      this.dynamicProperties.length || (this._mdf = !1);
    };
    function getFontProperties(e) {
      for (var t = e.fStyle ? e.fStyle.split(" ") : [], r = "normal", i = "normal", s = t.length, a, n = 0; n < s; n += 1)
        switch (a = t[n].toLowerCase(), a) {
          case "italic":
            i = "italic";
            break;
          case "bold":
            r = "700";
            break;
          case "black":
            r = "900";
            break;
          case "medium":
            r = "500";
            break;
          case "regular":
          case "normal":
            r = "400";
            break;
          case "light":
          case "thin":
            r = "200";
            break;
        }
      return {
        style: i,
        weight: e.fWeight || r
      };
    }
    var FontManager = function() {
      var e = 5e3, t = {
        w: 0,
        size: 0,
        shapes: [],
        data: {
          shapes: []
        }
      }, r = [];
      r = r.concat([2304, 2305, 2306, 2307, 2362, 2363, 2364, 2364, 2366, 2367, 2368, 2369, 2370, 2371, 2372, 2373, 2374, 2375, 2376, 2377, 2378, 2379, 2380, 2381, 2382, 2383, 2387, 2388, 2389, 2390, 2391, 2402, 2403]);
      var i = 127988, s = 917631, a = 917601, n = 917626, l = 65039, o = 8205, p = 127462, y = 127487, S = ["d83cdffb", "d83cdffc", "d83cdffd", "d83cdffe", "d83cdfff"];
      function u(x) {
        var T = x.split(","), v, _ = T.length, F = [];
        for (v = 0; v < _; v += 1)
          T[v] !== "sans-serif" && T[v] !== "monospace" && F.push(T[v]);
        return F.join(",");
      }
      function P(x, T) {
        var v = createTag("span");
        v.setAttribute("aria-hidden", !0), v.style.fontFamily = T;
        var _ = createTag("span");
        _.innerText = "giItT1WQy@!-/#", v.style.position = "absolute", v.style.left = "-10000px", v.style.top = "-10000px", v.style.fontSize = "300px", v.style.fontVariant = "normal", v.style.fontStyle = "normal", v.style.fontWeight = "normal", v.style.letterSpacing = "0", v.appendChild(_), document.body.appendChild(v);
        var F = _.offsetWidth;
        return _.style.fontFamily = u(x) + ", " + T, {
          node: _,
          w: F,
          parent: v
        };
      }
      function b() {
        var x, T = this.fonts.length, v, _, F = T;
        for (x = 0; x < T; x += 1)
          this.fonts[x].loaded ? F -= 1 : this.fonts[x].fOrigin === "n" || this.fonts[x].origin === 0 ? this.fonts[x].loaded = !0 : (v = this.fonts[x].monoCase.node, _ = this.fonts[x].monoCase.w, v.offsetWidth !== _ ? (F -= 1, this.fonts[x].loaded = !0) : (v = this.fonts[x].sansCase.node, _ = this.fonts[x].sansCase.w, v.offsetWidth !== _ && (F -= 1, this.fonts[x].loaded = !0)), this.fonts[x].loaded && (this.fonts[x].sansCase.parent.parentNode.removeChild(this.fonts[x].sansCase.parent), this.fonts[x].monoCase.parent.parentNode.removeChild(this.fonts[x].monoCase.parent)));
        F !== 0 && Date.now() - this.initTime < e ? setTimeout(this.checkLoadedFontsBinded, 20) : setTimeout(this.setIsLoadedBinded, 10);
      }
      function d(x, T) {
        var v = document.body && T ? "svg" : "canvas", _, F = getFontProperties(x);
        if (v === "svg") {
          var w = createNS("text");
          w.style.fontSize = "100px", w.setAttribute("font-family", x.fFamily), w.setAttribute("font-style", F.style), w.setAttribute("font-weight", F.weight), w.textContent = "1", x.fClass ? (w.style.fontFamily = "inherit", w.setAttribute("class", x.fClass)) : w.style.fontFamily = x.fFamily, T.appendChild(w), _ = w;
        } else {
          var N = new OffscreenCanvas(500, 500).getContext("2d");
          N.font = F.style + " " + F.weight + " 100px " + x.fFamily, _ = N;
        }
        function O(j) {
          return v === "svg" ? (_.textContent = j, _.getComputedTextLength()) : _.measureText(j).width;
        }
        return {
          measureText: O
        };
      }
      function C(x, T) {
        if (!x) {
          this.isLoaded = !0;
          return;
        }
        if (this.chars) {
          this.isLoaded = !0, this.fonts = x.list;
          return;
        }
        if (!document.body) {
          this.isLoaded = !0, x.list.forEach(function(Y) {
            Y.helper = d(Y), Y.cache = {};
          }), this.fonts = x.list;
          return;
        }
        var v = x.list, _, F = v.length, w = F;
        for (_ = 0; _ < F; _ += 1) {
          var N = !0, O, j;
          if (v[_].loaded = !1, v[_].monoCase = P(v[_].fFamily, "monospace"), v[_].sansCase = P(v[_].fFamily, "sans-serif"), !v[_].fPath)
            v[_].loaded = !0, w -= 1;
          else if (v[_].fOrigin === "p" || v[_].origin === 3) {
            if (O = document.querySelectorAll('style[f-forigin="p"][f-family="' + v[_].fFamily + '"], style[f-origin="3"][f-family="' + v[_].fFamily + '"]'), O.length > 0 && (N = !1), N) {
              var H = createTag("style");
              H.setAttribute("f-forigin", v[_].fOrigin), H.setAttribute("f-origin", v[_].origin), H.setAttribute("f-family", v[_].fFamily), H.type = "text/css", H.innerText = "@font-face {font-family: " + v[_].fFamily + "; font-style: normal; src: url('" + v[_].fPath + "');}", T.appendChild(H);
            }
          } else if (v[_].fOrigin === "g" || v[_].origin === 1) {
            for (O = document.querySelectorAll('link[f-forigin="g"], link[f-origin="1"]'), j = 0; j < O.length; j += 1)
              O[j].href.indexOf(v[_].fPath) !== -1 && (N = !1);
            if (N) {
              var W = createTag("link");
              W.setAttribute("f-forigin", v[_].fOrigin), W.setAttribute("f-origin", v[_].origin), W.type = "text/css", W.rel = "stylesheet", W.href = v[_].fPath, document.body.appendChild(W);
            }
          } else if (v[_].fOrigin === "t" || v[_].origin === 2) {
            for (O = document.querySelectorAll('script[f-forigin="t"], script[f-origin="2"]'), j = 0; j < O.length; j += 1)
              v[_].fPath === O[j].src && (N = !1);
            if (N) {
              var $ = createTag("link");
              $.setAttribute("f-forigin", v[_].fOrigin), $.setAttribute("f-origin", v[_].origin), $.setAttribute("rel", "stylesheet"), $.setAttribute("href", v[_].fPath), T.appendChild($);
            }
          }
          v[_].helper = d(v[_], T), v[_].cache = {}, this.fonts.push(v[_]);
        }
        w === 0 ? this.isLoaded = !0 : setTimeout(this.checkLoadedFonts.bind(this), 100);
      }
      function c(x) {
        if (x) {
          this.chars || (this.chars = []);
          var T, v = x.length, _, F = this.chars.length, w;
          for (T = 0; T < v; T += 1) {
            for (_ = 0, w = !1; _ < F; )
              this.chars[_].style === x[T].style && this.chars[_].fFamily === x[T].fFamily && this.chars[_].ch === x[T].ch && (w = !0), _ += 1;
            w || (this.chars.push(x[T]), F += 1);
          }
        }
      }
      function m(x, T, v) {
        for (var _ = 0, F = this.chars.length; _ < F; ) {
          if (this.chars[_].ch === x && this.chars[_].style === T && this.chars[_].fFamily === v)
            return this.chars[_];
          _ += 1;
        }
        return (typeof x == "string" && x.charCodeAt(0) !== 13 || !x) && console && console.warn && !this._warned && (this._warned = !0, console.warn("Missing character from exported characters list: ", x, T, v)), t;
      }
      function f(x, T, v) {
        var _ = this.getFontByName(T), F = x;
        if (!_.cache[F]) {
          var w = _.helper;
          if (x === " ") {
            var N = w.measureText("|" + x + "|"), O = w.measureText("||");
            _.cache[F] = (N - O) / 100;
          } else
            _.cache[F] = w.measureText(x) / 100;
        }
        return _.cache[F] * v;
      }
      function g(x) {
        for (var T = 0, v = this.fonts.length; T < v; ) {
          if (this.fonts[T].fName === x)
            return this.fonts[T];
          T += 1;
        }
        return this.fonts[0];
      }
      function E(x) {
        var T = 0, v = x.charCodeAt(0);
        if (v >= 55296 && v <= 56319) {
          var _ = x.charCodeAt(1);
          _ >= 56320 && _ <= 57343 && (T = (v - 55296) * 1024 + _ - 56320 + 65536);
        }
        return T;
      }
      function A(x, T) {
        var v = x.toString(16) + T.toString(16);
        return S.indexOf(v) !== -1;
      }
      function k(x) {
        return x === o;
      }
      function M(x) {
        return x === l;
      }
      function L(x) {
        var T = E(x);
        return T >= p && T <= y;
      }
      function B(x) {
        return L(x.substr(0, 2)) && L(x.substr(2, 2));
      }
      function D(x) {
        return r.indexOf(x) !== -1;
      }
      function V(x, T) {
        var v = E(x.substr(T, 2));
        if (v !== i)
          return !1;
        var _ = 0;
        for (T += 2; _ < 5; ) {
          if (v = E(x.substr(T, 2)), v < a || v > n)
            return !1;
          _ += 1, T += 2;
        }
        return E(x.substr(T, 2)) === s;
      }
      function z() {
        this.isLoaded = !0;
      }
      var I = function() {
        this.fonts = [], this.chars = null, this.typekitLoaded = 0, this.isLoaded = !1, this._warned = !1, this.initTime = Date.now(), this.setIsLoadedBinded = this.setIsLoaded.bind(this), this.checkLoadedFontsBinded = this.checkLoadedFonts.bind(this);
      };
      I.isModifier = A, I.isZeroWidthJoiner = k, I.isFlagEmoji = B, I.isRegionalCode = L, I.isCombinedCharacter = D, I.isRegionalFlag = V, I.isVariationSelector = M, I.BLACK_FLAG_CODE_POINT = i;
      var R = {
        addChars: c,
        addFonts: C,
        getCharData: m,
        getFontByName: g,
        measureText: f,
        checkLoadedFonts: b,
        setIsLoaded: z
      };
      return I.prototype = R, I;
    }();
    function SlotManager(e) {
      this.animationData = e;
    }
    SlotManager.prototype.getProp = function(e) {
      return this.animationData.slots && this.animationData.slots[e.sid] ? Object.assign(e, this.animationData.slots[e.sid].p) : e;
    };
    function slotFactory(e) {
      return new SlotManager(e);
    }
    function RenderableElement() {
    }
    RenderableElement.prototype = {
      initRenderable: function() {
        this.isInRange = !1, this.hidden = !1, this.isTransparent = !1, this.renderableComponents = [];
      },
      addRenderableComponent: function(t) {
        this.renderableComponents.indexOf(t) === -1 && this.renderableComponents.push(t);
      },
      removeRenderableComponent: function(t) {
        this.renderableComponents.indexOf(t) !== -1 && this.renderableComponents.splice(this.renderableComponents.indexOf(t), 1);
      },
      prepareRenderableFrame: function(t) {
        this.checkLayerLimits(t);
      },
      checkTransparency: function() {
        this.finalTransform.mProp.o.v <= 0 ? !this.isTransparent && this.globalData.renderConfig.hideOnTransparent && (this.isTransparent = !0, this.hide()) : this.isTransparent && (this.isTransparent = !1, this.show());
      },
      /**
         * @function
         * Initializes frame related properties.
         *
         * @param {number} num
         * current frame number in Layer's time
         *
         */
      checkLayerLimits: function(t) {
        this.data.ip - this.data.st <= t && this.data.op - this.data.st > t ? this.isInRange !== !0 && (this.globalData._mdf = !0, this._mdf = !0, this.isInRange = !0, this.show()) : this.isInRange !== !1 && (this.globalData._mdf = !0, this.isInRange = !1, this.hide());
      },
      renderRenderable: function() {
        var t, r = this.renderableComponents.length;
        for (t = 0; t < r; t += 1)
          this.renderableComponents[t].renderFrame(this._isFirstFrame);
      },
      sourceRectAtTime: function() {
        return {
          top: 0,
          left: 0,
          width: 100,
          height: 100
        };
      },
      getLayerSize: function() {
        return this.data.ty === 5 ? {
          w: this.data.textData.width,
          h: this.data.textData.height
        } : {
          w: this.data.width,
          h: this.data.height
        };
      }
    };
    var getBlendMode = function() {
      var e = {
        0: "source-over",
        1: "multiply",
        2: "screen",
        3: "overlay",
        4: "darken",
        5: "lighten",
        6: "color-dodge",
        7: "color-burn",
        8: "hard-light",
        9: "soft-light",
        10: "difference",
        11: "exclusion",
        12: "hue",
        13: "saturation",
        14: "color",
        15: "luminosity"
      };
      return function(t) {
        return e[t] || "";
      };
    }();
    function SliderEffect(e, t, r) {
      this.p = PropertyFactory.getProp(t, e.v, 0, 0, r);
    }
    function AngleEffect(e, t, r) {
      this.p = PropertyFactory.getProp(t, e.v, 0, 0, r);
    }
    function ColorEffect(e, t, r) {
      this.p = PropertyFactory.getProp(t, e.v, 1, 0, r);
    }
    function PointEffect(e, t, r) {
      this.p = PropertyFactory.getProp(t, e.v, 1, 0, r);
    }
    function LayerIndexEffect(e, t, r) {
      this.p = PropertyFactory.getProp(t, e.v, 0, 0, r);
    }
    function MaskIndexEffect(e, t, r) {
      this.p = PropertyFactory.getProp(t, e.v, 0, 0, r);
    }
    function CheckboxEffect(e, t, r) {
      this.p = PropertyFactory.getProp(t, e.v, 0, 0, r);
    }
    function NoValueEffect() {
      this.p = {};
    }
    function EffectsManager(e, t) {
      var r = e.ef || [];
      this.effectElements = [];
      var i, s = r.length, a;
      for (i = 0; i < s; i += 1)
        a = new GroupEffect(r[i], t), this.effectElements.push(a);
    }
    function GroupEffect(e, t) {
      this.init(e, t);
    }
    extendPrototype([DynamicPropertyContainer], GroupEffect), GroupEffect.prototype.getValue = GroupEffect.prototype.iterateDynamicProperties, GroupEffect.prototype.init = function(e, t) {
      this.data = e, this.effectElements = [], this.initDynamicPropertyContainer(t);
      var r, i = this.data.ef.length, s, a = this.data.ef;
      for (r = 0; r < i; r += 1) {
        switch (s = null, a[r].ty) {
          case 0:
            s = new SliderEffect(a[r], t, this);
            break;
          case 1:
            s = new AngleEffect(a[r], t, this);
            break;
          case 2:
            s = new ColorEffect(a[r], t, this);
            break;
          case 3:
            s = new PointEffect(a[r], t, this);
            break;
          case 4:
          case 7:
            s = new CheckboxEffect(a[r], t, this);
            break;
          case 10:
            s = new LayerIndexEffect(a[r], t, this);
            break;
          case 11:
            s = new MaskIndexEffect(a[r], t, this);
            break;
          case 5:
            s = new EffectsManager(a[r], t);
            break;
          default:
            s = new NoValueEffect(a[r]);
            break;
        }
        s && this.effectElements.push(s);
      }
    };
    function BaseElement() {
    }
    BaseElement.prototype = {
      checkMasks: function() {
        if (!this.data.hasMask)
          return !1;
        for (var t = 0, r = this.data.masksProperties.length; t < r; ) {
          if (this.data.masksProperties[t].mode !== "n" && this.data.masksProperties[t].cl !== !1)
            return !0;
          t += 1;
        }
        return !1;
      },
      initExpressions: function() {
        var t = getExpressionInterfaces();
        if (t) {
          var r = t("layer"), i = t("effects"), s = t("shape"), a = t("text"), n = t("comp");
          this.layerInterface = r(this), this.data.hasMask && this.maskManager && this.layerInterface.registerMaskInterface(this.maskManager);
          var l = i.createEffectsInterface(this, this.layerInterface);
          this.layerInterface.registerEffectsInterface(l), this.data.ty === 0 || this.data.xt ? this.compInterface = n(this) : this.data.ty === 4 ? (this.layerInterface.shapeInterface = s(this.shapesData, this.itemsData, this.layerInterface), this.layerInterface.content = this.layerInterface.shapeInterface) : this.data.ty === 5 && (this.layerInterface.textInterface = a(this), this.layerInterface.text = this.layerInterface.textInterface);
        }
      },
      setBlendMode: function() {
        var t = getBlendMode(this.data.bm), r = this.baseElement || this.layerElement;
        r.style["mix-blend-mode"] = t;
      },
      initBaseData: function(t, r, i) {
        this.globalData = r, this.comp = i, this.data = t, this.layerId = createElementID(), this.data.sr || (this.data.sr = 1), this.effectsManager = new EffectsManager(this.data, this, this.dynamicProperties);
      },
      getType: function() {
        return this.type;
      },
      sourceRectAtTime: function() {
      }
    };
    function FrameElement() {
    }
    FrameElement.prototype = {
      /**
         * @function
         * Initializes frame related properties.
         *
         */
      initFrame: function() {
        this._isFirstFrame = !1, this.dynamicProperties = [], this._mdf = !1;
      },
      /**
         * @function
         * Calculates all dynamic values
         *
         * @param {number} num
         * current frame number in Layer's time
         * @param {boolean} isVisible
         * if layers is currently in range
         *
         */
      prepareProperties: function(t, r) {
        var i, s = this.dynamicProperties.length;
        for (i = 0; i < s; i += 1)
          (r || this._isParent && this.dynamicProperties[i].propType === "transform") && (this.dynamicProperties[i].getValue(), this.dynamicProperties[i]._mdf && (this.globalData._mdf = !0, this._mdf = !0));
      },
      addDynamicProperty: function(t) {
        this.dynamicProperties.indexOf(t) === -1 && this.dynamicProperties.push(t);
      }
    };
    function FootageElement(e, t, r) {
      this.initFrame(), this.initRenderable(), this.assetData = t.getAssetData(e.refId), this.footageData = t.imageLoader.getAsset(this.assetData), this.initBaseData(e, t, r);
    }
    FootageElement.prototype.prepareFrame = function() {
    }, extendPrototype([RenderableElement, BaseElement, FrameElement], FootageElement), FootageElement.prototype.getBaseElement = function() {
      return null;
    }, FootageElement.prototype.renderFrame = function() {
    }, FootageElement.prototype.destroy = function() {
    }, FootageElement.prototype.initExpressions = function() {
      var e = getExpressionInterfaces();
      if (e) {
        var t = e("footage");
        this.layerInterface = t(this);
      }
    }, FootageElement.prototype.getFootageData = function() {
      return this.footageData;
    };
    function AudioElement(e, t, r) {
      this.initFrame(), this.initRenderable(), this.assetData = t.getAssetData(e.refId), this.initBaseData(e, t, r), this._isPlaying = !1, this._canPlay = !1;
      var i = this.globalData.getAssetsPath(this.assetData);
      this.audio = this.globalData.audioController.createAudio(i), this._currentTime = 0, this.globalData.audioController.addAudio(this), this._volumeMultiplier = 1, this._volume = 1, this._previousVolume = null, this.tm = e.tm ? PropertyFactory.getProp(this, e.tm, 0, t.frameRate, this) : {
        _placeholder: !0
      }, this.lv = PropertyFactory.getProp(this, e.au && e.au.lv ? e.au.lv : {
        k: [100]
      }, 1, 0.01, this);
    }
    AudioElement.prototype.prepareFrame = function(e) {
      if (this.prepareRenderableFrame(e, !0), this.prepareProperties(e, !0), this.tm._placeholder)
        this._currentTime = e / this.data.sr;
      else {
        var t = this.tm.v;
        this._currentTime = t;
      }
      this._volume = this.lv.v[0];
      var r = this._volume * this._volumeMultiplier;
      this._previousVolume !== r && (this._previousVolume = r, this.audio.volume(r));
    }, extendPrototype([RenderableElement, BaseElement, FrameElement], AudioElement), AudioElement.prototype.renderFrame = function() {
      this.isInRange && this._canPlay && (this._isPlaying ? (!this.audio.playing() || Math.abs(this._currentTime / this.globalData.frameRate - this.audio.seek()) > 0.1) && this.audio.seek(this._currentTime / this.globalData.frameRate) : (this.audio.play(), this.audio.seek(this._currentTime / this.globalData.frameRate), this._isPlaying = !0));
    }, AudioElement.prototype.show = function() {
    }, AudioElement.prototype.hide = function() {
      this.audio.pause(), this._isPlaying = !1;
    }, AudioElement.prototype.pause = function() {
      this.audio.pause(), this._isPlaying = !1, this._canPlay = !1;
    }, AudioElement.prototype.resume = function() {
      this._canPlay = !0;
    }, AudioElement.prototype.setRate = function(e) {
      this.audio.rate(e);
    }, AudioElement.prototype.volume = function(e) {
      this._volumeMultiplier = e, this._previousVolume = e * this._volume, this.audio.volume(this._previousVolume);
    }, AudioElement.prototype.getBaseElement = function() {
      return null;
    }, AudioElement.prototype.destroy = function() {
    }, AudioElement.prototype.sourceRectAtTime = function() {
    }, AudioElement.prototype.initExpressions = function() {
    };
    function BaseRenderer() {
    }
    BaseRenderer.prototype.checkLayers = function(e) {
      var t, r = this.layers.length, i;
      for (this.completeLayers = !0, t = r - 1; t >= 0; t -= 1)
        this.elements[t] || (i = this.layers[t], i.ip - i.st <= e - this.layers[t].st && i.op - i.st > e - this.layers[t].st && this.buildItem(t)), this.completeLayers = this.elements[t] ? this.completeLayers : !1;
      this.checkPendingElements();
    }, BaseRenderer.prototype.createItem = function(e) {
      switch (e.ty) {
        case 2:
          return this.createImage(e);
        case 0:
          return this.createComp(e);
        case 1:
          return this.createSolid(e);
        case 3:
          return this.createNull(e);
        case 4:
          return this.createShape(e);
        case 5:
          return this.createText(e);
        case 6:
          return this.createAudio(e);
        case 13:
          return this.createCamera(e);
        case 15:
          return this.createFootage(e);
        default:
          return this.createNull(e);
      }
    }, BaseRenderer.prototype.createCamera = function() {
      throw new Error("You're using a 3d camera. Try the html renderer.");
    }, BaseRenderer.prototype.createAudio = function(e) {
      return new AudioElement(e, this.globalData, this);
    }, BaseRenderer.prototype.createFootage = function(e) {
      return new FootageElement(e, this.globalData, this);
    }, BaseRenderer.prototype.buildAllItems = function() {
      var e, t = this.layers.length;
      for (e = 0; e < t; e += 1)
        this.buildItem(e);
      this.checkPendingElements();
    }, BaseRenderer.prototype.includeLayers = function(e) {
      this.completeLayers = !1;
      var t, r = e.length, i, s = this.layers.length;
      for (t = 0; t < r; t += 1)
        for (i = 0; i < s; ) {
          if (this.layers[i].id === e[t].id) {
            this.layers[i] = e[t];
            break;
          }
          i += 1;
        }
    }, BaseRenderer.prototype.setProjectInterface = function(e) {
      this.globalData.projectInterface = e;
    }, BaseRenderer.prototype.initItems = function() {
      this.globalData.progressiveLoad || this.buildAllItems();
    }, BaseRenderer.prototype.buildElementParenting = function(e, t, r) {
      for (var i = this.elements, s = this.layers, a = 0, n = s.length; a < n; )
        s[a].ind == t && (!i[a] || i[a] === !0 ? (this.buildItem(a), this.addPendingElement(e)) : (r.push(i[a]), i[a].setAsParent(), s[a].parent !== void 0 ? this.buildElementParenting(e, s[a].parent, r) : e.setHierarchy(r))), a += 1;
    }, BaseRenderer.prototype.addPendingElement = function(e) {
      this.pendingElements.push(e);
    }, BaseRenderer.prototype.searchExtraCompositions = function(e) {
      var t, r = e.length;
      for (t = 0; t < r; t += 1)
        if (e[t].xt) {
          var i = this.createComp(e[t]);
          i.initExpressions(), this.globalData.projectInterface.registerComposition(i);
        }
    }, BaseRenderer.prototype.getElementById = function(e) {
      var t, r = this.elements.length;
      for (t = 0; t < r; t += 1)
        if (this.elements[t].data.ind === e)
          return this.elements[t];
      return null;
    }, BaseRenderer.prototype.getElementByPath = function(e) {
      var t = e.shift(), r;
      if (typeof t == "number")
        r = this.elements[t];
      else {
        var i, s = this.elements.length;
        for (i = 0; i < s; i += 1)
          if (this.elements[i].data.nm === t) {
            r = this.elements[i];
            break;
          }
      }
      return e.length === 0 ? r : r.getElementByPath(e);
    }, BaseRenderer.prototype.setupGlobalData = function(e, t) {
      this.globalData.fontManager = new FontManager(), this.globalData.slotManager = slotFactory(e), this.globalData.fontManager.addChars(e.chars), this.globalData.fontManager.addFonts(e.fonts, t), this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem), this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem), this.globalData.imageLoader = this.animationItem.imagePreloader, this.globalData.audioController = this.animationItem.audioController, this.globalData.frameId = 0, this.globalData.frameRate = e.fr, this.globalData.nm = e.nm, this.globalData.compSize = {
        w: e.w,
        h: e.h
      };
    };
    var effectTypes = {
      TRANSFORM_EFFECT: "transformEFfect"
    };
    function TransformElement() {
    }
    TransformElement.prototype = {
      initTransform: function() {
        var t = new Matrix();
        this.finalTransform = {
          mProp: this.data.ks ? TransformPropertyFactory.getTransformProperty(this, this.data.ks, this) : {
            o: 0
          },
          _matMdf: !1,
          _localMatMdf: !1,
          _opMdf: !1,
          mat: t,
          localMat: t,
          localOpacity: 1
        }, this.data.ao && (this.finalTransform.mProp.autoOriented = !0);
      },
      renderTransform: function() {
        if (this.finalTransform._opMdf = this.finalTransform.mProp.o._mdf || this._isFirstFrame, this.finalTransform._matMdf = this.finalTransform.mProp._mdf || this._isFirstFrame, this.hierarchy) {
          var t, r = this.finalTransform.mat, i = 0, s = this.hierarchy.length;
          if (!this.finalTransform._matMdf)
            for (; i < s; ) {
              if (this.hierarchy[i].finalTransform.mProp._mdf) {
                this.finalTransform._matMdf = !0;
                break;
              }
              i += 1;
            }
          if (this.finalTransform._matMdf)
            for (t = this.finalTransform.mProp.v.props, r.cloneFromProps(t), i = 0; i < s; i += 1)
              r.multiply(this.hierarchy[i].finalTransform.mProp.v);
        }
        this.finalTransform._matMdf && (this.finalTransform._localMatMdf = this.finalTransform._matMdf), this.finalTransform._opMdf && (this.finalTransform.localOpacity = this.finalTransform.mProp.o.v);
      },
      renderLocalTransform: function() {
        if (this.localTransforms) {
          var t = 0, r = this.localTransforms.length;
          if (this.finalTransform._localMatMdf = this.finalTransform._matMdf, !this.finalTransform._localMatMdf || !this.finalTransform._opMdf)
            for (; t < r; )
              this.localTransforms[t]._mdf && (this.finalTransform._localMatMdf = !0), this.localTransforms[t]._opMdf && !this.finalTransform._opMdf && (this.finalTransform.localOpacity = this.finalTransform.mProp.o.v, this.finalTransform._opMdf = !0), t += 1;
          if (this.finalTransform._localMatMdf) {
            var i = this.finalTransform.localMat;
            for (this.localTransforms[0].matrix.clone(i), t = 1; t < r; t += 1) {
              var s = this.localTransforms[t].matrix;
              i.multiply(s);
            }
            i.multiply(this.finalTransform.mat);
          }
          if (this.finalTransform._opMdf) {
            var a = this.finalTransform.localOpacity;
            for (t = 0; t < r; t += 1)
              a *= this.localTransforms[t].opacity * 0.01;
            this.finalTransform.localOpacity = a;
          }
        }
      },
      searchEffectTransforms: function() {
        if (this.renderableEffectsManager) {
          var t = this.renderableEffectsManager.getEffects(effectTypes.TRANSFORM_EFFECT);
          if (t.length) {
            this.localTransforms = [], this.finalTransform.localMat = new Matrix();
            var r = 0, i = t.length;
            for (r = 0; r < i; r += 1)
              this.localTransforms.push(t[r]);
          }
        }
      },
      globalToLocal: function(t) {
        var r = [];
        r.push(this.finalTransform);
        for (var i = !0, s = this.comp; i; )
          s.finalTransform ? (s.data.hasMask && r.splice(0, 0, s.finalTransform), s = s.comp) : i = !1;
        var a, n = r.length, l;
        for (a = 0; a < n; a += 1)
          l = r[a].mat.applyToPointArray(0, 0, 0), t = [t[0] - l[0], t[1] - l[1], 0];
        return t;
      },
      mHelper: new Matrix()
    };
    function MaskElement(e, t, r) {
      this.data = e, this.element = t, this.globalData = r, this.storedData = [], this.masksProperties = this.data.masksProperties || [], this.maskElement = null;
      var i = this.globalData.defs, s, a = this.masksProperties ? this.masksProperties.length : 0;
      this.viewData = createSizedArray(a), this.solidPath = "";
      var n, l = this.masksProperties, o = 0, p = [], y, S, u = createElementID(), P, b, d, C, c = "clipPath", m = "clip-path";
      for (s = 0; s < a; s += 1)
        if ((l[s].mode !== "a" && l[s].mode !== "n" || l[s].inv || l[s].o.k !== 100 || l[s].o.x) && (c = "mask", m = "mask"), (l[s].mode === "s" || l[s].mode === "i") && o === 0 ? (P = createNS("rect"), P.setAttribute("fill", "#ffffff"), P.setAttribute("width", this.element.comp.data.w || 0), P.setAttribute("height", this.element.comp.data.h || 0), p.push(P)) : P = null, n = createNS("path"), l[s].mode === "n")
          this.viewData[s] = {
            op: PropertyFactory.getProp(this.element, l[s].o, 0, 0.01, this.element),
            prop: ShapePropertyFactory.getShapeProp(this.element, l[s], 3),
            elem: n,
            lastPath: ""
          }, i.appendChild(n);
        else {
          o += 1, n.setAttribute("fill", l[s].mode === "s" ? "#000000" : "#ffffff"), n.setAttribute("clip-rule", "nonzero");
          var f;
          if (l[s].x.k !== 0 ? (c = "mask", m = "mask", C = PropertyFactory.getProp(this.element, l[s].x, 0, null, this.element), f = createElementID(), b = createNS("filter"), b.setAttribute("id", f), d = createNS("feMorphology"), d.setAttribute("operator", "erode"), d.setAttribute("in", "SourceGraphic"), d.setAttribute("radius", "0"), b.appendChild(d), i.appendChild(b), n.setAttribute("stroke", l[s].mode === "s" ? "#000000" : "#ffffff")) : (d = null, C = null), this.storedData[s] = {
            elem: n,
            x: C,
            expan: d,
            lastPath: "",
            lastOperator: "",
            filterId: f,
            lastRadius: 0
          }, l[s].mode === "i") {
            S = p.length;
            var g = createNS("g");
            for (y = 0; y < S; y += 1)
              g.appendChild(p[y]);
            var E = createNS("mask");
            E.setAttribute("mask-type", "alpha"), E.setAttribute("id", u + "_" + o), E.appendChild(n), i.appendChild(E), g.setAttribute("mask", "url(" + getLocationHref() + "#" + u + "_" + o + ")"), p.length = 0, p.push(g);
          } else
            p.push(n);
          l[s].inv && !this.solidPath && (this.solidPath = this.createLayerSolidPath()), this.viewData[s] = {
            elem: n,
            lastPath: "",
            op: PropertyFactory.getProp(this.element, l[s].o, 0, 0.01, this.element),
            prop: ShapePropertyFactory.getShapeProp(this.element, l[s], 3),
            invRect: P
          }, this.viewData[s].prop.k || this.drawPath(l[s], this.viewData[s].prop.v, this.viewData[s]);
        }
      for (this.maskElement = createNS(c), a = p.length, s = 0; s < a; s += 1)
        this.maskElement.appendChild(p[s]);
      o > 0 && (this.maskElement.setAttribute("id", u), this.element.maskedElement.setAttribute(m, "url(" + getLocationHref() + "#" + u + ")"), i.appendChild(this.maskElement)), this.viewData.length && this.element.addRenderableComponent(this);
    }
    MaskElement.prototype.getMaskProperty = function(e) {
      return this.viewData[e].prop;
    }, MaskElement.prototype.renderFrame = function(e) {
      var t = this.element.finalTransform.mat, r, i = this.masksProperties.length;
      for (r = 0; r < i; r += 1)
        if ((this.viewData[r].prop._mdf || e) && this.drawPath(this.masksProperties[r], this.viewData[r].prop.v, this.viewData[r]), (this.viewData[r].op._mdf || e) && this.viewData[r].elem.setAttribute("fill-opacity", this.viewData[r].op.v), this.masksProperties[r].mode !== "n" && (this.viewData[r].invRect && (this.element.finalTransform.mProp._mdf || e) && this.viewData[r].invRect.setAttribute("transform", t.getInverseMatrix().to2dCSS()), this.storedData[r].x && (this.storedData[r].x._mdf || e))) {
          var s = this.storedData[r].expan;
          this.storedData[r].x.v < 0 ? (this.storedData[r].lastOperator !== "erode" && (this.storedData[r].lastOperator = "erode", this.storedData[r].elem.setAttribute("filter", "url(" + getLocationHref() + "#" + this.storedData[r].filterId + ")")), s.setAttribute("radius", -this.storedData[r].x.v)) : (this.storedData[r].lastOperator !== "dilate" && (this.storedData[r].lastOperator = "dilate", this.storedData[r].elem.setAttribute("filter", null)), this.storedData[r].elem.setAttribute("stroke-width", this.storedData[r].x.v * 2));
        }
    }, MaskElement.prototype.getMaskelement = function() {
      return this.maskElement;
    }, MaskElement.prototype.createLayerSolidPath = function() {
      var e = "M0,0 ";
      return e += " h" + this.globalData.compSize.w, e += " v" + this.globalData.compSize.h, e += " h-" + this.globalData.compSize.w, e += " v-" + this.globalData.compSize.h + " ", e;
    }, MaskElement.prototype.drawPath = function(e, t, r) {
      var i = " M" + t.v[0][0] + "," + t.v[0][1], s, a;
      for (a = t._length, s = 1; s < a; s += 1)
        i += " C" + t.o[s - 1][0] + "," + t.o[s - 1][1] + " " + t.i[s][0] + "," + t.i[s][1] + " " + t.v[s][0] + "," + t.v[s][1];
      if (t.c && a > 1 && (i += " C" + t.o[s - 1][0] + "," + t.o[s - 1][1] + " " + t.i[0][0] + "," + t.i[0][1] + " " + t.v[0][0] + "," + t.v[0][1]), r.lastPath !== i) {
        var n = "";
        r.elem && (t.c && (n = e.inv ? this.solidPath + i : i), r.elem.setAttribute("d", n)), r.lastPath = i;
      }
    }, MaskElement.prototype.destroy = function() {
      this.element = null, this.globalData = null, this.maskElement = null, this.data = null, this.masksProperties = null;
    };
    var filtersFactory = function() {
      var e = {};
      e.createFilter = t, e.createAlphaToLuminanceFilter = r;
      function t(i, s) {
        var a = createNS("filter");
        return a.setAttribute("id", i), s !== !0 && (a.setAttribute("filterUnits", "objectBoundingBox"), a.setAttribute("x", "0%"), a.setAttribute("y", "0%"), a.setAttribute("width", "100%"), a.setAttribute("height", "100%")), a;
      }
      function r() {
        var i = createNS("feColorMatrix");
        return i.setAttribute("type", "matrix"), i.setAttribute("color-interpolation-filters", "sRGB"), i.setAttribute("values", "0 0 0 1 0  0 0 0 1 0  0 0 0 1 0  0 0 0 1 1"), i;
      }
      return e;
    }(), featureSupport = function() {
      var e = {
        maskType: !0,
        svgLumaHidden: !0,
        offscreenCanvas: typeof OffscreenCanvas < "u"
      };
      return (/MSIE 10/i.test(navigator.userAgent) || /MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent) || /Edge\/\d./i.test(navigator.userAgent)) && (e.maskType = !1), /firefox/i.test(navigator.userAgent) && (e.svgLumaHidden = !1), e;
    }(), registeredEffects$1 = {}, idPrefix = "filter_result_";
    function SVGEffects(e) {
      var t, r = "SourceGraphic", i = e.data.ef ? e.data.ef.length : 0, s = createElementID(), a = filtersFactory.createFilter(s, !0), n = 0;
      this.filters = [];
      var l;
      for (t = 0; t < i; t += 1) {
        l = null;
        var o = e.data.ef[t].ty;
        if (registeredEffects$1[o]) {
          var p = registeredEffects$1[o].effect;
          l = new p(a, e.effectsManager.effectElements[t], e, idPrefix + n, r), r = idPrefix + n, registeredEffects$1[o].countsAsEffect && (n += 1);
        }
        l && this.filters.push(l);
      }
      n && (e.globalData.defs.appendChild(a), e.layerElement.setAttribute("filter", "url(" + getLocationHref() + "#" + s + ")")), this.filters.length && e.addRenderableComponent(this);
    }
    SVGEffects.prototype.renderFrame = function(e) {
      var t, r = this.filters.length;
      for (t = 0; t < r; t += 1)
        this.filters[t].renderFrame(e);
    }, SVGEffects.prototype.getEffects = function(e) {
      var t, r = this.filters.length, i = [];
      for (t = 0; t < r; t += 1)
        this.filters[t].type === e && i.push(this.filters[t]);
      return i;
    };
    function registerEffect$1(e, t, r) {
      registeredEffects$1[e] = {
        effect: t,
        countsAsEffect: r
      };
    }
    function SVGBaseElement() {
    }
    SVGBaseElement.prototype = {
      initRendererElement: function() {
        this.layerElement = createNS("g");
      },
      createContainerElements: function() {
        this.matteElement = createNS("g"), this.transformedElement = this.layerElement, this.maskedElement = this.layerElement, this._sizeChanged = !1;
        var t = null;
        if (this.data.td) {
          this.matteMasks = {};
          var r = createNS("g");
          r.setAttribute("id", this.layerId), r.appendChild(this.layerElement), t = r, this.globalData.defs.appendChild(r);
        } else
          this.data.tt ? (this.matteElement.appendChild(this.layerElement), t = this.matteElement, this.baseElement = this.matteElement) : this.baseElement = this.layerElement;
        if (this.data.ln && this.layerElement.setAttribute("id", this.data.ln), this.data.cl && this.layerElement.setAttribute("class", this.data.cl), this.data.ty === 0 && !this.data.hd) {
          var i = createNS("clipPath"), s = createNS("path");
          s.setAttribute("d", "M0,0 L" + this.data.w + ",0 L" + this.data.w + "," + this.data.h + " L0," + this.data.h + "z");
          var a = createElementID();
          if (i.setAttribute("id", a), i.appendChild(s), this.globalData.defs.appendChild(i), this.checkMasks()) {
            var n = createNS("g");
            n.setAttribute("clip-path", "url(" + getLocationHref() + "#" + a + ")"), n.appendChild(this.layerElement), this.transformedElement = n, t ? t.appendChild(this.transformedElement) : this.baseElement = this.transformedElement;
          } else
            this.layerElement.setAttribute("clip-path", "url(" + getLocationHref() + "#" + a + ")");
        }
        this.data.bm !== 0 && this.setBlendMode();
      },
      renderElement: function() {
        this.finalTransform._localMatMdf && this.transformedElement.setAttribute("transform", this.finalTransform.localMat.to2dCSS()), this.finalTransform._opMdf && this.transformedElement.setAttribute("opacity", this.finalTransform.localOpacity);
      },
      destroyBaseElement: function() {
        this.layerElement = null, this.matteElement = null, this.maskManager.destroy();
      },
      getBaseElement: function() {
        return this.data.hd ? null : this.baseElement;
      },
      createRenderableComponents: function() {
        this.maskManager = new MaskElement(this.data, this, this.globalData), this.renderableEffectsManager = new SVGEffects(this), this.searchEffectTransforms();
      },
      getMatte: function(t) {
        if (this.matteMasks || (this.matteMasks = {}), !this.matteMasks[t]) {
          var r = this.layerId + "_" + t, i, s, a, n;
          if (t === 1 || t === 3) {
            var l = createNS("mask");
            l.setAttribute("id", r), l.setAttribute("mask-type", t === 3 ? "luminance" : "alpha"), a = createNS("use"), a.setAttributeNS("http://www.w3.org/1999/xlink", "href", "#" + this.layerId), l.appendChild(a), this.globalData.defs.appendChild(l), !featureSupport.maskType && t === 1 && (l.setAttribute("mask-type", "luminance"), i = createElementID(), s = filtersFactory.createFilter(i), this.globalData.defs.appendChild(s), s.appendChild(filtersFactory.createAlphaToLuminanceFilter()), n = createNS("g"), n.appendChild(a), l.appendChild(n), n.setAttribute("filter", "url(" + getLocationHref() + "#" + i + ")"));
          } else if (t === 2) {
            var o = createNS("mask");
            o.setAttribute("id", r), o.setAttribute("mask-type", "alpha");
            var p = createNS("g");
            o.appendChild(p), i = createElementID(), s = filtersFactory.createFilter(i);
            var y = createNS("feComponentTransfer");
            y.setAttribute("in", "SourceGraphic"), s.appendChild(y);
            var S = createNS("feFuncA");
            S.setAttribute("type", "table"), S.setAttribute("tableValues", "1.0 0.0"), y.appendChild(S), this.globalData.defs.appendChild(s);
            var u = createNS("rect");
            u.setAttribute("width", this.comp.data.w), u.setAttribute("height", this.comp.data.h), u.setAttribute("x", "0"), u.setAttribute("y", "0"), u.setAttribute("fill", "#ffffff"), u.setAttribute("opacity", "0"), p.setAttribute("filter", "url(" + getLocationHref() + "#" + i + ")"), p.appendChild(u), a = createNS("use"), a.setAttributeNS("http://www.w3.org/1999/xlink", "href", "#" + this.layerId), p.appendChild(a), featureSupport.maskType || (o.setAttribute("mask-type", "luminance"), s.appendChild(filtersFactory.createAlphaToLuminanceFilter()), n = createNS("g"), p.appendChild(u), n.appendChild(this.layerElement), p.appendChild(n)), this.globalData.defs.appendChild(o);
          }
          this.matteMasks[t] = r;
        }
        return this.matteMasks[t];
      },
      setMatte: function(t) {
        this.matteElement && this.matteElement.setAttribute("mask", "url(" + getLocationHref() + "#" + t + ")");
      }
    };
    function HierarchyElement() {
    }
    HierarchyElement.prototype = {
      /**
         * @function
         * Initializes hierarchy properties
         *
         */
      initHierarchy: function() {
        this.hierarchy = [], this._isParent = !1, this.checkParenting();
      },
      /**
         * @function
         * Sets layer's hierarchy.
         * @param {array} hierarch
         * layer's parent list
         *
         */
      setHierarchy: function(t) {
        this.hierarchy = t;
      },
      /**
         * @function
         * Sets layer as parent.
         *
         */
      setAsParent: function() {
        this._isParent = !0;
      },
      /**
         * @function
         * Searches layer's parenting chain
         *
         */
      checkParenting: function() {
        this.data.parent !== void 0 && this.comp.buildElementParenting(this, this.data.parent, []);
      }
    };
    function RenderableDOMElement() {
    }
    (function() {
      var e = {
        initElement: function(r, i, s) {
          this.initFrame(), this.initBaseData(r, i, s), this.initTransform(r, i, s), this.initHierarchy(), this.initRenderable(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), this.createContent(), this.hide();
        },
        hide: function() {
          if (!this.hidden && (!this.isInRange || this.isTransparent)) {
            var r = this.baseElement || this.layerElement;
            r.style.display = "none", this.hidden = !0;
          }
        },
        show: function() {
          if (this.isInRange && !this.isTransparent) {
            if (!this.data.hd) {
              var r = this.baseElement || this.layerElement;
              r.style.display = "block";
            }
            this.hidden = !1, this._isFirstFrame = !0;
          }
        },
        renderFrame: function() {
          this.data.hd || this.hidden || (this.renderTransform(), this.renderRenderable(), this.renderLocalTransform(), this.renderElement(), this.renderInnerContent(), this._isFirstFrame && (this._isFirstFrame = !1));
        },
        renderInnerContent: function() {
        },
        prepareFrame: function(r) {
          this._mdf = !1, this.prepareRenderableFrame(r), this.prepareProperties(r, this.isInRange), this.checkTransparency();
        },
        destroy: function() {
          this.innerElem = null, this.destroyBaseElement();
        }
      };
      extendPrototype([RenderableElement, createProxyFunction(e)], RenderableDOMElement);
    })();
    function IImageElement(e, t, r) {
      this.assetData = t.getAssetData(e.refId), this.assetData && this.assetData.sid && (this.assetData = t.slotManager.getProp(this.assetData)), this.initElement(e, t, r), this.sourceRect = {
        top: 0,
        left: 0,
        width: this.assetData.w,
        height: this.assetData.h
      };
    }
    extendPrototype([BaseElement, TransformElement, SVGBaseElement, HierarchyElement, FrameElement, RenderableDOMElement], IImageElement), IImageElement.prototype.createContent = function() {
      var e = this.globalData.getAssetsPath(this.assetData);
      this.innerElem = createNS("image"), this.innerElem.setAttribute("width", this.assetData.w + "px"), this.innerElem.setAttribute("height", this.assetData.h + "px"), this.innerElem.setAttribute("preserveAspectRatio", this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio), this.innerElem.setAttributeNS("http://www.w3.org/1999/xlink", "href", e), this.layerElement.appendChild(this.innerElem);
    }, IImageElement.prototype.sourceRectAtTime = function() {
      return this.sourceRect;
    };
    function ProcessedElement(e, t) {
      this.elem = e, this.pos = t;
    }
    function IShapeElement() {
    }
    IShapeElement.prototype = {
      addShapeToModifiers: function(t) {
        var r, i = this.shapeModifiers.length;
        for (r = 0; r < i; r += 1)
          this.shapeModifiers[r].addShape(t);
      },
      isShapeInAnimatedModifiers: function(t) {
        for (var r = 0, i = this.shapeModifiers.length; r < i; )
          if (this.shapeModifiers[r].isAnimatedWithShape(t))
            return !0;
        return !1;
      },
      renderModifiers: function() {
        if (this.shapeModifiers.length) {
          var t, r = this.shapes.length;
          for (t = 0; t < r; t += 1)
            this.shapes[t].sh.reset();
          r = this.shapeModifiers.length;
          var i;
          for (t = r - 1; t >= 0 && (i = this.shapeModifiers[t].processShapes(this._isFirstFrame), !i); t -= 1)
            ;
        }
      },
      searchProcessedElement: function(t) {
        for (var r = this.processedElements, i = 0, s = r.length; i < s; ) {
          if (r[i].elem === t)
            return r[i].pos;
          i += 1;
        }
        return 0;
      },
      addProcessedElement: function(t, r) {
        for (var i = this.processedElements, s = i.length; s; )
          if (s -= 1, i[s].elem === t) {
            i[s].pos = r;
            return;
          }
        i.push(new ProcessedElement(t, r));
      },
      prepareFrame: function(t) {
        this.prepareRenderableFrame(t), this.prepareProperties(t, this.isInRange);
      }
    };
    var lineCapEnum = {
      1: "butt",
      2: "round",
      3: "square"
    }, lineJoinEnum = {
      1: "miter",
      2: "round",
      3: "bevel"
    };
    function SVGShapeData(e, t, r) {
      this.caches = [], this.styles = [], this.transformers = e, this.lStr = "", this.sh = r, this.lvl = t, this._isAnimated = !!r.k;
      for (var i = 0, s = e.length; i < s; ) {
        if (e[i].mProps.dynamicProperties.length) {
          this._isAnimated = !0;
          break;
        }
        i += 1;
      }
    }
    SVGShapeData.prototype.setAsAnimated = function() {
      this._isAnimated = !0;
    };
    function SVGStyleData(e, t) {
      this.data = e, this.type = e.ty, this.d = "", this.lvl = t, this._mdf = !1, this.closed = e.hd === !0, this.pElem = createNS("path"), this.msElem = null;
    }
    SVGStyleData.prototype.reset = function() {
      this.d = "", this._mdf = !1;
    };
    function DashProperty(e, t, r, i) {
      this.elem = e, this.frameId = -1, this.dataProps = createSizedArray(t.length), this.renderer = r, this.k = !1, this.dashStr = "", this.dashArray = createTypedArray("float32", t.length ? t.length - 1 : 0), this.dashoffset = createTypedArray("float32", 1), this.initDynamicPropertyContainer(i);
      var s, a = t.length || 0, n;
      for (s = 0; s < a; s += 1)
        n = PropertyFactory.getProp(e, t[s].v, 0, 0, this), this.k = n.k || this.k, this.dataProps[s] = {
          n: t[s].n,
          p: n
        };
      this.k || this.getValue(!0), this._isAnimated = this.k;
    }
    DashProperty.prototype.getValue = function(e) {
      if (!(this.elem.globalData.frameId === this.frameId && !e) && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf = this._mdf || e, this._mdf)) {
        var t = 0, r = this.dataProps.length;
        for (this.renderer === "svg" && (this.dashStr = ""), t = 0; t < r; t += 1)
          this.dataProps[t].n !== "o" ? this.renderer === "svg" ? this.dashStr += " " + this.dataProps[t].p.v : this.dashArray[t] = this.dataProps[t].p.v : this.dashoffset[0] = this.dataProps[t].p.v;
      }
    }, extendPrototype([DynamicPropertyContainer], DashProperty);
    function SVGStrokeStyleData(e, t, r) {
      this.initDynamicPropertyContainer(e), this.getValue = this.iterateDynamicProperties, this.o = PropertyFactory.getProp(e, t.o, 0, 0.01, this), this.w = PropertyFactory.getProp(e, t.w, 0, null, this), this.d = new DashProperty(e, t.d || {}, "svg", this), this.c = PropertyFactory.getProp(e, t.c, 1, 255, this), this.style = r, this._isAnimated = !!this._isAnimated;
    }
    extendPrototype([DynamicPropertyContainer], SVGStrokeStyleData);
    function SVGFillStyleData(e, t, r) {
      this.initDynamicPropertyContainer(e), this.getValue = this.iterateDynamicProperties, this.o = PropertyFactory.getProp(e, t.o, 0, 0.01, this), this.c = PropertyFactory.getProp(e, t.c, 1, 255, this), this.style = r;
    }
    extendPrototype([DynamicPropertyContainer], SVGFillStyleData);
    function SVGNoStyleData(e, t, r) {
      this.initDynamicPropertyContainer(e), this.getValue = this.iterateDynamicProperties, this.style = r;
    }
    extendPrototype([DynamicPropertyContainer], SVGNoStyleData);
    function GradientProperty(e, t, r) {
      this.data = t, this.c = createTypedArray("uint8c", t.p * 4);
      var i = t.k.k[0].s ? t.k.k[0].s.length - t.p * 4 : t.k.k.length - t.p * 4;
      this.o = createTypedArray("float32", i), this._cmdf = !1, this._omdf = !1, this._collapsable = this.checkCollapsable(), this._hasOpacity = i, this.initDynamicPropertyContainer(r), this.prop = PropertyFactory.getProp(e, t.k, 1, null, this), this.k = this.prop.k, this.getValue(!0);
    }
    GradientProperty.prototype.comparePoints = function(e, t) {
      for (var r = 0, i = this.o.length / 2, s; r < i; ) {
        if (s = Math.abs(e[r * 4] - e[t * 4 + r * 2]), s > 0.01)
          return !1;
        r += 1;
      }
      return !0;
    }, GradientProperty.prototype.checkCollapsable = function() {
      if (this.o.length / 2 !== this.c.length / 4)
        return !1;
      if (this.data.k.k[0].s)
        for (var e = 0, t = this.data.k.k.length; e < t; ) {
          if (!this.comparePoints(this.data.k.k[e].s, this.data.p))
            return !1;
          e += 1;
        }
      else if (!this.comparePoints(this.data.k.k, this.data.p))
        return !1;
      return !0;
    }, GradientProperty.prototype.getValue = function(e) {
      if (this.prop.getValue(), this._mdf = !1, this._cmdf = !1, this._omdf = !1, this.prop._mdf || e) {
        var t, r = this.data.p * 4, i, s;
        for (t = 0; t < r; t += 1)
          i = t % 4 === 0 ? 100 : 255, s = Math.round(this.prop.v[t] * i), this.c[t] !== s && (this.c[t] = s, this._cmdf = !e);
        if (this.o.length)
          for (r = this.prop.v.length, t = this.data.p * 4; t < r; t += 1)
            i = t % 2 === 0 ? 100 : 1, s = t % 2 === 0 ? Math.round(this.prop.v[t] * 100) : this.prop.v[t], this.o[t - this.data.p * 4] !== s && (this.o[t - this.data.p * 4] = s, this._omdf = !e);
        this._mdf = !e;
      }
    }, extendPrototype([DynamicPropertyContainer], GradientProperty);
    function SVGGradientFillStyleData(e, t, r) {
      this.initDynamicPropertyContainer(e), this.getValue = this.iterateDynamicProperties, this.initGradientData(e, t, r);
    }
    SVGGradientFillStyleData.prototype.initGradientData = function(e, t, r) {
      this.o = PropertyFactory.getProp(e, t.o, 0, 0.01, this), this.s = PropertyFactory.getProp(e, t.s, 1, null, this), this.e = PropertyFactory.getProp(e, t.e, 1, null, this), this.h = PropertyFactory.getProp(e, t.h || {
        k: 0
      }, 0, 0.01, this), this.a = PropertyFactory.getProp(e, t.a || {
        k: 0
      }, 0, degToRads, this), this.g = new GradientProperty(e, t.g, this), this.style = r, this.stops = [], this.setGradientData(r.pElem, t), this.setGradientOpacity(t, r), this._isAnimated = !!this._isAnimated;
    }, SVGGradientFillStyleData.prototype.setGradientData = function(e, t) {
      var r = createElementID(), i = createNS(t.t === 1 ? "linearGradient" : "radialGradient");
      i.setAttribute("id", r), i.setAttribute("spreadMethod", "pad"), i.setAttribute("gradientUnits", "userSpaceOnUse");
      var s = [], a, n, l;
      for (l = t.g.p * 4, n = 0; n < l; n += 4)
        a = createNS("stop"), i.appendChild(a), s.push(a);
      e.setAttribute(t.ty === "gf" ? "fill" : "stroke", "url(" + getLocationHref() + "#" + r + ")"), this.gf = i, this.cst = s;
    }, SVGGradientFillStyleData.prototype.setGradientOpacity = function(e, t) {
      if (this.g._hasOpacity && !this.g._collapsable) {
        var r, i, s, a = createNS("mask"), n = createNS("path");
        a.appendChild(n);
        var l = createElementID(), o = createElementID();
        a.setAttribute("id", o);
        var p = createNS(e.t === 1 ? "linearGradient" : "radialGradient");
        p.setAttribute("id", l), p.setAttribute("spreadMethod", "pad"), p.setAttribute("gradientUnits", "userSpaceOnUse"), s = e.g.k.k[0].s ? e.g.k.k[0].s.length : e.g.k.k.length;
        var y = this.stops;
        for (i = e.g.p * 4; i < s; i += 2)
          r = createNS("stop"), r.setAttribute("stop-color", "rgb(255,255,255)"), p.appendChild(r), y.push(r);
        n.setAttribute(e.ty === "gf" ? "fill" : "stroke", "url(" + getLocationHref() + "#" + l + ")"), e.ty === "gs" && (n.setAttribute("stroke-linecap", lineCapEnum[e.lc || 2]), n.setAttribute("stroke-linejoin", lineJoinEnum[e.lj || 2]), e.lj === 1 && n.setAttribute("stroke-miterlimit", e.ml)), this.of = p, this.ms = a, this.ost = y, this.maskId = o, t.msElem = n;
      }
    }, extendPrototype([DynamicPropertyContainer], SVGGradientFillStyleData);
    function SVGGradientStrokeStyleData(e, t, r) {
      this.initDynamicPropertyContainer(e), this.getValue = this.iterateDynamicProperties, this.w = PropertyFactory.getProp(e, t.w, 0, null, this), this.d = new DashProperty(e, t.d || {}, "svg", this), this.initGradientData(e, t, r), this._isAnimated = !!this._isAnimated;
    }
    extendPrototype([SVGGradientFillStyleData, DynamicPropertyContainer], SVGGradientStrokeStyleData);
    function ShapeGroupData() {
      this.it = [], this.prevViewData = [], this.gr = createNS("g");
    }
    function SVGTransformData(e, t, r) {
      this.transform = {
        mProps: e,
        op: t,
        container: r
      }, this.elements = [], this._isAnimated = this.transform.mProps.dynamicProperties.length || this.transform.op.effectsSequence.length;
    }
    var buildShapeString = function(t, r, i, s) {
      if (r === 0)
        return "";
      var a = t.o, n = t.i, l = t.v, o, p = " M" + s.applyToPointStringified(l[0][0], l[0][1]);
      for (o = 1; o < r; o += 1)
        p += " C" + s.applyToPointStringified(a[o - 1][0], a[o - 1][1]) + " " + s.applyToPointStringified(n[o][0], n[o][1]) + " " + s.applyToPointStringified(l[o][0], l[o][1]);
      return i && r && (p += " C" + s.applyToPointStringified(a[o - 1][0], a[o - 1][1]) + " " + s.applyToPointStringified(n[0][0], n[0][1]) + " " + s.applyToPointStringified(l[0][0], l[0][1]), p += "z"), p;
    }, SVGElementsRenderer = function() {
      var e = new Matrix(), t = new Matrix(), r = {
        createRenderFunction: i
      };
      function i(S) {
        switch (S.ty) {
          case "fl":
            return l;
          case "gf":
            return p;
          case "gs":
            return o;
          case "st":
            return y;
          case "sh":
          case "el":
          case "rc":
          case "sr":
            return n;
          case "tr":
            return s;
          case "no":
            return a;
          default:
            return null;
        }
      }
      function s(S, u, P) {
        (P || u.transform.op._mdf) && u.transform.container.setAttribute("opacity", u.transform.op.v), (P || u.transform.mProps._mdf) && u.transform.container.setAttribute("transform", u.transform.mProps.v.to2dCSS());
      }
      function a() {
      }
      function n(S, u, P) {
        var b, d, C, c, m, f, g = u.styles.length, E = u.lvl, A, k, M, L;
        for (f = 0; f < g; f += 1) {
          if (c = u.sh._mdf || P, u.styles[f].lvl < E) {
            for (k = t.reset(), M = E - u.styles[f].lvl, L = u.transformers.length - 1; !c && M > 0; )
              c = u.transformers[L].mProps._mdf || c, M -= 1, L -= 1;
            if (c)
              for (M = E - u.styles[f].lvl, L = u.transformers.length - 1; M > 0; )
                k.multiply(u.transformers[L].mProps.v), M -= 1, L -= 1;
          } else
            k = e;
          if (A = u.sh.paths, d = A._length, c) {
            for (C = "", b = 0; b < d; b += 1)
              m = A.shapes[b], m && m._length && (C += buildShapeString(m, m._length, m.c, k));
            u.caches[f] = C;
          } else
            C = u.caches[f];
          u.styles[f].d += S.hd === !0 ? "" : C, u.styles[f]._mdf = c || u.styles[f]._mdf;
        }
      }
      function l(S, u, P) {
        var b = u.style;
        (u.c._mdf || P) && b.pElem.setAttribute("fill", "rgb(" + bmFloor(u.c.v[0]) + "," + bmFloor(u.c.v[1]) + "," + bmFloor(u.c.v[2]) + ")"), (u.o._mdf || P) && b.pElem.setAttribute("fill-opacity", u.o.v);
      }
      function o(S, u, P) {
        p(S, u, P), y(S, u, P);
      }
      function p(S, u, P) {
        var b = u.gf, d = u.g._hasOpacity, C = u.s.v, c = u.e.v;
        if (u.o._mdf || P) {
          var m = S.ty === "gf" ? "fill-opacity" : "stroke-opacity";
          u.style.pElem.setAttribute(m, u.o.v);
        }
        if (u.s._mdf || P) {
          var f = S.t === 1 ? "x1" : "cx", g = f === "x1" ? "y1" : "cy";
          b.setAttribute(f, C[0]), b.setAttribute(g, C[1]), d && !u.g._collapsable && (u.of.setAttribute(f, C[0]), u.of.setAttribute(g, C[1]));
        }
        var E, A, k, M;
        if (u.g._cmdf || P) {
          E = u.cst;
          var L = u.g.c;
          for (k = E.length, A = 0; A < k; A += 1)
            M = E[A], M.setAttribute("offset", L[A * 4] + "%"), M.setAttribute("stop-color", "rgb(" + L[A * 4 + 1] + "," + L[A * 4 + 2] + "," + L[A * 4 + 3] + ")");
        }
        if (d && (u.g._omdf || P)) {
          var B = u.g.o;
          for (u.g._collapsable ? E = u.cst : E = u.ost, k = E.length, A = 0; A < k; A += 1)
            M = E[A], u.g._collapsable || M.setAttribute("offset", B[A * 2] + "%"), M.setAttribute("stop-opacity", B[A * 2 + 1]);
        }
        if (S.t === 1)
          (u.e._mdf || P) && (b.setAttribute("x2", c[0]), b.setAttribute("y2", c[1]), d && !u.g._collapsable && (u.of.setAttribute("x2", c[0]), u.of.setAttribute("y2", c[1])));
        else {
          var D;
          if ((u.s._mdf || u.e._mdf || P) && (D = Math.sqrt(Math.pow(C[0] - c[0], 2) + Math.pow(C[1] - c[1], 2)), b.setAttribute("r", D), d && !u.g._collapsable && u.of.setAttribute("r", D)), u.e._mdf || u.h._mdf || u.a._mdf || P) {
            D || (D = Math.sqrt(Math.pow(C[0] - c[0], 2) + Math.pow(C[1] - c[1], 2)));
            var V = Math.atan2(c[1] - C[1], c[0] - C[0]), z = u.h.v;
            z >= 1 ? z = 0.99 : z <= -1 && (z = -0.99);
            var I = D * z, R = Math.cos(V + u.a.v) * I + C[0], x = Math.sin(V + u.a.v) * I + C[1];
            b.setAttribute("fx", R), b.setAttribute("fy", x), d && !u.g._collapsable && (u.of.setAttribute("fx", R), u.of.setAttribute("fy", x));
          }
        }
      }
      function y(S, u, P) {
        var b = u.style, d = u.d;
        d && (d._mdf || P) && d.dashStr && (b.pElem.setAttribute("stroke-dasharray", d.dashStr), b.pElem.setAttribute("stroke-dashoffset", d.dashoffset[0])), u.c && (u.c._mdf || P) && b.pElem.setAttribute("stroke", "rgb(" + bmFloor(u.c.v[0]) + "," + bmFloor(u.c.v[1]) + "," + bmFloor(u.c.v[2]) + ")"), (u.o._mdf || P) && b.pElem.setAttribute("stroke-opacity", u.o.v), (u.w._mdf || P) && (b.pElem.setAttribute("stroke-width", u.w.v), b.msElem && b.msElem.setAttribute("stroke-width", u.w.v));
      }
      return r;
    }();
    function SVGShapeElement(e, t, r) {
      this.shapes = [], this.shapesData = e.shapes, this.stylesList = [], this.shapeModifiers = [], this.itemsData = [], this.processedElements = [], this.animatedContents = [], this.initElement(e, t, r), this.prevViewData = [];
    }
    extendPrototype([BaseElement, TransformElement, SVGBaseElement, IShapeElement, HierarchyElement, FrameElement, RenderableDOMElement], SVGShapeElement), SVGShapeElement.prototype.initSecondaryElement = function() {
    }, SVGShapeElement.prototype.identityMatrix = new Matrix(), SVGShapeElement.prototype.buildExpressionInterface = function() {
    }, SVGShapeElement.prototype.createContent = function() {
      this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], !0), this.filterUniqueShapes();
    }, SVGShapeElement.prototype.filterUniqueShapes = function() {
      var e, t = this.shapes.length, r, i, s = this.stylesList.length, a, n = [], l = !1;
      for (i = 0; i < s; i += 1) {
        for (a = this.stylesList[i], l = !1, n.length = 0, e = 0; e < t; e += 1)
          r = this.shapes[e], r.styles.indexOf(a) !== -1 && (n.push(r), l = r._isAnimated || l);
        n.length > 1 && l && this.setShapesAsAnimated(n);
      }
    }, SVGShapeElement.prototype.setShapesAsAnimated = function(e) {
      var t, r = e.length;
      for (t = 0; t < r; t += 1)
        e[t].setAsAnimated();
    }, SVGShapeElement.prototype.createStyleElement = function(e, t) {
      var r, i = new SVGStyleData(e, t), s = i.pElem;
      if (e.ty === "st")
        r = new SVGStrokeStyleData(this, e, i);
      else if (e.ty === "fl")
        r = new SVGFillStyleData(this, e, i);
      else if (e.ty === "gf" || e.ty === "gs") {
        var a = e.ty === "gf" ? SVGGradientFillStyleData : SVGGradientStrokeStyleData;
        r = new a(this, e, i), this.globalData.defs.appendChild(r.gf), r.maskId && (this.globalData.defs.appendChild(r.ms), this.globalData.defs.appendChild(r.of), s.setAttribute("mask", "url(" + getLocationHref() + "#" + r.maskId + ")"));
      } else
        e.ty === "no" && (r = new SVGNoStyleData(this, e, i));
      return (e.ty === "st" || e.ty === "gs") && (s.setAttribute("stroke-linecap", lineCapEnum[e.lc || 2]), s.setAttribute("stroke-linejoin", lineJoinEnum[e.lj || 2]), s.setAttribute("fill-opacity", "0"), e.lj === 1 && s.setAttribute("stroke-miterlimit", e.ml)), e.r === 2 && s.setAttribute("fill-rule", "evenodd"), e.ln && s.setAttribute("id", e.ln), e.cl && s.setAttribute("class", e.cl), e.bm && (s.style["mix-blend-mode"] = getBlendMode(e.bm)), this.stylesList.push(i), this.addToAnimatedContents(e, r), r;
    }, SVGShapeElement.prototype.createGroupElement = function(e) {
      var t = new ShapeGroupData();
      return e.ln && t.gr.setAttribute("id", e.ln), e.cl && t.gr.setAttribute("class", e.cl), e.bm && (t.gr.style["mix-blend-mode"] = getBlendMode(e.bm)), t;
    }, SVGShapeElement.prototype.createTransformElement = function(e, t) {
      var r = TransformPropertyFactory.getTransformProperty(this, e, this), i = new SVGTransformData(r, r.o, t);
      return this.addToAnimatedContents(e, i), i;
    }, SVGShapeElement.prototype.createShapeElement = function(e, t, r) {
      var i = 4;
      e.ty === "rc" ? i = 5 : e.ty === "el" ? i = 6 : e.ty === "sr" && (i = 7);
      var s = ShapePropertyFactory.getShapeProp(this, e, i, this), a = new SVGShapeData(t, r, s);
      return this.shapes.push(a), this.addShapeToModifiers(a), this.addToAnimatedContents(e, a), a;
    }, SVGShapeElement.prototype.addToAnimatedContents = function(e, t) {
      for (var r = 0, i = this.animatedContents.length; r < i; ) {
        if (this.animatedContents[r].element === t)
          return;
        r += 1;
      }
      this.animatedContents.push({
        fn: SVGElementsRenderer.createRenderFunction(e),
        element: t,
        data: e
      });
    }, SVGShapeElement.prototype.setElementStyles = function(e) {
      var t = e.styles, r, i = this.stylesList.length;
      for (r = 0; r < i; r += 1)
        this.stylesList[r].closed || t.push(this.stylesList[r]);
    }, SVGShapeElement.prototype.reloadShapes = function() {
      this._isFirstFrame = !0;
      var e, t = this.itemsData.length;
      for (e = 0; e < t; e += 1)
        this.prevViewData[e] = this.itemsData[e];
      for (this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], !0), this.filterUniqueShapes(), t = this.dynamicProperties.length, e = 0; e < t; e += 1)
        this.dynamicProperties[e].getValue();
      this.renderModifiers();
    }, SVGShapeElement.prototype.searchShapes = function(e, t, r, i, s, a, n) {
      var l = [].concat(a), o, p = e.length - 1, y, S, u = [], P = [], b, d, C;
      for (o = p; o >= 0; o -= 1) {
        if (C = this.searchProcessedElement(e[o]), C ? t[o] = r[C - 1] : e[o]._render = n, e[o].ty === "fl" || e[o].ty === "st" || e[o].ty === "gf" || e[o].ty === "gs" || e[o].ty === "no")
          C ? t[o].style.closed = !1 : t[o] = this.createStyleElement(e[o], s), e[o]._render && t[o].style.pElem.parentNode !== i && i.appendChild(t[o].style.pElem), u.push(t[o].style);
        else if (e[o].ty === "gr") {
          if (!C)
            t[o] = this.createGroupElement(e[o]);
          else
            for (S = t[o].it.length, y = 0; y < S; y += 1)
              t[o].prevViewData[y] = t[o].it[y];
          this.searchShapes(e[o].it, t[o].it, t[o].prevViewData, t[o].gr, s + 1, l, n), e[o]._render && t[o].gr.parentNode !== i && i.appendChild(t[o].gr);
        } else
          e[o].ty === "tr" ? (C || (t[o] = this.createTransformElement(e[o], i)), b = t[o].transform, l.push(b)) : e[o].ty === "sh" || e[o].ty === "rc" || e[o].ty === "el" || e[o].ty === "sr" ? (C || (t[o] = this.createShapeElement(e[o], l, s)), this.setElementStyles(t[o])) : e[o].ty === "tm" || e[o].ty === "rd" || e[o].ty === "ms" || e[o].ty === "pb" || e[o].ty === "zz" || e[o].ty === "op" ? (C ? (d = t[o], d.closed = !1) : (d = ShapeModifiers.getModifier(e[o].ty), d.init(this, e[o]), t[o] = d, this.shapeModifiers.push(d)), P.push(d)) : e[o].ty === "rp" && (C ? (d = t[o], d.closed = !0) : (d = ShapeModifiers.getModifier(e[o].ty), t[o] = d, d.init(this, e, o, t), this.shapeModifiers.push(d), n = !1), P.push(d));
        this.addProcessedElement(e[o], o + 1);
      }
      for (p = u.length, o = 0; o < p; o += 1)
        u[o].closed = !0;
      for (p = P.length, o = 0; o < p; o += 1)
        P[o].closed = !0;
    }, SVGShapeElement.prototype.renderInnerContent = function() {
      this.renderModifiers();
      var e, t = this.stylesList.length;
      for (e = 0; e < t; e += 1)
        this.stylesList[e].reset();
      for (this.renderShape(), e = 0; e < t; e += 1)
        (this.stylesList[e]._mdf || this._isFirstFrame) && (this.stylesList[e].msElem && (this.stylesList[e].msElem.setAttribute("d", this.stylesList[e].d), this.stylesList[e].d = "M0 0" + this.stylesList[e].d), this.stylesList[e].pElem.setAttribute("d", this.stylesList[e].d || "M0 0"));
    }, SVGShapeElement.prototype.renderShape = function() {
      var e, t = this.animatedContents.length, r;
      for (e = 0; e < t; e += 1)
        r = this.animatedContents[e], (this._isFirstFrame || r.element._isAnimated) && r.data !== !0 && r.fn(r.data, r.element, this._isFirstFrame);
    }, SVGShapeElement.prototype.destroy = function() {
      this.destroyBaseElement(), this.shapesData = null, this.itemsData = null;
    };
    function LetterProps(e, t, r, i, s, a) {
      this.o = e, this.sw = t, this.sc = r, this.fc = i, this.m = s, this.p = a, this._mdf = {
        o: !0,
        sw: !!t,
        sc: !!r,
        fc: !!i,
        m: !0,
        p: !0
      };
    }
    LetterProps.prototype.update = function(e, t, r, i, s, a) {
      this._mdf.o = !1, this._mdf.sw = !1, this._mdf.sc = !1, this._mdf.fc = !1, this._mdf.m = !1, this._mdf.p = !1;
      var n = !1;
      return this.o !== e && (this.o = e, this._mdf.o = !0, n = !0), this.sw !== t && (this.sw = t, this._mdf.sw = !0, n = !0), this.sc !== r && (this.sc = r, this._mdf.sc = !0, n = !0), this.fc !== i && (this.fc = i, this._mdf.fc = !0, n = !0), this.m !== s && (this.m = s, this._mdf.m = !0, n = !0), a.length && (this.p[0] !== a[0] || this.p[1] !== a[1] || this.p[4] !== a[4] || this.p[5] !== a[5] || this.p[12] !== a[12] || this.p[13] !== a[13]) && (this.p = a, this._mdf.p = !0, n = !0), n;
    };
    function TextProperty(e, t) {
      this._frameId = initialDefaultFrame, this.pv = "", this.v = "", this.kf = !1, this._isFirstFrame = !0, this._mdf = !1, t.d && t.d.sid && (t.d = e.globalData.slotManager.getProp(t.d)), this.data = t, this.elem = e, this.comp = this.elem.comp, this.keysIndex = 0, this.canResize = !1, this.minimumFontSize = 1, this.effectsSequence = [], this.currentData = {
        ascent: 0,
        boxWidth: this.defaultBoxWidth,
        f: "",
        fStyle: "",
        fWeight: "",
        fc: "",
        j: "",
        justifyOffset: "",
        l: [],
        lh: 0,
        lineWidths: [],
        ls: "",
        of: "",
        s: "",
        sc: "",
        sw: 0,
        t: 0,
        tr: 0,
        sz: 0,
        ps: null,
        fillColorAnim: !1,
        strokeColorAnim: !1,
        strokeWidthAnim: !1,
        yOffset: 0,
        finalSize: 0,
        finalText: [],
        finalLineHeight: 0,
        __complete: !1
      }, this.copyData(this.currentData, this.data.d.k[0].s), this.searchProperty() || this.completeTextData(this.currentData);
    }
    TextProperty.prototype.defaultBoxWidth = [0, 0], TextProperty.prototype.copyData = function(e, t) {
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
      return e;
    }, TextProperty.prototype.setCurrentData = function(e) {
      e.__complete || this.completeTextData(e), this.currentData = e, this.currentData.boxWidth = this.currentData.boxWidth || this.defaultBoxWidth, this._mdf = !0;
    }, TextProperty.prototype.searchProperty = function() {
      return this.searchKeyframes();
    }, TextProperty.prototype.searchKeyframes = function() {
      return this.kf = this.data.d.k.length > 1, this.kf && this.addEffect(this.getKeyframeValue.bind(this)), this.kf;
    }, TextProperty.prototype.addEffect = function(e) {
      this.effectsSequence.push(e), this.elem.addDynamicProperty(this);
    }, TextProperty.prototype.getValue = function(e) {
      if (!((this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length) && !e)) {
        this.currentData.t = this.data.d.k[this.keysIndex].s.t;
        var t = this.currentData, r = this.keysIndex;
        if (this.lock) {
          this.setCurrentData(this.currentData);
          return;
        }
        this.lock = !0, this._mdf = !1;
        var i, s = this.effectsSequence.length, a = e || this.data.d.k[this.keysIndex].s;
        for (i = 0; i < s; i += 1)
          r !== this.keysIndex ? a = this.effectsSequence[i](a, a.t) : a = this.effectsSequence[i](this.currentData, a.t);
        t !== a && this.setCurrentData(a), this.v = this.currentData, this.pv = this.v, this.lock = !1, this.frameId = this.elem.globalData.frameId;
      }
    }, TextProperty.prototype.getKeyframeValue = function() {
      for (var e = this.data.d.k, t = this.elem.comp.renderedFrame, r = 0, i = e.length; r <= i - 1 && !(r === i - 1 || e[r + 1].t > t); )
        r += 1;
      return this.keysIndex !== r && (this.keysIndex = r), this.data.d.k[this.keysIndex].s;
    }, TextProperty.prototype.buildFinalText = function(e) {
      for (var t = [], r = 0, i = e.length, s, a, n = !1, l = !1, o = ""; r < i; )
        n = l, l = !1, s = e.charCodeAt(r), o = e.charAt(r), FontManager.isCombinedCharacter(s) ? n = !0 : s >= 55296 && s <= 56319 ? FontManager.isRegionalFlag(e, r) ? o = e.substr(r, 14) : (a = e.charCodeAt(r + 1), a >= 56320 && a <= 57343 && (FontManager.isModifier(s, a) ? (o = e.substr(r, 2), n = !0) : FontManager.isFlagEmoji(e.substr(r, 4)) ? o = e.substr(r, 4) : o = e.substr(r, 2))) : s > 56319 ? (a = e.charCodeAt(r + 1), FontManager.isVariationSelector(s) && (n = !0)) : FontManager.isZeroWidthJoiner(s) && (n = !0, l = !0), n ? (t[t.length - 1] += o, n = !1) : t.push(o), r += o.length;
      return t;
    }, TextProperty.prototype.completeTextData = function(e) {
      e.__complete = !0;
      var t = this.elem.globalData.fontManager, r = this.data, i = [], s, a, n, l = 0, o, p = r.m.g, y = 0, S = 0, u = 0, P = [], b = 0, d = 0, C, c, m = t.getFontByName(e.f), f, g = 0, E = getFontProperties(m);
      e.fWeight = E.weight, e.fStyle = E.style, e.finalSize = e.s, e.finalText = this.buildFinalText(e.t), a = e.finalText.length, e.finalLineHeight = e.lh;
      var A = e.tr / 1e3 * e.finalSize, k;
      if (e.sz)
        for (var M = !0, L = e.sz[0], B = e.sz[1], D, V; M; ) {
          V = this.buildFinalText(e.t), D = 0, b = 0, a = V.length, A = e.tr / 1e3 * e.finalSize;
          var z = -1;
          for (s = 0; s < a; s += 1)
            k = V[s].charCodeAt(0), n = !1, V[s] === " " ? z = s : (k === 13 || k === 3) && (b = 0, n = !0, D += e.finalLineHeight || e.finalSize * 1.2), t.chars ? (f = t.getCharData(V[s], m.fStyle, m.fFamily), g = n ? 0 : f.w * e.finalSize / 100) : g = t.measureText(V[s], e.f, e.finalSize), b + g > L && V[s] !== " " ? (z === -1 ? a += 1 : s = z, D += e.finalLineHeight || e.finalSize * 1.2, V.splice(s, z === s ? 1 : 0, "\r"), z = -1, b = 0) : (b += g, b += A);
          D += m.ascent * e.finalSize / 100, this.canResize && e.finalSize > this.minimumFontSize && B < D ? (e.finalSize -= 1, e.finalLineHeight = e.finalSize * e.lh / e.s) : (e.finalText = V, a = e.finalText.length, M = !1);
        }
      b = -A, g = 0;
      var I = 0, R;
      for (s = 0; s < a; s += 1)
        if (n = !1, R = e.finalText[s], k = R.charCodeAt(0), k === 13 || k === 3 ? (I = 0, P.push(b), d = b > d ? b : d, b = -2 * A, o = "", n = !0, u += 1) : o = R, t.chars ? (f = t.getCharData(R, m.fStyle, t.getFontByName(e.f).fFamily), g = n ? 0 : f.w * e.finalSize / 100) : g = t.measureText(o, e.f, e.finalSize), R === " " ? I += g + A : (b += g + A + I, I = 0), i.push({
          l: g,
          an: g,
          add: y,
          n,
          anIndexes: [],
          val: o,
          line: u,
          animatorJustifyOffset: 0
        }), p == 2) {
          if (y += g, o === "" || o === " " || s === a - 1) {
            for ((o === "" || o === " ") && (y -= g); S <= s; )
              i[S].an = y, i[S].ind = l, i[S].extra = g, S += 1;
            l += 1, y = 0;
          }
        } else if (p == 3) {
          if (y += g, o === "" || s === a - 1) {
            for (o === "" && (y -= g); S <= s; )
              i[S].an = y, i[S].ind = l, i[S].extra = g, S += 1;
            y = 0, l += 1;
          }
        } else
          i[l].ind = l, i[l].extra = 0, l += 1;
      if (e.l = i, d = b > d ? b : d, P.push(b), e.sz)
        e.boxWidth = e.sz[0], e.justifyOffset = 0;
      else
        switch (e.boxWidth = d, e.j) {
          case 1:
            e.justifyOffset = -e.boxWidth;
            break;
          case 2:
            e.justifyOffset = -e.boxWidth / 2;
            break;
          default:
            e.justifyOffset = 0;
        }
      e.lineWidths = P;
      var x = r.a, T, v;
      c = x.length;
      var _, F, w = [];
      for (C = 0; C < c; C += 1) {
        for (T = x[C], T.a.sc && (e.strokeColorAnim = !0), T.a.sw && (e.strokeWidthAnim = !0), (T.a.fc || T.a.fh || T.a.fs || T.a.fb) && (e.fillColorAnim = !0), F = 0, _ = T.s.b, s = 0; s < a; s += 1)
          v = i[s], v.anIndexes[C] = F, (_ == 1 && v.val !== "" || _ == 2 && v.val !== "" && v.val !== " " || _ == 3 && (v.n || v.val == " " || s == a - 1) || _ == 4 && (v.n || s == a - 1)) && (T.s.rn === 1 && w.push(F), F += 1);
        r.a[C].s.totalChars = F;
        var N = -1, O;
        if (T.s.rn === 1)
          for (s = 0; s < a; s += 1)
            v = i[s], N != v.anIndexes[C] && (N = v.anIndexes[C], O = w.splice(Math.floor(Math.random() * w.length), 1)[0]), v.anIndexes[C] = O;
      }
      e.yOffset = e.finalLineHeight || e.finalSize * 1.2, e.ls = e.ls || 0, e.ascent = m.ascent * e.finalSize / 100;
    }, TextProperty.prototype.updateDocumentData = function(e, t) {
      t = t === void 0 ? this.keysIndex : t;
      var r = this.copyData({}, this.data.d.k[t].s);
      r = this.copyData(r, e), this.data.d.k[t].s = r, this.recalculate(t), this.setCurrentData(r), this.elem.addDynamicProperty(this);
    }, TextProperty.prototype.recalculate = function(e) {
      var t = this.data.d.k[e].s;
      t.__complete = !1, this.keysIndex = 0, this._isFirstFrame = !0, this.getValue(t);
    }, TextProperty.prototype.canResizeFont = function(e) {
      this.canResize = e, this.recalculate(this.keysIndex), this.elem.addDynamicProperty(this);
    }, TextProperty.prototype.setMinimumFontSize = function(e) {
      this.minimumFontSize = Math.floor(e) || 1, this.recalculate(this.keysIndex), this.elem.addDynamicProperty(this);
    };
    var TextSelectorProp = function() {
      var e = Math.max, t = Math.min, r = Math.floor;
      function i(a, n) {
        this._currentTextLength = -1, this.k = !1, this.data = n, this.elem = a, this.comp = a.comp, this.finalS = 0, this.finalE = 0, this.initDynamicPropertyContainer(a), this.s = PropertyFactory.getProp(a, n.s || {
          k: 0
        }, 0, 0, this), "e" in n ? this.e = PropertyFactory.getProp(a, n.e, 0, 0, this) : this.e = {
          v: 100
        }, this.o = PropertyFactory.getProp(a, n.o || {
          k: 0
        }, 0, 0, this), this.xe = PropertyFactory.getProp(a, n.xe || {
          k: 0
        }, 0, 0, this), this.ne = PropertyFactory.getProp(a, n.ne || {
          k: 0
        }, 0, 0, this), this.sm = PropertyFactory.getProp(a, n.sm || {
          k: 100
        }, 0, 0, this), this.a = PropertyFactory.getProp(a, n.a, 0, 0.01, this), this.dynamicProperties.length || this.getValue();
      }
      i.prototype = {
        getMult: function(n) {
          this._currentTextLength !== this.elem.textProperty.currentData.l.length && this.getValue();
          var l = 0, o = 0, p = 1, y = 1;
          this.ne.v > 0 ? l = this.ne.v / 100 : o = -this.ne.v / 100, this.xe.v > 0 ? p = 1 - this.xe.v / 100 : y = 1 + this.xe.v / 100;
          var S = BezierFactory.getBezierEasing(l, o, p, y).get, u = 0, P = this.finalS, b = this.finalE, d = this.data.sh;
          if (d === 2)
            b === P ? u = n >= b ? 1 : 0 : u = e(0, t(0.5 / (b - P) + (n - P) / (b - P), 1)), u = S(u);
          else if (d === 3)
            b === P ? u = n >= b ? 0 : 1 : u = 1 - e(0, t(0.5 / (b - P) + (n - P) / (b - P), 1)), u = S(u);
          else if (d === 4)
            b === P ? u = 0 : (u = e(0, t(0.5 / (b - P) + (n - P) / (b - P), 1)), u < 0.5 ? u *= 2 : u = 1 - 2 * (u - 0.5)), u = S(u);
          else if (d === 5) {
            if (b === P)
              u = 0;
            else {
              var C = b - P;
              n = t(e(0, n + 0.5 - P), b - P);
              var c = -C / 2 + n, m = C / 2;
              u = Math.sqrt(1 - c * c / (m * m));
            }
            u = S(u);
          } else
            d === 6 ? (b === P ? u = 0 : (n = t(e(0, n + 0.5 - P), b - P), u = (1 + Math.cos(Math.PI + Math.PI * 2 * n / (b - P))) / 2), u = S(u)) : (n >= r(P) && (n - P < 0 ? u = e(0, t(t(b, 1) - (P - n), 1)) : u = e(0, t(b - n, 1))), u = S(u));
          if (this.sm.v !== 100) {
            var f = this.sm.v * 0.01;
            f === 0 && (f = 1e-8);
            var g = 0.5 - f * 0.5;
            u < g ? u = 0 : (u = (u - g) / f, u > 1 && (u = 1));
          }
          return u * this.a.v;
        },
        getValue: function(n) {
          this.iterateDynamicProperties(), this._mdf = n || this._mdf, this._currentTextLength = this.elem.textProperty.currentData.l.length || 0, n && this.data.r === 2 && (this.e.v = this._currentTextLength);
          var l = this.data.r === 2 ? 1 : 100 / this.data.totalChars, o = this.o.v / l, p = this.s.v / l + o, y = this.e.v / l + o;
          if (p > y) {
            var S = p;
            p = y, y = S;
          }
          this.finalS = p, this.finalE = y;
        }
      }, extendPrototype([DynamicPropertyContainer], i);
      function s(a, n, l) {
        return new i(a, n);
      }
      return {
        getTextSelectorProp: s
      };
    }();
    function TextAnimatorDataProperty(e, t, r) {
      var i = {
        propType: !1
      }, s = PropertyFactory.getProp, a = t.a;
      this.a = {
        r: a.r ? s(e, a.r, 0, degToRads, r) : i,
        rx: a.rx ? s(e, a.rx, 0, degToRads, r) : i,
        ry: a.ry ? s(e, a.ry, 0, degToRads, r) : i,
        sk: a.sk ? s(e, a.sk, 0, degToRads, r) : i,
        sa: a.sa ? s(e, a.sa, 0, degToRads, r) : i,
        s: a.s ? s(e, a.s, 1, 0.01, r) : i,
        a: a.a ? s(e, a.a, 1, 0, r) : i,
        o: a.o ? s(e, a.o, 0, 0.01, r) : i,
        p: a.p ? s(e, a.p, 1, 0, r) : i,
        sw: a.sw ? s(e, a.sw, 0, 0, r) : i,
        sc: a.sc ? s(e, a.sc, 1, 0, r) : i,
        fc: a.fc ? s(e, a.fc, 1, 0, r) : i,
        fh: a.fh ? s(e, a.fh, 0, 0, r) : i,
        fs: a.fs ? s(e, a.fs, 0, 0.01, r) : i,
        fb: a.fb ? s(e, a.fb, 0, 0.01, r) : i,
        t: a.t ? s(e, a.t, 0, 0, r) : i
      }, this.s = TextSelectorProp.getTextSelectorProp(e, t.s, r), this.s.t = t.s.t;
    }
    function TextAnimatorProperty(e, t, r) {
      this._isFirstFrame = !0, this._hasMaskedPath = !1, this._frameId = -1, this._textData = e, this._renderType = t, this._elem = r, this._animatorsData = createSizedArray(this._textData.a.length), this._pathData = {}, this._moreOptions = {
        alignment: {}
      }, this.renderedLetters = [], this.lettersChangedFlag = !1, this.initDynamicPropertyContainer(r);
    }
    TextAnimatorProperty.prototype.searchProperties = function() {
      var e, t = this._textData.a.length, r, i = PropertyFactory.getProp;
      for (e = 0; e < t; e += 1)
        r = this._textData.a[e], this._animatorsData[e] = new TextAnimatorDataProperty(this._elem, r, this);
      this._textData.p && "m" in this._textData.p ? (this._pathData = {
        a: i(this._elem, this._textData.p.a, 0, 0, this),
        f: i(this._elem, this._textData.p.f, 0, 0, this),
        l: i(this._elem, this._textData.p.l, 0, 0, this),
        r: i(this._elem, this._textData.p.r, 0, 0, this),
        p: i(this._elem, this._textData.p.p, 0, 0, this),
        m: this._elem.maskManager.getMaskProperty(this._textData.p.m)
      }, this._hasMaskedPath = !0) : this._hasMaskedPath = !1, this._moreOptions.alignment = i(this._elem, this._textData.m.a, 1, 0, this);
    }, TextAnimatorProperty.prototype.getMeasures = function(e, t) {
      if (this.lettersChangedFlag = t, !(!this._mdf && !this._isFirstFrame && !t && (!this._hasMaskedPath || !this._pathData.m._mdf))) {
        this._isFirstFrame = !1;
        var r = this._moreOptions.alignment.v, i = this._animatorsData, s = this._textData, a = this.mHelper, n = this._renderType, l = this.renderedLetters.length, o, p, y, S, u = e.l, P, b, d, C, c, m, f, g, E, A, k, M, L, B, D;
        if (this._hasMaskedPath) {
          if (D = this._pathData.m, !this._pathData.n || this._pathData._mdf) {
            var V = D.v;
            this._pathData.r.v && (V = V.reverse()), P = {
              tLength: 0,
              segments: []
            }, S = V._length - 1;
            var z;
            for (M = 0, y = 0; y < S; y += 1)
              z = bez.buildBezierData(V.v[y], V.v[y + 1], [V.o[y][0] - V.v[y][0], V.o[y][1] - V.v[y][1]], [V.i[y + 1][0] - V.v[y + 1][0], V.i[y + 1][1] - V.v[y + 1][1]]), P.tLength += z.segmentLength, P.segments.push(z), M += z.segmentLength;
            y = S, D.v.c && (z = bez.buildBezierData(V.v[y], V.v[0], [V.o[y][0] - V.v[y][0], V.o[y][1] - V.v[y][1]], [V.i[0][0] - V.v[0][0], V.i[0][1] - V.v[0][1]]), P.tLength += z.segmentLength, P.segments.push(z), M += z.segmentLength), this._pathData.pi = P;
          }
          if (P = this._pathData.pi, b = this._pathData.f.v, f = 0, m = 1, C = 0, c = !0, A = P.segments, b < 0 && D.v.c)
            for (P.tLength < Math.abs(b) && (b = -Math.abs(b) % P.tLength), f = A.length - 1, E = A[f].points, m = E.length - 1; b < 0; )
              b += E[m].partialLength, m -= 1, m < 0 && (f -= 1, E = A[f].points, m = E.length - 1);
          E = A[f].points, g = E[m - 1], d = E[m], k = d.partialLength;
        }
        S = u.length, o = 0, p = 0;
        var I = e.finalSize * 1.2 * 0.714, R = !0, x, T, v, _, F;
        _ = i.length;
        var w, N = -1, O, j, H, W = b, $ = f, Y = m, ee = -1, X, J, Z, q, G, re, ne, ie, te = "", se = this.defaultPropsArray, ae;
        if (e.j === 2 || e.j === 1) {
          var U = 0, oe = 0, he = e.j === 2 ? -0.5 : -1, K = 0, le = !0;
          for (y = 0; y < S; y += 1)
            if (u[y].n) {
              for (U && (U += oe); K < y; )
                u[K].animatorJustifyOffset = U, K += 1;
              U = 0, le = !0;
            } else {
              for (v = 0; v < _; v += 1)
                x = i[v].a, x.t.propType && (le && e.j === 2 && (oe += x.t.v * he), T = i[v].s, w = T.getMult(u[y].anIndexes[v], s.a[v].s.totalChars), w.length ? U += x.t.v * w[0] * he : U += x.t.v * w * he);
              le = !1;
            }
          for (U && (U += oe); K < y; )
            u[K].animatorJustifyOffset = U, K += 1;
        }
        for (y = 0; y < S; y += 1) {
          if (a.reset(), X = 1, u[y].n)
            o = 0, p += e.yOffset, p += R ? 1 : 0, b = W, R = !1, this._hasMaskedPath && (f = $, m = Y, E = A[f].points, g = E[m - 1], d = E[m], k = d.partialLength, C = 0), te = "", ie = "", re = "", ae = "", se = this.defaultPropsArray;
          else {
            if (this._hasMaskedPath) {
              if (ee !== u[y].line) {
                switch (e.j) {
                  case 1:
                    b += M - e.lineWidths[u[y].line];
                    break;
                  case 2:
                    b += (M - e.lineWidths[u[y].line]) / 2;
                    break;
                }
                ee = u[y].line;
              }
              N !== u[y].ind && (u[N] && (b += u[N].extra), b += u[y].an / 2, N = u[y].ind), b += r[0] * u[y].an * 5e-3;
              var Q = 0;
              for (v = 0; v < _; v += 1)
                x = i[v].a, x.p.propType && (T = i[v].s, w = T.getMult(u[y].anIndexes[v], s.a[v].s.totalChars), w.length ? Q += x.p.v[0] * w[0] : Q += x.p.v[0] * w), x.a.propType && (T = i[v].s, w = T.getMult(u[y].anIndexes[v], s.a[v].s.totalChars), w.length ? Q += x.a.v[0] * w[0] : Q += x.a.v[0] * w);
              for (c = !0, this._pathData.a.v && (b = u[0].an * 0.5 + (M - this._pathData.f.v - u[0].an * 0.5 - u[u.length - 1].an * 0.5) * N / (S - 1), b += this._pathData.f.v); c; )
                C + k >= b + Q || !E ? (L = (b + Q - C) / d.partialLength, j = g.point[0] + (d.point[0] - g.point[0]) * L, H = g.point[1] + (d.point[1] - g.point[1]) * L, a.translate(-r[0] * u[y].an * 5e-3, -(r[1] * I) * 0.01), c = !1) : E && (C += d.partialLength, m += 1, m >= E.length && (m = 0, f += 1, A[f] ? E = A[f].points : D.v.c ? (m = 0, f = 0, E = A[f].points) : (C -= d.partialLength, E = null)), E && (g = d, d = E[m], k = d.partialLength));
              O = u[y].an / 2 - u[y].add, a.translate(-O, 0, 0);
            } else
              O = u[y].an / 2 - u[y].add, a.translate(-O, 0, 0), a.translate(-r[0] * u[y].an * 5e-3, -r[1] * I * 0.01, 0);
            for (v = 0; v < _; v += 1)
              x = i[v].a, x.t.propType && (T = i[v].s, w = T.getMult(u[y].anIndexes[v], s.a[v].s.totalChars), (o !== 0 || e.j !== 0) && (this._hasMaskedPath ? w.length ? b += x.t.v * w[0] : b += x.t.v * w : w.length ? o += x.t.v * w[0] : o += x.t.v * w));
            for (e.strokeWidthAnim && (Z = e.sw || 0), e.strokeColorAnim && (e.sc ? J = [e.sc[0], e.sc[1], e.sc[2]] : J = [0, 0, 0]), e.fillColorAnim && e.fc && (q = [e.fc[0], e.fc[1], e.fc[2]]), v = 0; v < _; v += 1)
              x = i[v].a, x.a.propType && (T = i[v].s, w = T.getMult(u[y].anIndexes[v], s.a[v].s.totalChars), w.length ? a.translate(-x.a.v[0] * w[0], -x.a.v[1] * w[1], x.a.v[2] * w[2]) : a.translate(-x.a.v[0] * w, -x.a.v[1] * w, x.a.v[2] * w));
            for (v = 0; v < _; v += 1)
              x = i[v].a, x.s.propType && (T = i[v].s, w = T.getMult(u[y].anIndexes[v], s.a[v].s.totalChars), w.length ? a.scale(1 + (x.s.v[0] - 1) * w[0], 1 + (x.s.v[1] - 1) * w[1], 1) : a.scale(1 + (x.s.v[0] - 1) * w, 1 + (x.s.v[1] - 1) * w, 1));
            for (v = 0; v < _; v += 1) {
              if (x = i[v].a, T = i[v].s, w = T.getMult(u[y].anIndexes[v], s.a[v].s.totalChars), x.sk.propType && (w.length ? a.skewFromAxis(-x.sk.v * w[0], x.sa.v * w[1]) : a.skewFromAxis(-x.sk.v * w, x.sa.v * w)), x.r.propType && (w.length ? a.rotateZ(-x.r.v * w[2]) : a.rotateZ(-x.r.v * w)), x.ry.propType && (w.length ? a.rotateY(x.ry.v * w[1]) : a.rotateY(x.ry.v * w)), x.rx.propType && (w.length ? a.rotateX(x.rx.v * w[0]) : a.rotateX(x.rx.v * w)), x.o.propType && (w.length ? X += (x.o.v * w[0] - X) * w[0] : X += (x.o.v * w - X) * w), e.strokeWidthAnim && x.sw.propType && (w.length ? Z += x.sw.v * w[0] : Z += x.sw.v * w), e.strokeColorAnim && x.sc.propType)
                for (G = 0; G < 3; G += 1)
                  w.length ? J[G] += (x.sc.v[G] - J[G]) * w[0] : J[G] += (x.sc.v[G] - J[G]) * w;
              if (e.fillColorAnim && e.fc) {
                if (x.fc.propType)
                  for (G = 0; G < 3; G += 1)
                    w.length ? q[G] += (x.fc.v[G] - q[G]) * w[0] : q[G] += (x.fc.v[G] - q[G]) * w;
                x.fh.propType && (w.length ? q = addHueToRGB(q, x.fh.v * w[0]) : q = addHueToRGB(q, x.fh.v * w)), x.fs.propType && (w.length ? q = addSaturationToRGB(q, x.fs.v * w[0]) : q = addSaturationToRGB(q, x.fs.v * w)), x.fb.propType && (w.length ? q = addBrightnessToRGB(q, x.fb.v * w[0]) : q = addBrightnessToRGB(q, x.fb.v * w));
              }
            }
            for (v = 0; v < _; v += 1)
              x = i[v].a, x.p.propType && (T = i[v].s, w = T.getMult(u[y].anIndexes[v], s.a[v].s.totalChars), this._hasMaskedPath ? w.length ? a.translate(0, x.p.v[1] * w[0], -x.p.v[2] * w[1]) : a.translate(0, x.p.v[1] * w, -x.p.v[2] * w) : w.length ? a.translate(x.p.v[0] * w[0], x.p.v[1] * w[1], -x.p.v[2] * w[2]) : a.translate(x.p.v[0] * w, x.p.v[1] * w, -x.p.v[2] * w));
            if (e.strokeWidthAnim && (re = Z < 0 ? 0 : Z), e.strokeColorAnim && (ne = "rgb(" + Math.round(J[0] * 255) + "," + Math.round(J[1] * 255) + "," + Math.round(J[2] * 255) + ")"), e.fillColorAnim && e.fc && (ie = "rgb(" + Math.round(q[0] * 255) + "," + Math.round(q[1] * 255) + "," + Math.round(q[2] * 255) + ")"), this._hasMaskedPath) {
              if (a.translate(0, -e.ls), a.translate(0, r[1] * I * 0.01 + p, 0), this._pathData.p.v) {
                B = (d.point[1] - g.point[1]) / (d.point[0] - g.point[0]);
                var fe = Math.atan(B) * 180 / Math.PI;
                d.point[0] < g.point[0] && (fe += 180), a.rotate(-fe * Math.PI / 180);
              }
              a.translate(j, H, 0), b -= r[0] * u[y].an * 5e-3, u[y + 1] && N !== u[y + 1].ind && (b += u[y].an / 2, b += e.tr * 1e-3 * e.finalSize);
            } else {
              switch (a.translate(o, p, 0), e.ps && a.translate(e.ps[0], e.ps[1] + e.ascent, 0), e.j) {
                case 1:
                  a.translate(u[y].animatorJustifyOffset + e.justifyOffset + (e.boxWidth - e.lineWidths[u[y].line]), 0, 0);
                  break;
                case 2:
                  a.translate(u[y].animatorJustifyOffset + e.justifyOffset + (e.boxWidth - e.lineWidths[u[y].line]) / 2, 0, 0);
                  break;
              }
              a.translate(0, -e.ls), a.translate(O, 0, 0), a.translate(r[0] * u[y].an * 5e-3, r[1] * I * 0.01, 0), o += u[y].l + e.tr * 1e-3 * e.finalSize;
            }
            n === "html" ? te = a.toCSS() : n === "svg" ? te = a.to2dCSS() : se = [a.props[0], a.props[1], a.props[2], a.props[3], a.props[4], a.props[5], a.props[6], a.props[7], a.props[8], a.props[9], a.props[10], a.props[11], a.props[12], a.props[13], a.props[14], a.props[15]], ae = X;
          }
          l <= y ? (F = new LetterProps(ae, re, ne, ie, te, se), this.renderedLetters.push(F), l += 1, this.lettersChangedFlag = !0) : (F = this.renderedLetters[y], this.lettersChangedFlag = F.update(ae, re, ne, ie, te, se) || this.lettersChangedFlag);
        }
      }
    }, TextAnimatorProperty.prototype.getValue = function() {
      this._elem.globalData.frameId !== this._frameId && (this._frameId = this._elem.globalData.frameId, this.iterateDynamicProperties());
    }, TextAnimatorProperty.prototype.mHelper = new Matrix(), TextAnimatorProperty.prototype.defaultPropsArray = [], extendPrototype([DynamicPropertyContainer], TextAnimatorProperty);
    function ITextElement() {
    }
    ITextElement.prototype.initElement = function(e, t, r) {
      this.lettersChangedFlag = !0, this.initFrame(), this.initBaseData(e, t, r), this.textProperty = new TextProperty(this, e.t, this.dynamicProperties), this.textAnimator = new TextAnimatorProperty(e.t, this.renderType, this), this.initTransform(e, t, r), this.initHierarchy(), this.initRenderable(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), this.createContent(), this.hide(), this.textAnimator.searchProperties(this.dynamicProperties);
    }, ITextElement.prototype.prepareFrame = function(e) {
      this._mdf = !1, this.prepareRenderableFrame(e), this.prepareProperties(e, this.isInRange);
    }, ITextElement.prototype.createPathShape = function(e, t) {
      var r, i = t.length, s, a = "";
      for (r = 0; r < i; r += 1)
        t[r].ty === "sh" && (s = t[r].ks.k, a += buildShapeString(s, s.i.length, !0, e));
      return a;
    }, ITextElement.prototype.updateDocumentData = function(e, t) {
      this.textProperty.updateDocumentData(e, t);
    }, ITextElement.prototype.canResizeFont = function(e) {
      this.textProperty.canResizeFont(e);
    }, ITextElement.prototype.setMinimumFontSize = function(e) {
      this.textProperty.setMinimumFontSize(e);
    }, ITextElement.prototype.applyTextPropertiesToMatrix = function(e, t, r, i, s) {
      switch (e.ps && t.translate(e.ps[0], e.ps[1] + e.ascent, 0), t.translate(0, -e.ls, 0), e.j) {
        case 1:
          t.translate(e.justifyOffset + (e.boxWidth - e.lineWidths[r]), 0, 0);
          break;
        case 2:
          t.translate(e.justifyOffset + (e.boxWidth - e.lineWidths[r]) / 2, 0, 0);
          break;
      }
      t.translate(i, s, 0);
    }, ITextElement.prototype.buildColor = function(e) {
      return "rgb(" + Math.round(e[0] * 255) + "," + Math.round(e[1] * 255) + "," + Math.round(e[2] * 255) + ")";
    }, ITextElement.prototype.emptyProp = new LetterProps(), ITextElement.prototype.destroy = function() {
    }, ITextElement.prototype.validateText = function() {
      (this.textProperty._mdf || this.textProperty._isFirstFrame) && (this.buildNewText(), this.textProperty._isFirstFrame = !1, this.textProperty._mdf = !1);
    };
    var emptyShapeData = {
      shapes: []
    };
    function SVGTextLottieElement(e, t, r) {
      this.textSpans = [], this.renderType = "svg", this.initElement(e, t, r);
    }
    extendPrototype([BaseElement, TransformElement, SVGBaseElement, HierarchyElement, FrameElement, RenderableDOMElement, ITextElement], SVGTextLottieElement), SVGTextLottieElement.prototype.createContent = function() {
      this.data.singleShape && !this.globalData.fontManager.chars && (this.textContainer = createNS("text"));
    }, SVGTextLottieElement.prototype.buildTextContents = function(e) {
      for (var t = 0, r = e.length, i = [], s = ""; t < r; )
        e[t] === String.fromCharCode(13) || e[t] === String.fromCharCode(3) ? (i.push(s), s = "") : s += e[t], t += 1;
      return i.push(s), i;
    }, SVGTextLottieElement.prototype.buildShapeData = function(e, t) {
      if (e.shapes && e.shapes.length) {
        var r = e.shapes[0];
        if (r.it) {
          var i = r.it[r.it.length - 1];
          i.s && (i.s.k[0] = t, i.s.k[1] = t);
        }
      }
      return e;
    }, SVGTextLottieElement.prototype.buildNewText = function() {
      this.addDynamicProperty(this);
      var e, t, r = this.textProperty.currentData;
      this.renderedLetters = createSizedArray(r ? r.l.length : 0), r.fc ? this.layerElement.setAttribute("fill", this.buildColor(r.fc)) : this.layerElement.setAttribute("fill", "rgba(0,0,0,0)"), r.sc && (this.layerElement.setAttribute("stroke", this.buildColor(r.sc)), this.layerElement.setAttribute("stroke-width", r.sw)), this.layerElement.setAttribute("font-size", r.finalSize);
      var i = this.globalData.fontManager.getFontByName(r.f);
      if (i.fClass)
        this.layerElement.setAttribute("class", i.fClass);
      else {
        this.layerElement.setAttribute("font-family", i.fFamily);
        var s = r.fWeight, a = r.fStyle;
        this.layerElement.setAttribute("font-style", a), this.layerElement.setAttribute("font-weight", s);
      }
      this.layerElement.setAttribute("aria-label", r.t);
      var n = r.l || [], l = !!this.globalData.fontManager.chars;
      t = n.length;
      var o, p = this.mHelper, y = "", S = this.data.singleShape, u = 0, P = 0, b = !0, d = r.tr * 1e-3 * r.finalSize;
      if (S && !l && !r.sz) {
        var C = this.textContainer, c = "start";
        switch (r.j) {
          case 1:
            c = "end";
            break;
          case 2:
            c = "middle";
            break;
          default:
            c = "start";
            break;
        }
        C.setAttribute("text-anchor", c), C.setAttribute("letter-spacing", d);
        var m = this.buildTextContents(r.finalText);
        for (t = m.length, P = r.ps ? r.ps[1] + r.ascent : 0, e = 0; e < t; e += 1)
          o = this.textSpans[e].span || createNS("tspan"), o.textContent = m[e], o.setAttribute("x", 0), o.setAttribute("y", P), o.style.display = "inherit", C.appendChild(o), this.textSpans[e] || (this.textSpans[e] = {
            span: null,
            glyph: null
          }), this.textSpans[e].span = o, P += r.finalLineHeight;
        this.layerElement.appendChild(C);
      } else {
        var f = this.textSpans.length, g;
        for (e = 0; e < t; e += 1) {
          if (this.textSpans[e] || (this.textSpans[e] = {
            span: null,
            childSpan: null,
            glyph: null
          }), !l || !S || e === 0) {
            if (o = f > e ? this.textSpans[e].span : createNS(l ? "g" : "text"), f <= e) {
              if (o.setAttribute("stroke-linecap", "butt"), o.setAttribute("stroke-linejoin", "round"), o.setAttribute("stroke-miterlimit", "4"), this.textSpans[e].span = o, l) {
                var E = createNS("g");
                o.appendChild(E), this.textSpans[e].childSpan = E;
              }
              this.textSpans[e].span = o, this.layerElement.appendChild(o);
            }
            o.style.display = "inherit";
          }
          if (p.reset(), S && (n[e].n && (u = -d, P += r.yOffset, P += b ? 1 : 0, b = !1), this.applyTextPropertiesToMatrix(r, p, n[e].line, u, P), u += n[e].l || 0, u += d), l) {
            g = this.globalData.fontManager.getCharData(r.finalText[e], i.fStyle, this.globalData.fontManager.getFontByName(r.f).fFamily);
            var A;
            if (g.t === 1)
              A = new SVGCompElement(g.data, this.globalData, this);
            else {
              var k = emptyShapeData;
              g.data && g.data.shapes && (k = this.buildShapeData(g.data, r.finalSize)), A = new SVGShapeElement(k, this.globalData, this);
            }
            if (this.textSpans[e].glyph) {
              var M = this.textSpans[e].glyph;
              this.textSpans[e].childSpan.removeChild(M.layerElement), M.destroy();
            }
            this.textSpans[e].glyph = A, A._debug = !0, A.prepareFrame(0), A.renderFrame(), this.textSpans[e].childSpan.appendChild(A.layerElement), g.t === 1 && this.textSpans[e].childSpan.setAttribute("transform", "scale(" + r.finalSize / 100 + "," + r.finalSize / 100 + ")");
          } else
            S && o.setAttribute("transform", "translate(" + p.props[12] + "," + p.props[13] + ")"), o.textContent = n[e].val, o.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve");
        }
        S && o && o.setAttribute("d", y);
      }
      for (; e < this.textSpans.length; )
        this.textSpans[e].span.style.display = "none", e += 1;
      this._sizeChanged = !0;
    }, SVGTextLottieElement.prototype.sourceRectAtTime = function() {
      if (this.prepareFrame(this.comp.renderedFrame - this.data.st), this.renderInnerContent(), this._sizeChanged) {
        this._sizeChanged = !1;
        var e = this.layerElement.getBBox();
        this.bbox = {
          top: e.y,
          left: e.x,
          width: e.width,
          height: e.height
        };
      }
      return this.bbox;
    }, SVGTextLottieElement.prototype.getValue = function() {
      var e, t = this.textSpans.length, r;
      for (this.renderedFrame = this.comp.renderedFrame, e = 0; e < t; e += 1)
        r = this.textSpans[e].glyph, r && (r.prepareFrame(this.comp.renderedFrame - this.data.st), r._mdf && (this._mdf = !0));
    }, SVGTextLottieElement.prototype.renderInnerContent = function() {
      if (this.validateText(), (!this.data.singleShape || this._mdf) && (this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag), this.lettersChangedFlag || this.textAnimator.lettersChangedFlag)) {
        this._sizeChanged = !0;
        var e, t, r = this.textAnimator.renderedLetters, i = this.textProperty.currentData.l;
        t = i.length;
        var s, a, n;
        for (e = 0; e < t; e += 1)
          i[e].n || (s = r[e], a = this.textSpans[e].span, n = this.textSpans[e].glyph, n && n.renderFrame(), s._mdf.m && a.setAttribute("transform", s.m), s._mdf.o && a.setAttribute("opacity", s.o), s._mdf.sw && a.setAttribute("stroke-width", s.sw), s._mdf.sc && a.setAttribute("stroke", s.sc), s._mdf.fc && a.setAttribute("fill", s.fc));
      }
    };
    function ISolidElement(e, t, r) {
      this.initElement(e, t, r);
    }
    extendPrototype([IImageElement], ISolidElement), ISolidElement.prototype.createContent = function() {
      var e = createNS("rect");
      e.setAttribute("width", this.data.sw), e.setAttribute("height", this.data.sh), e.setAttribute("fill", this.data.sc), this.layerElement.appendChild(e);
    };
    function NullElement(e, t, r) {
      this.initFrame(), this.initBaseData(e, t, r), this.initFrame(), this.initTransform(e, t, r), this.initHierarchy();
    }
    NullElement.prototype.prepareFrame = function(e) {
      this.prepareProperties(e, !0);
    }, NullElement.prototype.renderFrame = function() {
    }, NullElement.prototype.getBaseElement = function() {
      return null;
    }, NullElement.prototype.destroy = function() {
    }, NullElement.prototype.sourceRectAtTime = function() {
    }, NullElement.prototype.hide = function() {
    }, extendPrototype([BaseElement, TransformElement, HierarchyElement, FrameElement], NullElement);
    function SVGRendererBase() {
    }
    extendPrototype([BaseRenderer], SVGRendererBase), SVGRendererBase.prototype.createNull = function(e) {
      return new NullElement(e, this.globalData, this);
    }, SVGRendererBase.prototype.createShape = function(e) {
      return new SVGShapeElement(e, this.globalData, this);
    }, SVGRendererBase.prototype.createText = function(e) {
      return new SVGTextLottieElement(e, this.globalData, this);
    }, SVGRendererBase.prototype.createImage = function(e) {
      return new IImageElement(e, this.globalData, this);
    }, SVGRendererBase.prototype.createSolid = function(e) {
      return new ISolidElement(e, this.globalData, this);
    }, SVGRendererBase.prototype.configAnimation = function(e) {
      this.svgElement.setAttribute("xmlns", "http://www.w3.org/2000/svg"), this.svgElement.setAttribute("xmlns:xlink", "http://www.w3.org/1999/xlink"), this.renderConfig.viewBoxSize ? this.svgElement.setAttribute("viewBox", this.renderConfig.viewBoxSize) : this.svgElement.setAttribute("viewBox", "0 0 " + e.w + " " + e.h), this.renderConfig.viewBoxOnly || (this.svgElement.setAttribute("width", e.w), this.svgElement.setAttribute("height", e.h), this.svgElement.style.width = "100%", this.svgElement.style.height = "100%", this.svgElement.style.transform = "translate3d(0,0,0)", this.svgElement.style.contentVisibility = this.renderConfig.contentVisibility), this.renderConfig.width && this.svgElement.setAttribute("width", this.renderConfig.width), this.renderConfig.height && this.svgElement.setAttribute("height", this.renderConfig.height), this.renderConfig.className && this.svgElement.setAttribute("class", this.renderConfig.className), this.renderConfig.id && this.svgElement.setAttribute("id", this.renderConfig.id), this.renderConfig.focusable !== void 0 && this.svgElement.setAttribute("focusable", this.renderConfig.focusable), this.svgElement.setAttribute("preserveAspectRatio", this.renderConfig.preserveAspectRatio), this.animationItem.wrapper.appendChild(this.svgElement);
      var t = this.globalData.defs;
      this.setupGlobalData(e, t), this.globalData.progressiveLoad = this.renderConfig.progressiveLoad, this.data = e;
      var r = createNS("clipPath"), i = createNS("rect");
      i.setAttribute("width", e.w), i.setAttribute("height", e.h), i.setAttribute("x", 0), i.setAttribute("y", 0);
      var s = createElementID();
      r.setAttribute("id", s), r.appendChild(i), this.layerElement.setAttribute("clip-path", "url(" + getLocationHref() + "#" + s + ")"), t.appendChild(r), this.layers = e.layers, this.elements = createSizedArray(e.layers.length);
    }, SVGRendererBase.prototype.destroy = function() {
      this.animationItem.wrapper && (this.animationItem.wrapper.innerText = ""), this.layerElement = null, this.globalData.defs = null;
      var e, t = this.layers ? this.layers.length : 0;
      for (e = 0; e < t; e += 1)
        this.elements[e] && this.elements[e].destroy && this.elements[e].destroy();
      this.elements.length = 0, this.destroyed = !0, this.animationItem = null;
    }, SVGRendererBase.prototype.updateContainerSize = function() {
    }, SVGRendererBase.prototype.findIndexByInd = function(e) {
      var t = 0, r = this.layers.length;
      for (t = 0; t < r; t += 1)
        if (this.layers[t].ind === e)
          return t;
      return -1;
    }, SVGRendererBase.prototype.buildItem = function(e) {
      var t = this.elements;
      if (!(t[e] || this.layers[e].ty === 99)) {
        t[e] = !0;
        var r = this.createItem(this.layers[e]);
        if (t[e] = r, getExpressionsPlugin() && (this.layers[e].ty === 0 && this.globalData.projectInterface.registerComposition(r), r.initExpressions()), this.appendElementInPos(r, e), this.layers[e].tt) {
          var i = "tp" in this.layers[e] ? this.findIndexByInd(this.layers[e].tp) : e - 1;
          if (i === -1)
            return;
          if (!this.elements[i] || this.elements[i] === !0)
            this.buildItem(i), this.addPendingElement(r);
          else {
            var s = t[i], a = s.getMatte(this.layers[e].tt);
            r.setMatte(a);
          }
        }
      }
    }, SVGRendererBase.prototype.checkPendingElements = function() {
      for (; this.pendingElements.length; ) {
        var e = this.pendingElements.pop();
        if (e.checkParenting(), e.data.tt)
          for (var t = 0, r = this.elements.length; t < r; ) {
            if (this.elements[t] === e) {
              var i = "tp" in e.data ? this.findIndexByInd(e.data.tp) : t - 1, s = this.elements[i], a = s.getMatte(this.layers[t].tt);
              e.setMatte(a);
              break;
            }
            t += 1;
          }
      }
    }, SVGRendererBase.prototype.renderFrame = function(e) {
      if (!(this.renderedFrame === e || this.destroyed)) {
        e === null ? e = this.renderedFrame : this.renderedFrame = e, this.globalData.frameNum = e, this.globalData.frameId += 1, this.globalData.projectInterface.currentFrame = e, this.globalData._mdf = !1;
        var t, r = this.layers.length;
        for (this.completeLayers || this.checkLayers(e), t = r - 1; t >= 0; t -= 1)
          (this.completeLayers || this.elements[t]) && this.elements[t].prepareFrame(e - this.layers[t].st);
        if (this.globalData._mdf)
          for (t = 0; t < r; t += 1)
            (this.completeLayers || this.elements[t]) && this.elements[t].renderFrame();
      }
    }, SVGRendererBase.prototype.appendElementInPos = function(e, t) {
      var r = e.getBaseElement();
      if (r) {
        for (var i = 0, s; i < t; )
          this.elements[i] && this.elements[i] !== !0 && this.elements[i].getBaseElement() && (s = this.elements[i].getBaseElement()), i += 1;
        s ? this.layerElement.insertBefore(r, s) : this.layerElement.appendChild(r);
      }
    }, SVGRendererBase.prototype.hide = function() {
      this.layerElement.style.display = "none";
    }, SVGRendererBase.prototype.show = function() {
      this.layerElement.style.display = "block";
    };
    function ICompElement() {
    }
    extendPrototype([BaseElement, TransformElement, HierarchyElement, FrameElement, RenderableDOMElement], ICompElement), ICompElement.prototype.initElement = function(e, t, r) {
      this.initFrame(), this.initBaseData(e, t, r), this.initTransform(e, t, r), this.initRenderable(), this.initHierarchy(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), (this.data.xt || !t.progressiveLoad) && this.buildAllItems(), this.hide();
    }, ICompElement.prototype.prepareFrame = function(e) {
      if (this._mdf = !1, this.prepareRenderableFrame(e), this.prepareProperties(e, this.isInRange), !(!this.isInRange && !this.data.xt)) {
        if (this.tm._placeholder)
          this.renderedFrame = e / this.data.sr;
        else {
          var t = this.tm.v;
          t === this.data.op && (t = this.data.op - 1), this.renderedFrame = t;
        }
        var r, i = this.elements.length;
        for (this.completeLayers || this.checkLayers(this.renderedFrame), r = i - 1; r >= 0; r -= 1)
          (this.completeLayers || this.elements[r]) && (this.elements[r].prepareFrame(this.renderedFrame - this.layers[r].st), this.elements[r]._mdf && (this._mdf = !0));
      }
    }, ICompElement.prototype.renderInnerContent = function() {
      var e, t = this.layers.length;
      for (e = 0; e < t; e += 1)
        (this.completeLayers || this.elements[e]) && this.elements[e].renderFrame();
    }, ICompElement.prototype.setElements = function(e) {
      this.elements = e;
    }, ICompElement.prototype.getElements = function() {
      return this.elements;
    }, ICompElement.prototype.destroyElements = function() {
      var e, t = this.layers.length;
      for (e = 0; e < t; e += 1)
        this.elements[e] && this.elements[e].destroy();
    }, ICompElement.prototype.destroy = function() {
      this.destroyElements(), this.destroyBaseElement();
    };
    function SVGCompElement(e, t, r) {
      this.layers = e.layers, this.supports3d = !0, this.completeLayers = !1, this.pendingElements = [], this.elements = this.layers ? createSizedArray(this.layers.length) : [], this.initElement(e, t, r), this.tm = e.tm ? PropertyFactory.getProp(this, e.tm, 0, t.frameRate, this) : {
        _placeholder: !0
      };
    }
    extendPrototype([SVGRendererBase, ICompElement, SVGBaseElement], SVGCompElement), SVGCompElement.prototype.createComp = function(e) {
      return new SVGCompElement(e, this.globalData, this);
    };
    function SVGRenderer(e, t) {
      this.animationItem = e, this.layers = null, this.renderedFrame = -1, this.svgElement = createNS("svg");
      var r = "";
      if (t && t.title) {
        var i = createNS("title"), s = createElementID();
        i.setAttribute("id", s), i.textContent = t.title, this.svgElement.appendChild(i), r += s;
      }
      if (t && t.description) {
        var a = createNS("desc"), n = createElementID();
        a.setAttribute("id", n), a.textContent = t.description, this.svgElement.appendChild(a), r += " " + n;
      }
      r && this.svgElement.setAttribute("aria-labelledby", r);
      var l = createNS("defs");
      this.svgElement.appendChild(l);
      var o = createNS("g");
      this.svgElement.appendChild(o), this.layerElement = o, this.renderConfig = {
        preserveAspectRatio: t && t.preserveAspectRatio || "xMidYMid meet",
        imagePreserveAspectRatio: t && t.imagePreserveAspectRatio || "xMidYMid slice",
        contentVisibility: t && t.contentVisibility || "visible",
        progressiveLoad: t && t.progressiveLoad || !1,
        hideOnTransparent: !(t && t.hideOnTransparent === !1),
        viewBoxOnly: t && t.viewBoxOnly || !1,
        viewBoxSize: t && t.viewBoxSize || !1,
        className: t && t.className || "",
        id: t && t.id || "",
        focusable: t && t.focusable,
        filterSize: {
          width: t && t.filterSize && t.filterSize.width || "100%",
          height: t && t.filterSize && t.filterSize.height || "100%",
          x: t && t.filterSize && t.filterSize.x || "0%",
          y: t && t.filterSize && t.filterSize.y || "0%"
        },
        width: t && t.width,
        height: t && t.height,
        runExpressions: !t || t.runExpressions === void 0 || t.runExpressions
      }, this.globalData = {
        _mdf: !1,
        frameNum: -1,
        defs: l,
        renderConfig: this.renderConfig
      }, this.elements = [], this.pendingElements = [], this.destroyed = !1, this.rendererType = "svg";
    }
    extendPrototype([SVGRendererBase], SVGRenderer), SVGRenderer.prototype.createComp = function(e) {
      return new SVGCompElement(e, this.globalData, this);
    };
    function ShapeTransformManager() {
      this.sequences = {}, this.sequenceList = [], this.transform_key_count = 0;
    }
    ShapeTransformManager.prototype = {
      addTransformSequence: function(t) {
        var r, i = t.length, s = "_";
        for (r = 0; r < i; r += 1)
          s += t[r].transform.key + "_";
        var a = this.sequences[s];
        return a || (a = {
          transforms: [].concat(t),
          finalTransform: new Matrix(),
          _mdf: !1
        }, this.sequences[s] = a, this.sequenceList.push(a)), a;
      },
      processSequence: function(t, r) {
        for (var i = 0, s = t.transforms.length, a = r; i < s && !r; ) {
          if (t.transforms[i].transform.mProps._mdf) {
            a = !0;
            break;
          }
          i += 1;
        }
        if (a)
          for (t.finalTransform.reset(), i = s - 1; i >= 0; i -= 1)
            t.finalTransform.multiply(t.transforms[i].transform.mProps.v);
        t._mdf = a;
      },
      processSequences: function(t) {
        var r, i = this.sequenceList.length;
        for (r = 0; r < i; r += 1)
          this.processSequence(this.sequenceList[r], t);
      },
      getNewKey: function() {
        return this.transform_key_count += 1, "_" + this.transform_key_count;
      }
    };
    var lumaLoader = function() {
      var t = "__lottie_element_luma_buffer", r = null, i = null, s = null;
      function a() {
        var o = createNS("svg"), p = createNS("filter"), y = createNS("feColorMatrix");
        return p.setAttribute("id", t), y.setAttribute("type", "matrix"), y.setAttribute("color-interpolation-filters", "sRGB"), y.setAttribute("values", "0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0"), p.appendChild(y), o.appendChild(p), o.setAttribute("id", t + "_svg"), featureSupport.svgLumaHidden && (o.style.display = "none"), o;
      }
      function n() {
        r || (s = a(), document.body.appendChild(s), r = createTag("canvas"), i = r.getContext("2d"), i.filter = "url(#" + t + ")", i.fillStyle = "rgba(0,0,0,0)", i.fillRect(0, 0, 1, 1));
      }
      function l(o) {
        return r || n(), r.width = o.width, r.height = o.height, i.filter = "url(#" + t + ")", r;
      }
      return {
        load: n,
        get: l
      };
    };
    function createCanvas(e, t) {
      if (featureSupport.offscreenCanvas)
        return new OffscreenCanvas(e, t);
      var r = createTag("canvas");
      return r.width = e, r.height = t, r;
    }
    var assetLoader = function() {
      return {
        loadLumaCanvas: lumaLoader.load,
        getLumaCanvas: lumaLoader.get,
        createCanvas
      };
    }(), registeredEffects = {};
    function CVEffects(e) {
      var t, r = e.data.ef ? e.data.ef.length : 0;
      this.filters = [];
      var i;
      for (t = 0; t < r; t += 1) {
        i = null;
        var s = e.data.ef[t].ty;
        if (registeredEffects[s]) {
          var a = registeredEffects[s].effect;
          i = new a(e.effectsManager.effectElements[t], e);
        }
        i && this.filters.push(i);
      }
      this.filters.length && e.addRenderableComponent(this);
    }
    CVEffects.prototype.renderFrame = function(e) {
      var t, r = this.filters.length;
      for (t = 0; t < r; t += 1)
        this.filters[t].renderFrame(e);
    }, CVEffects.prototype.getEffects = function(e) {
      var t, r = this.filters.length, i = [];
      for (t = 0; t < r; t += 1)
        this.filters[t].type === e && i.push(this.filters[t]);
      return i;
    };
    function registerEffect(e, t) {
      registeredEffects[e] = {
        effect: t
      };
    }
    function CVMaskElement(e, t) {
      this.data = e, this.element = t, this.masksProperties = this.data.masksProperties || [], this.viewData = createSizedArray(this.masksProperties.length);
      var r, i = this.masksProperties.length, s = !1;
      for (r = 0; r < i; r += 1)
        this.masksProperties[r].mode !== "n" && (s = !0), this.viewData[r] = ShapePropertyFactory.getShapeProp(this.element, this.masksProperties[r], 3);
      this.hasMasks = s, s && this.element.addRenderableComponent(this);
    }
    CVMaskElement.prototype.renderFrame = function() {
      if (this.hasMasks) {
        var e = this.element.finalTransform.mat, t = this.element.canvasContext, r, i = this.masksProperties.length, s, a, n;
        for (t.beginPath(), r = 0; r < i; r += 1)
          if (this.masksProperties[r].mode !== "n") {
            this.masksProperties[r].inv && (t.moveTo(0, 0), t.lineTo(this.element.globalData.compSize.w, 0), t.lineTo(this.element.globalData.compSize.w, this.element.globalData.compSize.h), t.lineTo(0, this.element.globalData.compSize.h), t.lineTo(0, 0)), n = this.viewData[r].v, s = e.applyToPointArray(n.v[0][0], n.v[0][1], 0), t.moveTo(s[0], s[1]);
            var l, o = n._length;
            for (l = 1; l < o; l += 1)
              a = e.applyToTriplePoints(n.o[l - 1], n.i[l], n.v[l]), t.bezierCurveTo(a[0], a[1], a[2], a[3], a[4], a[5]);
            a = e.applyToTriplePoints(n.o[l - 1], n.i[0], n.v[0]), t.bezierCurveTo(a[0], a[1], a[2], a[3], a[4], a[5]);
          }
        this.element.globalData.renderer.save(!0), t.clip();
      }
    }, CVMaskElement.prototype.getMaskProperty = MaskElement.prototype.getMaskProperty, CVMaskElement.prototype.destroy = function() {
      this.element = null;
    };
    function CVBaseElement() {
    }
    var operationsMap = {
      1: "source-in",
      2: "source-out",
      3: "source-in",
      4: "source-out"
    };
    CVBaseElement.prototype = {
      createElements: function() {
      },
      initRendererElement: function() {
      },
      createContainerElements: function() {
        if (this.data.tt >= 1) {
          this.buffers = [];
          var t = this.globalData.canvasContext, r = assetLoader.createCanvas(t.canvas.width, t.canvas.height);
          this.buffers.push(r);
          var i = assetLoader.createCanvas(t.canvas.width, t.canvas.height);
          this.buffers.push(i), this.data.tt >= 3 && !document._isProxy && assetLoader.loadLumaCanvas();
        }
        this.canvasContext = this.globalData.canvasContext, this.transformCanvas = this.globalData.transformCanvas, this.renderableEffectsManager = new CVEffects(this), this.searchEffectTransforms();
      },
      createContent: function() {
      },
      setBlendMode: function() {
        var t = this.globalData;
        if (t.blendMode !== this.data.bm) {
          t.blendMode = this.data.bm;
          var r = getBlendMode(this.data.bm);
          t.canvasContext.globalCompositeOperation = r;
        }
      },
      createRenderableComponents: function() {
        this.maskManager = new CVMaskElement(this.data, this), this.transformEffects = this.renderableEffectsManager.getEffects(effectTypes.TRANSFORM_EFFECT);
      },
      hideElement: function() {
        !this.hidden && (!this.isInRange || this.isTransparent) && (this.hidden = !0);
      },
      showElement: function() {
        this.isInRange && !this.isTransparent && (this.hidden = !1, this._isFirstFrame = !0, this.maskManager._isFirstFrame = !0);
      },
      clearCanvas: function(t) {
        t.clearRect(this.transformCanvas.tx, this.transformCanvas.ty, this.transformCanvas.w * this.transformCanvas.sx, this.transformCanvas.h * this.transformCanvas.sy);
      },
      prepareLayer: function() {
        if (this.data.tt >= 1) {
          var t = this.buffers[0], r = t.getContext("2d");
          this.clearCanvas(r), r.drawImage(this.canvasContext.canvas, 0, 0), this.currentTransform = this.canvasContext.getTransform(), this.canvasContext.setTransform(1, 0, 0, 1, 0, 0), this.clearCanvas(this.canvasContext), this.canvasContext.setTransform(this.currentTransform);
        }
      },
      exitLayer: function() {
        if (this.data.tt >= 1) {
          var t = this.buffers[1], r = t.getContext("2d");
          this.clearCanvas(r), r.drawImage(this.canvasContext.canvas, 0, 0), this.canvasContext.setTransform(1, 0, 0, 1, 0, 0), this.clearCanvas(this.canvasContext), this.canvasContext.setTransform(this.currentTransform);
          var i = this.comp.getElementById("tp" in this.data ? this.data.tp : this.data.ind - 1);
          if (i.renderFrame(!0), this.canvasContext.setTransform(1, 0, 0, 1, 0, 0), this.data.tt >= 3 && !document._isProxy) {
            var s = assetLoader.getLumaCanvas(this.canvasContext.canvas), a = s.getContext("2d");
            a.drawImage(this.canvasContext.canvas, 0, 0), this.clearCanvas(this.canvasContext), this.canvasContext.drawImage(s, 0, 0);
          }
          this.canvasContext.globalCompositeOperation = operationsMap[this.data.tt], this.canvasContext.drawImage(t, 0, 0), this.canvasContext.globalCompositeOperation = "destination-over", this.canvasContext.drawImage(this.buffers[0], 0, 0), this.canvasContext.setTransform(this.currentTransform), this.canvasContext.globalCompositeOperation = "source-over";
        }
      },
      renderFrame: function(t) {
        if (!(this.hidden || this.data.hd) && !(this.data.td === 1 && !t)) {
          this.renderTransform(), this.renderRenderable(), this.renderLocalTransform(), this.setBlendMode();
          var r = this.data.ty === 0;
          this.prepareLayer(), this.globalData.renderer.save(r), this.globalData.renderer.ctxTransform(this.finalTransform.localMat.props), this.globalData.renderer.ctxOpacity(this.finalTransform.localOpacity), this.renderInnerContent(), this.globalData.renderer.restore(r), this.exitLayer(), this.maskManager.hasMasks && this.globalData.renderer.restore(!0), this._isFirstFrame && (this._isFirstFrame = !1);
        }
      },
      destroy: function() {
        this.canvasContext = null, this.data = null, this.globalData = null, this.maskManager.destroy();
      },
      mHelper: new Matrix()
    }, CVBaseElement.prototype.hide = CVBaseElement.prototype.hideElement, CVBaseElement.prototype.show = CVBaseElement.prototype.showElement;
    function CVShapeData(e, t, r, i) {
      this.styledShapes = [], this.tr = [0, 0, 0, 0, 0, 0];
      var s = 4;
      t.ty === "rc" ? s = 5 : t.ty === "el" ? s = 6 : t.ty === "sr" && (s = 7), this.sh = ShapePropertyFactory.getShapeProp(e, t, s, e);
      var a, n = r.length, l;
      for (a = 0; a < n; a += 1)
        r[a].closed || (l = {
          transforms: i.addTransformSequence(r[a].transforms),
          trNodes: []
        }, this.styledShapes.push(l), r[a].elements.push(l));
    }
    CVShapeData.prototype.setAsAnimated = SVGShapeData.prototype.setAsAnimated;
    function CVShapeElement(e, t, r) {
      this.shapes = [], this.shapesData = e.shapes, this.stylesList = [], this.itemsData = [], this.prevViewData = [], this.shapeModifiers = [], this.processedElements = [], this.transformsManager = new ShapeTransformManager(), this.initElement(e, t, r);
    }
    extendPrototype([BaseElement, TransformElement, CVBaseElement, IShapeElement, HierarchyElement, FrameElement, RenderableElement], CVShapeElement), CVShapeElement.prototype.initElement = RenderableDOMElement.prototype.initElement, CVShapeElement.prototype.transformHelper = {
      opacity: 1,
      _opMdf: !1
    }, CVShapeElement.prototype.dashResetter = [], CVShapeElement.prototype.createContent = function() {
      this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, !0, []);
    }, CVShapeElement.prototype.createStyleElement = function(e, t) {
      var r = {
        data: e,
        type: e.ty,
        preTransforms: this.transformsManager.addTransformSequence(t),
        transforms: [],
        elements: [],
        closed: e.hd === !0
      }, i = {};
      if (e.ty === "fl" || e.ty === "st" ? (i.c = PropertyFactory.getProp(this, e.c, 1, 255, this), i.c.k || (r.co = "rgb(" + bmFloor(i.c.v[0]) + "," + bmFloor(i.c.v[1]) + "," + bmFloor(i.c.v[2]) + ")")) : (e.ty === "gf" || e.ty === "gs") && (i.s = PropertyFactory.getProp(this, e.s, 1, null, this), i.e = PropertyFactory.getProp(this, e.e, 1, null, this), i.h = PropertyFactory.getProp(this, e.h || {
        k: 0
      }, 0, 0.01, this), i.a = PropertyFactory.getProp(this, e.a || {
        k: 0
      }, 0, degToRads, this), i.g = new GradientProperty(this, e.g, this)), i.o = PropertyFactory.getProp(this, e.o, 0, 0.01, this), e.ty === "st" || e.ty === "gs") {
        if (r.lc = lineCapEnum[e.lc || 2], r.lj = lineJoinEnum[e.lj || 2], e.lj == 1 && (r.ml = e.ml), i.w = PropertyFactory.getProp(this, e.w, 0, null, this), i.w.k || (r.wi = i.w.v), e.d) {
          var s = new DashProperty(this, e.d, "canvas", this);
          i.d = s, i.d.k || (r.da = i.d.dashArray, r.do = i.d.dashoffset[0]);
        }
      } else
        r.r = e.r === 2 ? "evenodd" : "nonzero";
      return this.stylesList.push(r), i.style = r, i;
    }, CVShapeElement.prototype.createGroupElement = function() {
      var e = {
        it: [],
        prevViewData: []
      };
      return e;
    }, CVShapeElement.prototype.createTransformElement = function(e) {
      var t = {
        transform: {
          opacity: 1,
          _opMdf: !1,
          key: this.transformsManager.getNewKey(),
          op: PropertyFactory.getProp(this, e.o, 0, 0.01, this),
          mProps: TransformPropertyFactory.getTransformProperty(this, e, this)
        }
      };
      return t;
    }, CVShapeElement.prototype.createShapeElement = function(e) {
      var t = new CVShapeData(this, e, this.stylesList, this.transformsManager);
      return this.shapes.push(t), this.addShapeToModifiers(t), t;
    }, CVShapeElement.prototype.reloadShapes = function() {
      this._isFirstFrame = !0;
      var e, t = this.itemsData.length;
      for (e = 0; e < t; e += 1)
        this.prevViewData[e] = this.itemsData[e];
      for (this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, !0, []), t = this.dynamicProperties.length, e = 0; e < t; e += 1)
        this.dynamicProperties[e].getValue();
      this.renderModifiers(), this.transformsManager.processSequences(this._isFirstFrame);
    }, CVShapeElement.prototype.addTransformToStyleList = function(e) {
      var t, r = this.stylesList.length;
      for (t = 0; t < r; t += 1)
        this.stylesList[t].closed || this.stylesList[t].transforms.push(e);
    }, CVShapeElement.prototype.removeTransformFromStyleList = function() {
      var e, t = this.stylesList.length;
      for (e = 0; e < t; e += 1)
        this.stylesList[e].closed || this.stylesList[e].transforms.pop();
    }, CVShapeElement.prototype.closeStyles = function(e) {
      var t, r = e.length;
      for (t = 0; t < r; t += 1)
        e[t].closed = !0;
    }, CVShapeElement.prototype.searchShapes = function(e, t, r, i, s) {
      var a, n = e.length - 1, l, o, p = [], y = [], S, u, P, b = [].concat(s);
      for (a = n; a >= 0; a -= 1) {
        if (S = this.searchProcessedElement(e[a]), S ? t[a] = r[S - 1] : e[a]._shouldRender = i, e[a].ty === "fl" || e[a].ty === "st" || e[a].ty === "gf" || e[a].ty === "gs")
          S ? t[a].style.closed = !1 : t[a] = this.createStyleElement(e[a], b), p.push(t[a].style);
        else if (e[a].ty === "gr") {
          if (!S)
            t[a] = this.createGroupElement(e[a]);
          else
            for (o = t[a].it.length, l = 0; l < o; l += 1)
              t[a].prevViewData[l] = t[a].it[l];
          this.searchShapes(e[a].it, t[a].it, t[a].prevViewData, i, b);
        } else
          e[a].ty === "tr" ? (S || (P = this.createTransformElement(e[a]), t[a] = P), b.push(t[a]), this.addTransformToStyleList(t[a])) : e[a].ty === "sh" || e[a].ty === "rc" || e[a].ty === "el" || e[a].ty === "sr" ? S || (t[a] = this.createShapeElement(e[a])) : e[a].ty === "tm" || e[a].ty === "rd" || e[a].ty === "pb" || e[a].ty === "zz" || e[a].ty === "op" ? (S ? (u = t[a], u.closed = !1) : (u = ShapeModifiers.getModifier(e[a].ty), u.init(this, e[a]), t[a] = u, this.shapeModifiers.push(u)), y.push(u)) : e[a].ty === "rp" && (S ? (u = t[a], u.closed = !0) : (u = ShapeModifiers.getModifier(e[a].ty), t[a] = u, u.init(this, e, a, t), this.shapeModifiers.push(u), i = !1), y.push(u));
        this.addProcessedElement(e[a], a + 1);
      }
      for (this.removeTransformFromStyleList(), this.closeStyles(p), n = y.length, a = 0; a < n; a += 1)
        y[a].closed = !0;
    }, CVShapeElement.prototype.renderInnerContent = function() {
      this.transformHelper.opacity = 1, this.transformHelper._opMdf = !1, this.renderModifiers(), this.transformsManager.processSequences(this._isFirstFrame), this.renderShape(this.transformHelper, this.shapesData, this.itemsData, !0);
    }, CVShapeElement.prototype.renderShapeTransform = function(e, t) {
      (e._opMdf || t.op._mdf || this._isFirstFrame) && (t.opacity = e.opacity, t.opacity *= t.op.v, t._opMdf = !0);
    }, CVShapeElement.prototype.drawLayer = function() {
      var e, t = this.stylesList.length, r, i, s, a, n, l, o = this.globalData.renderer, p = this.globalData.canvasContext, y, S;
      for (e = 0; e < t; e += 1)
        if (S = this.stylesList[e], y = S.type, !((y === "st" || y === "gs") && S.wi === 0 || !S.data._shouldRender || S.coOp === 0 || this.globalData.currentGlobalAlpha === 0)) {
          for (o.save(), n = S.elements, y === "st" || y === "gs" ? (o.ctxStrokeStyle(y === "st" ? S.co : S.grd), o.ctxLineWidth(S.wi), o.ctxLineCap(S.lc), o.ctxLineJoin(S.lj), o.ctxMiterLimit(S.ml || 0)) : o.ctxFillStyle(y === "fl" ? S.co : S.grd), o.ctxOpacity(S.coOp), y !== "st" && y !== "gs" && p.beginPath(), o.ctxTransform(S.preTransforms.finalTransform.props), i = n.length, r = 0; r < i; r += 1) {
            for ((y === "st" || y === "gs") && (p.beginPath(), S.da && (p.setLineDash(S.da), p.lineDashOffset = S.do)), l = n[r].trNodes, a = l.length, s = 0; s < a; s += 1)
              l[s].t === "m" ? p.moveTo(l[s].p[0], l[s].p[1]) : l[s].t === "c" ? p.bezierCurveTo(l[s].pts[0], l[s].pts[1], l[s].pts[2], l[s].pts[3], l[s].pts[4], l[s].pts[5]) : p.closePath();
            (y === "st" || y === "gs") && (o.ctxStroke(), S.da && p.setLineDash(this.dashResetter));
          }
          y !== "st" && y !== "gs" && this.globalData.renderer.ctxFill(S.r), o.restore();
        }
    }, CVShapeElement.prototype.renderShape = function(e, t, r, i) {
      var s, a = t.length - 1, n;
      for (n = e, s = a; s >= 0; s -= 1)
        t[s].ty === "tr" ? (n = r[s].transform, this.renderShapeTransform(e, n)) : t[s].ty === "sh" || t[s].ty === "el" || t[s].ty === "rc" || t[s].ty === "sr" ? this.renderPath(t[s], r[s]) : t[s].ty === "fl" ? this.renderFill(t[s], r[s], n) : t[s].ty === "st" ? this.renderStroke(t[s], r[s], n) : t[s].ty === "gf" || t[s].ty === "gs" ? this.renderGradientFill(t[s], r[s], n) : t[s].ty === "gr" && this.renderShape(n, t[s].it, r[s].it);
      i && this.drawLayer();
    }, CVShapeElement.prototype.renderStyledShape = function(e, t) {
      if (this._isFirstFrame || t._mdf || e.transforms._mdf) {
        var r = e.trNodes, i = t.paths, s, a, n, l = i._length;
        r.length = 0;
        var o = e.transforms.finalTransform;
        for (n = 0; n < l; n += 1) {
          var p = i.shapes[n];
          if (p && p.v) {
            for (a = p._length, s = 1; s < a; s += 1)
              s === 1 && r.push({
                t: "m",
                p: o.applyToPointArray(p.v[0][0], p.v[0][1], 0)
              }), r.push({
                t: "c",
                pts: o.applyToTriplePoints(p.o[s - 1], p.i[s], p.v[s])
              });
            a === 1 && r.push({
              t: "m",
              p: o.applyToPointArray(p.v[0][0], p.v[0][1], 0)
            }), p.c && a && (r.push({
              t: "c",
              pts: o.applyToTriplePoints(p.o[s - 1], p.i[0], p.v[0])
            }), r.push({
              t: "z"
            }));
          }
        }
        e.trNodes = r;
      }
    }, CVShapeElement.prototype.renderPath = function(e, t) {
      if (e.hd !== !0 && e._shouldRender) {
        var r, i = t.styledShapes.length;
        for (r = 0; r < i; r += 1)
          this.renderStyledShape(t.styledShapes[r], t.sh);
      }
    }, CVShapeElement.prototype.renderFill = function(e, t, r) {
      var i = t.style;
      (t.c._mdf || this._isFirstFrame) && (i.co = "rgb(" + bmFloor(t.c.v[0]) + "," + bmFloor(t.c.v[1]) + "," + bmFloor(t.c.v[2]) + ")"), (t.o._mdf || r._opMdf || this._isFirstFrame) && (i.coOp = t.o.v * r.opacity);
    }, CVShapeElement.prototype.renderGradientFill = function(e, t, r) {
      var i = t.style, s;
      if (!i.grd || t.g._mdf || t.s._mdf || t.e._mdf || e.t !== 1 && (t.h._mdf || t.a._mdf)) {
        var a = this.globalData.canvasContext, n = t.s.v, l = t.e.v;
        if (e.t === 1)
          s = a.createLinearGradient(n[0], n[1], l[0], l[1]);
        else {
          var o = Math.sqrt(Math.pow(n[0] - l[0], 2) + Math.pow(n[1] - l[1], 2)), p = Math.atan2(l[1] - n[1], l[0] - n[0]), y = t.h.v;
          y >= 1 ? y = 0.99 : y <= -1 && (y = -0.99);
          var S = o * y, u = Math.cos(p + t.a.v) * S + n[0], P = Math.sin(p + t.a.v) * S + n[1];
          s = a.createRadialGradient(u, P, 0, n[0], n[1], o);
        }
        var b, d = e.g.p, C = t.g.c, c = 1;
        for (b = 0; b < d; b += 1)
          t.g._hasOpacity && t.g._collapsable && (c = t.g.o[b * 2 + 1]), s.addColorStop(C[b * 4] / 100, "rgba(" + C[b * 4 + 1] + "," + C[b * 4 + 2] + "," + C[b * 4 + 3] + "," + c + ")");
        i.grd = s;
      }
      i.coOp = t.o.v * r.opacity;
    }, CVShapeElement.prototype.renderStroke = function(e, t, r) {
      var i = t.style, s = t.d;
      s && (s._mdf || this._isFirstFrame) && (i.da = s.dashArray, i.do = s.dashoffset[0]), (t.c._mdf || this._isFirstFrame) && (i.co = "rgb(" + bmFloor(t.c.v[0]) + "," + bmFloor(t.c.v[1]) + "," + bmFloor(t.c.v[2]) + ")"), (t.o._mdf || r._opMdf || this._isFirstFrame) && (i.coOp = t.o.v * r.opacity), (t.w._mdf || this._isFirstFrame) && (i.wi = t.w.v);
    }, CVShapeElement.prototype.destroy = function() {
      this.shapesData = null, this.globalData = null, this.canvasContext = null, this.stylesList.length = 0, this.itemsData.length = 0;
    };
    function CVTextElement(e, t, r) {
      this.textSpans = [], this.yOffset = 0, this.fillColorAnim = !1, this.strokeColorAnim = !1, this.strokeWidthAnim = !1, this.stroke = !1, this.fill = !1, this.justifyOffset = 0, this.currentRender = null, this.renderType = "canvas", this.values = {
        fill: "rgba(0,0,0,0)",
        stroke: "rgba(0,0,0,0)",
        sWidth: 0,
        fValue: ""
      }, this.initElement(e, t, r);
    }
    extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement, ITextElement], CVTextElement), CVTextElement.prototype.tHelper = createTag("canvas").getContext("2d"), CVTextElement.prototype.buildNewText = function() {
      var e = this.textProperty.currentData;
      this.renderedLetters = createSizedArray(e.l ? e.l.length : 0);
      var t = !1;
      e.fc ? (t = !0, this.values.fill = this.buildColor(e.fc)) : this.values.fill = "rgba(0,0,0,0)", this.fill = t;
      var r = !1;
      e.sc && (r = !0, this.values.stroke = this.buildColor(e.sc), this.values.sWidth = e.sw);
      var i = this.globalData.fontManager.getFontByName(e.f), s, a, n = e.l, l = this.mHelper;
      this.stroke = r, this.values.fValue = e.finalSize + "px " + this.globalData.fontManager.getFontByName(e.f).fFamily, a = e.finalText.length;
      var o, p, y, S, u, P, b, d, C, c, m = this.data.singleShape, f = e.tr * 1e-3 * e.finalSize, g = 0, E = 0, A = !0, k = 0;
      for (s = 0; s < a; s += 1) {
        o = this.globalData.fontManager.getCharData(e.finalText[s], i.fStyle, this.globalData.fontManager.getFontByName(e.f).fFamily), p = o && o.data || {}, l.reset(), m && n[s].n && (g = -f, E += e.yOffset, E += A ? 1 : 0, A = !1), u = p.shapes ? p.shapes[0].it : [], b = u.length, l.scale(e.finalSize / 100, e.finalSize / 100), m && this.applyTextPropertiesToMatrix(e, l, n[s].line, g, E), C = createSizedArray(b - 1);
        var M = 0;
        for (P = 0; P < b; P += 1)
          if (u[P].ty === "sh") {
            for (S = u[P].ks.k.i.length, d = u[P].ks.k, c = [], y = 1; y < S; y += 1)
              y === 1 && c.push(l.applyToX(d.v[0][0], d.v[0][1], 0), l.applyToY(d.v[0][0], d.v[0][1], 0)), c.push(l.applyToX(d.o[y - 1][0], d.o[y - 1][1], 0), l.applyToY(d.o[y - 1][0], d.o[y - 1][1], 0), l.applyToX(d.i[y][0], d.i[y][1], 0), l.applyToY(d.i[y][0], d.i[y][1], 0), l.applyToX(d.v[y][0], d.v[y][1], 0), l.applyToY(d.v[y][0], d.v[y][1], 0));
            c.push(l.applyToX(d.o[y - 1][0], d.o[y - 1][1], 0), l.applyToY(d.o[y - 1][0], d.o[y - 1][1], 0), l.applyToX(d.i[0][0], d.i[0][1], 0), l.applyToY(d.i[0][0], d.i[0][1], 0), l.applyToX(d.v[0][0], d.v[0][1], 0), l.applyToY(d.v[0][0], d.v[0][1], 0)), C[M] = c, M += 1;
          }
        m && (g += n[s].l, g += f), this.textSpans[k] ? this.textSpans[k].elem = C : this.textSpans[k] = {
          elem: C
        }, k += 1;
      }
    }, CVTextElement.prototype.renderInnerContent = function() {
      this.validateText();
      var e = this.canvasContext;
      e.font = this.values.fValue, this.globalData.renderer.ctxLineCap("butt"), this.globalData.renderer.ctxLineJoin("miter"), this.globalData.renderer.ctxMiterLimit(4), this.data.singleShape || this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
      var t, r, i, s, a, n, l = this.textAnimator.renderedLetters, o = this.textProperty.currentData.l;
      r = o.length;
      var p, y = null, S = null, u = null, P, b, d = this.globalData.renderer;
      for (t = 0; t < r; t += 1)
        if (!o[t].n) {
          if (p = l[t], p && (d.save(), d.ctxTransform(p.p), d.ctxOpacity(p.o)), this.fill) {
            for (p && p.fc ? y !== p.fc && (d.ctxFillStyle(p.fc), y = p.fc) : y !== this.values.fill && (y = this.values.fill, d.ctxFillStyle(this.values.fill)), P = this.textSpans[t].elem, s = P.length, this.globalData.canvasContext.beginPath(), i = 0; i < s; i += 1)
              for (b = P[i], n = b.length, this.globalData.canvasContext.moveTo(b[0], b[1]), a = 2; a < n; a += 6)
                this.globalData.canvasContext.bezierCurveTo(b[a], b[a + 1], b[a + 2], b[a + 3], b[a + 4], b[a + 5]);
            this.globalData.canvasContext.closePath(), d.ctxFill();
          }
          if (this.stroke) {
            for (p && p.sw ? u !== p.sw && (u = p.sw, d.ctxLineWidth(p.sw)) : u !== this.values.sWidth && (u = this.values.sWidth, d.ctxLineWidth(this.values.sWidth)), p && p.sc ? S !== p.sc && (S = p.sc, d.ctxStrokeStyle(p.sc)) : S !== this.values.stroke && (S = this.values.stroke, d.ctxStrokeStyle(this.values.stroke)), P = this.textSpans[t].elem, s = P.length, this.globalData.canvasContext.beginPath(), i = 0; i < s; i += 1)
              for (b = P[i], n = b.length, this.globalData.canvasContext.moveTo(b[0], b[1]), a = 2; a < n; a += 6)
                this.globalData.canvasContext.bezierCurveTo(b[a], b[a + 1], b[a + 2], b[a + 3], b[a + 4], b[a + 5]);
            this.globalData.canvasContext.closePath(), d.ctxStroke();
          }
          p && this.globalData.renderer.restore();
        }
    };
    function CVImageElement(e, t, r) {
      this.assetData = t.getAssetData(e.refId), this.img = t.imageLoader.getAsset(this.assetData), this.initElement(e, t, r);
    }
    extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement], CVImageElement), CVImageElement.prototype.initElement = SVGShapeElement.prototype.initElement, CVImageElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame, CVImageElement.prototype.createContent = function() {
      if (this.img.width && (this.assetData.w !== this.img.width || this.assetData.h !== this.img.height)) {
        var e = createTag("canvas");
        e.width = this.assetData.w, e.height = this.assetData.h;
        var t = e.getContext("2d"), r = this.img.width, i = this.img.height, s = r / i, a = this.assetData.w / this.assetData.h, n, l, o = this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio;
        s > a && o === "xMidYMid slice" || s < a && o !== "xMidYMid slice" ? (l = i, n = l * a) : (n = r, l = n / a), t.drawImage(this.img, (r - n) / 2, (i - l) / 2, n, l, 0, 0, this.assetData.w, this.assetData.h), this.img = e;
      }
    }, CVImageElement.prototype.renderInnerContent = function() {
      this.canvasContext.drawImage(this.img, 0, 0);
    }, CVImageElement.prototype.destroy = function() {
      this.img = null;
    };
    function CVSolidElement(e, t, r) {
      this.initElement(e, t, r);
    }
    extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement], CVSolidElement), CVSolidElement.prototype.initElement = SVGShapeElement.prototype.initElement, CVSolidElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame, CVSolidElement.prototype.renderInnerContent = function() {
      this.globalData.renderer.ctxFillStyle(this.data.sc), this.globalData.renderer.ctxFillRect(0, 0, this.data.sw, this.data.sh);
    };
    function CanvasRendererBase() {
    }
    extendPrototype([BaseRenderer], CanvasRendererBase), CanvasRendererBase.prototype.createShape = function(e) {
      return new CVShapeElement(e, this.globalData, this);
    }, CanvasRendererBase.prototype.createText = function(e) {
      return new CVTextElement(e, this.globalData, this);
    }, CanvasRendererBase.prototype.createImage = function(e) {
      return new CVImageElement(e, this.globalData, this);
    }, CanvasRendererBase.prototype.createSolid = function(e) {
      return new CVSolidElement(e, this.globalData, this);
    }, CanvasRendererBase.prototype.createNull = SVGRenderer.prototype.createNull, CanvasRendererBase.prototype.ctxTransform = function(e) {
      e[0] === 1 && e[1] === 0 && e[4] === 0 && e[5] === 1 && e[12] === 0 && e[13] === 0 || this.canvasContext.transform(e[0], e[1], e[4], e[5], e[12], e[13]);
    }, CanvasRendererBase.prototype.ctxOpacity = function(e) {
      this.canvasContext.globalAlpha *= e < 0 ? 0 : e;
    }, CanvasRendererBase.prototype.ctxFillStyle = function(e) {
      this.canvasContext.fillStyle = e;
    }, CanvasRendererBase.prototype.ctxStrokeStyle = function(e) {
      this.canvasContext.strokeStyle = e;
    }, CanvasRendererBase.prototype.ctxLineWidth = function(e) {
      this.canvasContext.lineWidth = e;
    }, CanvasRendererBase.prototype.ctxLineCap = function(e) {
      this.canvasContext.lineCap = e;
    }, CanvasRendererBase.prototype.ctxLineJoin = function(e) {
      this.canvasContext.lineJoin = e;
    }, CanvasRendererBase.prototype.ctxMiterLimit = function(e) {
      this.canvasContext.miterLimit = e;
    }, CanvasRendererBase.prototype.ctxFill = function(e) {
      this.canvasContext.fill(e);
    }, CanvasRendererBase.prototype.ctxFillRect = function(e, t, r, i) {
      this.canvasContext.fillRect(e, t, r, i);
    }, CanvasRendererBase.prototype.ctxStroke = function() {
      this.canvasContext.stroke();
    }, CanvasRendererBase.prototype.reset = function() {
      if (!this.renderConfig.clearCanvas) {
        this.canvasContext.restore();
        return;
      }
      this.contextData.reset();
    }, CanvasRendererBase.prototype.save = function() {
      this.canvasContext.save();
    }, CanvasRendererBase.prototype.restore = function(e) {
      if (!this.renderConfig.clearCanvas) {
        this.canvasContext.restore();
        return;
      }
      e && (this.globalData.blendMode = "source-over"), this.contextData.restore(e);
    }, CanvasRendererBase.prototype.configAnimation = function(e) {
      if (this.animationItem.wrapper) {
        this.animationItem.container = createTag("canvas");
        var t = this.animationItem.container.style;
        t.width = "100%", t.height = "100%";
        var r = "0px 0px 0px";
        t.transformOrigin = r, t.mozTransformOrigin = r, t.webkitTransformOrigin = r, t["-webkit-transform"] = r, t.contentVisibility = this.renderConfig.contentVisibility, this.animationItem.wrapper.appendChild(this.animationItem.container), this.canvasContext = this.animationItem.container.getContext("2d"), this.renderConfig.className && this.animationItem.container.setAttribute("class", this.renderConfig.className), this.renderConfig.id && this.animationItem.container.setAttribute("id", this.renderConfig.id);
      } else
        this.canvasContext = this.renderConfig.context;
      this.contextData.setContext(this.canvasContext), this.data = e, this.layers = e.layers, this.transformCanvas = {
        w: e.w,
        h: e.h,
        sx: 0,
        sy: 0,
        tx: 0,
        ty: 0
      }, this.setupGlobalData(e, document.body), this.globalData.canvasContext = this.canvasContext, this.globalData.renderer = this, this.globalData.isDashed = !1, this.globalData.progressiveLoad = this.renderConfig.progressiveLoad, this.globalData.transformCanvas = this.transformCanvas, this.elements = createSizedArray(e.layers.length), this.updateContainerSize();
    }, CanvasRendererBase.prototype.updateContainerSize = function(e, t) {
      this.reset();
      var r, i;
      e ? (r = e, i = t, this.canvasContext.canvas.width = r, this.canvasContext.canvas.height = i) : (this.animationItem.wrapper && this.animationItem.container ? (r = this.animationItem.wrapper.offsetWidth, i = this.animationItem.wrapper.offsetHeight) : (r = this.canvasContext.canvas.width, i = this.canvasContext.canvas.height), this.canvasContext.canvas.width = r * this.renderConfig.dpr, this.canvasContext.canvas.height = i * this.renderConfig.dpr);
      var s, a;
      if (this.renderConfig.preserveAspectRatio.indexOf("meet") !== -1 || this.renderConfig.preserveAspectRatio.indexOf("slice") !== -1) {
        var n = this.renderConfig.preserveAspectRatio.split(" "), l = n[1] || "meet", o = n[0] || "xMidYMid", p = o.substr(0, 4), y = o.substr(4);
        s = r / i, a = this.transformCanvas.w / this.transformCanvas.h, a > s && l === "meet" || a < s && l === "slice" ? (this.transformCanvas.sx = r / (this.transformCanvas.w / this.renderConfig.dpr), this.transformCanvas.sy = r / (this.transformCanvas.w / this.renderConfig.dpr)) : (this.transformCanvas.sx = i / (this.transformCanvas.h / this.renderConfig.dpr), this.transformCanvas.sy = i / (this.transformCanvas.h / this.renderConfig.dpr)), p === "xMid" && (a < s && l === "meet" || a > s && l === "slice") ? this.transformCanvas.tx = (r - this.transformCanvas.w * (i / this.transformCanvas.h)) / 2 * this.renderConfig.dpr : p === "xMax" && (a < s && l === "meet" || a > s && l === "slice") ? this.transformCanvas.tx = (r - this.transformCanvas.w * (i / this.transformCanvas.h)) * this.renderConfig.dpr : this.transformCanvas.tx = 0, y === "YMid" && (a > s && l === "meet" || a < s && l === "slice") ? this.transformCanvas.ty = (i - this.transformCanvas.h * (r / this.transformCanvas.w)) / 2 * this.renderConfig.dpr : y === "YMax" && (a > s && l === "meet" || a < s && l === "slice") ? this.transformCanvas.ty = (i - this.transformCanvas.h * (r / this.transformCanvas.w)) * this.renderConfig.dpr : this.transformCanvas.ty = 0;
      } else
        this.renderConfig.preserveAspectRatio === "none" ? (this.transformCanvas.sx = r / (this.transformCanvas.w / this.renderConfig.dpr), this.transformCanvas.sy = i / (this.transformCanvas.h / this.renderConfig.dpr), this.transformCanvas.tx = 0, this.transformCanvas.ty = 0) : (this.transformCanvas.sx = this.renderConfig.dpr, this.transformCanvas.sy = this.renderConfig.dpr, this.transformCanvas.tx = 0, this.transformCanvas.ty = 0);
      this.transformCanvas.props = [this.transformCanvas.sx, 0, 0, 0, 0, this.transformCanvas.sy, 0, 0, 0, 0, 1, 0, this.transformCanvas.tx, this.transformCanvas.ty, 0, 1], this.ctxTransform(this.transformCanvas.props), this.canvasContext.beginPath(), this.canvasContext.rect(0, 0, this.transformCanvas.w, this.transformCanvas.h), this.canvasContext.closePath(), this.canvasContext.clip(), this.renderFrame(this.renderedFrame, !0);
    }, CanvasRendererBase.prototype.destroy = function() {
      this.renderConfig.clearCanvas && this.animationItem.wrapper && (this.animationItem.wrapper.innerText = "");
      var e, t = this.layers ? this.layers.length : 0;
      for (e = t - 1; e >= 0; e -= 1)
        this.elements[e] && this.elements[e].destroy && this.elements[e].destroy();
      this.elements.length = 0, this.globalData.canvasContext = null, this.animationItem.container = null, this.destroyed = !0;
    }, CanvasRendererBase.prototype.renderFrame = function(e, t) {
      if (!(this.renderedFrame === e && this.renderConfig.clearCanvas === !0 && !t || this.destroyed || e === -1)) {
        this.renderedFrame = e, this.globalData.frameNum = e - this.animationItem._isFirstFrame, this.globalData.frameId += 1, this.globalData._mdf = !this.renderConfig.clearCanvas || t, this.globalData.projectInterface.currentFrame = e;
        var r, i = this.layers.length;
        for (this.completeLayers || this.checkLayers(e), r = i - 1; r >= 0; r -= 1)
          (this.completeLayers || this.elements[r]) && this.elements[r].prepareFrame(e - this.layers[r].st);
        if (this.globalData._mdf) {
          for (this.renderConfig.clearCanvas === !0 ? this.canvasContext.clearRect(0, 0, this.transformCanvas.w, this.transformCanvas.h) : this.save(), r = i - 1; r >= 0; r -= 1)
            (this.completeLayers || this.elements[r]) && this.elements[r].renderFrame();
          this.renderConfig.clearCanvas !== !0 && this.restore();
        }
      }
    }, CanvasRendererBase.prototype.buildItem = function(e) {
      var t = this.elements;
      if (!(t[e] || this.layers[e].ty === 99)) {
        var r = this.createItem(this.layers[e], this, this.globalData);
        t[e] = r, r.initExpressions();
      }
    }, CanvasRendererBase.prototype.checkPendingElements = function() {
      for (; this.pendingElements.length; ) {
        var e = this.pendingElements.pop();
        e.checkParenting();
      }
    }, CanvasRendererBase.prototype.hide = function() {
      this.animationItem.container.style.display = "none";
    }, CanvasRendererBase.prototype.show = function() {
      this.animationItem.container.style.display = "block";
    };
    function CanvasContext() {
      this.opacity = -1, this.transform = createTypedArray("float32", 16), this.fillStyle = "", this.strokeStyle = "", this.lineWidth = "", this.lineCap = "", this.lineJoin = "", this.miterLimit = "", this.id = Math.random();
    }
    function CVContextData() {
      this.stack = [], this.cArrPos = 0, this.cTr = new Matrix();
      var e, t = 15;
      for (e = 0; e < t; e += 1) {
        var r = new CanvasContext();
        this.stack[e] = r;
      }
      this._length = t, this.nativeContext = null, this.transformMat = new Matrix(), this.currentOpacity = 1, this.currentFillStyle = "", this.appliedFillStyle = "", this.currentStrokeStyle = "", this.appliedStrokeStyle = "", this.currentLineWidth = "", this.appliedLineWidth = "", this.currentLineCap = "", this.appliedLineCap = "", this.currentLineJoin = "", this.appliedLineJoin = "", this.appliedMiterLimit = "", this.currentMiterLimit = "";
    }
    CVContextData.prototype.duplicate = function() {
      var e = this._length * 2, t = 0;
      for (t = this._length; t < e; t += 1)
        this.stack[t] = new CanvasContext();
      this._length = e;
    }, CVContextData.prototype.reset = function() {
      this.cArrPos = 0, this.cTr.reset(), this.stack[this.cArrPos].opacity = 1;
    }, CVContextData.prototype.restore = function(e) {
      this.cArrPos -= 1;
      var t = this.stack[this.cArrPos], r = t.transform, i, s = this.cTr.props;
      for (i = 0; i < 16; i += 1)
        s[i] = r[i];
      if (e) {
        this.nativeContext.restore();
        var a = this.stack[this.cArrPos + 1];
        this.appliedFillStyle = a.fillStyle, this.appliedStrokeStyle = a.strokeStyle, this.appliedLineWidth = a.lineWidth, this.appliedLineCap = a.lineCap, this.appliedLineJoin = a.lineJoin, this.appliedMiterLimit = a.miterLimit;
      }
      this.nativeContext.setTransform(r[0], r[1], r[4], r[5], r[12], r[13]), (e || t.opacity !== -1 && this.currentOpacity !== t.opacity) && (this.nativeContext.globalAlpha = t.opacity, this.currentOpacity = t.opacity), this.currentFillStyle = t.fillStyle, this.currentStrokeStyle = t.strokeStyle, this.currentLineWidth = t.lineWidth, this.currentLineCap = t.lineCap, this.currentLineJoin = t.lineJoin, this.currentMiterLimit = t.miterLimit;
    }, CVContextData.prototype.save = function(e) {
      e && this.nativeContext.save();
      var t = this.cTr.props;
      this._length <= this.cArrPos && this.duplicate();
      var r = this.stack[this.cArrPos], i;
      for (i = 0; i < 16; i += 1)
        r.transform[i] = t[i];
      this.cArrPos += 1;
      var s = this.stack[this.cArrPos];
      s.opacity = r.opacity, s.fillStyle = r.fillStyle, s.strokeStyle = r.strokeStyle, s.lineWidth = r.lineWidth, s.lineCap = r.lineCap, s.lineJoin = r.lineJoin, s.miterLimit = r.miterLimit;
    }, CVContextData.prototype.setOpacity = function(e) {
      this.stack[this.cArrPos].opacity = e;
    }, CVContextData.prototype.setContext = function(e) {
      this.nativeContext = e;
    }, CVContextData.prototype.fillStyle = function(e) {
      this.stack[this.cArrPos].fillStyle !== e && (this.currentFillStyle = e, this.stack[this.cArrPos].fillStyle = e);
    }, CVContextData.prototype.strokeStyle = function(e) {
      this.stack[this.cArrPos].strokeStyle !== e && (this.currentStrokeStyle = e, this.stack[this.cArrPos].strokeStyle = e);
    }, CVContextData.prototype.lineWidth = function(e) {
      this.stack[this.cArrPos].lineWidth !== e && (this.currentLineWidth = e, this.stack[this.cArrPos].lineWidth = e);
    }, CVContextData.prototype.lineCap = function(e) {
      this.stack[this.cArrPos].lineCap !== e && (this.currentLineCap = e, this.stack[this.cArrPos].lineCap = e);
    }, CVContextData.prototype.lineJoin = function(e) {
      this.stack[this.cArrPos].lineJoin !== e && (this.currentLineJoin = e, this.stack[this.cArrPos].lineJoin = e);
    }, CVContextData.prototype.miterLimit = function(e) {
      this.stack[this.cArrPos].miterLimit !== e && (this.currentMiterLimit = e, this.stack[this.cArrPos].miterLimit = e);
    }, CVContextData.prototype.transform = function(e) {
      this.transformMat.cloneFromProps(e);
      var t = this.cTr;
      this.transformMat.multiply(t), t.cloneFromProps(this.transformMat.props);
      var r = t.props;
      this.nativeContext.setTransform(r[0], r[1], r[4], r[5], r[12], r[13]);
    }, CVContextData.prototype.opacity = function(e) {
      var t = this.stack[this.cArrPos].opacity;
      t *= e < 0 ? 0 : e, this.stack[this.cArrPos].opacity !== t && (this.currentOpacity !== e && (this.nativeContext.globalAlpha = e, this.currentOpacity = e), this.stack[this.cArrPos].opacity = t);
    }, CVContextData.prototype.fill = function(e) {
      this.appliedFillStyle !== this.currentFillStyle && (this.appliedFillStyle = this.currentFillStyle, this.nativeContext.fillStyle = this.appliedFillStyle), this.nativeContext.fill(e);
    }, CVContextData.prototype.fillRect = function(e, t, r, i) {
      this.appliedFillStyle !== this.currentFillStyle && (this.appliedFillStyle = this.currentFillStyle, this.nativeContext.fillStyle = this.appliedFillStyle), this.nativeContext.fillRect(e, t, r, i);
    }, CVContextData.prototype.stroke = function() {
      this.appliedStrokeStyle !== this.currentStrokeStyle && (this.appliedStrokeStyle = this.currentStrokeStyle, this.nativeContext.strokeStyle = this.appliedStrokeStyle), this.appliedLineWidth !== this.currentLineWidth && (this.appliedLineWidth = this.currentLineWidth, this.nativeContext.lineWidth = this.appliedLineWidth), this.appliedLineCap !== this.currentLineCap && (this.appliedLineCap = this.currentLineCap, this.nativeContext.lineCap = this.appliedLineCap), this.appliedLineJoin !== this.currentLineJoin && (this.appliedLineJoin = this.currentLineJoin, this.nativeContext.lineJoin = this.appliedLineJoin), this.appliedMiterLimit !== this.currentMiterLimit && (this.appliedMiterLimit = this.currentMiterLimit, this.nativeContext.miterLimit = this.appliedMiterLimit), this.nativeContext.stroke();
    };
    function CVCompElement(e, t, r) {
      this.completeLayers = !1, this.layers = e.layers, this.pendingElements = [], this.elements = createSizedArray(this.layers.length), this.initElement(e, t, r), this.tm = e.tm ? PropertyFactory.getProp(this, e.tm, 0, t.frameRate, this) : {
        _placeholder: !0
      };
    }
    extendPrototype([CanvasRendererBase, ICompElement, CVBaseElement], CVCompElement), CVCompElement.prototype.renderInnerContent = function() {
      var e = this.canvasContext;
      e.beginPath(), e.moveTo(0, 0), e.lineTo(this.data.w, 0), e.lineTo(this.data.w, this.data.h), e.lineTo(0, this.data.h), e.lineTo(0, 0), e.clip();
      var t, r = this.layers.length;
      for (t = r - 1; t >= 0; t -= 1)
        (this.completeLayers || this.elements[t]) && this.elements[t].renderFrame();
    }, CVCompElement.prototype.destroy = function() {
      var e, t = this.layers.length;
      for (e = t - 1; e >= 0; e -= 1)
        this.elements[e] && this.elements[e].destroy();
      this.layers = null, this.elements = null;
    }, CVCompElement.prototype.createComp = function(e) {
      return new CVCompElement(e, this.globalData, this);
    };
    function CanvasRenderer(e, t) {
      this.animationItem = e, this.renderConfig = {
        clearCanvas: t && t.clearCanvas !== void 0 ? t.clearCanvas : !0,
        context: t && t.context || null,
        progressiveLoad: t && t.progressiveLoad || !1,
        preserveAspectRatio: t && t.preserveAspectRatio || "xMidYMid meet",
        imagePreserveAspectRatio: t && t.imagePreserveAspectRatio || "xMidYMid slice",
        contentVisibility: t && t.contentVisibility || "visible",
        className: t && t.className || "",
        id: t && t.id || "",
        runExpressions: !t || t.runExpressions === void 0 || t.runExpressions
      }, this.renderConfig.dpr = t && t.dpr || 1, this.animationItem.wrapper && (this.renderConfig.dpr = t && t.dpr || window.devicePixelRatio || 1), this.renderedFrame = -1, this.globalData = {
        frameNum: -1,
        _mdf: !1,
        renderConfig: this.renderConfig,
        currentGlobalAlpha: -1
      }, this.contextData = new CVContextData(), this.elements = [], this.pendingElements = [], this.transformMat = new Matrix(), this.completeLayers = !1, this.rendererType = "canvas", this.renderConfig.clearCanvas && (this.ctxTransform = this.contextData.transform.bind(this.contextData), this.ctxOpacity = this.contextData.opacity.bind(this.contextData), this.ctxFillStyle = this.contextData.fillStyle.bind(this.contextData), this.ctxStrokeStyle = this.contextData.strokeStyle.bind(this.contextData), this.ctxLineWidth = this.contextData.lineWidth.bind(this.contextData), this.ctxLineCap = this.contextData.lineCap.bind(this.contextData), this.ctxLineJoin = this.contextData.lineJoin.bind(this.contextData), this.ctxMiterLimit = this.contextData.miterLimit.bind(this.contextData), this.ctxFill = this.contextData.fill.bind(this.contextData), this.ctxFillRect = this.contextData.fillRect.bind(this.contextData), this.ctxStroke = this.contextData.stroke.bind(this.contextData), this.save = this.contextData.save.bind(this.contextData));
    }
    extendPrototype([CanvasRendererBase], CanvasRenderer), CanvasRenderer.prototype.createComp = function(e) {
      return new CVCompElement(e, this.globalData, this);
    };
    function HBaseElement() {
    }
    HBaseElement.prototype = {
      checkBlendMode: function() {
      },
      initRendererElement: function() {
        this.baseElement = createTag(this.data.tg || "div"), this.data.hasMask ? (this.svgElement = createNS("svg"), this.layerElement = createNS("g"), this.maskedElement = this.layerElement, this.svgElement.appendChild(this.layerElement), this.baseElement.appendChild(this.svgElement)) : this.layerElement = this.baseElement, styleDiv(this.baseElement);
      },
      createContainerElements: function() {
        this.renderableEffectsManager = new CVEffects(this), this.transformedElement = this.baseElement, this.maskedElement = this.layerElement, this.data.ln && this.layerElement.setAttribute("id", this.data.ln), this.data.cl && this.layerElement.setAttribute("class", this.data.cl), this.data.bm !== 0 && this.setBlendMode();
      },
      renderElement: function() {
        var t = this.transformedElement ? this.transformedElement.style : {};
        if (this.finalTransform._matMdf) {
          var r = this.finalTransform.mat.toCSS();
          t.transform = r, t.webkitTransform = r;
        }
        this.finalTransform._opMdf && (t.opacity = this.finalTransform.mProp.o.v);
      },
      renderFrame: function() {
        this.data.hd || this.hidden || (this.renderTransform(), this.renderRenderable(), this.renderElement(), this.renderInnerContent(), this._isFirstFrame && (this._isFirstFrame = !1));
      },
      destroy: function() {
        this.layerElement = null, this.transformedElement = null, this.matteElement && (this.matteElement = null), this.maskManager && (this.maskManager.destroy(), this.maskManager = null);
      },
      createRenderableComponents: function() {
        this.maskManager = new MaskElement(this.data, this, this.globalData);
      },
      addEffects: function() {
      },
      setMatte: function() {
      }
    }, HBaseElement.prototype.getBaseElement = SVGBaseElement.prototype.getBaseElement, HBaseElement.prototype.destroyBaseElement = HBaseElement.prototype.destroy, HBaseElement.prototype.buildElementParenting = BaseRenderer.prototype.buildElementParenting;
    function HSolidElement(e, t, r) {
      this.initElement(e, t, r);
    }
    extendPrototype([BaseElement, TransformElement, HBaseElement, HierarchyElement, FrameElement, RenderableDOMElement], HSolidElement), HSolidElement.prototype.createContent = function() {
      var e;
      this.data.hasMask ? (e = createNS("rect"), e.setAttribute("width", this.data.sw), e.setAttribute("height", this.data.sh), e.setAttribute("fill", this.data.sc), this.svgElement.setAttribute("width", this.data.sw), this.svgElement.setAttribute("height", this.data.sh)) : (e = createTag("div"), e.style.width = this.data.sw + "px", e.style.height = this.data.sh + "px", e.style.backgroundColor = this.data.sc), this.layerElement.appendChild(e);
    };
    function HShapeElement(e, t, r) {
      this.shapes = [], this.shapesData = e.shapes, this.stylesList = [], this.shapeModifiers = [], this.itemsData = [], this.processedElements = [], this.animatedContents = [], this.shapesContainer = createNS("g"), this.initElement(e, t, r), this.prevViewData = [], this.currentBBox = {
        x: 999999,
        y: -999999,
        h: 0,
        w: 0
      };
    }
    extendPrototype([BaseElement, TransformElement, HSolidElement, SVGShapeElement, HBaseElement, HierarchyElement, FrameElement, RenderableElement], HShapeElement), HShapeElement.prototype._renderShapeFrame = HShapeElement.prototype.renderInnerContent, HShapeElement.prototype.createContent = function() {
      var e;
      if (this.baseElement.style.fontSize = 0, this.data.hasMask)
        this.layerElement.appendChild(this.shapesContainer), e = this.svgElement;
      else {
        e = createNS("svg");
        var t = this.comp.data ? this.comp.data : this.globalData.compSize;
        e.setAttribute("width", t.w), e.setAttribute("height", t.h), e.appendChild(this.shapesContainer), this.layerElement.appendChild(e);
      }
      this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.shapesContainer, 0, [], !0), this.filterUniqueShapes(), this.shapeCont = e;
    }, HShapeElement.prototype.getTransformedPoint = function(e, t) {
      var r, i = e.length;
      for (r = 0; r < i; r += 1)
        t = e[r].mProps.v.applyToPointArray(t[0], t[1], 0);
      return t;
    }, HShapeElement.prototype.calculateShapeBoundingBox = function(e, t) {
      var r = e.sh.v, i = e.transformers, s, a = r._length, n, l, o, p;
      if (!(a <= 1)) {
        for (s = 0; s < a - 1; s += 1)
          n = this.getTransformedPoint(i, r.v[s]), l = this.getTransformedPoint(i, r.o[s]), o = this.getTransformedPoint(i, r.i[s + 1]), p = this.getTransformedPoint(i, r.v[s + 1]), this.checkBounds(n, l, o, p, t);
        r.c && (n = this.getTransformedPoint(i, r.v[s]), l = this.getTransformedPoint(i, r.o[s]), o = this.getTransformedPoint(i, r.i[0]), p = this.getTransformedPoint(i, r.v[0]), this.checkBounds(n, l, o, p, t));
      }
    }, HShapeElement.prototype.checkBounds = function(e, t, r, i, s) {
      this.getBoundsOfCurve(e, t, r, i);
      var a = this.shapeBoundingBox;
      s.x = bmMin(a.left, s.x), s.xMax = bmMax(a.right, s.xMax), s.y = bmMin(a.top, s.y), s.yMax = bmMax(a.bottom, s.yMax);
    }, HShapeElement.prototype.shapeBoundingBox = {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, HShapeElement.prototype.tempBoundingBox = {
      x: 0,
      xMax: 0,
      y: 0,
      yMax: 0,
      width: 0,
      height: 0
    }, HShapeElement.prototype.getBoundsOfCurve = function(e, t, r, i) {
      for (var s = [[e[0], i[0]], [e[1], i[1]]], a, n, l, o, p, y, S, u = 0; u < 2; ++u)
        n = 6 * e[u] - 12 * t[u] + 6 * r[u], a = -3 * e[u] + 9 * t[u] - 9 * r[u] + 3 * i[u], l = 3 * t[u] - 3 * e[u], n |= 0, a |= 0, l |= 0, a === 0 && n === 0 || (a === 0 ? (o = -l / n, o > 0 && o < 1 && s[u].push(this.calculateF(o, e, t, r, i, u))) : (p = n * n - 4 * l * a, p >= 0 && (y = (-n + bmSqrt(p)) / (2 * a), y > 0 && y < 1 && s[u].push(this.calculateF(y, e, t, r, i, u)), S = (-n - bmSqrt(p)) / (2 * a), S > 0 && S < 1 && s[u].push(this.calculateF(S, e, t, r, i, u)))));
      this.shapeBoundingBox.left = bmMin.apply(null, s[0]), this.shapeBoundingBox.top = bmMin.apply(null, s[1]), this.shapeBoundingBox.right = bmMax.apply(null, s[0]), this.shapeBoundingBox.bottom = bmMax.apply(null, s[1]);
    }, HShapeElement.prototype.calculateF = function(e, t, r, i, s, a) {
      return bmPow(1 - e, 3) * t[a] + 3 * bmPow(1 - e, 2) * e * r[a] + 3 * (1 - e) * bmPow(e, 2) * i[a] + bmPow(e, 3) * s[a];
    }, HShapeElement.prototype.calculateBoundingBox = function(e, t) {
      var r, i = e.length;
      for (r = 0; r < i; r += 1)
        e[r] && e[r].sh ? this.calculateShapeBoundingBox(e[r], t) : e[r] && e[r].it ? this.calculateBoundingBox(e[r].it, t) : e[r] && e[r].style && e[r].w && this.expandStrokeBoundingBox(e[r].w, t);
    }, HShapeElement.prototype.expandStrokeBoundingBox = function(e, t) {
      var r = 0;
      if (e.keyframes) {
        for (var i = 0; i < e.keyframes.length; i += 1) {
          var s = e.keyframes[i].s;
          s > r && (r = s);
        }
        r *= e.mult;
      } else
        r = e.v * e.mult;
      t.x -= r, t.xMax += r, t.y -= r, t.yMax += r;
    }, HShapeElement.prototype.currentBoxContains = function(e) {
      return this.currentBBox.x <= e.x && this.currentBBox.y <= e.y && this.currentBBox.width + this.currentBBox.x >= e.x + e.width && this.currentBBox.height + this.currentBBox.y >= e.y + e.height;
    }, HShapeElement.prototype.renderInnerContent = function() {
      if (this._renderShapeFrame(), !this.hidden && (this._isFirstFrame || this._mdf)) {
        var e = this.tempBoundingBox, t = 999999;
        if (e.x = t, e.xMax = -t, e.y = t, e.yMax = -t, this.calculateBoundingBox(this.itemsData, e), e.width = e.xMax < e.x ? 0 : e.xMax - e.x, e.height = e.yMax < e.y ? 0 : e.yMax - e.y, this.currentBoxContains(e))
          return;
        var r = !1;
        if (this.currentBBox.w !== e.width && (this.currentBBox.w = e.width, this.shapeCont.setAttribute("width", e.width), r = !0), this.currentBBox.h !== e.height && (this.currentBBox.h = e.height, this.shapeCont.setAttribute("height", e.height), r = !0), r || this.currentBBox.x !== e.x || this.currentBBox.y !== e.y) {
          this.currentBBox.w = e.width, this.currentBBox.h = e.height, this.currentBBox.x = e.x, this.currentBBox.y = e.y, this.shapeCont.setAttribute("viewBox", this.currentBBox.x + " " + this.currentBBox.y + " " + this.currentBBox.w + " " + this.currentBBox.h);
          var i = this.shapeCont.style, s = "translate(" + this.currentBBox.x + "px," + this.currentBBox.y + "px)";
          i.transform = s, i.webkitTransform = s;
        }
      }
    };
    function HTextElement(e, t, r) {
      this.textSpans = [], this.textPaths = [], this.currentBBox = {
        x: 999999,
        y: -999999,
        h: 0,
        w: 0
      }, this.renderType = "svg", this.isMasked = !1, this.initElement(e, t, r);
    }
    extendPrototype([BaseElement, TransformElement, HBaseElement, HierarchyElement, FrameElement, RenderableDOMElement, ITextElement], HTextElement), HTextElement.prototype.createContent = function() {
      if (this.isMasked = this.checkMasks(), this.isMasked) {
        this.renderType = "svg", this.compW = this.comp.data.w, this.compH = this.comp.data.h, this.svgElement.setAttribute("width", this.compW), this.svgElement.setAttribute("height", this.compH);
        var e = createNS("g");
        this.maskedElement.appendChild(e), this.innerElem = e;
      } else
        this.renderType = "html", this.innerElem = this.layerElement;
      this.checkParenting();
    }, HTextElement.prototype.buildNewText = function() {
      var e = this.textProperty.currentData;
      this.renderedLetters = createSizedArray(e.l ? e.l.length : 0);
      var t = this.innerElem.style, r = e.fc ? this.buildColor(e.fc) : "rgba(0,0,0,0)";
      t.fill = r, t.color = r, e.sc && (t.stroke = this.buildColor(e.sc), t.strokeWidth = e.sw + "px");
      var i = this.globalData.fontManager.getFontByName(e.f);
      if (!this.globalData.fontManager.chars)
        if (t.fontSize = e.finalSize + "px", t.lineHeight = e.finalSize + "px", i.fClass)
          this.innerElem.className = i.fClass;
        else {
          t.fontFamily = i.fFamily;
          var s = e.fWeight, a = e.fStyle;
          t.fontStyle = a, t.fontWeight = s;
        }
      var n, l, o = e.l;
      l = o.length;
      var p, y, S, u = this.mHelper, P, b = "", d = 0;
      for (n = 0; n < l; n += 1) {
        if (this.globalData.fontManager.chars ? (this.textPaths[d] ? p = this.textPaths[d] : (p = createNS("path"), p.setAttribute("stroke-linecap", lineCapEnum[1]), p.setAttribute("stroke-linejoin", lineJoinEnum[2]), p.setAttribute("stroke-miterlimit", "4")), this.isMasked || (this.textSpans[d] ? (y = this.textSpans[d], S = y.children[0]) : (y = createTag("div"), y.style.lineHeight = 0, S = createNS("svg"), S.appendChild(p), styleDiv(y)))) : this.isMasked ? p = this.textPaths[d] ? this.textPaths[d] : createNS("text") : this.textSpans[d] ? (y = this.textSpans[d], p = this.textPaths[d]) : (y = createTag("span"), styleDiv(y), p = createTag("span"), styleDiv(p), y.appendChild(p)), this.globalData.fontManager.chars) {
          var C = this.globalData.fontManager.getCharData(e.finalText[n], i.fStyle, this.globalData.fontManager.getFontByName(e.f).fFamily), c;
          if (C ? c = C.data : c = null, u.reset(), c && c.shapes && c.shapes.length && (P = c.shapes[0].it, u.scale(e.finalSize / 100, e.finalSize / 100), b = this.createPathShape(u, P), p.setAttribute("d", b)), this.isMasked)
            this.innerElem.appendChild(p);
          else {
            if (this.innerElem.appendChild(y), c && c.shapes) {
              document.body.appendChild(S);
              var m = S.getBBox();
              S.setAttribute("width", m.width + 2), S.setAttribute("height", m.height + 2), S.setAttribute("viewBox", m.x - 1 + " " + (m.y - 1) + " " + (m.width + 2) + " " + (m.height + 2));
              var f = S.style, g = "translate(" + (m.x - 1) + "px," + (m.y - 1) + "px)";
              f.transform = g, f.webkitTransform = g, o[n].yOffset = m.y - 1;
            } else
              S.setAttribute("width", 1), S.setAttribute("height", 1);
            y.appendChild(S);
          }
        } else if (p.textContent = o[n].val, p.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve"), this.isMasked)
          this.innerElem.appendChild(p);
        else {
          this.innerElem.appendChild(y);
          var E = p.style, A = "translate3d(0," + -e.finalSize / 1.2 + "px,0)";
          E.transform = A, E.webkitTransform = A;
        }
        this.isMasked ? this.textSpans[d] = p : this.textSpans[d] = y, this.textSpans[d].style.display = "block", this.textPaths[d] = p, d += 1;
      }
      for (; d < this.textSpans.length; )
        this.textSpans[d].style.display = "none", d += 1;
    }, HTextElement.prototype.renderInnerContent = function() {
      this.validateText();
      var e;
      if (this.data.singleShape) {
        if (!this._isFirstFrame && !this.lettersChangedFlag)
          return;
        if (this.isMasked && this.finalTransform._matMdf) {
          this.svgElement.setAttribute("viewBox", -this.finalTransform.mProp.p.v[0] + " " + -this.finalTransform.mProp.p.v[1] + " " + this.compW + " " + this.compH), e = this.svgElement.style;
          var t = "translate(" + -this.finalTransform.mProp.p.v[0] + "px," + -this.finalTransform.mProp.p.v[1] + "px)";
          e.transform = t, e.webkitTransform = t;
        }
      }
      if (this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag), !(!this.lettersChangedFlag && !this.textAnimator.lettersChangedFlag)) {
        var r, i, s = 0, a = this.textAnimator.renderedLetters, n = this.textProperty.currentData.l;
        i = n.length;
        var l, o, p;
        for (r = 0; r < i; r += 1)
          n[r].n ? s += 1 : (o = this.textSpans[r], p = this.textPaths[r], l = a[s], s += 1, l._mdf.m && (this.isMasked ? o.setAttribute("transform", l.m) : (o.style.webkitTransform = l.m, o.style.transform = l.m)), o.style.opacity = l.o, l.sw && l._mdf.sw && p.setAttribute("stroke-width", l.sw), l.sc && l._mdf.sc && p.setAttribute("stroke", l.sc), l.fc && l._mdf.fc && (p.setAttribute("fill", l.fc), p.style.color = l.fc));
        if (this.innerElem.getBBox && !this.hidden && (this._isFirstFrame || this._mdf)) {
          var y = this.innerElem.getBBox();
          this.currentBBox.w !== y.width && (this.currentBBox.w = y.width, this.svgElement.setAttribute("width", y.width)), this.currentBBox.h !== y.height && (this.currentBBox.h = y.height, this.svgElement.setAttribute("height", y.height));
          var S = 1;
          if (this.currentBBox.w !== y.width + S * 2 || this.currentBBox.h !== y.height + S * 2 || this.currentBBox.x !== y.x - S || this.currentBBox.y !== y.y - S) {
            this.currentBBox.w = y.width + S * 2, this.currentBBox.h = y.height + S * 2, this.currentBBox.x = y.x - S, this.currentBBox.y = y.y - S, this.svgElement.setAttribute("viewBox", this.currentBBox.x + " " + this.currentBBox.y + " " + this.currentBBox.w + " " + this.currentBBox.h), e = this.svgElement.style;
            var u = "translate(" + this.currentBBox.x + "px," + this.currentBBox.y + "px)";
            e.transform = u, e.webkitTransform = u;
          }
        }
      }
    };
    function HCameraElement(e, t, r) {
      this.initFrame(), this.initBaseData(e, t, r), this.initHierarchy();
      var i = PropertyFactory.getProp;
      if (this.pe = i(this, e.pe, 0, 0, this), e.ks.p.s ? (this.px = i(this, e.ks.p.x, 1, 0, this), this.py = i(this, e.ks.p.y, 1, 0, this), this.pz = i(this, e.ks.p.z, 1, 0, this)) : this.p = i(this, e.ks.p, 1, 0, this), e.ks.a && (this.a = i(this, e.ks.a, 1, 0, this)), e.ks.or.k.length && e.ks.or.k[0].to) {
        var s, a = e.ks.or.k.length;
        for (s = 0; s < a; s += 1)
          e.ks.or.k[s].to = null, e.ks.or.k[s].ti = null;
      }
      this.or = i(this, e.ks.or, 1, degToRads, this), this.or.sh = !0, this.rx = i(this, e.ks.rx, 0, degToRads, this), this.ry = i(this, e.ks.ry, 0, degToRads, this), this.rz = i(this, e.ks.rz, 0, degToRads, this), this.mat = new Matrix(), this._prevMat = new Matrix(), this._isFirstFrame = !0, this.finalTransform = {
        mProp: this
      };
    }
    extendPrototype([BaseElement, FrameElement, HierarchyElement], HCameraElement), HCameraElement.prototype.setup = function() {
      var e, t = this.comp.threeDElements.length, r, i, s;
      for (e = 0; e < t; e += 1)
        if (r = this.comp.threeDElements[e], r.type === "3d") {
          i = r.perspectiveElem.style, s = r.container.style;
          var a = this.pe.v + "px", n = "0px 0px 0px", l = "matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)";
          i.perspective = a, i.webkitPerspective = a, s.transformOrigin = n, s.mozTransformOrigin = n, s.webkitTransformOrigin = n, i.transform = l, i.webkitTransform = l;
        }
    }, HCameraElement.prototype.createElements = function() {
    }, HCameraElement.prototype.hide = function() {
    }, HCameraElement.prototype.renderFrame = function() {
      var e = this._isFirstFrame, t, r;
      if (this.hierarchy)
        for (r = this.hierarchy.length, t = 0; t < r; t += 1)
          e = this.hierarchy[t].finalTransform.mProp._mdf || e;
      if (e || this.pe._mdf || this.p && this.p._mdf || this.px && (this.px._mdf || this.py._mdf || this.pz._mdf) || this.rx._mdf || this.ry._mdf || this.rz._mdf || this.or._mdf || this.a && this.a._mdf) {
        if (this.mat.reset(), this.hierarchy)
          for (r = this.hierarchy.length - 1, t = r; t >= 0; t -= 1) {
            var i = this.hierarchy[t].finalTransform.mProp;
            this.mat.translate(-i.p.v[0], -i.p.v[1], i.p.v[2]), this.mat.rotateX(-i.or.v[0]).rotateY(-i.or.v[1]).rotateZ(i.or.v[2]), this.mat.rotateX(-i.rx.v).rotateY(-i.ry.v).rotateZ(i.rz.v), this.mat.scale(1 / i.s.v[0], 1 / i.s.v[1], 1 / i.s.v[2]), this.mat.translate(i.a.v[0], i.a.v[1], i.a.v[2]);
          }
        if (this.p ? this.mat.translate(-this.p.v[0], -this.p.v[1], this.p.v[2]) : this.mat.translate(-this.px.v, -this.py.v, this.pz.v), this.a) {
          var s;
          this.p ? s = [this.p.v[0] - this.a.v[0], this.p.v[1] - this.a.v[1], this.p.v[2] - this.a.v[2]] : s = [this.px.v - this.a.v[0], this.py.v - this.a.v[1], this.pz.v - this.a.v[2]];
          var a = Math.sqrt(Math.pow(s[0], 2) + Math.pow(s[1], 2) + Math.pow(s[2], 2)), n = [s[0] / a, s[1] / a, s[2] / a], l = Math.sqrt(n[2] * n[2] + n[0] * n[0]), o = Math.atan2(n[1], l), p = Math.atan2(n[0], -n[2]);
          this.mat.rotateY(p).rotateX(-o);
        }
        this.mat.rotateX(-this.rx.v).rotateY(-this.ry.v).rotateZ(this.rz.v), this.mat.rotateX(-this.or.v[0]).rotateY(-this.or.v[1]).rotateZ(this.or.v[2]), this.mat.translate(this.globalData.compSize.w / 2, this.globalData.compSize.h / 2, 0), this.mat.translate(0, 0, this.pe.v);
        var y = !this._prevMat.equals(this.mat);
        if ((y || this.pe._mdf) && this.comp.threeDElements) {
          r = this.comp.threeDElements.length;
          var S, u, P;
          for (t = 0; t < r; t += 1)
            if (S = this.comp.threeDElements[t], S.type === "3d") {
              if (y) {
                var b = this.mat.toCSS();
                P = S.container.style, P.transform = b, P.webkitTransform = b;
              }
              this.pe._mdf && (u = S.perspectiveElem.style, u.perspective = this.pe.v + "px", u.webkitPerspective = this.pe.v + "px");
            }
          this.mat.clone(this._prevMat);
        }
      }
      this._isFirstFrame = !1;
    }, HCameraElement.prototype.prepareFrame = function(e) {
      this.prepareProperties(e, !0);
    }, HCameraElement.prototype.destroy = function() {
    }, HCameraElement.prototype.getBaseElement = function() {
      return null;
    };
    function HImageElement(e, t, r) {
      this.assetData = t.getAssetData(e.refId), this.initElement(e, t, r);
    }
    extendPrototype([BaseElement, TransformElement, HBaseElement, HSolidElement, HierarchyElement, FrameElement, RenderableElement], HImageElement), HImageElement.prototype.createContent = function() {
      var e = this.globalData.getAssetsPath(this.assetData), t = new Image();
      this.data.hasMask ? (this.imageElem = createNS("image"), this.imageElem.setAttribute("width", this.assetData.w + "px"), this.imageElem.setAttribute("height", this.assetData.h + "px"), this.imageElem.setAttributeNS("http://www.w3.org/1999/xlink", "href", e), this.layerElement.appendChild(this.imageElem), this.baseElement.setAttribute("width", this.assetData.w), this.baseElement.setAttribute("height", this.assetData.h)) : this.layerElement.appendChild(t), t.crossOrigin = "anonymous", t.src = e, this.data.ln && this.baseElement.setAttribute("id", this.data.ln);
    };
    function HybridRendererBase(e, t) {
      this.animationItem = e, this.layers = null, this.renderedFrame = -1, this.renderConfig = {
        className: t && t.className || "",
        imagePreserveAspectRatio: t && t.imagePreserveAspectRatio || "xMidYMid slice",
        hideOnTransparent: !(t && t.hideOnTransparent === !1),
        filterSize: {
          width: t && t.filterSize && t.filterSize.width || "400%",
          height: t && t.filterSize && t.filterSize.height || "400%",
          x: t && t.filterSize && t.filterSize.x || "-100%",
          y: t && t.filterSize && t.filterSize.y || "-100%"
        }
      }, this.globalData = {
        _mdf: !1,
        frameNum: -1,
        renderConfig: this.renderConfig
      }, this.pendingElements = [], this.elements = [], this.threeDElements = [], this.destroyed = !1, this.camera = null, this.supports3d = !0, this.rendererType = "html";
    }
    extendPrototype([BaseRenderer], HybridRendererBase), HybridRendererBase.prototype.buildItem = SVGRenderer.prototype.buildItem, HybridRendererBase.prototype.checkPendingElements = function() {
      for (; this.pendingElements.length; ) {
        var e = this.pendingElements.pop();
        e.checkParenting();
      }
    }, HybridRendererBase.prototype.appendElementInPos = function(e, t) {
      var r = e.getBaseElement();
      if (r) {
        var i = this.layers[t];
        if (!i.ddd || !this.supports3d)
          if (this.threeDElements)
            this.addTo3dContainer(r, t);
          else {
            for (var s = 0, a, n, l; s < t; )
              this.elements[s] && this.elements[s] !== !0 && this.elements[s].getBaseElement && (n = this.elements[s], l = this.layers[s].ddd ? this.getThreeDContainerByPos(s) : n.getBaseElement(), a = l || a), s += 1;
            a ? (!i.ddd || !this.supports3d) && this.layerElement.insertBefore(r, a) : (!i.ddd || !this.supports3d) && this.layerElement.appendChild(r);
          }
        else
          this.addTo3dContainer(r, t);
      }
    }, HybridRendererBase.prototype.createShape = function(e) {
      return this.supports3d ? new HShapeElement(e, this.globalData, this) : new SVGShapeElement(e, this.globalData, this);
    }, HybridRendererBase.prototype.createText = function(e) {
      return this.supports3d ? new HTextElement(e, this.globalData, this) : new SVGTextLottieElement(e, this.globalData, this);
    }, HybridRendererBase.prototype.createCamera = function(e) {
      return this.camera = new HCameraElement(e, this.globalData, this), this.camera;
    }, HybridRendererBase.prototype.createImage = function(e) {
      return this.supports3d ? new HImageElement(e, this.globalData, this) : new IImageElement(e, this.globalData, this);
    }, HybridRendererBase.prototype.createSolid = function(e) {
      return this.supports3d ? new HSolidElement(e, this.globalData, this) : new ISolidElement(e, this.globalData, this);
    }, HybridRendererBase.prototype.createNull = SVGRenderer.prototype.createNull, HybridRendererBase.prototype.getThreeDContainerByPos = function(e) {
      for (var t = 0, r = this.threeDElements.length; t < r; ) {
        if (this.threeDElements[t].startPos <= e && this.threeDElements[t].endPos >= e)
          return this.threeDElements[t].perspectiveElem;
        t += 1;
      }
      return null;
    }, HybridRendererBase.prototype.createThreeDContainer = function(e, t) {
      var r = createTag("div"), i, s;
      styleDiv(r);
      var a = createTag("div");
      if (styleDiv(a), t === "3d") {
        i = r.style, i.width = this.globalData.compSize.w + "px", i.height = this.globalData.compSize.h + "px";
        var n = "50% 50%";
        i.webkitTransformOrigin = n, i.mozTransformOrigin = n, i.transformOrigin = n, s = a.style;
        var l = "matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)";
        s.transform = l, s.webkitTransform = l;
      }
      r.appendChild(a);
      var o = {
        container: a,
        perspectiveElem: r,
        startPos: e,
        endPos: e,
        type: t
      };
      return this.threeDElements.push(o), o;
    }, HybridRendererBase.prototype.build3dContainers = function() {
      var e, t = this.layers.length, r, i = "";
      for (e = 0; e < t; e += 1)
        this.layers[e].ddd && this.layers[e].ty !== 3 ? (i !== "3d" && (i = "3d", r = this.createThreeDContainer(e, "3d")), r.endPos = Math.max(r.endPos, e)) : (i !== "2d" && (i = "2d", r = this.createThreeDContainer(e, "2d")), r.endPos = Math.max(r.endPos, e));
      for (t = this.threeDElements.length, e = t - 1; e >= 0; e -= 1)
        this.resizerElem.appendChild(this.threeDElements[e].perspectiveElem);
    }, HybridRendererBase.prototype.addTo3dContainer = function(e, t) {
      for (var r = 0, i = this.threeDElements.length; r < i; ) {
        if (t <= this.threeDElements[r].endPos) {
          for (var s = this.threeDElements[r].startPos, a; s < t; )
            this.elements[s] && this.elements[s].getBaseElement && (a = this.elements[s].getBaseElement()), s += 1;
          a ? this.threeDElements[r].container.insertBefore(e, a) : this.threeDElements[r].container.appendChild(e);
          break;
        }
        r += 1;
      }
    }, HybridRendererBase.prototype.configAnimation = function(e) {
      var t = createTag("div"), r = this.animationItem.wrapper, i = t.style;
      i.width = e.w + "px", i.height = e.h + "px", this.resizerElem = t, styleDiv(t), i.transformStyle = "flat", i.mozTransformStyle = "flat", i.webkitTransformStyle = "flat", this.renderConfig.className && t.setAttribute("class", this.renderConfig.className), r.appendChild(t), i.overflow = "hidden";
      var s = createNS("svg");
      s.setAttribute("width", "1"), s.setAttribute("height", "1"), styleDiv(s), this.resizerElem.appendChild(s);
      var a = createNS("defs");
      s.appendChild(a), this.data = e, this.setupGlobalData(e, s), this.globalData.defs = a, this.layers = e.layers, this.layerElement = this.resizerElem, this.build3dContainers(), this.updateContainerSize();
    }, HybridRendererBase.prototype.destroy = function() {
      this.animationItem.wrapper && (this.animationItem.wrapper.innerText = ""), this.animationItem.container = null, this.globalData.defs = null;
      var e, t = this.layers ? this.layers.length : 0;
      for (e = 0; e < t; e += 1)
        this.elements[e] && this.elements[e].destroy && this.elements[e].destroy();
      this.elements.length = 0, this.destroyed = !0, this.animationItem = null;
    }, HybridRendererBase.prototype.updateContainerSize = function() {
      var e = this.animationItem.wrapper.offsetWidth, t = this.animationItem.wrapper.offsetHeight, r = e / t, i = this.globalData.compSize.w / this.globalData.compSize.h, s, a, n, l;
      i > r ? (s = e / this.globalData.compSize.w, a = e / this.globalData.compSize.w, n = 0, l = (t - this.globalData.compSize.h * (e / this.globalData.compSize.w)) / 2) : (s = t / this.globalData.compSize.h, a = t / this.globalData.compSize.h, n = (e - this.globalData.compSize.w * (t / this.globalData.compSize.h)) / 2, l = 0);
      var o = this.resizerElem.style;
      o.webkitTransform = "matrix3d(" + s + ",0,0,0,0," + a + ",0,0,0,0,1,0," + n + "," + l + ",0,1)", o.transform = o.webkitTransform;
    }, HybridRendererBase.prototype.renderFrame = SVGRenderer.prototype.renderFrame, HybridRendererBase.prototype.hide = function() {
      this.resizerElem.style.display = "none";
    }, HybridRendererBase.prototype.show = function() {
      this.resizerElem.style.display = "block";
    }, HybridRendererBase.prototype.initItems = function() {
      if (this.buildAllItems(), this.camera)
        this.camera.setup();
      else {
        var e = this.globalData.compSize.w, t = this.globalData.compSize.h, r, i = this.threeDElements.length;
        for (r = 0; r < i; r += 1) {
          var s = this.threeDElements[r].perspectiveElem.style;
          s.webkitPerspective = Math.sqrt(Math.pow(e, 2) + Math.pow(t, 2)) + "px", s.perspective = s.webkitPerspective;
        }
      }
    }, HybridRendererBase.prototype.searchExtraCompositions = function(e) {
      var t, r = e.length, i = createTag("div");
      for (t = 0; t < r; t += 1)
        if (e[t].xt) {
          var s = this.createComp(e[t], i, this.globalData.comp, null);
          s.initExpressions(), this.globalData.projectInterface.registerComposition(s);
        }
    };
    function HCompElement(e, t, r) {
      this.layers = e.layers, this.supports3d = !e.hasMask, this.completeLayers = !1, this.pendingElements = [], this.elements = this.layers ? createSizedArray(this.layers.length) : [], this.initElement(e, t, r), this.tm = e.tm ? PropertyFactory.getProp(this, e.tm, 0, t.frameRate, this) : {
        _placeholder: !0
      };
    }
    extendPrototype([HybridRendererBase, ICompElement, HBaseElement], HCompElement), HCompElement.prototype._createBaseContainerElements = HCompElement.prototype.createContainerElements, HCompElement.prototype.createContainerElements = function() {
      this._createBaseContainerElements(), this.data.hasMask ? (this.svgElement.setAttribute("width", this.data.w), this.svgElement.setAttribute("height", this.data.h), this.transformedElement = this.baseElement) : this.transformedElement = this.layerElement;
    }, HCompElement.prototype.addTo3dContainer = function(e, t) {
      for (var r = 0, i; r < t; )
        this.elements[r] && this.elements[r].getBaseElement && (i = this.elements[r].getBaseElement()), r += 1;
      i ? this.layerElement.insertBefore(e, i) : this.layerElement.appendChild(e);
    }, HCompElement.prototype.createComp = function(e) {
      return this.supports3d ? new HCompElement(e, this.globalData, this) : new SVGCompElement(e, this.globalData, this);
    };
    function HybridRenderer(e, t) {
      this.animationItem = e, this.layers = null, this.renderedFrame = -1, this.renderConfig = {
        className: t && t.className || "",
        imagePreserveAspectRatio: t && t.imagePreserveAspectRatio || "xMidYMid slice",
        hideOnTransparent: !(t && t.hideOnTransparent === !1),
        filterSize: {
          width: t && t.filterSize && t.filterSize.width || "400%",
          height: t && t.filterSize && t.filterSize.height || "400%",
          x: t && t.filterSize && t.filterSize.x || "-100%",
          y: t && t.filterSize && t.filterSize.y || "-100%"
        },
        runExpressions: !t || t.runExpressions === void 0 || t.runExpressions
      }, this.globalData = {
        _mdf: !1,
        frameNum: -1,
        renderConfig: this.renderConfig
      }, this.pendingElements = [], this.elements = [], this.threeDElements = [], this.destroyed = !1, this.camera = null, this.supports3d = !0, this.rendererType = "html";
    }
    extendPrototype([HybridRendererBase], HybridRenderer), HybridRenderer.prototype.createComp = function(e) {
      return this.supports3d ? new HCompElement(e, this.globalData, this) : new SVGCompElement(e, this.globalData, this);
    };
    var CompExpressionInterface = function() {
      return function(e) {
        function t(r) {
          for (var i = 0, s = e.layers.length; i < s; ) {
            if (e.layers[i].nm === r || e.layers[i].ind === r)
              return e.elements[i].layerInterface;
            i += 1;
          }
          return null;
        }
        return Object.defineProperty(t, "_name", {
          value: e.data.nm
        }), t.layer = t, t.pixelAspect = 1, t.height = e.data.h || e.globalData.compSize.h, t.width = e.data.w || e.globalData.compSize.w, t.pixelAspect = 1, t.frameDuration = 1 / e.globalData.frameRate, t.displayStartTime = 0, t.numLayers = e.layers.length, t;
      };
    }();
    function _typeof$2(e) {
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof$2 = function(r) {
        return typeof r;
      } : _typeof$2 = function(r) {
        return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
      }, _typeof$2(e);
    }
    function seedRandom(e, t) {
      var r = this, i = 256, s = 6, a = 52, n = "random", l = t.pow(i, s), o = t.pow(2, a), p = o * 2, y = i - 1;
      function S(m, f, g) {
        var E = [];
        f = f === !0 ? {
          entropy: !0
        } : f || {};
        var A = d(b(f.entropy ? [m, c(e)] : m === null ? C() : m, 3), E), k = new u(E), M = function() {
          for (var B = k.g(s), D = l, V = 0; B < o; )
            B = (B + V) * i, D *= i, V = k.g(1);
          for (; B >= p; )
            B /= 2, D /= 2, V >>>= 1;
          return (B + V) / D;
        };
        return M.int32 = function() {
          return k.g(4) | 0;
        }, M.quick = function() {
          return k.g(4) / 4294967296;
        }, M.double = M, d(c(k.S), e), (f.pass || g || function(L, B, D, V) {
          return V && (V.S && P(V, k), L.state = function() {
            return P(k, {});
          }), D ? (t[n] = L, B) : L;
        })(M, A, "global" in f ? f.global : this == t, f.state);
      }
      t["seed" + n] = S;
      function u(m) {
        var f, g = m.length, E = this, A = 0, k = E.i = E.j = 0, M = E.S = [];
        for (g || (m = [g++]); A < i; )
          M[A] = A++;
        for (A = 0; A < i; A++)
          M[A] = M[k = y & k + m[A % g] + (f = M[A])], M[k] = f;
        E.g = function(L) {
          for (var B, D = 0, V = E.i, z = E.j, I = E.S; L--; )
            B = I[V = y & V + 1], D = D * i + I[y & (I[V] = I[z = y & z + B]) + (I[z] = B)];
          return E.i = V, E.j = z, D;
        };
      }
      function P(m, f) {
        return f.i = m.i, f.j = m.j, f.S = m.S.slice(), f;
      }
      function b(m, f) {
        var g = [], E = _typeof$2(m), A;
        if (f && E == "object")
          for (A in m)
            try {
              g.push(b(m[A], f - 1));
            } catch {
            }
        return g.length ? g : E == "string" ? m : m + "\0";
      }
      function d(m, f) {
        for (var g = m + "", E, A = 0; A < g.length; )
          f[y & A] = y & (E ^= f[y & A] * 19) + g.charCodeAt(A++);
        return c(f);
      }
      function C() {
        try {
          var m = new Uint8Array(i);
          return (r.crypto || r.msCrypto).getRandomValues(m), c(m);
        } catch {
          var f = r.navigator, g = f && f.plugins;
          return [+/* @__PURE__ */ new Date(), r, g, r.screen, c(e)];
        }
      }
      function c(m) {
        return String.fromCharCode.apply(0, m);
      }
      d(t.random(), e);
    }
    function initialize$2(e) {
      seedRandom([], e);
    }
    var propTypes = {
      SHAPE: "shape"
    };
    function _typeof$1(e) {
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof$1 = function(r) {
        return typeof r;
      } : _typeof$1 = function(r) {
        return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
      }, _typeof$1(e);
    }
    var ExpressionManager = function() {
      var ob = {}, Math = BMMath, window = null, document = null, XMLHttpRequest = null, fetch = null, frames = null, _lottieGlobal = {};
      initialize$2(BMMath);
      function resetFrame() {
        _lottieGlobal = {};
      }
      function $bm_isInstanceOfArray(e) {
        return e.constructor === Array || e.constructor === Float32Array;
      }
      function isNumerable(e, t) {
        return e === "number" || t instanceof Number || e === "boolean" || e === "string";
      }
      function $bm_neg(e) {
        var t = _typeof$1(e);
        if (t === "number" || e instanceof Number || t === "boolean")
          return -e;
        if ($bm_isInstanceOfArray(e)) {
          var r, i = e.length, s = [];
          for (r = 0; r < i; r += 1)
            s[r] = -e[r];
          return s;
        }
        return e.propType ? e.v : -e;
      }
      var easeInBez = BezierFactory.getBezierEasing(0.333, 0, 0.833, 0.833, "easeIn").get, easeOutBez = BezierFactory.getBezierEasing(0.167, 0.167, 0.667, 1, "easeOut").get, easeInOutBez = BezierFactory.getBezierEasing(0.33, 0, 0.667, 1, "easeInOut").get;
      function sum(e, t) {
        var r = _typeof$1(e), i = _typeof$1(t);
        if (isNumerable(r, e) && isNumerable(i, t) || r === "string" || i === "string")
          return e + t;
        if ($bm_isInstanceOfArray(e) && isNumerable(i, t))
          return e = e.slice(0), e[0] += t, e;
        if (isNumerable(r, e) && $bm_isInstanceOfArray(t))
          return t = t.slice(0), t[0] = e + t[0], t;
        if ($bm_isInstanceOfArray(e) && $bm_isInstanceOfArray(t)) {
          for (var s = 0, a = e.length, n = t.length, l = []; s < a || s < n; )
            (typeof e[s] == "number" || e[s] instanceof Number) && (typeof t[s] == "number" || t[s] instanceof Number) ? l[s] = e[s] + t[s] : l[s] = t[s] === void 0 ? e[s] : e[s] || t[s], s += 1;
          return l;
        }
        return 0;
      }
      var add = sum;
      function sub(e, t) {
        var r = _typeof$1(e), i = _typeof$1(t);
        if (isNumerable(r, e) && isNumerable(i, t))
          return r === "string" && (e = parseInt(e, 10)), i === "string" && (t = parseInt(t, 10)), e - t;
        if ($bm_isInstanceOfArray(e) && isNumerable(i, t))
          return e = e.slice(0), e[0] -= t, e;
        if (isNumerable(r, e) && $bm_isInstanceOfArray(t))
          return t = t.slice(0), t[0] = e - t[0], t;
        if ($bm_isInstanceOfArray(e) && $bm_isInstanceOfArray(t)) {
          for (var s = 0, a = e.length, n = t.length, l = []; s < a || s < n; )
            (typeof e[s] == "number" || e[s] instanceof Number) && (typeof t[s] == "number" || t[s] instanceof Number) ? l[s] = e[s] - t[s] : l[s] = t[s] === void 0 ? e[s] : e[s] || t[s], s += 1;
          return l;
        }
        return 0;
      }
      function mul(e, t) {
        var r = _typeof$1(e), i = _typeof$1(t), s;
        if (isNumerable(r, e) && isNumerable(i, t))
          return e * t;
        var a, n;
        if ($bm_isInstanceOfArray(e) && isNumerable(i, t)) {
          for (n = e.length, s = createTypedArray("float32", n), a = 0; a < n; a += 1)
            s[a] = e[a] * t;
          return s;
        }
        if (isNumerable(r, e) && $bm_isInstanceOfArray(t)) {
          for (n = t.length, s = createTypedArray("float32", n), a = 0; a < n; a += 1)
            s[a] = e * t[a];
          return s;
        }
        return 0;
      }
      function div(e, t) {
        var r = _typeof$1(e), i = _typeof$1(t), s;
        if (isNumerable(r, e) && isNumerable(i, t))
          return e / t;
        var a, n;
        if ($bm_isInstanceOfArray(e) && isNumerable(i, t)) {
          for (n = e.length, s = createTypedArray("float32", n), a = 0; a < n; a += 1)
            s[a] = e[a] / t;
          return s;
        }
        if (isNumerable(r, e) && $bm_isInstanceOfArray(t)) {
          for (n = t.length, s = createTypedArray("float32", n), a = 0; a < n; a += 1)
            s[a] = e / t[a];
          return s;
        }
        return 0;
      }
      function mod(e, t) {
        return typeof e == "string" && (e = parseInt(e, 10)), typeof t == "string" && (t = parseInt(t, 10)), e % t;
      }
      var $bm_sum = sum, $bm_sub = sub, $bm_mul = mul, $bm_div = div, $bm_mod = mod;
      function clamp(e, t, r) {
        if (t > r) {
          var i = r;
          r = t, t = i;
        }
        return Math.min(Math.max(e, t), r);
      }
      function radiansToDegrees(e) {
        return e / degToRads;
      }
      var radians_to_degrees = radiansToDegrees;
      function degreesToRadians(e) {
        return e * degToRads;
      }
      var degrees_to_radians = radiansToDegrees, helperLengthArray = [0, 0, 0, 0, 0, 0];
      function length(e, t) {
        if (typeof e == "number" || e instanceof Number)
          return t = t || 0, Math.abs(e - t);
        t || (t = helperLengthArray);
        var r, i = Math.min(e.length, t.length), s = 0;
        for (r = 0; r < i; r += 1)
          s += Math.pow(t[r] - e[r], 2);
        return Math.sqrt(s);
      }
      function normalize(e) {
        return div(e, length(e));
      }
      function rgbToHsl(e) {
        var t = e[0], r = e[1], i = e[2], s = Math.max(t, r, i), a = Math.min(t, r, i), n, l, o = (s + a) / 2;
        if (s === a)
          n = 0, l = 0;
        else {
          var p = s - a;
          switch (l = o > 0.5 ? p / (2 - s - a) : p / (s + a), s) {
            case t:
              n = (r - i) / p + (r < i ? 6 : 0);
              break;
            case r:
              n = (i - t) / p + 2;
              break;
            case i:
              n = (t - r) / p + 4;
              break;
          }
          n /= 6;
        }
        return [n, l, o, e[3]];
      }
      function hue2rgb(e, t, r) {
        return r < 0 && (r += 1), r > 1 && (r -= 1), r < 1 / 6 ? e + (t - e) * 6 * r : r < 1 / 2 ? t : r < 2 / 3 ? e + (t - e) * (2 / 3 - r) * 6 : e;
      }
      function hslToRgb(e) {
        var t = e[0], r = e[1], i = e[2], s, a, n;
        if (r === 0)
          s = i, n = i, a = i;
        else {
          var l = i < 0.5 ? i * (1 + r) : i + r - i * r, o = 2 * i - l;
          s = hue2rgb(o, l, t + 1 / 3), a = hue2rgb(o, l, t), n = hue2rgb(o, l, t - 1 / 3);
        }
        return [s, a, n, e[3]];
      }
      function linear(e, t, r, i, s) {
        if ((i === void 0 || s === void 0) && (i = t, s = r, t = 0, r = 1), r < t) {
          var a = r;
          r = t, t = a;
        }
        if (e <= t)
          return i;
        if (e >= r)
          return s;
        var n = r === t ? 0 : (e - t) / (r - t);
        if (!i.length)
          return i + (s - i) * n;
        var l, o = i.length, p = createTypedArray("float32", o);
        for (l = 0; l < o; l += 1)
          p[l] = i[l] + (s[l] - i[l]) * n;
        return p;
      }
      function random(e, t) {
        if (t === void 0 && (e === void 0 ? (e = 0, t = 1) : (t = e, e = void 0)), t.length) {
          var r, i = t.length;
          e || (e = createTypedArray("float32", i));
          var s = createTypedArray("float32", i), a = BMMath.random();
          for (r = 0; r < i; r += 1)
            s[r] = e[r] + a * (t[r] - e[r]);
          return s;
        }
        e === void 0 && (e = 0);
        var n = BMMath.random();
        return e + n * (t - e);
      }
      function createPath(e, t, r, i) {
        var s, a = e.length, n = shapePool.newElement();
        n.setPathData(!!i, a);
        var l = [0, 0], o, p;
        for (s = 0; s < a; s += 1)
          o = t && t[s] ? t[s] : l, p = r && r[s] ? r[s] : l, n.setTripleAt(e[s][0], e[s][1], p[0] + e[s][0], p[1] + e[s][1], o[0] + e[s][0], o[1] + e[s][1], s, !0);
        return n;
      }
      function initiateExpression(elem, data, property) {
        function noOp(e) {
          return e;
        }
        if (!elem.globalData.renderConfig.runExpressions)
          return noOp;
        var val = data.x, needsVelocity = /velocity(?![\w\d])/.test(val), _needsRandom = val.indexOf("random") !== -1, elemType = elem.data.ty, transform, $bm_transform, content, effect, thisProperty = property;
        thisProperty.valueAtTime = thisProperty.getValueAtTime, Object.defineProperty(thisProperty, "value", {
          get: function() {
            return thisProperty.v;
          }
        }), elem.comp.frameDuration = 1 / elem.comp.globalData.frameRate, elem.comp.displayStartTime = 0;
        var inPoint = elem.data.ip / elem.comp.globalData.frameRate, outPoint = elem.data.op / elem.comp.globalData.frameRate, width = elem.data.sw ? elem.data.sw : 0, height = elem.data.sh ? elem.data.sh : 0, name = elem.data.nm, loopIn, loop_in, loopOut, loop_out, smooth, toWorld, fromWorld, fromComp, toComp, fromCompToSurface, position, rotation, anchorPoint, scale, thisLayer, thisComp, mask, valueAtTime, velocityAtTime, scoped_bm_rt, expression_function = eval("[function _expression_function(){" + val + ";scoped_bm_rt=$bm_rt}]")[0], numKeys = property.kf ? data.k.length : 0, active = !this.data || this.data.hd !== !0, wiggle = function e(t, r) {
          var i, s, a = this.pv.length ? this.pv.length : 1, n = createTypedArray("float32", a);
          t = 5;
          var l = Math.floor(time * t);
          for (i = 0, s = 0; i < l; ) {
            for (s = 0; s < a; s += 1)
              n[s] += -r + r * 2 * BMMath.random();
            i += 1;
          }
          var o = time * t, p = o - Math.floor(o), y = createTypedArray("float32", a);
          if (a > 1) {
            for (s = 0; s < a; s += 1)
              y[s] = this.pv[s] + n[s] + (-r + r * 2 * BMMath.random()) * p;
            return y;
          }
          return this.pv + n[0] + (-r + r * 2 * BMMath.random()) * p;
        }.bind(this);
        thisProperty.loopIn && (loopIn = thisProperty.loopIn.bind(thisProperty), loop_in = loopIn), thisProperty.loopOut && (loopOut = thisProperty.loopOut.bind(thisProperty), loop_out = loopOut), thisProperty.smooth && (smooth = thisProperty.smooth.bind(thisProperty));
        function loopInDuration(e, t) {
          return loopIn(e, t, !0);
        }
        function loopOutDuration(e, t) {
          return loopOut(e, t, !0);
        }
        this.getValueAtTime && (valueAtTime = this.getValueAtTime.bind(this)), this.getVelocityAtTime && (velocityAtTime = this.getVelocityAtTime.bind(this));
        var comp = elem.comp.globalData.projectInterface.bind(elem.comp.globalData.projectInterface);
        function lookAt(e, t) {
          var r = [t[0] - e[0], t[1] - e[1], t[2] - e[2]], i = Math.atan2(r[0], Math.sqrt(r[1] * r[1] + r[2] * r[2])) / degToRads, s = -Math.atan2(r[1], r[2]) / degToRads;
          return [s, i, 0];
        }
        function easeOut(e, t, r, i, s) {
          return applyEase(easeOutBez, e, t, r, i, s);
        }
        function easeIn(e, t, r, i, s) {
          return applyEase(easeInBez, e, t, r, i, s);
        }
        function ease(e, t, r, i, s) {
          return applyEase(easeInOutBez, e, t, r, i, s);
        }
        function applyEase(e, t, r, i, s, a) {
          s === void 0 ? (s = r, a = i) : t = (t - r) / (i - r), t > 1 ? t = 1 : t < 0 && (t = 0);
          var n = e(t);
          if ($bm_isInstanceOfArray(s)) {
            var l, o = s.length, p = createTypedArray("float32", o);
            for (l = 0; l < o; l += 1)
              p[l] = (a[l] - s[l]) * n + s[l];
            return p;
          }
          return (a - s) * n + s;
        }
        function nearestKey(e) {
          var t, r = data.k.length, i, s;
          if (!data.k.length || typeof data.k[0] == "number")
            i = 0, s = 0;
          else if (i = -1, e *= elem.comp.globalData.frameRate, e < data.k[0].t)
            i = 1, s = data.k[0].t;
          else {
            for (t = 0; t < r - 1; t += 1)
              if (e === data.k[t].t) {
                i = t + 1, s = data.k[t].t;
                break;
              } else if (e > data.k[t].t && e < data.k[t + 1].t) {
                e - data.k[t].t > data.k[t + 1].t - e ? (i = t + 2, s = data.k[t + 1].t) : (i = t + 1, s = data.k[t].t);
                break;
              }
            i === -1 && (i = t + 1, s = data.k[t].t);
          }
          var a = {};
          return a.index = i, a.time = s / elem.comp.globalData.frameRate, a;
        }
        function key(e) {
          var t, r, i;
          if (!data.k.length || typeof data.k[0] == "number")
            throw new Error("The property has no keyframe at index " + e);
          e -= 1, t = {
            time: data.k[e].t / elem.comp.globalData.frameRate,
            value: []
          };
          var s = Object.prototype.hasOwnProperty.call(data.k[e], "s") ? data.k[e].s : data.k[e - 1].e;
          for (i = s.length, r = 0; r < i; r += 1)
            t[r] = s[r], t.value[r] = s[r];
          return t;
        }
        function framesToTime(e, t) {
          return t || (t = elem.comp.globalData.frameRate), e / t;
        }
        function timeToFrames(e, t) {
          return !e && e !== 0 && (e = time), t || (t = elem.comp.globalData.frameRate), e * t;
        }
        function seedRandom(e) {
          BMMath.seedrandom(randSeed + e);
        }
        function sourceRectAtTime() {
          return elem.sourceRectAtTime();
        }
        function substring(e, t) {
          return typeof value == "string" ? t === void 0 ? value.substring(e) : value.substring(e, t) : "";
        }
        function substr(e, t) {
          return typeof value == "string" ? t === void 0 ? value.substr(e) : value.substr(e, t) : "";
        }
        function posterizeTime(e) {
          time = e === 0 ? 0 : Math.floor(time * e) / e, value = valueAtTime(time);
        }
        var time, velocity, value, text, textIndex, textTotal, selectorValue, index = elem.data.ind, randSeed = Math.floor(Math.random() * 1e6), globalData = elem.globalData;
        function executeExpression(e) {
          return value = e, this.frameExpressionId === elem.globalData.frameId && this.propType !== "textSelector" ? value : (this.propType === "textSelector" && (textIndex = this.textIndex, textTotal = this.textTotal, selectorValue = this.selectorValue), thisLayer || (text = elem.layerInterface.text, thisLayer = elem.layerInterface, thisComp = elem.comp.compInterface, toWorld = thisLayer.toWorld.bind(thisLayer), fromWorld = thisLayer.fromWorld.bind(thisLayer), fromComp = thisLayer.fromComp.bind(thisLayer), toComp = thisLayer.toComp.bind(thisLayer), mask = thisLayer.mask ? thisLayer.mask.bind(thisLayer) : null, fromCompToSurface = fromComp), transform || (transform = elem.layerInterface("ADBE Transform Group"), $bm_transform = transform, transform && (anchorPoint = transform.anchorPoint)), elemType === 4 && !content && (content = thisLayer("ADBE Root Vectors Group")), effect || (effect = thisLayer(4)), time = this.comp.renderedFrame / this.comp.globalData.frameRate, _needsRandom && seedRandom(randSeed + time), needsVelocity && (velocity = velocityAtTime(time)), expression_function(), this.frameExpressionId = elem.globalData.frameId, scoped_bm_rt = scoped_bm_rt.propType === propTypes.SHAPE ? scoped_bm_rt.v : scoped_bm_rt, scoped_bm_rt);
        }
        return executeExpression.__preventDeadCodeRemoval = [$bm_transform, anchorPoint, time, velocity, inPoint, outPoint, width, height, name, loop_in, loop_out, smooth, toComp, fromCompToSurface, toWorld, fromWorld, mask, position, rotation, scale, thisComp, numKeys, active, wiggle, loopInDuration, loopOutDuration, comp, lookAt, easeOut, easeIn, ease, nearestKey, key, text, textIndex, textTotal, selectorValue, framesToTime, timeToFrames, sourceRectAtTime, substring, substr, posterizeTime, index, globalData], executeExpression;
      }
      return ob.initiateExpression = initiateExpression, ob.__preventDeadCodeRemoval = [window, document, XMLHttpRequest, fetch, frames, $bm_neg, add, $bm_sum, $bm_sub, $bm_mul, $bm_div, $bm_mod, clamp, radians_to_degrees, degreesToRadians, degrees_to_radians, normalize, rgbToHsl, hslToRgb, linear, random, createPath, _lottieGlobal], ob.resetFrame = resetFrame, ob;
    }(), Expressions = function() {
      var e = {};
      e.initExpressions = t, e.resetFrame = ExpressionManager.resetFrame;
      function t(r) {
        var i = 0, s = [];
        function a() {
          i += 1;
        }
        function n() {
          i -= 1, i === 0 && o();
        }
        function l(p) {
          s.indexOf(p) === -1 && s.push(p);
        }
        function o() {
          var p, y = s.length;
          for (p = 0; p < y; p += 1)
            s[p].release();
          s.length = 0;
        }
        r.renderer.compInterface = CompExpressionInterface(r.renderer), r.renderer.globalData.projectInterface.registerComposition(r.renderer), r.renderer.globalData.pushExpression = a, r.renderer.globalData.popExpression = n, r.renderer.globalData.registerExpressionProperty = l;
      }
      return e;
    }(), MaskManagerInterface = function() {
      function e(r, i) {
        this._mask = r, this._data = i;
      }
      Object.defineProperty(e.prototype, "maskPath", {
        get: function() {
          return this._mask.prop.k && this._mask.prop.getValue(), this._mask.prop;
        }
      }), Object.defineProperty(e.prototype, "maskOpacity", {
        get: function() {
          return this._mask.op.k && this._mask.op.getValue(), this._mask.op.v * 100;
        }
      });
      var t = function(i) {
        var s = createSizedArray(i.viewData.length), a, n = i.viewData.length;
        for (a = 0; a < n; a += 1)
          s[a] = new e(i.viewData[a], i.masksProperties[a]);
        var l = function(p) {
          for (a = 0; a < n; ) {
            if (i.masksProperties[a].nm === p)
              return s[a];
            a += 1;
          }
          return null;
        };
        return l;
      };
      return t;
    }(), ExpressionPropertyInterface = function() {
      var e = {
        pv: 0,
        v: 0,
        mult: 1
      }, t = {
        pv: [0, 0, 0],
        v: [0, 0, 0],
        mult: 1
      };
      function r(n, l, o) {
        Object.defineProperty(n, "velocity", {
          get: function() {
            return l.getVelocityAtTime(l.comp.currentFrame);
          }
        }), n.numKeys = l.keyframes ? l.keyframes.length : 0, n.key = function(p) {
          if (!n.numKeys)
            return 0;
          var y = "";
          "s" in l.keyframes[p - 1] ? y = l.keyframes[p - 1].s : "e" in l.keyframes[p - 2] ? y = l.keyframes[p - 2].e : y = l.keyframes[p - 2].s;
          var S = o === "unidimensional" ? new Number(y) : Object.assign({}, y);
          return S.time = l.keyframes[p - 1].t / l.elem.comp.globalData.frameRate, S.value = o === "unidimensional" ? y[0] : y, S;
        }, n.valueAtTime = l.getValueAtTime, n.speedAtTime = l.getSpeedAtTime, n.velocityAtTime = l.getVelocityAtTime, n.propertyGroup = l.propertyGroup;
      }
      function i(n) {
        (!n || !("pv" in n)) && (n = e);
        var l = 1 / n.mult, o = n.pv * l, p = new Number(o);
        return p.value = o, r(p, n, "unidimensional"), function() {
          return n.k && n.getValue(), o = n.v * l, p.value !== o && (p = new Number(o), p.value = o, r(p, n, "unidimensional")), p;
        };
      }
      function s(n) {
        (!n || !("pv" in n)) && (n = t);
        var l = 1 / n.mult, o = n.data && n.data.l || n.pv.length, p = createTypedArray("float32", o), y = createTypedArray("float32", o);
        return p.value = y, r(p, n, "multidimensional"), function() {
          n.k && n.getValue();
          for (var S = 0; S < o; S += 1)
            y[S] = n.v[S] * l, p[S] = y[S];
          return p;
        };
      }
      function a() {
        return e;
      }
      return function(n) {
        return n ? n.propType === "unidimensional" ? i(n) : s(n) : a;
      };
    }(), TransformExpressionInterface = function() {
      return function(e) {
        function t(n) {
          switch (n) {
            case "scale":
            case "Scale":
            case "ADBE Scale":
            case 6:
              return t.scale;
            case "rotation":
            case "Rotation":
            case "ADBE Rotation":
            case "ADBE Rotate Z":
            case 10:
              return t.rotation;
            case "ADBE Rotate X":
              return t.xRotation;
            case "ADBE Rotate Y":
              return t.yRotation;
            case "position":
            case "Position":
            case "ADBE Position":
            case 2:
              return t.position;
            case "ADBE Position_0":
              return t.xPosition;
            case "ADBE Position_1":
              return t.yPosition;
            case "ADBE Position_2":
              return t.zPosition;
            case "anchorPoint":
            case "AnchorPoint":
            case "Anchor Point":
            case "ADBE AnchorPoint":
            case 1:
              return t.anchorPoint;
            case "opacity":
            case "Opacity":
            case 11:
              return t.opacity;
            default:
              return null;
          }
        }
        Object.defineProperty(t, "rotation", {
          get: ExpressionPropertyInterface(e.r || e.rz)
        }), Object.defineProperty(t, "zRotation", {
          get: ExpressionPropertyInterface(e.rz || e.r)
        }), Object.defineProperty(t, "xRotation", {
          get: ExpressionPropertyInterface(e.rx)
        }), Object.defineProperty(t, "yRotation", {
          get: ExpressionPropertyInterface(e.ry)
        }), Object.defineProperty(t, "scale", {
          get: ExpressionPropertyInterface(e.s)
        });
        var r, i, s, a;
        return e.p ? a = ExpressionPropertyInterface(e.p) : (r = ExpressionPropertyInterface(e.px), i = ExpressionPropertyInterface(e.py), e.pz && (s = ExpressionPropertyInterface(e.pz))), Object.defineProperty(t, "position", {
          get: function() {
            return e.p ? a() : [r(), i(), s ? s() : 0];
          }
        }), Object.defineProperty(t, "xPosition", {
          get: ExpressionPropertyInterface(e.px)
        }), Object.defineProperty(t, "yPosition", {
          get: ExpressionPropertyInterface(e.py)
        }), Object.defineProperty(t, "zPosition", {
          get: ExpressionPropertyInterface(e.pz)
        }), Object.defineProperty(t, "anchorPoint", {
          get: ExpressionPropertyInterface(e.a)
        }), Object.defineProperty(t, "opacity", {
          get: ExpressionPropertyInterface(e.o)
        }), Object.defineProperty(t, "skew", {
          get: ExpressionPropertyInterface(e.sk)
        }), Object.defineProperty(t, "skewAxis", {
          get: ExpressionPropertyInterface(e.sa)
        }), Object.defineProperty(t, "orientation", {
          get: ExpressionPropertyInterface(e.or)
        }), t;
      };
    }(), LayerExpressionInterface = function() {
      function e(p) {
        var y = new Matrix();
        if (p !== void 0) {
          var S = this._elem.finalTransform.mProp.getValueAtTime(p);
          S.clone(y);
        } else {
          var u = this._elem.finalTransform.mProp;
          u.applyToMatrix(y);
        }
        return y;
      }
      function t(p, y) {
        var S = this.getMatrix(y);
        return S.props[12] = 0, S.props[13] = 0, S.props[14] = 0, this.applyPoint(S, p);
      }
      function r(p, y) {
        var S = this.getMatrix(y);
        return this.applyPoint(S, p);
      }
      function i(p, y) {
        var S = this.getMatrix(y);
        return S.props[12] = 0, S.props[13] = 0, S.props[14] = 0, this.invertPoint(S, p);
      }
      function s(p, y) {
        var S = this.getMatrix(y);
        return this.invertPoint(S, p);
      }
      function a(p, y) {
        if (this._elem.hierarchy && this._elem.hierarchy.length) {
          var S, u = this._elem.hierarchy.length;
          for (S = 0; S < u; S += 1)
            this._elem.hierarchy[S].finalTransform.mProp.applyToMatrix(p);
        }
        return p.applyToPointArray(y[0], y[1], y[2] || 0);
      }
      function n(p, y) {
        if (this._elem.hierarchy && this._elem.hierarchy.length) {
          var S, u = this._elem.hierarchy.length;
          for (S = 0; S < u; S += 1)
            this._elem.hierarchy[S].finalTransform.mProp.applyToMatrix(p);
        }
        return p.inversePoint(y);
      }
      function l(p) {
        var y = new Matrix();
        if (y.reset(), this._elem.finalTransform.mProp.applyToMatrix(y), this._elem.hierarchy && this._elem.hierarchy.length) {
          var S, u = this._elem.hierarchy.length;
          for (S = 0; S < u; S += 1)
            this._elem.hierarchy[S].finalTransform.mProp.applyToMatrix(y);
          return y.inversePoint(p);
        }
        return y.inversePoint(p);
      }
      function o() {
        return [1, 1, 1, 1];
      }
      return function(p) {
        var y;
        function S(d) {
          P.mask = new MaskManagerInterface(d, p);
        }
        function u(d) {
          P.effect = d;
        }
        function P(d) {
          switch (d) {
            case "ADBE Root Vectors Group":
            case "Contents":
            case 2:
              return P.shapeInterface;
            case 1:
            case 6:
            case "Transform":
            case "transform":
            case "ADBE Transform Group":
              return y;
            case 4:
            case "ADBE Effect Parade":
            case "effects":
            case "Effects":
              return P.effect;
            case "ADBE Text Properties":
              return P.textInterface;
            default:
              return null;
          }
        }
        P.getMatrix = e, P.invertPoint = n, P.applyPoint = a, P.toWorld = r, P.toWorldVec = t, P.fromWorld = s, P.fromWorldVec = i, P.toComp = r, P.fromComp = l, P.sampleImage = o, P.sourceRectAtTime = p.sourceRectAtTime.bind(p), P._elem = p, y = TransformExpressionInterface(p.finalTransform.mProp);
        var b = getDescriptor(y, "anchorPoint");
        return Object.defineProperties(P, {
          hasParent: {
            get: function() {
              return p.hierarchy.length;
            }
          },
          parent: {
            get: function() {
              return p.hierarchy[0].layerInterface;
            }
          },
          rotation: getDescriptor(y, "rotation"),
          scale: getDescriptor(y, "scale"),
          position: getDescriptor(y, "position"),
          opacity: getDescriptor(y, "opacity"),
          anchorPoint: b,
          anchor_point: b,
          transform: {
            get: function() {
              return y;
            }
          },
          active: {
            get: function() {
              return p.isInRange;
            }
          }
        }), P.startTime = p.data.st, P.index = p.data.ind, P.source = p.data.refId, P.height = p.data.ty === 0 ? p.data.h : 100, P.width = p.data.ty === 0 ? p.data.w : 100, P.inPoint = p.data.ip / p.comp.globalData.frameRate, P.outPoint = p.data.op / p.comp.globalData.frameRate, P._name = p.data.nm, P.registerMaskInterface = S, P.registerEffectsInterface = u, P;
      };
    }(), propertyGroupFactory = function() {
      return function(e, t) {
        return function(r) {
          return r = r === void 0 ? 1 : r, r <= 0 ? e : t(r - 1);
        };
      };
    }(), PropertyInterface = function() {
      return function(e, t) {
        var r = {
          _name: e
        };
        function i(s) {
          return s = s === void 0 ? 1 : s, s <= 0 ? r : t(s - 1);
        }
        return i;
      };
    }(), EffectsExpressionInterface = function() {
      var e = {
        createEffectsInterface: t
      };
      function t(s, a) {
        if (s.effectsManager) {
          var n = [], l = s.data.ef, o, p = s.effectsManager.effectElements.length;
          for (o = 0; o < p; o += 1)
            n.push(r(l[o], s.effectsManager.effectElements[o], a, s));
          var y = s.data.ef || [], S = function(P) {
            for (o = 0, p = y.length; o < p; ) {
              if (P === y[o].nm || P === y[o].mn || P === y[o].ix)
                return n[o];
              o += 1;
            }
            return null;
          };
          return Object.defineProperty(S, "numProperties", {
            get: function() {
              return y.length;
            }
          }), S;
        }
        return null;
      }
      function r(s, a, n, l) {
        function o(P) {
          for (var b = s.ef, d = 0, C = b.length; d < C; ) {
            if (P === b[d].nm || P === b[d].mn || P === b[d].ix)
              return b[d].ty === 5 ? y[d] : y[d]();
            d += 1;
          }
          throw new Error();
        }
        var p = propertyGroupFactory(o, n), y = [], S, u = s.ef.length;
        for (S = 0; S < u; S += 1)
          s.ef[S].ty === 5 ? y.push(r(s.ef[S], a.effectElements[S], a.effectElements[S].propertyGroup, l)) : y.push(i(a.effectElements[S], s.ef[S].ty, l, p));
        return s.mn === "ADBE Color Control" && Object.defineProperty(o, "color", {
          get: function() {
            return y[0]();
          }
        }), Object.defineProperties(o, {
          numProperties: {
            get: function() {
              return s.np;
            }
          },
          _name: {
            value: s.nm
          },
          propertyGroup: {
            value: p
          }
        }), o.enabled = s.en !== 0, o.active = o.enabled, o;
      }
      function i(s, a, n, l) {
        var o = ExpressionPropertyInterface(s.p);
        function p() {
          return a === 10 ? n.comp.compInterface(s.p.v) : o();
        }
        return s.p.setGroupProperty && s.p.setGroupProperty(PropertyInterface("", l)), p;
      }
      return e;
    }(), ShapePathInterface = function() {
      return function(t, r, i) {
        var s = r.sh;
        function a(l) {
          return l === "Shape" || l === "shape" || l === "Path" || l === "path" || l === "ADBE Vector Shape" || l === 2 ? a.path : null;
        }
        var n = propertyGroupFactory(a, i);
        return s.setGroupProperty(PropertyInterface("Path", n)), Object.defineProperties(a, {
          path: {
            get: function() {
              return s.k && s.getValue(), s;
            }
          },
          shape: {
            get: function() {
              return s.k && s.getValue(), s;
            }
          },
          _name: {
            value: t.nm
          },
          ix: {
            value: t.ix
          },
          propertyIndex: {
            value: t.ix
          },
          mn: {
            value: t.mn
          },
          propertyGroup: {
            value: i
          }
        }), a;
      };
    }(), ShapeExpressionInterface = function() {
      function e(b, d, C) {
        var c = [], m, f = b ? b.length : 0;
        for (m = 0; m < f; m += 1)
          b[m].ty === "gr" ? c.push(r(b[m], d[m], C)) : b[m].ty === "fl" ? c.push(i(b[m], d[m], C)) : b[m].ty === "st" ? c.push(n(b[m], d[m], C)) : b[m].ty === "tm" ? c.push(l(b[m], d[m], C)) : b[m].ty === "tr" || (b[m].ty === "el" ? c.push(p(b[m], d[m], C)) : b[m].ty === "sr" ? c.push(y(b[m], d[m], C)) : b[m].ty === "sh" ? c.push(ShapePathInterface(b[m], d[m], C)) : b[m].ty === "rc" ? c.push(S(b[m], d[m], C)) : b[m].ty === "rd" ? c.push(u(b[m], d[m], C)) : b[m].ty === "rp" ? c.push(P(b[m], d[m], C)) : b[m].ty === "gf" ? c.push(s(b[m], d[m], C)) : c.push(a()));
        return c;
      }
      function t(b, d, C) {
        var c, m = function(E) {
          for (var A = 0, k = c.length; A < k; ) {
            if (c[A]._name === E || c[A].mn === E || c[A].propertyIndex === E || c[A].ix === E || c[A].ind === E)
              return c[A];
            A += 1;
          }
          return typeof E == "number" ? c[E - 1] : null;
        };
        m.propertyGroup = propertyGroupFactory(m, C), c = e(b.it, d.it, m.propertyGroup), m.numProperties = c.length;
        var f = o(b.it[b.it.length - 1], d.it[d.it.length - 1], m.propertyGroup);
        return m.transform = f, m.propertyIndex = b.cix, m._name = b.nm, m;
      }
      function r(b, d, C) {
        var c = function(E) {
          switch (E) {
            case "ADBE Vectors Group":
            case "Contents":
            case 2:
              return c.content;
            default:
              return c.transform;
          }
        };
        c.propertyGroup = propertyGroupFactory(c, C);
        var m = t(b, d, c.propertyGroup), f = o(b.it[b.it.length - 1], d.it[d.it.length - 1], c.propertyGroup);
        return c.content = m, c.transform = f, Object.defineProperty(c, "_name", {
          get: function() {
            return b.nm;
          }
        }), c.numProperties = b.np, c.propertyIndex = b.ix, c.nm = b.nm, c.mn = b.mn, c;
      }
      function i(b, d, C) {
        function c(m) {
          return m === "Color" || m === "color" ? c.color : m === "Opacity" || m === "opacity" ? c.opacity : null;
        }
        return Object.defineProperties(c, {
          color: {
            get: ExpressionPropertyInterface(d.c)
          },
          opacity: {
            get: ExpressionPropertyInterface(d.o)
          },
          _name: {
            value: b.nm
          },
          mn: {
            value: b.mn
          }
        }), d.c.setGroupProperty(PropertyInterface("Color", C)), d.o.setGroupProperty(PropertyInterface("Opacity", C)), c;
      }
      function s(b, d, C) {
        function c(m) {
          return m === "Start Point" || m === "start point" ? c.startPoint : m === "End Point" || m === "end point" ? c.endPoint : m === "Opacity" || m === "opacity" ? c.opacity : null;
        }
        return Object.defineProperties(c, {
          startPoint: {
            get: ExpressionPropertyInterface(d.s)
          },
          endPoint: {
            get: ExpressionPropertyInterface(d.e)
          },
          opacity: {
            get: ExpressionPropertyInterface(d.o)
          },
          type: {
            get: function() {
              return "a";
            }
          },
          _name: {
            value: b.nm
          },
          mn: {
            value: b.mn
          }
        }), d.s.setGroupProperty(PropertyInterface("Start Point", C)), d.e.setGroupProperty(PropertyInterface("End Point", C)), d.o.setGroupProperty(PropertyInterface("Opacity", C)), c;
      }
      function a() {
        function b() {
          return null;
        }
        return b;
      }
      function n(b, d, C) {
        var c = propertyGroupFactory(k, C), m = propertyGroupFactory(A, c);
        function f(M) {
          Object.defineProperty(A, b.d[M].nm, {
            get: ExpressionPropertyInterface(d.d.dataProps[M].p)
          });
        }
        var g, E = b.d ? b.d.length : 0, A = {};
        for (g = 0; g < E; g += 1)
          f(g), d.d.dataProps[g].p.setGroupProperty(m);
        function k(M) {
          return M === "Color" || M === "color" ? k.color : M === "Opacity" || M === "opacity" ? k.opacity : M === "Stroke Width" || M === "stroke width" ? k.strokeWidth : null;
        }
        return Object.defineProperties(k, {
          color: {
            get: ExpressionPropertyInterface(d.c)
          },
          opacity: {
            get: ExpressionPropertyInterface(d.o)
          },
          strokeWidth: {
            get: ExpressionPropertyInterface(d.w)
          },
          dash: {
            get: function() {
              return A;
            }
          },
          _name: {
            value: b.nm
          },
          mn: {
            value: b.mn
          }
        }), d.c.setGroupProperty(PropertyInterface("Color", c)), d.o.setGroupProperty(PropertyInterface("Opacity", c)), d.w.setGroupProperty(PropertyInterface("Stroke Width", c)), k;
      }
      function l(b, d, C) {
        function c(f) {
          return f === b.e.ix || f === "End" || f === "end" ? c.end : f === b.s.ix ? c.start : f === b.o.ix ? c.offset : null;
        }
        var m = propertyGroupFactory(c, C);
        return c.propertyIndex = b.ix, d.s.setGroupProperty(PropertyInterface("Start", m)), d.e.setGroupProperty(PropertyInterface("End", m)), d.o.setGroupProperty(PropertyInterface("Offset", m)), c.propertyIndex = b.ix, c.propertyGroup = C, Object.defineProperties(c, {
          start: {
            get: ExpressionPropertyInterface(d.s)
          },
          end: {
            get: ExpressionPropertyInterface(d.e)
          },
          offset: {
            get: ExpressionPropertyInterface(d.o)
          },
          _name: {
            value: b.nm
          }
        }), c.mn = b.mn, c;
      }
      function o(b, d, C) {
        function c(f) {
          return b.a.ix === f || f === "Anchor Point" ? c.anchorPoint : b.o.ix === f || f === "Opacity" ? c.opacity : b.p.ix === f || f === "Position" ? c.position : b.r.ix === f || f === "Rotation" || f === "ADBE Vector Rotation" ? c.rotation : b.s.ix === f || f === "Scale" ? c.scale : b.sk && b.sk.ix === f || f === "Skew" ? c.skew : b.sa && b.sa.ix === f || f === "Skew Axis" ? c.skewAxis : null;
        }
        var m = propertyGroupFactory(c, C);
        return d.transform.mProps.o.setGroupProperty(PropertyInterface("Opacity", m)), d.transform.mProps.p.setGroupProperty(PropertyInterface("Position", m)), d.transform.mProps.a.setGroupProperty(PropertyInterface("Anchor Point", m)), d.transform.mProps.s.setGroupProperty(PropertyInterface("Scale", m)), d.transform.mProps.r.setGroupProperty(PropertyInterface("Rotation", m)), d.transform.mProps.sk && (d.transform.mProps.sk.setGroupProperty(PropertyInterface("Skew", m)), d.transform.mProps.sa.setGroupProperty(PropertyInterface("Skew Angle", m))), d.transform.op.setGroupProperty(PropertyInterface("Opacity", m)), Object.defineProperties(c, {
          opacity: {
            get: ExpressionPropertyInterface(d.transform.mProps.o)
          },
          position: {
            get: ExpressionPropertyInterface(d.transform.mProps.p)
          },
          anchorPoint: {
            get: ExpressionPropertyInterface(d.transform.mProps.a)
          },
          scale: {
            get: ExpressionPropertyInterface(d.transform.mProps.s)
          },
          rotation: {
            get: ExpressionPropertyInterface(d.transform.mProps.r)
          },
          skew: {
            get: ExpressionPropertyInterface(d.transform.mProps.sk)
          },
          skewAxis: {
            get: ExpressionPropertyInterface(d.transform.mProps.sa)
          },
          _name: {
            value: b.nm
          }
        }), c.ty = "tr", c.mn = b.mn, c.propertyGroup = C, c;
      }
      function p(b, d, C) {
        function c(g) {
          return b.p.ix === g ? c.position : b.s.ix === g ? c.size : null;
        }
        var m = propertyGroupFactory(c, C);
        c.propertyIndex = b.ix;
        var f = d.sh.ty === "tm" ? d.sh.prop : d.sh;
        return f.s.setGroupProperty(PropertyInterface("Size", m)), f.p.setGroupProperty(PropertyInterface("Position", m)), Object.defineProperties(c, {
          size: {
            get: ExpressionPropertyInterface(f.s)
          },
          position: {
            get: ExpressionPropertyInterface(f.p)
          },
          _name: {
            value: b.nm
          }
        }), c.mn = b.mn, c;
      }
      function y(b, d, C) {
        function c(g) {
          return b.p.ix === g ? c.position : b.r.ix === g ? c.rotation : b.pt.ix === g ? c.points : b.or.ix === g || g === "ADBE Vector Star Outer Radius" ? c.outerRadius : b.os.ix === g ? c.outerRoundness : b.ir && (b.ir.ix === g || g === "ADBE Vector Star Inner Radius") ? c.innerRadius : b.is && b.is.ix === g ? c.innerRoundness : null;
        }
        var m = propertyGroupFactory(c, C), f = d.sh.ty === "tm" ? d.sh.prop : d.sh;
        return c.propertyIndex = b.ix, f.or.setGroupProperty(PropertyInterface("Outer Radius", m)), f.os.setGroupProperty(PropertyInterface("Outer Roundness", m)), f.pt.setGroupProperty(PropertyInterface("Points", m)), f.p.setGroupProperty(PropertyInterface("Position", m)), f.r.setGroupProperty(PropertyInterface("Rotation", m)), b.ir && (f.ir.setGroupProperty(PropertyInterface("Inner Radius", m)), f.is.setGroupProperty(PropertyInterface("Inner Roundness", m))), Object.defineProperties(c, {
          position: {
            get: ExpressionPropertyInterface(f.p)
          },
          rotation: {
            get: ExpressionPropertyInterface(f.r)
          },
          points: {
            get: ExpressionPropertyInterface(f.pt)
          },
          outerRadius: {
            get: ExpressionPropertyInterface(f.or)
          },
          outerRoundness: {
            get: ExpressionPropertyInterface(f.os)
          },
          innerRadius: {
            get: ExpressionPropertyInterface(f.ir)
          },
          innerRoundness: {
            get: ExpressionPropertyInterface(f.is)
          },
          _name: {
            value: b.nm
          }
        }), c.mn = b.mn, c;
      }
      function S(b, d, C) {
        function c(g) {
          return b.p.ix === g ? c.position : b.r.ix === g ? c.roundness : b.s.ix === g || g === "Size" || g === "ADBE Vector Rect Size" ? c.size : null;
        }
        var m = propertyGroupFactory(c, C), f = d.sh.ty === "tm" ? d.sh.prop : d.sh;
        return c.propertyIndex = b.ix, f.p.setGroupProperty(PropertyInterface("Position", m)), f.s.setGroupProperty(PropertyInterface("Size", m)), f.r.setGroupProperty(PropertyInterface("Rotation", m)), Object.defineProperties(c, {
          position: {
            get: ExpressionPropertyInterface(f.p)
          },
          roundness: {
            get: ExpressionPropertyInterface(f.r)
          },
          size: {
            get: ExpressionPropertyInterface(f.s)
          },
          _name: {
            value: b.nm
          }
        }), c.mn = b.mn, c;
      }
      function u(b, d, C) {
        function c(g) {
          return b.r.ix === g || g === "Round Corners 1" ? c.radius : null;
        }
        var m = propertyGroupFactory(c, C), f = d;
        return c.propertyIndex = b.ix, f.rd.setGroupProperty(PropertyInterface("Radius", m)), Object.defineProperties(c, {
          radius: {
            get: ExpressionPropertyInterface(f.rd)
          },
          _name: {
            value: b.nm
          }
        }), c.mn = b.mn, c;
      }
      function P(b, d, C) {
        function c(g) {
          return b.c.ix === g || g === "Copies" ? c.copies : b.o.ix === g || g === "Offset" ? c.offset : null;
        }
        var m = propertyGroupFactory(c, C), f = d;
        return c.propertyIndex = b.ix, f.c.setGroupProperty(PropertyInterface("Copies", m)), f.o.setGroupProperty(PropertyInterface("Offset", m)), Object.defineProperties(c, {
          copies: {
            get: ExpressionPropertyInterface(f.c)
          },
          offset: {
            get: ExpressionPropertyInterface(f.o)
          },
          _name: {
            value: b.nm
          }
        }), c.mn = b.mn, c;
      }
      return function(b, d, C) {
        var c;
        function m(g) {
          if (typeof g == "number")
            return g = g === void 0 ? 1 : g, g === 0 ? C : c[g - 1];
          for (var E = 0, A = c.length; E < A; ) {
            if (c[E]._name === g)
              return c[E];
            E += 1;
          }
          return null;
        }
        function f() {
          return C;
        }
        return m.propertyGroup = propertyGroupFactory(m, f), c = e(b, d, m.propertyGroup), m.numProperties = c.length, m._name = "Contents", m;
      };
    }(), TextExpressionInterface = function() {
      return function(e) {
        var t;
        function r(i) {
          switch (i) {
            case "ADBE Text Document":
              return r.sourceText;
            default:
              return null;
          }
        }
        return Object.defineProperty(r, "sourceText", {
          get: function() {
            e.textProperty.getValue();
            var s = e.textProperty.currentData.t;
            return (!t || s !== t.value) && (t = new String(s), t.value = s || new String(s), Object.defineProperty(t, "style", {
              get: function() {
                return {
                  fillColor: e.textProperty.currentData.fc
                };
              }
            })), t;
          }
        }), r;
      };
    }();
    function _typeof(e) {
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof = function(r) {
        return typeof r;
      } : _typeof = function(r) {
        return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
      }, _typeof(e);
    }
    var FootageInterface = function() {
      var e = function(i) {
        var s = "", a = i.getFootageData();
        function n() {
          return s = "", a = i.getFootageData(), l;
        }
        function l(o) {
          if (a[o])
            return s = o, a = a[o], _typeof(a) === "object" ? l : a;
          var p = o.indexOf(s);
          if (p !== -1) {
            var y = parseInt(o.substr(p + s.length), 10);
            return a = a[y], _typeof(a) === "object" ? l : a;
          }
          return "";
        }
        return n;
      }, t = function(i) {
        function s(a) {
          return a === "Outline" ? s.outlineInterface() : null;
        }
        return s._name = "Outline", s.outlineInterface = e(i), s;
      };
      return function(r) {
        function i(s) {
          return s === "Data" ? i.dataInterface : null;
        }
        return i._name = "Data", i.dataInterface = t(r), i;
      };
    }(), interfaces = {
      layer: LayerExpressionInterface,
      effects: EffectsExpressionInterface,
      comp: CompExpressionInterface,
      shape: ShapeExpressionInterface,
      text: TextExpressionInterface,
      footage: FootageInterface
    };
    function getInterface(e) {
      return interfaces[e] || null;
    }
    var expressionHelpers = function() {
      function e(n, l, o) {
        l.x && (o.k = !0, o.x = !0, o.initiateExpression = ExpressionManager.initiateExpression, o.effectsSequence.push(o.initiateExpression(n, l, o).bind(o)));
      }
      function t(n) {
        return n *= this.elem.globalData.frameRate, n -= this.offsetTime, n !== this._cachingAtTime.lastFrame && (this._cachingAtTime.lastIndex = this._cachingAtTime.lastFrame < n ? this._cachingAtTime.lastIndex : 0, this._cachingAtTime.value = this.interpolateValue(n, this._cachingAtTime), this._cachingAtTime.lastFrame = n), this._cachingAtTime.value;
      }
      function r(n) {
        var l = -0.01, o = this.getValueAtTime(n), p = this.getValueAtTime(n + l), y = 0;
        if (o.length) {
          var S;
          for (S = 0; S < o.length; S += 1)
            y += Math.pow(p[S] - o[S], 2);
          y = Math.sqrt(y) * 100;
        } else
          y = 0;
        return y;
      }
      function i(n) {
        if (this.vel !== void 0)
          return this.vel;
        var l = -1e-3, o = this.getValueAtTime(n), p = this.getValueAtTime(n + l), y;
        if (o.length) {
          y = createTypedArray("float32", o.length);
          var S;
          for (S = 0; S < o.length; S += 1)
            y[S] = (p[S] - o[S]) / l;
        } else
          y = (p - o) / l;
        return y;
      }
      function s() {
        return this.pv;
      }
      function a(n) {
        this.propertyGroup = n;
      }
      return {
        searchExpressions: e,
        getSpeedAtTime: r,
        getVelocityAtTime: i,
        getValueAtTime: t,
        getStaticValueAtTime: s,
        setGroupProperty: a
      };
    }();
    function addPropertyDecorator() {
      function e(u, P, b) {
        if (!this.k || !this.keyframes)
          return this.pv;
        u = u ? u.toLowerCase() : "";
        var d = this.comp.renderedFrame, C = this.keyframes, c = C[C.length - 1].t;
        if (d <= c)
          return this.pv;
        var m, f;
        b ? (P ? m = Math.abs(c - this.elem.comp.globalData.frameRate * P) : m = Math.max(0, c - this.elem.data.ip), f = c - m) : ((!P || P > C.length - 1) && (P = C.length - 1), f = C[C.length - 1 - P].t, m = c - f);
        var g, E, A;
        if (u === "pingpong") {
          var k = Math.floor((d - f) / m);
          if (k % 2 !== 0)
            return this.getValueAtTime((m - (d - f) % m + f) / this.comp.globalData.frameRate, 0);
        } else if (u === "offset") {
          var M = this.getValueAtTime(f / this.comp.globalData.frameRate, 0), L = this.getValueAtTime(c / this.comp.globalData.frameRate, 0), B = this.getValueAtTime(((d - f) % m + f) / this.comp.globalData.frameRate, 0), D = Math.floor((d - f) / m);
          if (this.pv.length) {
            for (A = new Array(M.length), E = A.length, g = 0; g < E; g += 1)
              A[g] = (L[g] - M[g]) * D + B[g];
            return A;
          }
          return (L - M) * D + B;
        } else if (u === "continue") {
          var V = this.getValueAtTime(c / this.comp.globalData.frameRate, 0), z = this.getValueAtTime((c - 1e-3) / this.comp.globalData.frameRate, 0);
          if (this.pv.length) {
            for (A = new Array(V.length), E = A.length, g = 0; g < E; g += 1)
              A[g] = V[g] + (V[g] - z[g]) * ((d - c) / this.comp.globalData.frameRate) / 5e-4;
            return A;
          }
          return V + (V - z) * ((d - c) / 1e-3);
        }
        return this.getValueAtTime(((d - f) % m + f) / this.comp.globalData.frameRate, 0);
      }
      function t(u, P, b) {
        if (!this.k)
          return this.pv;
        u = u ? u.toLowerCase() : "";
        var d = this.comp.renderedFrame, C = this.keyframes, c = C[0].t;
        if (d >= c)
          return this.pv;
        var m, f;
        b ? (P ? m = Math.abs(this.elem.comp.globalData.frameRate * P) : m = Math.max(0, this.elem.data.op - c), f = c + m) : ((!P || P > C.length - 1) && (P = C.length - 1), f = C[P].t, m = f - c);
        var g, E, A;
        if (u === "pingpong") {
          var k = Math.floor((c - d) / m);
          if (k % 2 === 0)
            return this.getValueAtTime(((c - d) % m + c) / this.comp.globalData.frameRate, 0);
        } else if (u === "offset") {
          var M = this.getValueAtTime(c / this.comp.globalData.frameRate, 0), L = this.getValueAtTime(f / this.comp.globalData.frameRate, 0), B = this.getValueAtTime((m - (c - d) % m + c) / this.comp.globalData.frameRate, 0), D = Math.floor((c - d) / m) + 1;
          if (this.pv.length) {
            for (A = new Array(M.length), E = A.length, g = 0; g < E; g += 1)
              A[g] = B[g] - (L[g] - M[g]) * D;
            return A;
          }
          return B - (L - M) * D;
        } else if (u === "continue") {
          var V = this.getValueAtTime(c / this.comp.globalData.frameRate, 0), z = this.getValueAtTime((c + 1e-3) / this.comp.globalData.frameRate, 0);
          if (this.pv.length) {
            for (A = new Array(V.length), E = A.length, g = 0; g < E; g += 1)
              A[g] = V[g] + (V[g] - z[g]) * (c - d) / 1e-3;
            return A;
          }
          return V + (V - z) * (c - d) / 1e-3;
        }
        return this.getValueAtTime((m - ((c - d) % m + c)) / this.comp.globalData.frameRate, 0);
      }
      function r(u, P) {
        if (!this.k)
          return this.pv;
        if (u = (u || 0.4) * 0.5, P = Math.floor(P || 5), P <= 1)
          return this.pv;
        var b = this.comp.renderedFrame / this.comp.globalData.frameRate, d = b - u, C = b + u, c = P > 1 ? (C - d) / (P - 1) : 1, m = 0, f = 0, g;
        this.pv.length ? g = createTypedArray("float32", this.pv.length) : g = 0;
        for (var E; m < P; ) {
          if (E = this.getValueAtTime(d + m * c), this.pv.length)
            for (f = 0; f < this.pv.length; f += 1)
              g[f] += E[f];
          else
            g += E;
          m += 1;
        }
        if (this.pv.length)
          for (f = 0; f < this.pv.length; f += 1)
            g[f] /= P;
        else
          g /= P;
        return g;
      }
      function i(u) {
        this._transformCachingAtTime || (this._transformCachingAtTime = {
          v: new Matrix()
        });
        var P = this._transformCachingAtTime.v;
        if (P.cloneFromProps(this.pre.props), this.appliedTransformations < 1) {
          var b = this.a.getValueAtTime(u);
          P.translate(-b[0] * this.a.mult, -b[1] * this.a.mult, b[2] * this.a.mult);
        }
        if (this.appliedTransformations < 2) {
          var d = this.s.getValueAtTime(u);
          P.scale(d[0] * this.s.mult, d[1] * this.s.mult, d[2] * this.s.mult);
        }
        if (this.sk && this.appliedTransformations < 3) {
          var C = this.sk.getValueAtTime(u), c = this.sa.getValueAtTime(u);
          P.skewFromAxis(-C * this.sk.mult, c * this.sa.mult);
        }
        if (this.r && this.appliedTransformations < 4) {
          var m = this.r.getValueAtTime(u);
          P.rotate(-m * this.r.mult);
        } else if (!this.r && this.appliedTransformations < 4) {
          var f = this.rz.getValueAtTime(u), g = this.ry.getValueAtTime(u), E = this.rx.getValueAtTime(u), A = this.or.getValueAtTime(u);
          P.rotateZ(-f * this.rz.mult).rotateY(g * this.ry.mult).rotateX(E * this.rx.mult).rotateZ(-A[2] * this.or.mult).rotateY(A[1] * this.or.mult).rotateX(A[0] * this.or.mult);
        }
        if (this.data.p && this.data.p.s) {
          var k = this.px.getValueAtTime(u), M = this.py.getValueAtTime(u);
          if (this.data.p.z) {
            var L = this.pz.getValueAtTime(u);
            P.translate(k * this.px.mult, M * this.py.mult, -L * this.pz.mult);
          } else
            P.translate(k * this.px.mult, M * this.py.mult, 0);
        } else {
          var B = this.p.getValueAtTime(u);
          P.translate(B[0] * this.p.mult, B[1] * this.p.mult, -B[2] * this.p.mult);
        }
        return P;
      }
      function s() {
        return this.v.clone(new Matrix());
      }
      var a = TransformPropertyFactory.getTransformProperty;
      TransformPropertyFactory.getTransformProperty = function(u, P, b) {
        var d = a(u, P, b);
        return d.dynamicProperties.length ? d.getValueAtTime = i.bind(d) : d.getValueAtTime = s.bind(d), d.setGroupProperty = expressionHelpers.setGroupProperty, d;
      };
      var n = PropertyFactory.getProp;
      PropertyFactory.getProp = function(u, P, b, d, C) {
        var c = n(u, P, b, d, C);
        c.kf ? c.getValueAtTime = expressionHelpers.getValueAtTime.bind(c) : c.getValueAtTime = expressionHelpers.getStaticValueAtTime.bind(c), c.setGroupProperty = expressionHelpers.setGroupProperty, c.loopOut = e, c.loopIn = t, c.smooth = r, c.getVelocityAtTime = expressionHelpers.getVelocityAtTime.bind(c), c.getSpeedAtTime = expressionHelpers.getSpeedAtTime.bind(c), c.numKeys = P.a === 1 ? P.k.length : 0, c.propertyIndex = P.ix;
        var m = 0;
        return b !== 0 && (m = createTypedArray("float32", P.a === 1 ? P.k[0].s.length : P.k.length)), c._cachingAtTime = {
          lastFrame: initialDefaultFrame,
          lastIndex: 0,
          value: m
        }, expressionHelpers.searchExpressions(u, P, c), c.k && C.addDynamicProperty(c), c;
      };
      function l(u) {
        return this._cachingAtTime || (this._cachingAtTime = {
          shapeValue: shapePool.clone(this.pv),
          lastIndex: 0,
          lastTime: initialDefaultFrame
        }), u *= this.elem.globalData.frameRate, u -= this.offsetTime, u !== this._cachingAtTime.lastTime && (this._cachingAtTime.lastIndex = this._cachingAtTime.lastTime < u ? this._caching.lastIndex : 0, this._cachingAtTime.lastTime = u, this.interpolateShape(u, this._cachingAtTime.shapeValue, this._cachingAtTime)), this._cachingAtTime.shapeValue;
      }
      var o = ShapePropertyFactory.getConstructorFunction(), p = ShapePropertyFactory.getKeyframedConstructorFunction();
      function y() {
      }
      y.prototype = {
        vertices: function(P, b) {
          this.k && this.getValue();
          var d = this.v;
          b !== void 0 && (d = this.getValueAtTime(b, 0));
          var C, c = d._length, m = d[P], f = d.v, g = createSizedArray(c);
          for (C = 0; C < c; C += 1)
            P === "i" || P === "o" ? g[C] = [m[C][0] - f[C][0], m[C][1] - f[C][1]] : g[C] = [m[C][0], m[C][1]];
          return g;
        },
        points: function(P) {
          return this.vertices("v", P);
        },
        inTangents: function(P) {
          return this.vertices("i", P);
        },
        outTangents: function(P) {
          return this.vertices("o", P);
        },
        isClosed: function() {
          return this.v.c;
        },
        pointOnPath: function(P, b) {
          var d = this.v;
          b !== void 0 && (d = this.getValueAtTime(b, 0)), this._segmentsLength || (this._segmentsLength = bez.getSegmentsLength(d));
          for (var C = this._segmentsLength, c = C.lengths, m = C.totalLength * P, f = 0, g = c.length, E = 0, A; f < g; ) {
            if (E + c[f].addedLength > m) {
              var k = f, M = d.c && f === g - 1 ? 0 : f + 1, L = (m - E) / c[f].addedLength;
              A = bez.getPointInSegment(d.v[k], d.v[M], d.o[k], d.i[M], L, c[f]);
              break;
            } else
              E += c[f].addedLength;
            f += 1;
          }
          return A || (A = d.c ? [d.v[0][0], d.v[0][1]] : [d.v[d._length - 1][0], d.v[d._length - 1][1]]), A;
        },
        vectorOnPath: function(P, b, d) {
          P == 1 ? P = this.v.c : P == 0 && (P = 0.999);
          var C = this.pointOnPath(P, b), c = this.pointOnPath(P + 1e-3, b), m = c[0] - C[0], f = c[1] - C[1], g = Math.sqrt(Math.pow(m, 2) + Math.pow(f, 2));
          if (g === 0)
            return [0, 0];
          var E = d === "tangent" ? [m / g, f / g] : [-f / g, m / g];
          return E;
        },
        tangentOnPath: function(P, b) {
          return this.vectorOnPath(P, b, "tangent");
        },
        normalOnPath: function(P, b) {
          return this.vectorOnPath(P, b, "normal");
        },
        setGroupProperty: expressionHelpers.setGroupProperty,
        getValueAtTime: expressionHelpers.getStaticValueAtTime
      }, extendPrototype([y], o), extendPrototype([y], p), p.prototype.getValueAtTime = l, p.prototype.initiateExpression = ExpressionManager.initiateExpression;
      var S = ShapePropertyFactory.getShapeProp;
      ShapePropertyFactory.getShapeProp = function(u, P, b, d, C) {
        var c = S(u, P, b, d, C);
        return c.propertyIndex = P.ix, c.lock = !1, b === 3 ? expressionHelpers.searchExpressions(u, P.pt, c) : b === 4 && expressionHelpers.searchExpressions(u, P.ks, c), c.k && u.addDynamicProperty(c), c;
      };
    }
    function initialize$1() {
      addPropertyDecorator();
    }
    function addDecorator() {
      function e() {
        return this.data.d.x ? (this.calculateExpression = ExpressionManager.initiateExpression.bind(this)(this.elem, this.data.d, this), this.addEffect(this.getExpressionValue.bind(this)), !0) : null;
      }
      TextProperty.prototype.getExpressionValue = function(t, r) {
        var i = this.calculateExpression(r);
        if (t.t !== i) {
          var s = {};
          return this.copyData(s, t), s.t = i.toString(), s.__complete = !1, s;
        }
        return t;
      }, TextProperty.prototype.searchProperty = function() {
        var t = this.searchKeyframes(), r = this.searchExpressions();
        return this.kf = t || r, this.kf;
      }, TextProperty.prototype.searchExpressions = e;
    }
    function initialize() {
      addDecorator();
    }
    function SVGComposableEffect() {
    }
    SVGComposableEffect.prototype = {
      createMergeNode: function e(t, r) {
        var i = createNS("feMerge");
        i.setAttribute("result", t);
        var s, a;
        for (a = 0; a < r.length; a += 1)
          s = createNS("feMergeNode"), s.setAttribute("in", r[a]), i.appendChild(s), i.appendChild(s);
        return i;
      }
    };
    var linearFilterValue = "0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0";
    function SVGTintFilter(e, t, r, i, s) {
      this.filterManager = t;
      var a = createNS("feColorMatrix");
      a.setAttribute("type", "matrix"), a.setAttribute("color-interpolation-filters", "linearRGB"), a.setAttribute("values", linearFilterValue + " 1 0"), this.linearFilter = a, a.setAttribute("result", i + "_tint_1"), e.appendChild(a), a = createNS("feColorMatrix"), a.setAttribute("type", "matrix"), a.setAttribute("color-interpolation-filters", "sRGB"), a.setAttribute("values", "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"), a.setAttribute("result", i + "_tint_2"), e.appendChild(a), this.matrixFilter = a;
      var n = this.createMergeNode(i, [s, i + "_tint_1", i + "_tint_2"]);
      e.appendChild(n);
    }
    extendPrototype([SVGComposableEffect], SVGTintFilter), SVGTintFilter.prototype.renderFrame = function(e) {
      if (e || this.filterManager._mdf) {
        var t = this.filterManager.effectElements[0].p.v, r = this.filterManager.effectElements[1].p.v, i = this.filterManager.effectElements[2].p.v / 100;
        this.linearFilter.setAttribute("values", linearFilterValue + " " + i + " 0"), this.matrixFilter.setAttribute("values", r[0] - t[0] + " 0 0 0 " + t[0] + " " + (r[1] - t[1]) + " 0 0 0 " + t[1] + " " + (r[2] - t[2]) + " 0 0 0 " + t[2] + " 0 0 0 1 0");
      }
    };
    function SVGFillFilter(e, t, r, i) {
      this.filterManager = t;
      var s = createNS("feColorMatrix");
      s.setAttribute("type", "matrix"), s.setAttribute("color-interpolation-filters", "sRGB"), s.setAttribute("values", "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"), s.setAttribute("result", i), e.appendChild(s), this.matrixFilter = s;
    }
    SVGFillFilter.prototype.renderFrame = function(e) {
      if (e || this.filterManager._mdf) {
        var t = this.filterManager.effectElements[2].p.v, r = this.filterManager.effectElements[6].p.v;
        this.matrixFilter.setAttribute("values", "0 0 0 0 " + t[0] + " 0 0 0 0 " + t[1] + " 0 0 0 0 " + t[2] + " 0 0 0 " + r + " 0");
      }
    };
    function SVGStrokeEffect(e, t, r) {
      this.initialized = !1, this.filterManager = t, this.elem = r, this.paths = [];
    }
    SVGStrokeEffect.prototype.initialize = function() {
      var e = this.elem.layerElement.children || this.elem.layerElement.childNodes, t, r, i, s;
      for (this.filterManager.effectElements[1].p.v === 1 ? (s = this.elem.maskManager.masksProperties.length, i = 0) : (i = this.filterManager.effectElements[0].p.v - 1, s = i + 1), r = createNS("g"), r.setAttribute("fill", "none"), r.setAttribute("stroke-linecap", "round"), r.setAttribute("stroke-dashoffset", 1), i; i < s; i += 1)
        t = createNS("path"), r.appendChild(t), this.paths.push({
          p: t,
          m: i
        });
      if (this.filterManager.effectElements[10].p.v === 3) {
        var a = createNS("mask"), n = createElementID();
        a.setAttribute("id", n), a.setAttribute("mask-type", "alpha"), a.appendChild(r), this.elem.globalData.defs.appendChild(a);
        var l = createNS("g");
        for (l.setAttribute("mask", "url(" + getLocationHref() + "#" + n + ")"); e[0]; )
          l.appendChild(e[0]);
        this.elem.layerElement.appendChild(l), this.masker = a, r.setAttribute("stroke", "#fff");
      } else if (this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2) {
        if (this.filterManager.effectElements[10].p.v === 2)
          for (e = this.elem.layerElement.children || this.elem.layerElement.childNodes; e.length; )
            this.elem.layerElement.removeChild(e[0]);
        this.elem.layerElement.appendChild(r), this.elem.layerElement.removeAttribute("mask"), r.setAttribute("stroke", "#fff");
      }
      this.initialized = !0, this.pathMasker = r;
    }, SVGStrokeEffect.prototype.renderFrame = function(e) {
      this.initialized || this.initialize();
      var t, r = this.paths.length, i, s;
      for (t = 0; t < r; t += 1)
        if (this.paths[t].m !== -1 && (i = this.elem.maskManager.viewData[this.paths[t].m], s = this.paths[t].p, (e || this.filterManager._mdf || i.prop._mdf) && s.setAttribute("d", i.lastPath), e || this.filterManager.effectElements[9].p._mdf || this.filterManager.effectElements[4].p._mdf || this.filterManager.effectElements[7].p._mdf || this.filterManager.effectElements[8].p._mdf || i.prop._mdf)) {
          var a;
          if (this.filterManager.effectElements[7].p.v !== 0 || this.filterManager.effectElements[8].p.v !== 100) {
            var n = Math.min(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v) * 0.01, l = Math.max(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v) * 0.01, o = s.getTotalLength();
            a = "0 0 0 " + o * n + " ";
            var p = o * (l - n), y = 1 + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01, S = Math.floor(p / y), u;
            for (u = 0; u < S; u += 1)
              a += "1 " + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01 + " ";
            a += "0 " + o * 10 + " 0 0";
          } else
            a = "1 " + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01;
          s.setAttribute("stroke-dasharray", a);
        }
      if ((e || this.filterManager.effectElements[4].p._mdf) && this.pathMasker.setAttribute("stroke-width", this.filterManager.effectElements[4].p.v * 2), (e || this.filterManager.effectElements[6].p._mdf) && this.pathMasker.setAttribute("opacity", this.filterManager.effectElements[6].p.v), (this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2) && (e || this.filterManager.effectElements[3].p._mdf)) {
        var P = this.filterManager.effectElements[3].p.v;
        this.pathMasker.setAttribute("stroke", "rgb(" + bmFloor(P[0] * 255) + "," + bmFloor(P[1] * 255) + "," + bmFloor(P[2] * 255) + ")");
      }
    };
    function SVGTritoneFilter(e, t, r, i) {
      this.filterManager = t;
      var s = createNS("feColorMatrix");
      s.setAttribute("type", "matrix"), s.setAttribute("color-interpolation-filters", "linearRGB"), s.setAttribute("values", "0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0"), e.appendChild(s);
      var a = createNS("feComponentTransfer");
      a.setAttribute("color-interpolation-filters", "sRGB"), a.setAttribute("result", i), this.matrixFilter = a;
      var n = createNS("feFuncR");
      n.setAttribute("type", "table"), a.appendChild(n), this.feFuncR = n;
      var l = createNS("feFuncG");
      l.setAttribute("type", "table"), a.appendChild(l), this.feFuncG = l;
      var o = createNS("feFuncB");
      o.setAttribute("type", "table"), a.appendChild(o), this.feFuncB = o, e.appendChild(a);
    }
    SVGTritoneFilter.prototype.renderFrame = function(e) {
      if (e || this.filterManager._mdf) {
        var t = this.filterManager.effectElements[0].p.v, r = this.filterManager.effectElements[1].p.v, i = this.filterManager.effectElements[2].p.v, s = i[0] + " " + r[0] + " " + t[0], a = i[1] + " " + r[1] + " " + t[1], n = i[2] + " " + r[2] + " " + t[2];
        this.feFuncR.setAttribute("tableValues", s), this.feFuncG.setAttribute("tableValues", a), this.feFuncB.setAttribute("tableValues", n);
      }
    };
    function SVGProLevelsFilter(e, t, r, i) {
      this.filterManager = t;
      var s = this.filterManager.effectElements, a = createNS("feComponentTransfer");
      (s[10].p.k || s[10].p.v !== 0 || s[11].p.k || s[11].p.v !== 1 || s[12].p.k || s[12].p.v !== 1 || s[13].p.k || s[13].p.v !== 0 || s[14].p.k || s[14].p.v !== 1) && (this.feFuncR = this.createFeFunc("feFuncR", a)), (s[17].p.k || s[17].p.v !== 0 || s[18].p.k || s[18].p.v !== 1 || s[19].p.k || s[19].p.v !== 1 || s[20].p.k || s[20].p.v !== 0 || s[21].p.k || s[21].p.v !== 1) && (this.feFuncG = this.createFeFunc("feFuncG", a)), (s[24].p.k || s[24].p.v !== 0 || s[25].p.k || s[25].p.v !== 1 || s[26].p.k || s[26].p.v !== 1 || s[27].p.k || s[27].p.v !== 0 || s[28].p.k || s[28].p.v !== 1) && (this.feFuncB = this.createFeFunc("feFuncB", a)), (s[31].p.k || s[31].p.v !== 0 || s[32].p.k || s[32].p.v !== 1 || s[33].p.k || s[33].p.v !== 1 || s[34].p.k || s[34].p.v !== 0 || s[35].p.k || s[35].p.v !== 1) && (this.feFuncA = this.createFeFunc("feFuncA", a)), (this.feFuncR || this.feFuncG || this.feFuncB || this.feFuncA) && (a.setAttribute("color-interpolation-filters", "sRGB"), e.appendChild(a)), (s[3].p.k || s[3].p.v !== 0 || s[4].p.k || s[4].p.v !== 1 || s[5].p.k || s[5].p.v !== 1 || s[6].p.k || s[6].p.v !== 0 || s[7].p.k || s[7].p.v !== 1) && (a = createNS("feComponentTransfer"), a.setAttribute("color-interpolation-filters", "sRGB"), a.setAttribute("result", i), e.appendChild(a), this.feFuncRComposed = this.createFeFunc("feFuncR", a), this.feFuncGComposed = this.createFeFunc("feFuncG", a), this.feFuncBComposed = this.createFeFunc("feFuncB", a));
    }
    SVGProLevelsFilter.prototype.createFeFunc = function(e, t) {
      var r = createNS(e);
      return r.setAttribute("type", "table"), t.appendChild(r), r;
    }, SVGProLevelsFilter.prototype.getTableValue = function(e, t, r, i, s) {
      for (var a = 0, n = 256, l, o = Math.min(e, t), p = Math.max(e, t), y = Array.call(null, {
        length: n
      }), S, u = 0, P = s - i, b = t - e; a <= 256; )
        l = a / 256, l <= o ? S = b < 0 ? s : i : l >= p ? S = b < 0 ? i : s : S = i + P * Math.pow((l - e) / b, 1 / r), y[u] = S, u += 1, a += 256 / (n - 1);
      return y.join(" ");
    }, SVGProLevelsFilter.prototype.renderFrame = function(e) {
      if (e || this.filterManager._mdf) {
        var t, r = this.filterManager.effectElements;
        this.feFuncRComposed && (e || r[3].p._mdf || r[4].p._mdf || r[5].p._mdf || r[6].p._mdf || r[7].p._mdf) && (t = this.getTableValue(r[3].p.v, r[4].p.v, r[5].p.v, r[6].p.v, r[7].p.v), this.feFuncRComposed.setAttribute("tableValues", t), this.feFuncGComposed.setAttribute("tableValues", t), this.feFuncBComposed.setAttribute("tableValues", t)), this.feFuncR && (e || r[10].p._mdf || r[11].p._mdf || r[12].p._mdf || r[13].p._mdf || r[14].p._mdf) && (t = this.getTableValue(r[10].p.v, r[11].p.v, r[12].p.v, r[13].p.v, r[14].p.v), this.feFuncR.setAttribute("tableValues", t)), this.feFuncG && (e || r[17].p._mdf || r[18].p._mdf || r[19].p._mdf || r[20].p._mdf || r[21].p._mdf) && (t = this.getTableValue(r[17].p.v, r[18].p.v, r[19].p.v, r[20].p.v, r[21].p.v), this.feFuncG.setAttribute("tableValues", t)), this.feFuncB && (e || r[24].p._mdf || r[25].p._mdf || r[26].p._mdf || r[27].p._mdf || r[28].p._mdf) && (t = this.getTableValue(r[24].p.v, r[25].p.v, r[26].p.v, r[27].p.v, r[28].p.v), this.feFuncB.setAttribute("tableValues", t)), this.feFuncA && (e || r[31].p._mdf || r[32].p._mdf || r[33].p._mdf || r[34].p._mdf || r[35].p._mdf) && (t = this.getTableValue(r[31].p.v, r[32].p.v, r[33].p.v, r[34].p.v, r[35].p.v), this.feFuncA.setAttribute("tableValues", t));
      }
    };
    function SVGDropShadowEffect(e, t, r, i, s) {
      var a = t.container.globalData.renderConfig.filterSize, n = t.data.fs || a;
      e.setAttribute("x", n.x || a.x), e.setAttribute("y", n.y || a.y), e.setAttribute("width", n.width || a.width), e.setAttribute("height", n.height || a.height), this.filterManager = t;
      var l = createNS("feGaussianBlur");
      l.setAttribute("in", "SourceAlpha"), l.setAttribute("result", i + "_drop_shadow_1"), l.setAttribute("stdDeviation", "0"), this.feGaussianBlur = l, e.appendChild(l);
      var o = createNS("feOffset");
      o.setAttribute("dx", "25"), o.setAttribute("dy", "0"), o.setAttribute("in", i + "_drop_shadow_1"), o.setAttribute("result", i + "_drop_shadow_2"), this.feOffset = o, e.appendChild(o);
      var p = createNS("feFlood");
      p.setAttribute("flood-color", "#00ff00"), p.setAttribute("flood-opacity", "1"), p.setAttribute("result", i + "_drop_shadow_3"), this.feFlood = p, e.appendChild(p);
      var y = createNS("feComposite");
      y.setAttribute("in", i + "_drop_shadow_3"), y.setAttribute("in2", i + "_drop_shadow_2"), y.setAttribute("operator", "in"), y.setAttribute("result", i + "_drop_shadow_4"), e.appendChild(y);
      var S = this.createMergeNode(i, [i + "_drop_shadow_4", s]);
      e.appendChild(S);
    }
    extendPrototype([SVGComposableEffect], SVGDropShadowEffect), SVGDropShadowEffect.prototype.renderFrame = function(e) {
      if (e || this.filterManager._mdf) {
        if ((e || this.filterManager.effectElements[4].p._mdf) && this.feGaussianBlur.setAttribute("stdDeviation", this.filterManager.effectElements[4].p.v / 4), e || this.filterManager.effectElements[0].p._mdf) {
          var t = this.filterManager.effectElements[0].p.v;
          this.feFlood.setAttribute("flood-color", rgbToHex(Math.round(t[0] * 255), Math.round(t[1] * 255), Math.round(t[2] * 255)));
        }
        if ((e || this.filterManager.effectElements[1].p._mdf) && this.feFlood.setAttribute("flood-opacity", this.filterManager.effectElements[1].p.v / 255), e || this.filterManager.effectElements[2].p._mdf || this.filterManager.effectElements[3].p._mdf) {
          var r = this.filterManager.effectElements[3].p.v, i = (this.filterManager.effectElements[2].p.v - 90) * degToRads, s = r * Math.cos(i), a = r * Math.sin(i);
          this.feOffset.setAttribute("dx", s), this.feOffset.setAttribute("dy", a);
        }
      }
    };
    var _svgMatteSymbols = [];
    function SVGMatte3Effect(e, t, r) {
      this.initialized = !1, this.filterManager = t, this.filterElem = e, this.elem = r, r.matteElement = createNS("g"), r.matteElement.appendChild(r.layerElement), r.matteElement.appendChild(r.transformedElement), r.baseElement = r.matteElement;
    }
    SVGMatte3Effect.prototype.findSymbol = function(e) {
      for (var t = 0, r = _svgMatteSymbols.length; t < r; ) {
        if (_svgMatteSymbols[t] === e)
          return _svgMatteSymbols[t];
        t += 1;
      }
      return null;
    }, SVGMatte3Effect.prototype.replaceInParent = function(e, t) {
      var r = e.layerElement.parentNode;
      if (r) {
        for (var i = r.children, s = 0, a = i.length; s < a && i[s] !== e.layerElement; )
          s += 1;
        var n;
        s <= a - 2 && (n = i[s + 1]);
        var l = createNS("use");
        l.setAttribute("href", "#" + t), n ? r.insertBefore(l, n) : r.appendChild(l);
      }
    }, SVGMatte3Effect.prototype.setElementAsMask = function(e, t) {
      if (!this.findSymbol(t)) {
        var r = createElementID(), i = createNS("mask");
        i.setAttribute("id", t.layerId), i.setAttribute("mask-type", "alpha"), _svgMatteSymbols.push(t);
        var s = e.globalData.defs;
        s.appendChild(i);
        var a = createNS("symbol");
        a.setAttribute("id", r), this.replaceInParent(t, r), a.appendChild(t.layerElement), s.appendChild(a);
        var n = createNS("use");
        n.setAttribute("href", "#" + r), i.appendChild(n), t.data.hd = !1, t.show();
      }
      e.setMatte(t.layerId);
    }, SVGMatte3Effect.prototype.initialize = function() {
      for (var e = this.filterManager.effectElements[0].p.v, t = this.elem.comp.elements, r = 0, i = t.length; r < i; )
        t[r] && t[r].data.ind === e && this.setElementAsMask(this.elem, t[r]), r += 1;
      this.initialized = !0;
    }, SVGMatte3Effect.prototype.renderFrame = function() {
      this.initialized || this.initialize();
    };
    function SVGGaussianBlurEffect(e, t, r, i) {
      e.setAttribute("x", "-100%"), e.setAttribute("y", "-100%"), e.setAttribute("width", "300%"), e.setAttribute("height", "300%"), this.filterManager = t;
      var s = createNS("feGaussianBlur");
      s.setAttribute("result", i), e.appendChild(s), this.feGaussianBlur = s;
    }
    SVGGaussianBlurEffect.prototype.renderFrame = function(e) {
      if (e || this.filterManager._mdf) {
        var t = 0.3, r = this.filterManager.effectElements[0].p.v * t, i = this.filterManager.effectElements[1].p.v, s = i == 3 ? 0 : r, a = i == 2 ? 0 : r;
        this.feGaussianBlur.setAttribute("stdDeviation", s + " " + a);
        var n = this.filterManager.effectElements[2].p.v == 1 ? "wrap" : "duplicate";
        this.feGaussianBlur.setAttribute("edgeMode", n);
      }
    };
    function TransformEffect() {
    }
    TransformEffect.prototype.init = function(e) {
      this.effectsManager = e, this.type = effectTypes.TRANSFORM_EFFECT, this.matrix = new Matrix(), this.opacity = -1, this._mdf = !1, this._opMdf = !1;
    }, TransformEffect.prototype.renderFrame = function(e) {
      if (this._opMdf = !1, this._mdf = !1, e || this.effectsManager._mdf) {
        var t = this.effectsManager.effectElements, r = t[0].p.v, i = t[1].p.v, s = t[2].p.v === 1, a = t[3].p.v, n = s ? a : t[4].p.v, l = t[5].p.v, o = t[6].p.v, p = t[7].p.v;
        this.matrix.reset(), this.matrix.translate(-r[0], -r[1], r[2]), this.matrix.scale(n * 0.01, a * 0.01, 1), this.matrix.rotate(-p * degToRads), this.matrix.skewFromAxis(-l * degToRads, (o + 90) * degToRads), this.matrix.translate(i[0], i[1], 0), this._mdf = !0, this.opacity !== t[8].p.v && (this.opacity = t[8].p.v, this._opMdf = !0);
      }
    };
    function SVGTransformEffect(e, t) {
      this.init(t);
    }
    extendPrototype([TransformEffect], SVGTransformEffect);
    function CVTransformEffect(e) {
      this.init(e);
    }
    return extendPrototype([TransformEffect], CVTransformEffect), registerRenderer("canvas", CanvasRenderer), registerRenderer("html", HybridRenderer), registerRenderer("svg", SVGRenderer), ShapeModifiers.registerModifier("tm", TrimModifier), ShapeModifiers.registerModifier("pb", PuckerAndBloatModifier), ShapeModifiers.registerModifier("rp", RepeaterModifier), ShapeModifiers.registerModifier("rd", RoundCornersModifier), ShapeModifiers.registerModifier("zz", ZigZagModifier), ShapeModifiers.registerModifier("op", OffsetPathModifier), setExpressionsPlugin(Expressions), setExpressionInterfaces(getInterface), initialize$1(), initialize(), registerEffect$1(20, SVGTintFilter, !0), registerEffect$1(21, SVGFillFilter, !0), registerEffect$1(22, SVGStrokeEffect, !1), registerEffect$1(23, SVGTritoneFilter, !0), registerEffect$1(24, SVGProLevelsFilter, !0), registerEffect$1(25, SVGDropShadowEffect, !0), registerEffect$1(28, SVGMatte3Effect, !1), registerEffect$1(29, SVGGaussianBlurEffect, !0), registerEffect$1(35, SVGTransformEffect, !1), registerEffect(35, CVTransformEffect), lottie;
  });
})(lottie, lottie.exports);
const lottiePlayer = lottie.exports, de = {
  400: {
    title: "Fehlerhafte Anfrage - 400",
    message: "Der Server kann die Anfrage aufgrund eines wahrgenommenen Fehlers nicht verarbeiten oder ablehnen."
  },
  401: {
    title: "Nicht autorisiert - 401",
    message: "Es tut uns leid, aber Sie konnten nicht authentifiziert werden. Bitte versuchen Sie, sich erneut anzumelden."
  },
  403: {
    title: "Zugriff verweigert - 403",
    message: "Sie verfügen nicht über die erforderlichen Zugriffsrechte. Kontaktieren Sie den Administrator, um die Berechtigung zu erhalten."
  },
  404: {
    title: "Die angeforderte Webseite wurde nicht gefunden - 404",
    details: [
      {
        header: "Warum erhalte ich diese Nachricht?",
        message: [
          "Die URL ist inkorrekt oder veraltet.",
          "Wir haben die Seite während der Neugestaltung unserer Webseite umbenannt oder verschoben."
        ]
      },
      {
        header: "Was kann ich tun?",
        message: [
          "Überprüfen Sie die eingegebene URL.",
          "Versuchen Sie, die angeforderten Inhalte über unsere Startseite oder die Navigation zu finden.",
          "Verwenden Sie die Volltextsuche."
        ]
      }
    ],
    message: "Es tut uns leid, aber die Seite kann nicht aufgerufen werden."
  },
  500: {
    title: "Serverfehler - 500",
    message: "Es tut uns leid, es gibt technische Probleme. Wir werden das Problem so schnell wie möglich beheben. Bitte versuchen Sie es später erneut."
  },
  503: {
    title: "Dienst nicht verfügbar - 503",
    message: "Der Server ist derzeit nicht verfügbar (weil er überlastet ist oder Wartungsarbeiten durchgeführt werden). Bitte versuchen Sie es später erneut."
  }
}, deJson = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: de
}), en = {
  400: {
    title: "Bad request – 400",
    message: "Server cannot or will not process the request due to something that is perceived"
  },
  401: {
    title: "Unauthorized – 401",
    message: "This server could not verify that you are authorized to access the document requested. Either you supplied the wrong credentials (e.g., bad password), or your browser doesn’t understand how to supply the credentials required."
  },
  403: {
    title: "Forbidden – 403",
    message: "You have not the required access privileges. Contact administrator for permission."
  },
  404: {
    title: "The requested website was not found – 404",
    details: [
      {
        header: "Why I get this message?",
        message: [
          "The URL is incorrect or out of date.",
          "We renamed or moved the page during the revamping of our website."
        ]
      },
      {
        header: "What can I do?",
        message: [
          "Check the entered URL.",
          "Try and find the requested contents using our start page or the navigation.",
          "Use the full-text search."
        ]
      }
    ],
    message: "We are sorry, but the page cannot be accessed."
  },
  500: {
    title: "Server error – 500",
    message: "We are sorry, there are some technical issues. We will fix the problem as fast as we can. Please try again later."
  },
  503: {
    title: "Service unavailable – 503",
    message: "The server is currently unavailable (because it is overloaded or down for maintanance). Please try again later."
  }
}, enJson = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: en
}), es = {
  400: {
    title: "Solicitud incorrecta - 400",
    message: "El servidor no puede o no procesará la solicitud debido a algo que se percibe."
  },
  401: {
    title: "No autorizado - 401",
    message: "Lo sentimos, no se pudo autenticar. Por favor, intente iniciar sesión nuevamente."
  },
  403: {
    title: "Prohibido - 403",
    message: "No tiene los privilegios de acceso requeridos. Contacte al administrador para obtener permiso."
  },
  404: {
    title: "No se encontró la página solicitada - 404",
    details: [
      {
        header: "¿Por qué recibo este mensaje?",
        message: [
          "La URL es incorrecta o está desactualizada.",
          "Renombramos o movimos la página durante la reestructuración de nuestro sitio web."
        ]
      },
      {
        header: "¿Qué puedo hacer?",
        message: [
          "Verifique la URL ingresada.",
          "Intente encontrar el contenido solicitado usando nuestra página de inicio o la navegación.",
          "Use la búsqueda de texto completo."
        ]
      }
    ],
    message: "Lo sentimos, pero no se puede acceder a la página."
  },
  500: {
    title: "Error del servidor - 500",
    message: "Lo sentimos, hay algunos problemas técnicos. Resolveremos el problema lo más rápido posible. Por favor, intente nuevamente más tarde."
  },
  503: {
    title: "Servicio no disponible - 503",
    message: "El servidor no está disponible actualmente (debido a sobrecarga o mantenimiento). Por favor, intente nuevamente más tarde."
  }
}, esJson = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: es
}), fr = {
  400: {
    title: "Requête incorrecte - 400",
    message: "Le serveur ne peut pas ou ne traitera pas la demande en raison de quelque chose qui est perçu."
  },
  401: {
    title: "Non autorisé - 401",
    message: "Nous sommes désolés, vous n'avez pas pu être authentifié. Veuillez essayer de vous connecter à nouveau."
  },
  403: {
    title: "Interdit - 403",
    message: "Vous n'avez pas les privilèges d'accès requis. Contactez l'administrateur pour obtenir l'autorisation."
  },
  404: {
    title: "La page demandée est introuvable - 404",
    details: [
      {
        header: "Pourquoi ai-je reçu ce message ?",
        message: [
          "L'URL est incorrecte ou obsolète.",
          "Nous avons renommé ou déplacé la page lors de la refonte de notre site web."
        ]
      },
      {
        header: "Que puis-je faire ?",
        message: [
          "Vérifiez l'URL saisie.",
          "Essayez de trouver le contenu demandé en utilisant notre page de démarrage ou la navigation.",
          "Utilisez la recherche en texte intégral."
        ]
      }
    ],
    message: "Nous sommes désolés, mais la page est inaccessible."
  },
  500: {
    title: "Erreur du serveur - 500",
    message: "Nous sommes désolés, il y a des problèmes techniques. Nous allons résoudre le problème dès que possible. Veuillez réessayer plus tard."
  },
  503: {
    title: "Service non disponible - 503",
    message: "Le serveur n'est pas disponible actuellement (en raison d'une surcharge ou de travaux de maintenance). Veuillez réessayer ultérieurement."
  }
}, frJson = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: fr
}), it = {
  400: {
    title: "Richiesta non valida - 400",
    message: "Il server non può o non elaborerà la richiesta a causa di qualcosa che è percepito."
  },
  401: {
    title: "Non autorizzato - 401",
    message: "Ci dispiace, non è stato possibile autenticarti. Per favore, prova a effettuare nuovamente l'accesso."
  },
  403: {
    title: "Vietato - 403",
    message: "Non hai i privilegi di accesso necessari. Contatta l'amministratore per ottenere l'autorizzazione."
  },
  404: {
    title: "Pagina non trovata - 404",
    details: [
      {
        header: "Perché ricevo questo messaggio?",
        message: [
          "L'URL non è corretto o è obsoleto.",
          "Abbiamo rinominato o spostato la pagina durante la revisione del nostro sito web."
        ]
      },
      {
        header: "Cosa posso fare?",
        message: [
          "Verifica l'URL inserito.",
          "Prova a trovare i contenuti richiesti utilizzando la nostra pagina iniziale o la navigazione.",
          "Usa la ricerca full-text."
        ]
      }
    ],
    message: "Ci dispiace, ma la pagina non può essere accessa."
  },
  500: {
    title: "Errore del server - 500",
    message: "Ci scusiamo, ci sono alcuni problemi tecnici. Risolveremo il problema il prima possibile. Per favore, riprova più tardi."
  },
  503: {
    title: "Servizio non disponibile - 503",
    message: "Il server non è attualmente disponibile (a causa di sovraccarico o manutenzione). Per favore, riprova più tardi."
  }
}, itJson = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: it
}), ja = {
  400: {
    title: "不正なリクエスト - 400",
    message: "サーバーがリクエストを処理できない、または処理しようとしない"
  },
  401: {
    title: "認証されていません - 401",
    message: "このサーバーは、あなたが要求されたドキュメントにアクセスする権限があることを確認できませんでした。間違った認証情報を入力した可能性があります、または、ブラウザが必要な認証情報を提供する方法を理解していません。"
  },
  403: {
    title: "禁止 - 403",
    message: "必要なアクセス権限がありません。管理者に連絡して許可を得てください。"
  },
  404: {
    title: "要求されたウェブサイトが見つかりません - 404",
    details: [
      {
        header: "なぜこのメッセージが表示されるのですか？",
        message: [
          "URLが間違っているか、古くなっています。",
          "ウェブサイトのリニューアル中にページ名を変更または移動しました。"
        ]
      },
      {
        header: "どうすればよいですか？",
        message: [
          "入力されたURLを確認してください。",
          "スタートページまたはナビゲーションを使用して、リクエストされたコンテンツを見つけてください。",
          "全文検索をご利用ください。"
        ]
      }
    ],
    message: "申し訳ありませんが、このページにはアクセスできません。"
  },
  500: {
    title: "サーバーエラー - 500",
    message: "申し訳ございません。できるだけ早く問題を解決します。後でもう一度お試しください。"
  },
  503: {
    title: "サービスを利用できません - 503",
    message: "サーバーは現在利用できません (過負荷またはメンテナンスのために停止しているため)。後でもう一度お試しください。"
  }
}, jaJson = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: ja
}), ko = {
  400: {
    title: "잘못된 요청 - 400",
    message: "서버가 요청을 처리할 수 없거나 처리하지 않습니다."
  },
  401: {
    title: "권한 없음 - 401",
    message: "이 서버는 요청된 문서에 액세스할 수 있는 권한이 있는지 확인할 수 없습니다. 잘못된 자격 증명을 제공했거나(예: 잘못된 비밀번호), 또는 브라우저가 필요한 자격 증명을 제공하는 방법을 이해하지 못합니다."
  },
  403: {
    title: "금지됨 - 403",
    message: "필요한 액세스 권한이 없습니다. 관리자에게 문의하여 권한을 요청하세요."
  },
  404: {
    title: "요청하신 웹사이트를 찾을 수 없습니다 - 404",
    details: [
      {
        header: "이 메시지가 표시되는 이유는 무엇인가요?",
        message: [
          "URL이 올바르지 않거나 오래되었습니다.",
          "웹사이트 개편 중에 페이지의 이름을 변경하거나 이동했습니다."
        ]
      },
      {
        header: "어떻게 해야 하나요?",
        message: [
          "입력한 URL을 확인하세요.",
          "시작 페이지 또는 탐색을 사용하여 요청된 콘텐츠를 찾아보세요.",
          "전체 텍스트 검색을 사용하세요."
        ]
      }
    ],
    message: "죄송하지만 해당 페이지에 액세스할 수 없습니다."
  },
  500: {
    title: "서버 오류 - 500",
    message: "죄송합니다. 기술적 문제가 발생했습니다. 최대한 빨리 문제를 해결하겠습니다. 나중에 다시 시도해 주세요."
  },
  503: {
    title: "서비스를 사용할 수 없음 - 503",
    message: "현재 서버를 사용할 수 없습니다. (과부하가 걸렸거나 유지보수를 위해 다운되었기 때문입니다). 나중에 다시 시도해 주세요."
  }
}, koJson = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: ko
}), nl = {
  400: {
    title: "Slecht verzoek - 400",
    message: "De server kan of wil het verzoek niet verwerken vanwege iets dat wordt waargenomen"
  },
  401: {
    title: "Ongeautoriseerd - 401",
    message: "Deze server kon niet verifiëren of u geautoriseerd bent om toegang te krijgen tot het gevraagde document. Of je hebt de verkeerde gegevens opgegeven (bijvoorbeeld een slecht wachtwoord), of uw browser begrijpt niet hoe u de vereiste gegevens moet invoeren."
  },
  403: {
    title: "Verboden - 403",
    message: "Je hebt niet de vereiste toegangsrechten. Neem contact op met de beheerder voor toestemming."
  },
  404: {
    title: "De opgevraagde website is niet gevonden - 404",
    details: [
      {
        header: "Waarom krijg ik deze melding?",
        message: [
          "De URL is onjuist of verouderd.",
          "We hebben de pagina hernoemd of verplaatst tijdens het vernieuwen van onze website."
        ]
      },
      {
        header: "Wat kan ik doen?",
        message: [
          "Controleer de ingevoerde URL.",
          "Probeer de opgevraagde inhoud te vinden via onze startpagina of de navigatie.",
          "Gebruik de zoekfunctie voor de volledige tekst."
        ]
      }
    ],
    message: "Het spijt ons, maar de pagina kan niet worden geopend."
  },
  500: {
    title: "Serverfout - 500",
    message: "Het spijt ons, er zijn wat technische problemen. We zullen het probleem zo snel mogelijk oplossen. Probeer het later nog eens."
  },
  503: {
    title: "Service niet beschikbaar - 503",
    message: "De server is momenteel niet beschikbaar (omdat hij overbelast is of niet bereikbaar voor onderhoud). Probeer het later nog eens."
  }
}, nlJson = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: nl
}), pl = {
  400: {
    title: "Błędne żądanie - 400",
    message: "Serwer nie może lub nie przetworzy żądania z powodu czegoś, co jest postrzegane"
  },
  401: {
    title: "Nieautoryzowany - 401",
    message: "Ten serwer nie mógł zweryfikować, czy użytkownik jest uprawniony do uzyskania dostępu do żądanego dokumentu. Podano nieprawidłowe dane uwierzytelniające (np. złe hasło), lub przeglądarka nie wie, jak podać wymagane dane uwierzytelniające."
  },
  403: {
    title: "Zabronione - 403",
    message: "Nie masz wymaganych uprawnień dostępu. Skontaktuj się z administratorem w celu uzyskania uprawnień."
  },
  404: {
    title: "Żądana strona nie została znaleziona - 404",
    details: [
      {
        header: "Dlaczego otrzymuję ten komunikat?",
        message: [
          "Adres URL jest nieprawidłowy lub nieaktualny.",
          "Zmieniliśmy nazwę lub przenieśliśmy stronę podczas modernizacji naszej witryny."
        ]
      },
      {
        header: "Co mogę zrobić?",
        message: [
          "Sprawdź wprowadzony adres URL.",
          "Spróbuj znaleźć żądaną zawartość, korzystając z naszej strony startowej lub nawigacji.",
          "Użyj wyszukiwania pełnotekstowego."
        ]
      }
    ],
    message: "Przepraszamy, ale nie można uzyskać dostępu do tej strony."
  },
  500: {
    title: "Błąd serwera - 500",
    message: "Przepraszamy, wystąpiły problemy techniczne. Naprawimy problem tak szybko, jak to możliwe. Spróbuj ponownie później."
  },
  503: {
    title: "Usługa niedostępna - 503",
    message: "Serwer jest obecnie niedostępny (ponieważ jest przeciążony lub wyłączony z powodu konserwacji). Spróbuj ponownie później."
  }
}, plJson = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: pl
}), pt = {
  400: {
    title: "Requisição Inválida - 400",
    message: "O servidor não pode ou não processará a solicitação devido a algo que é percebido."
  },
  401: {
    title: "Não Autorizado - 401",
    message: "Lamentamos, mas não foi possível autenticar você. Por favor, tente fazer o login novamente."
  },
  403: {
    title: "Acesso Proibido - 403",
    message: "Você não tem as privilégios de acesso necessários. Entre em contato com o administrador para obter permissão."
  },
  404: {
    title: "Página Não Encontrada - 404",
    details: [
      {
        header: "Por que estou recebendo essa mensagem?",
        message: [
          "O URL está incorreto ou desatualizado.",
          "Renomeamos ou movemos a página durante a reformulação do nosso site."
        ]
      },
      {
        header: "O que posso fazer?",
        message: [
          "Verifique o URL digitado.",
          "Tente encontrar o conteúdo solicitado usando nossa página inicial ou a navegação.",
          "Use a pesquisa em texto completo."
        ]
      }
    ],
    message: "Lamentamos, mas a página não pode ser acessada."
  },
  500: {
    title: "Erro de Servidor - 500",
    message: "Lamentamos, mas há alguns problemas técnicos. Vamos resolver o problema o mais rápido possível. Por favor, tente novamente mais tarde."
  },
  503: {
    title: "Serviço Indisponível - 503",
    message: "O servidor está indisponível no momento (devido a sobrecarga ou manutenção). Por favor, tente novamente mais tarde."
  }
}, ptJson = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: pt
}), ru = {
  400: {
    title: "Неверный запрос - 400",
    message: "Сервер не может или не будет обрабатывать запрос из-за какой-то воспринимаемой проблемы."
  },
  401: {
    title: "Не авторизовано - 401",
    message: "Извините, вы не могли быть аутентифицированы. Пожалуйста, попробуйте войти снова."
  },
  403: {
    title: "Доступ запрещен - 403",
    message: "У вас нет необходимых прав доступа. Свяжитесь с администратором, чтобы получить разрешение."
  },
  404: {
    title: "Запрошенная страница не найдена - 404",
    details: [
      {
        header: "Почему я получил это сообщение?",
        message: [
          "URL неверен или устарел.",
          "Мы переименовали или переместили страницу во время пересмотра нашего веб-сайта."
        ]
      },
      {
        header: "Что я могу сделать?",
        message: [
          "Проверьте введенный URL.",
          "Попробуйте найти запрашиваемый контент, используя нашу стартовую страницу или навигацию.",
          "Используйте полнотекстовый поиск."
        ]
      }
    ],
    message: "Извините, но страница недоступна."
  },
  500: {
    title: "Ошибка сервера - 500",
    message: "Извините, возникли некоторые технические проблемы. Мы исправим проблему как можно скорее. Пожалуйста, попробуйте позже."
  },
  503: {
    title: "Сервис недоступен - 503",
    message: "Сервер в настоящее время недоступен (из-за перегрузки или технического обслуживания). Пожалуйста, попробуйте позже."
  }
}, ruJson = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: ru
}), tr = {
  400: {
    title: "Kötü istek - 400",
    message: "Sunucu, talep nedeniyle işlem yapamıyor veya yapmayacak vanwege iets dat wordt waargenomen"
  },
  401: {
    title: "Yetkisiz - 401",
    message: "Bu sunucu, istenen belgeye erişim yetkiniz olduğunu doğrulayamadı. Ya yanlış kimlik bilgilerini verdiniz (örneğin, hatalı şifre), veya tarayıcınız gerekli kimlik bilgilerinin nasıl sağlanacağını anlamıyor."
  },
  403: {
    title: "Yasak - 403",
    message: "Gerekli erişim ayrıcalıklarına sahip değilsiniz. İzin için yöneticiye başvurun."
  },
  404: {
    title: "İstenen web sitesi bulunamadı - 404",
    details: [
      {
        header: "Neden bu mesajı alıyorum?",
        message: [
          "URL yanlış veya güncel değil.",
          "Web sitemizin yenilenmesi sırasında sayfayı yeniden adlandırdık veya taşıdık."
        ]
      },
      {
        header: "Ne yapabilirim?",
        message: [
          "Girilen URL'yi kontrol edin.",
          "Başlangıç sayfamızı veya navigasyonu kullanarak istenen içeriği bulmaya çalışın.",
          "- Tam metin aramayı kullanın."
        ]
      }
    ],
    message: "Üzgünüz, ancak sayfaya erişilemiyor."
  },
  500: {
    title: "Sunucu hatası - 500",
    message: "Üzgünüz, bazı teknik sorunlar var. Sorunu olabildiğince hızlı çözeceğiz. Lütfen daha sonra tekrar deneyin."
  },
  503: {
    title: "Hizmet kullanılamıyor - 503",
    message: "Sunucu şu anda kullanılamıyor (aşırı yüklendiğinden veya bakım için kapalı olduğundan). Lütfen daha sonra tekrar deneyin."
  }
}, trJson = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: tr
}), zh = {
  400: {
    title: "错误请求 - 400",
    message: "由于某种被感知到的问题，服务器无法或不会处理请求。"
  },
  401: {
    title: "未经授权 - 401",
    message: "很抱歉，您无法通过身份验证。请尝试重新登录。"
  },
  403: {
    title: "禁止访问 - 403",
    message: "您没有所需的访问权限。请联系管理员以获取权限。"
  },
  404: {
    title: "未找到请求的网页 - 404",
    details: [
      {
        header: "为什么会收到此消息？",
        message: [
          "URL 错误或已过期。",
          "我们在重新设计网站期间更改了页面的名称或位置。"
        ]
      },
      {
        header: "我可以做什么？",
        message: [
          "检查输入的 URL。",
          "尝试使用我们的起始页或导航来查找所需内容。",
          "使用全文搜索。"
        ]
      }
    ],
    message: "很抱歉，但页面无法访问。"
  },
  500: {
    title: "服务器错误 - 500",
    message: "很抱歉，出现了一些技术问题。我们会尽快解决问题。请稍后再试。"
  },
  503: {
    title: "服务不可用 - 503",
    message: "服务器当前不可用（因为超负荷或维护）。请稍后再试。"
  }
}, zhJson = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: zh
}), patternlibHttpErrorPageCss = '*,:after,:before{border-color:var(--color-neutral-steel-200);border-style:solid;border-width:0;box-sizing:border-box}a{color:inherit;text-decoration:inherit}audio,canvas,embed,iframe,img,object,svg,video{display:block;vertical-align:middle}button,input,optgroup,select,textarea{font-feature-settings:inherit;color:inherit;font-family:inherit;font-size:100%;font-variation-settings:inherit;font-weight:inherit;letter-spacing:inherit;line-height:inherit;margin:0;padding:0}blockquote,dd,dl,fieldset,figure,h1,h2,h3,h4,h5,h6,hr,p,pre{margin:0}fieldset,legend{padding:0}.block{display:block}.custom-list{list-style-type:none;padding-left:20px}.custom-list li:before{content:"–";display:inline-block;margin-left:-1em;width:1em}.list-wrapper{display:none;width:560px}.accordion{display:block;margin-bottom:80px;margin-left:20px;margin-right:20px;width:560px}@media (min-width:1440px){.list-wrapper{display:block;margin-right:80px}.accordion{display:none}}.static{position:static}.mx-auto{margin-left:auto;margin-right:auto}.my-\\[96px\\]{margin-bottom:96px;margin-top:96px}.mx-5{margin-left:var(--spacing-5);margin-right:var(--spacing-5)}.my-5{margin-bottom:var(--spacing-5);margin-top:var(--spacing-5)}.mt-\\[80px\\]{margin-top:80px}.mb-5{margin-bottom:var(--spacing-5)}.flex{display:flex}.max-w-\\[560px\\]{max-width:560px}.flex-col{flex-direction:column}.flex-wrap{flex-wrap:wrap}.justify-center{justify-content:center}.gap-\\[40px\\]{gap:40px}.pl-5{padding-left:var(--spacing-5)}.text-center{text-align:center}.font-head{font-family:var(--headline-font-family)}.font-text{font-family:var(--copytext-font-family)}.font-text-bold{font-family:var(--copytext-font-family-bold)}.text-h1{font-size:var(--corporate-h1-font-size);line-height:var(--corporate-h1-line-height)}.text-copy{font-size:var(--copytext-font-size)}.text-gray-800{color:var(--color-neutral-steel-800)}', PatternlibHttpErrorPageStyle0 = patternlibHttpErrorPageCss, jsonLangs = {
  de: deJson,
  en: enJson,
  es: esJson,
  fr: frJson,
  it: itJson,
  ja: jaJson,
  pt: ptJson,
  ru: ruJson,
  zh: zhJson,
  ko: koJson,
  nl: nlJson,
  pl: plJson,
  tr: trJson
}, PatternlibHttpErrorPage = class {
  constructor(e) {
    registerInstance(this, e), this.languageChangeListener = async (t) => {
      this.i18n = TranslationService.resolveJsonBasedOnLanguage(t, jsonLangs);
    }, this.statusCode = 404, this.message = void 0, this.suppressAnimation = !1, this.i18n = void 0;
  }
  async componentWillLoad() {
    const e = await TranslationService.getCurrentLanguage(), t = TranslationService.getInstance();
    this.i18n = TranslationService.resolveJsonBasedOnLanguage(e, jsonLangs), t.on("onLanguageChange", this.languageChangeListener), this.hasDetails = this.i18n[this.statusCode].details !== void 0;
  }
  disconnectedCallback() {
    TranslationService.getInstance().off("onLanguageChange", this.languageChangeListener);
  }
  componentDidLoad() {
    const e = getAssetPath(`assets/lotties/${this.statusCode}.json`);
    this.suppressAnimation || lottiePlayer.loadAnimation({
      container: this.lottieRef,
      renderer: "svg",
      loop: !0,
      autoplay: !0,
      path: e
    });
  }
  render() {
    var e;
    return h(Host, { key: "7bd1c8a1c2588d94550dfe2e6d48682eb7a92206" }, h("div", { key: "a98df7bb934a76718dd410c95fdf1bc727dea86e", class: "mx-auto my-[96px]" }, h("div", { key: "30e29b7f3ce532ef012c230d6dba1d3ae99991a9", class: "mx-5 text-center" }, h("h1", { key: "4af6fb7832ffdb58d901d8446b5649e9b6945169", class: "text-h1 font-head my-5" }, this.i18n[this.statusCode].title), h("p", { key: "933538d1fa3e41059eccf9f33fe6396dc6bd40cb", class: "text-copy font-text text-gray-800 my-5" }, (e = this.message) !== null && e !== void 0 ? e : this.i18n[this.statusCode].message), h("slot", { key: "e467495eb129960b68b23bf5e031cb9792118a4e", name: "action" })), h("div", { key: "398e6ce377cee8b24604c569943e9532ef15b0af", class: "mt-[80px] flex justify-center flex-wrap" }, this.hasDetails && h("div", { key: "0d9413b875a7f6fb3e0d735ae440ceeec99f7f37", class: "list-wrapper flex flex-col gap-[40px]" }, this.i18n[this.statusCode].details.map((t) => h("div", null, h("p", { class: "font-text-bold mb-5" }, t.header), h("ul", { class: "custom-list pl-5" }, t.message.map((r) => h("li", { class: "font-text" }, r)))))), !this.suppressAnimation && h("div", { key: "b746d4bad782129c2e1b9c71fe444b1c3da438b8", class: "max-w-[560px]", ref: (t) => this.lottieRef = t }))));
  }
  static get assetsDirs() {
    return ["assets"];
  }
  get hostElement() {
    return getElement(this);
  }
};
PatternlibHttpErrorPage.style = PatternlibHttpErrorPageStyle0;
export {
  PatternlibHttpErrorPage as patternlib_http_error_page
};
